import React, { useContext, useEffect, useState } from "react";
import ErrorField from "../../../Components/ErrorField";
import {
  HTTPResponse,
  PageDesignConstants,
  RRMMCohortTreatment,
  SideMenuItems,
  ToastMessageType,
  ToastMessages,
  DiscontinuationReason,
  TRPQuestionType,
} from "../../../Helpers/Enums";
import SideBarMenu from "../../../Components/SideBarMenu";
import dayjs from "dayjs";
import {
  AllowNumericWithDecimal,
  AllowOnlyNonZeroNumeric,
  CheckDateValidation,
  CheckDateValidationQ36,
  DateInRange,
  GetLocalStorageData,
  GetLoggedInUserID,
  GetOrdinal,
  IsAdmin,
  IsDateAfter,
  IsDateLessThanThirtyDays,
  IsLessOrEqual,
  isStringEmpty,
  IsValidDateValue,
  isValidNumberRange,
  ValidateQ26LastAdministrationMatch,
  buildNextLotStartDatesLookup,
  IsDateValid,
  ValidateQ402BDate,
  ValidateQ403BDate,
} from "../../../Helpers/Utilities";
import PatientDetails from "../../../Components/PatientInformation";
import SaveAndNavigate from "../../../Components/SaveAndNavigate";
import {
  CommonError_Msgs,
  TTCharacteristics_MSGS,
  hyperlinkTextQ36Tecvayli,
  hyperlinkTextQ36Talvey,
  hyperlinkTextLineOfTherapy,
} from "../../../Helpers/HelperText";
import { AppContext } from "../../../Contexts/AppContextProvider";
import { AdditionalTreatmentService } from "../../../WebApiServices/AdditionalTreatment.service";

import InfoPopUp from "../../../Components/InfoPopUp";
import DatePickerComponent from "../../../Components/DatePickerComponent";

const TTCharacteristics = () => {
  const storedData = GetLocalStorageData("CohortTreatment");
  const pid = GetLocalStorageData("patientId") ?? 0;

  const [isNewEcrfA, setIsNewEcrfA] = useState(false);
  const [isNewEcrfB, setIsNewEcrfB] = useState(false);

  const [cohortNextLotDatesList, setCohortNextLotDatesList] = useState([]);

  const [ndmmAvailable, setNdmmAvailable] = useState(false);

  const [isTechvayliSelected, setTechvayliSelected] = useState(false);
  const [isTalveySelected, setTalveySelected] = useState(false);

  const [reasonsList, setDiscontinuationReasonsList] = useState([]); // bispecifictreatmentdiscontinuationreason
  const [reasonsListQ382A, setQ382ADiscontinuationReasonsList] = useState([]);
  const [aeReasonsList, setAEReasonsList] = useState([]); // bispecifictreatmentdiscontinuationreason_ae
  const [neurologicAEReasonList, setNeurologicAEReasonList] = useState([]);

  const [indexDateRRMM_techHard, setIndexDateRRMM_techHard] = useState(null);
  const [indexDateRRMM_talHard, setIndexDateRRMM_talHard] = useState(null);

  const [dateRRMMTec_dupDateHard, setDateRRMMTec_dupDateHard] = useState(null);
  const [dateRRMMTal_dupDateHard, setDateRRMMTal_dupDateHard] = useState(null);

  const [setupTec_WarningHard, setSetupTec_WarningHard] = useState(false);
  const [setupTal_WarningHard, setSetupTal_WarningHard] = useState(false);

  const [q40Tec_WarningHard, setQ40Tec_WarningHard] = useState(false);
  const [q40Tal_WarningHard, setQ40Tal_WarningHard] = useState(false);

  const [nosetupTec_WarningHard, setNosetupTec_WarningHard] = useState(false);
  const [nosetupTal_WarningHard, setNosetupTal_WarningHard] = useState(false);

  const [atleastonesetupTec_WarningHard, setAtleastonesetupTec_WarningHard] =
    useState(false);
  const [atleastonesetupTal_WarningHard, setAtleastonesetupTal_WarningHard] =
    useState(false);

  const [tecNumberofAdministrator, setTecNumberofAdministrator] =
    useState(null);
  const [talNumberofAdministrator, setTalNumberofAdministrator] =
    useState(null);

  const [
    tecNumberofAdministratorMatching,
    setTecNumberofAdministratorMatching,
  ] = useState(false);
  const [
    talNumberofAdministratorMatching,
    setTalNumberofAdministratorMatching,
  ] = useState(false);

  const [isTecLastAdminDateValid, setIsTecLastAdminDateValid] = useState(true);
  const [isTalLastAdminDateValid, setIsTalLastAdminDateValid] = useState(true);

  const [tecvayliDateRRMM, setTecvayliDateRRMM] = useState(
    "[Bispecifics/CAR-T end of follow up]",
  );
  const [talveyDateRRMM, setTalveyDateRRMM] = useState(
    "[Bispecifics/CAR-T end of follow up]",
  );

  const [rrmmAvailable, setRRMMAvailable] = useState(false);
  const [rrmmElLinAvailable, setRRMMElLinAvailable] = useState(false);

  const [techIndexDate, setTechIndexDate] = useState("");
  const [talIndexDate, setTalIndexDate] = useState("");
  const [endOfFollowUpDate, setEndOfFollowUpDate] = useState("");

  const [techLOTStartDate, setTechLOTStartDate] = useState("");
  const [talLOTStartDate, setTalLOTStartDate] = useState("");

  const [
    showHideHyperlinkModalQ36Tecvayli,
    setShowHideHyperlinkModalQ36Tecvayli,
  ] = useState(false);
  const [showHideHyperlinkModalQ36Talvey, setShowHideHyperlinkModalQ36Talvey] =
    useState(false);

  const [showLineOfTherapyModal, setShowLineOfTherapyModal] = useState(false);

  const [deathDate, setDeathDate] = useState(null);

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setIsSideMenuActive,
  } = useContext(AppContext);

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  const navigatePaths = {
    prevPage: ndmmAvailable
      ? "/NDMMSCTCharacteristics"
      : "/NonCohortDefiningTreatment",
    currPage: "/TTCharacteristics",
    nextPage: rrmmElLinAvailable
      ? "/ELCharacteristics"
      : rrmmAvailable
        ? "/CarTCharacteristics"
        : "/IMWGReporting",
  };

  const TechvayliRow = {
    teclistamatalquetamabdosagebridgeid: 0,
    cohorttreatmentid: isTechvayliSelected ? RRMMCohortTreatment.TECVAYLI : 0, // GetLocalStorageData("techvayliID") || 0

    //TECHVAYLI
    dose_administration_tech: null,
    dosing_phase_tech: null,
    siteofcare_tech: null,
    tech_dose_strength_rbl: null,
    tech_dose_strength_mg: "",
    tech_dose_strength_mg_kg: "",
    tech_dose_strength_mgm: "",
    tech_dose_strength_mg_kgHard: false,
    tech_dose_strength_mg_kgRange: false,

    dose_administration_tech_dt: "",
    dt_admission_tech_dt: "",
    dt_discharge_tech_dt: "",

    dosing_phase_techHard_othEmpty: false,
    dose_administration_techHard: false,
    dosing_phase_techHard: false,
    siteofcare_techHard: false,
    dt_admission_techHard: false,
    dt_discharge_techHard: false,

    dose_administration_techHard_dt: false,
    Invalid_dose_administration_tech_dt: false,
    dt_admission_techHard_dt: false,
    dt_discharge_techHard_dt: false,
    dt_admission_techHard_dt_check: false,
    dt_discharge_techHard_dt_check: false,
    dose_administration_tech_dt_before_eof: false,
    dt_tech_date_out_of_bound: false,

    Q36TechConditionMet: false,

    //new
    dosing_phase_oth_txt_tech: "",
  };

  const TalveyRow = {
    teclistamatalquetamabdosagebridgeid: 0,
    cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0, //GetLocalStorageData("talveyID") || 0

    //TALVEY

    dose_administration_tal: null,
    dosing_phase_tal: null,
    siteofcare_tal: null,
    tal_dose_strength_rbl: null,
    tal_dose_strength_mg: "",
    tal_dose_strength_mg_kg: "",
    tal_dose_strength_mgm: "",
    tal_dose_strength_mg_kgHard: false,
    tal_dose_strength_mg_kgRange: false,

    dose_administration_tal_dt: "",
    Invalid_dose_administration_tal_dt: false,
    dt_admission_tal_dt: "",
    dt_discharge_tal_dt: "",

    dose_administration_talHard: false,
    dosing_phase_talHard: false,
    siteofcare_talHard: false,
    dt_admission_talHard: false,
    dt_discharge_talHard: false,

    dose_administration_talHard_dt: false,
    dt_admission_talHard_dt: false,
    dt_discharge_talHard_dt: false,

    dt_admission_talHard_dt_check: false,
    dt_discharge_talHard_dt_check: false,

    dt_tal_date_out_of_bound: false,
    dt_tal_2L_3L_date_conditions: false,

    dosing_phase_oth_txt_tal: "",
    dosing_phase_talHard_othEmpty: false,
  };
  //36.1
  const HospitalizationRow = {
    teclistamatalquetamabhospitalizationbridgeid: 0,
    cohorttreatmentid: 0,
    //B
    dt_admission: null,
    dt_admission_dt: "",
    dt_admission_Hard: false,
    dt_admission_Hard_dt: false,
    dt_admission_out_of_bound: false,
    Invalid_admission_Hard_dt: false,
    dt_admission_before_eof: false,

    //C
    dt_discharge: null,
    dt_discharge_dt: "",
    dt_discharge_Hard: false,
    dt_discharge_Hard_dt: false,
    dt_discharge_Hard_dt_check: false,
    dt_discharge_out_of_bound: false,
    dateRangeThirty: false,
    dischargeMoreThanAdministrationWarning: false,
    Invalid_dt_discharge_Hard: false,
    dt_discharge_before_eof: false,
    //D
    hospReason1: false,
    hospReason2: false,
    hospReason3: false,
    hospReason4: false,
    hospReason5: false,
    hospReason6: false,
    hosp_reason_oth_txt: "",
    hospReasonUnk: false,
    hospReasonEmptyHard: false,
    hospReasonTxtEmpty: false,
  };

  const Q37TechRow = {
    teclistamabcharacteristicsid: 0,
    cohorttreatmentid: isTechvayliSelected ? RRMMCohortTreatment.TECVAYLI : 0, //GetLocalStorageData("techvayliID") || 0
    Q37TechvayliRd: null,

    q37TechvayliEmpty: false,

    q37_Tec_Dose_week_frquencyRd: null,
    q37_Tec_Dose_week_frquency_txt: "",
    q37_Tec_Dose_week_frquencyRd_Empty: false,
    q37_Tec_Dose_week_frquency_txt_Empty: false,
    q37TecDoseWeekFrequencyRangeError: false,

    q37_Tec_Dose_week_strengthRd: null,
    q37_Tec_Dose_week_strength_txt: "",
    q37_Tec_Dose_week_strengthRd_Empty: false,
    q37_Tec_Dose_week_strength_txt_Empty: false,

    q37_atleasetOneAdministrationTecWarningHard: false,

    //40
    Q40dosingfreqRd: null,
    Q40IgILevelRd: null,
    Q40init_dt_Rd: null,
    Q40init_dt: "",
    primaryProf: false,
    secondaryProf: false,
    otherReson: false,
    InvalidQ40init_dt: false,
    init_dt_before_eof: false,

    dosing_freq_oth_txt: "",
    showDateRedFreqTec: false,

    //40 validations state
    Q40DosingFreqEmptyHard: false,
    Q40DosingFreqTxtEmptyHard: false,
    Q40IgGEmptyHard: false,
    Q40Init_dtHard: false,
    Q40Init_RdHard: false,
    Q40ReasonEmptyHard: false,

    //39
    tocilizumab_tech: false,
    granulocyte_tech: false,
    noneoftheabove_tech: null,
    steroids_tech: false,
    q39TechEmptyHard: false,

    //Q39.1 - Tocilizumab
    cytokin_tech: false,
    secondary_prophylactic_crs_tech: false,
    crs_tech: false,
    neurotoxicity_tech: false,
    secondary_neurotoxicity_tech: false,
    tmt_neurotoxicity_tech: false,
    tmt_tech_unknown: false,
    q39TechReasonHard: false,

    //Q39.3 - Granulocyte
    prophylactic_use_tech: false,
    secondary_prophylactic_use_tech: false,
    oth_use_tech: false,
    unknown_tech: null,
    q39TechGranulocyteEmptyHard: false,

    // Q39.2 - Steroid
    steroid_pre_tmt_tech: false,
    cytokin_tech_steroids: false,
    secondary_prophylactic_tech_steroids: false,
    crs_tech_steroids: false,
    neurotoxicity_tech_steroids: false,
    secondary_neurotoxicity_tech_steroids: false,
    tmt_neurotoxicity_tech_steroids: false,
    tmt_steroids_tech_unknown: false,

    q39TechSteroidsEmptyHard: false,

    //Tecvayli New column
    betamethasone_tech: false,
    betamethasone_techNum: "",

    betamethasone_tech_txtEmpty: false,

    dexamethasone_tech: false,
    dexamethasone_techNum: "",

    dexamethasone_tech_txtEmpty: false,

    hydrocortisone_tech: false,
    hydrocortisone_techNum: "",

    hydrocortisone_tech_txtEmpty: false,

    methylprednisolone: false,
    methylprednisoloneNum: "",
    methylprednisolone_txtEmpty: false,

    prednisolone_tech: false,
    prednisolone_techNum: "",
    prednisolone_tech_txtEmpty: false,

    prednisone_tech: false,
    prednisone_techNum: "",

    prednisone_tech_txtEmpty: false,

    triamcinolone_tech: false,
    triamcinolone_techNum: "",
    triamcinolone_tech_txtEmpty: false,

    dose_name_tech_unknown: false,

    name_dose_steroidsHardEmpty: false,
    steroids_tech_txtEmpty: false,
  };

  const Q37TalRow = {
    teclistamabcharacteristicsid: 0,
    cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0, //GetLocalStorageData("talveyID") || 0
    Q37TalveyRd: null,

    q37TalveyEmpty: false,

    showDateRedFreqTal: false,

    //New Column Q37
    q37_Tal_Dose_week_frquencyRd: null,
    q37_Tal_Dose_week_frquency_txt: "",
    q37_Tal_Dose_week_frquencyRd_Empty: false,
    q37_Tal_Dose_week_frquency_txt_Empty: false,
    q37TalDoseWeekFrequencyRangeError: false,

    q37_Tal_Dose_week_strengthRd: null,
    q37_Tal_Dose_week_strength_txt: "",
    q37_Tal_Dose_week_strengthRd_Empty: false,
    q37_Tal_Dose_week_strength_txt_Empty: false,

    //talvey new column
    betamethasone_tal: false,
    betamethasone_talNum: "",

    dexamethasone_tal: false,
    dexamethasone_talNum: "",

    hydrocortisone_tal: false,
    hydrocortisone_talNum: "",

    methylprednisolone_tal: false,
    methylprednisolone_talNum: "",

    prednisolone_tal: false,
    prednisolone_talNum: "",

    prednisone_tal: false,
    prednisone_talNum: "",

    triamcinolone_tal: false,
    triamcinolone_talNum: "",

    dose_name_tal_unknown: false,

    name_dose_steroids_talHardEmpty: false,
    steroids_tal_txtEmpty: false,

    q37_atleasetOneAdministrationTalWarningHard: false,

    //39
    tocilizumab_tal: false,
    steroids_tal: false,
    granulocyte_tal: false,
    noneoftheabove_tal: null,
    q39TalEmptyHard: false,

    //Q39.1 -- Tocilizumab
    cytokin_tal: false,
    secondary_prophylactic_crs_tal: false,
    crs_tal: false,
    neurotoxicity_tal: false,
    secondary_neurotoxicity_tal: false,
    tmt_neurotoxicity_tal: false,
    tmt_talvey_unknown: false,
    q39TalReasonHard: false,

    //Q39.3 - Granulocyte
    prophylactic_use_tal: false,
    secondary_prophylactic_use_tal: false,
    oth_use_tal: false,
    unknown_tal: null,
    q39TalGranulocyteEmptyHard: false,

    //Q39.2 - Steroids
    steroid_pre_tmt_tal: false,
    cytokin_tal_steroids: false,
    secondary_prophylactic_tal_steroids: false,
    crs_tal_steroids: false,
    neurotoxicity_tal_steroids: false,
    secondary_neurotoxicity_tal_steroids: false,
    tmt_neurotoxicity_tal_steroids: false,
    tmt_tal_unknown: false,

    Q39talSteroidsEmptyHard: false,

    //40
    Q40dosingfreqRd_Tal: null,
    Q40IgILevelRd_Tal: null,
    Q40init_dt_Rd_Tal: null,
    Q40init_dt_Tal: "",
    primaryProf_Tal: false,
    secondaryProf_Tal: false,
    otherReson_Tal: false,
    InvalidQ40init_dt_Tal: false,
    init_dt_before_eof_Tal: false,

    dosing_freq_oth_txt_Tal: "",
    showDateRedFreqTec_Tal: false,

    //40 validations state
    Q40TalDosingFreqEmptyHard: false,
    Q40TalDosingFreqTxtEmptyHard: false,
    Q40TalIgGEmptyHard: false,
    Q40TalInit_dtHard: false,
    Q40TalInit_RdHard: false,
    Q40TalReasonEmptyHard: false,
  };

  const Q38TechRow = {
    teclistamatalquetamabdosefrequencybridgeid: 0,
    cohorttreatmentid: isTechvayliSelected ? RRMMCohortTreatment.TECVAYLI : 0, //GetLocalStorageData("techvayliID") || 0

    Q38TechvayliRd: null,
    dt_dosefreq_tech_dt: "",
    Invalid_dt_dosefreq_tech_dt: false,

    Q38TechEmptyHard: false,
    Q38DateEmpty: false,
    Q38TechDateInvalid: false,

    q38_Tec_Dose_week_frquencyRd: null,
    q38_Tec_Dose_week_frquency_txt: "",

    q38_Tec_Dose_week_frquencyRd_Empty: false,
    q38_Tec_Dose_week_frquency_txt_Empty: false,
    q38TecDoseFrequencyConflict: false,
  };

  const Q38TalRow = {
    teclistamatalquetamabdosefrequencybridgeid: 0,
    cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0, //GetLocalStorageData("talveyID") || 0

    Q38TalveyRd: null,
    dt_dosefreq_tal_dt: "",

    InvalidQ38Talveydate: false,

    q39TalEmptyHard: false,
    Q39TalDateInvalid: false,

    Q38TalEmptyHard: false,
    Q38TalDateEmpty: false,
    Q38TalDateInvalid: false,

    q38_Tal_Dose_week_frquencyRd: null,
    q38_Tal_Dose_week_frquency_txt: "",
    q38_Tal_Dosage_Rd: null,
    q38_Tal_Dosage_OtherTxt: "",

    q38_Tal_Dose_week_frquencyRd_Empty: false,
    q38_Tal_Dose_week_frquency_txt_Empty: false,
    q38_Tal_Dosage_Rd_Empty: false,
    q38_Tal_Dosage_OtherTxt_Empty: false,
    q38TalDoseFrequencyConflict: false,
  };

  // Q39.1.A
  const q391ATechRow = {
    cohorttreatmentid: RRMMCohortTreatment.TECVAYLI,
    tocilizumabmedicationid: 0,
    patientid: 0,
    //checkbox
    primaryProphylacticCrs_tech: false,
    secondaryProphylacticCrs_tech: false,
    supportiveCareCrs_tech: false,
    primaryProphylacticNeurologic_tech: false,
    secondaryProphylacticNeurologic_tech: false,
    supportiveCareNeurologic_tech: false,
    medicationReasonUnk_tech: false,
    q39TechReasonEmpty: false,

    //date
    administrationDate_tech: null,
    administrationDateRD_tech: null,
    q39TechInvalidAdministrationDate: false,
    q39TechAdministrationDateEmpty: false,
    q39TechAdministrationRDEmpty: false,
  };

  const q391ATalRow = {
    cohorttreatmentid: RRMMCohortTreatment.TALVEY,
    tocilizumabmedicationid: 0,
    patientid: 0,
    //checkbox
    primaryProphylacticCrs_tal: false,
    secondaryProphylacticCrs_tal: false,
    supportiveCareCrs_tal: false,
    primaryProphylacticNeurologic_tal: false,
    secondaryProphylacticNeurologic_tal: false,
    supportiveCareNeurologic_tal: false,
    medicationReasonUnk_tal: false,
    q39TalReasonEmpty: false,

    //date
    administrationDate_tal: null,
    administrationDateRD_tal: null,
    q39TalInvalidAdministrationDate: false,
    q39TalAdministrationDateEmpty: false,
    q39TalAdministrationRDEmpty: false,
  };

  const Q401aTechRow = {
    tectalivigreceivedbridgeid: 0,
    cohorttreatmentid: isTechvayliSelected ? RRMMCohortTreatment.TECVAYLI : 0, //GetLocalStorageData("techvayliID") || 0

    Q401ainit_dt_Rd_Tec: null,
    Q401ainit_Tec_dt: "",
    Q401aInit_Tec_RdHard: false,
    Q401aInit_Tec_dtHard: false,
    Q401aInvalidQ401ainit_Tec_dt: false,
    Q401aInit_Tec_dt_before_eof: false,

    Q401aIntendedDosing_Tec: null,
    Q401aIntendedDosing_Tec_WeekValue: "",
    Q401aIntendedDosing_Tec_MonthValue: "",
    Q401aIntendedDosing_Tec_OnceWeekValue: "",
    Q401aIntendedDosing_Tec_OnceMonthValue: "",
    Q401aIntendedDosing_Tec_OtherValue: "",
    Q401aIntendedDosingEmpty_Tec: false,
    Q401aIntendedDosingRangeInvalid_Tec: false,

    Q401aPrimaryProf_Tec: false,
    Q401aSecProf_Tec: false,
    Q401aOtherProf_Tec: false,
    Q401aUnknownProf_Tec: null,
    Q401aReasonIvigEmptyHard_Tec: false,

    Q401aDosingType_Tec: null,
    Q401aDosingType_TecEmptyHard: false,

    Q401aDosage_Tec: null,
    Q401aDosage_Tec_GValue: "",
    Q401aDosage_Tec_MgValue: "",
    Q401aDosageFrequencyEmpty_Tec: false,
    Q401aDosageRangeInvalid_Tec: false,

    Q401aWeight_Tec: null,
    Q401aWeight_Value_KgTec: "",
    Q401aWeight_Value_LbsTec: "",
    Q401aWeightEmpty_Tec: false,
    Q401aWeightRangeInvalid_Tec: false,

    Q401aWeight_Asses_Tec: null,
    Q401aWeight_Asses_Tec_dt: "",
    Q401aWeight_AssesEmptyHard_Tec: false,
    Q401aWeight_AssesDtEmptyHard_Tec: false,
    Q401aWeight_AssesDtInvalid_Tec: false,
    Q401aWeight_Asses_dt_before_eof_Tec: false,
  };

  const Q401aTalRow = {
    tectalivigreceivedbridgeid: 0,
    cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0, //GetLocalStorageData("talveyID") || 0

    Q401ainit_dt_Rd_Tal: null,
    Q401ainit_Tal_dt: "",
    Q401aInit_Tal_RdHard: false,
    Q401aInit_Tal_dtHard: false,
    Q401aInvalidQ401ainit_Tal_dt: false,
    Q401aInit_Tal_dt_before_eof: false,

    Q401aIntendedDosing_Tal: null,
    Q401aIntendedDosing_Tal_WeekValue: "",
    Q401aIntendedDosing_Tal_MonthValue: "",
    Q401aIntendedDosing_Tal_OnceWeekValue: "",
    Q401aIntendedDosing_Tal_OnceMonthValue: "",
    Q401aIntendedDosing_Tal_OtherValue: "",
    Q401aIntendedDosingEmpty_Tal: false,
    Q401aIntendedDosingRangeInvalid_Tal: false,

    Q401aPrimaryProf_Tal: false,
    Q401aSecProf_Tal: false,
    Q401aOtherProf_Tal: false,
    Q401aUnknownProf_Tal: null,
    Q401aReasonIvigEmptyHard_Tal: false,

    Q401aDosingType_Tal: null,
    Q401aDosingType_TalEmptyHard: false,

    Q401aDosage_Tal: null,
    Q401aDosage_Tal_GValue: "",
    Q401aDosage_Tal_MgValue: "",
    Q401aDosageFrequencyEmpty_Tal: false,
    Q401aDosageRangeInvalid_Tal: false,

    Q401aWeight_Tal: null,
    Q401aWeight_Value_KgTal: "",
    Q401aWeight_Value_LbsTal: "",
    Q401aWeightEmpty_Tal: false,
    Q401aWeightRangeInvalid_Tal: false,

    Q401aWeight_Asses_Tal: null,
    Q401aWeight_Asses_Tal_dt: "",
    Q401aWeight_AssesEmptyHard_Tal: false,
    Q401aWeight_AssesDtEmptyHard_Tal: false,
    Q401aWeight_AssesDtInvalid_Tal: false,
    Q401aWeight_Asses_dt_before_eof_Tal: false,
  };

  const Q26AllRecords = {
    bispecificQ26ModelId: 0,
    cohorttreatmentid: 0,
    lotNumber: null,

    firstAdministrationDt: null,
    lastAdministrationDt: null,
  };

  const Q331AAllRecords = {
    bispecificQ26ModelId: 0,
    cohorttreatmentid: 0,
    lotNumber: null,

    firstAdministrationDt: null,
    lastAdministrationDt: null,
  };

  const NdmmAllRecords = {
    ndmmModelId: 0,
    cohorttreatmentid: 0,
    lotNumber: null,

    startLotDt: null,
    endLotDt: null,
  };

  const Q402aTechRow = {
    tectalivigiggreceivedbridgeid: 0,
    cohorttreatmentid: isTechvayliSelected ? RRMMCohortTreatment.TECVAYLI : 0, //GetLocalStorageData("techvayliID") || 0

    Q402aIgg_assessment_Tec: null,
    Q402aIgg_assessment_Tec_dt: "",
    Q402aIgg_assessment_Tec_RdHard: false,
    Q402aIgg_assessment_Tec_dtHard: false,
    Q402aIgg_assessment_Tec_dtInvalid: false,
    Q402aIgg_assessment_Tec_dt_before_eof: false,
    Q402aIgg_level_Tec: null,
    Q402aIgg_level_Tec_MgValue: "",
    Q402aIgg_level_Tec_GValue: "",
    Q402aIgg_level_Tec_Empty: false,
    Q402aIgg_level_Tec_RangeInvalid: false,
  };

  const Q402aTalRow = {
    tectalivigiggreceivedbridgeid: 0,
    cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0,

    Q402aIgg_assessment_Tal: null,
    Q402aIgg_assessment_Tal_dt: "",
    Q402aIgg_assessment_Tal_RdHard: false,
    Q402aIgg_assessment_Tal_dtHard: false,
    Q402aIgg_assessment_Tal_dtInvalid: false,
    Q402aIgg_assessment_Tal_dt_before_eof: false,
    Q402aIgg_level_Tal: null,
    Q402aIgg_level_Tal_MgValue: "",
    Q402aIgg_level_Tal_GValue: "",
    Q402aIgg_level_Tal_Empty: false,
    Q402aIgg_level_Tal_RangeInvalid: false,
  };

  const Q403aTechRow = {
    tectalivigiggneverreceivedbridgeid: 0,
    cohorttreatmentid: isTechvayliSelected ? RRMMCohortTreatment.TECVAYLI : 0, //GetLocalStorageData("techvayliID") || 0

    Q403aIgg_assessment_Tec: null,
    Q403aIgg_assessment_Tec_dt: "",
    Q403aIgg_assessment_Tec_RdHard: false,
    Q403aIgg_assessment_Tec_dtHard: false,
    Q403aIgg_assessment_Tec_dtInvalid: false,
    Q403aIgg_assessment_Tec_dt_before_eof: false,
    Q403aIgg_level_Tec: null,
    Q403aIgg_level_Tec_MgValue: "",
    Q403aIgg_level_Tec_GValue: "",
    Q403aIgg_level_Tec_Empty: false,
    Q403aIgg_level_Tec_RangeInvalid: false,
  };

  const Q403aTalRow = {
    tectalivigiggneverreceivedbridgeid: 0,
    cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0,

    Q403aIgg_assessment_Tal: null,
    Q403aIgg_assessment_Tal_dt: "",
    Q403aIgg_assessment_Tal_RdHard: false,
    Q403aIgg_assessment_Tal_dtHard: false,
    Q403aIgg_assessment_Tal_dtInvalid: false,
    Q403aIgg_assessment_Tal_dt_before_eof: false,
    Q403aIgg_level_Tal: null,
    Q403aIgg_level_Tal_MgValue: "",
    Q403aIgg_level_Tal_GValue: "",
    Q403aIgg_level_Tal_Empty: false,
    Q403aIgg_level_Tal_RangeInvalid: false,
  };

  //39.1.A
  const [q391ATechTocilzumabList, setQ391ATechTocilzumabList] = useState([
    q391ATechRow,
  ]);
  const [q391ATalTocilzumabList, setQ391ATalTocilzumabList] = useState([
    q391ATalRow,
  ]);
  const [
    q391ATechAdministrationDateOutOfRange,
    setQ391ATechAdministrationDateOutOfRange,
  ] = useState(false);

  const [
    q391ATalAdministrationDateOutOfRange,
    setQ391ATalAdministrationDateOutOfRange,
  ] = useState(false);

  const [Q37TechDetails, setQ37TechDetails] = useState([Q37TechRow]);
  const [Q37TalDetails, setQ37TalDetails] = useState([Q37TalRow]);

  const [Q38TechDetails, setQ38TechDetails] = useState([Q38TechRow]);
  const [Q38TalDetails, setQ38TalDetails] = useState([Q38TalRow]);

  const [Q401aTecDetails, setQ401aTecDetails] = useState([Q401aTechRow]);
  const [Q401aTalDetails, setQ401aTalDetails] = useState([Q401aTalRow]);

  const [Q402aTecDetails, setQ402aTecDetails] = useState([Q402aTechRow]);
  const [Q402aTalDetails, setQ402aTalDetails] = useState([Q402aTalRow]);

  const [Q403aTecDetails, setQ403aTecDetails] = useState([Q403aTechRow]);
  const [Q403aTalDetails, setQ403aTalDetails] = useState([Q403aTalRow]);

  const [techvayliDetails, setTechvayliDetails] = useState([TechvayliRow]);
  const [talveyDetails, setTalveyDetails] = useState([TalveyRow]);
  //36.1
  const [tecHospDetails, setTecHospDetails] = useState([HospitalizationRow]);
  const [talHospDetails, setTalHospDetails] = useState([HospitalizationRow]);

  const [bispecificQ26Data, setBispecificQ26Data] = useState([Q26AllRecords]);
  const [bispecificQ331AData, setBispecificQ331AData] = useState([
    Q26AllRecords,
  ]);

  const [bispecificQ31Q32Data, setBispecificQ31Q32Data] = useState([
    Q26AllRecords,
  ]);
  const [ndmmLotData, setNdmmLotData] = useState([NdmmAllRecords]);

  const Q381ATechRow = {
    teclistamatalquetamabdosefrequencyinfobridgeid: 0,
    cohorttreatmentid: isTechvayliSelected ? RRMMCohortTreatment.TECVAYLI : 0,
    discontinuationSoftError: false,
    // Column B - Type of change
    changeType: null, // 1=No changes, 2=Frequency, 3=Strength, 99=Unknown
    changeTypeDoseFrequency: null, // 1=Increase, 2=Decrease
    changeTypeDoseStrength: null, // 1=Increase, 2=Decrease

    // Column C - Reasons (multi-select arrays)
    discontinuationReasons: [], // Array of bispecifictreatmentdiscontinuationreasonid
    adverseEventReasons: [], // Array of bispecifictreatmentdiscontinuationreasonaeid
    reasonOtherText: "", // For "Other" reason (ID=14)
    neurologicAEReasonList: [],

    // Column D - Pattern BEFORE change
    patterBeforeChangeDoseFrequency: null, // 1=times/week, 2=every X weeks, 99=Unknown
    patterBeforeChangeDoseFrequencyPerWeek: "",
    patterBeforeChangeDoseFrequencyEveryWeek: "",
    patterBeforeChangeDoseStrength: null, // 1=mg, 2=mg/kg, 3=mg/m², 99=Unknown

    patterBeforeChangeDoseStrengthMg: "", // For radio value 1
    patterBeforeChangeDoseStrengthMgKg: "", // For radio value 2
    patterBeforeChangeDoseStrengthMgM2: "", // For radio value 3

    // Column E - Pattern AFTER change
    patterAfterChangeDoseFrequency: null,
    patterAfterChangeDoseFrequencyPerWeek: "",
    patterAfterChangeDoseFrequencyEveryWeek: "",

    patterAfterChangeDoseStrength: null,

    patterAfterChangeDoseStrengthMg: "", // For radio value 1
    patterAfterChangeDoseStrengthMgKg: "", // For radio value 2
    patterAfterChangeDoseStrengthMgM2: "", // For radio value 3

    // Column F - Date of change
    dateChangeRd: null, // 1=Date provided, 99=Unknown
    dateChange: "",

    // ========================================
    // VALIDATION FLAGS - HARD ERRORS
    // ========================================
    // Column B validations
    changeTypeEmpty: false,
    changeTypeDoseFrequencyEmpty: false,
    changeTypeDoseStrengthEmpty: false,

    // Column C validations
    reasonEmpty: false,
    reasonOtherTextEmpty: false,
    aeSubReasonEmpty: false,
    neuroReasonEmpty: false,
    neuroOtherTextEmpty: false,

    // Column D validations (Pattern BEFORE)
    patternBeforeFrequencyEmpty: false,
    patternBeforeFrequencyRangeInvalid: false,

    patternBeforeStrengthEmpty: false,
    patternBeforeStrengthRangeInvalid: false,
    // Column E validations (Pattern AFTER)
    patternAfterFrequencyEmpty: false,
    patternAfterFrequencyRangeInvalid: false,

    patternAfterStrengthEmpty: false,
    patternAfterStrengthRangeInvalid: false,
    // Column F validations
    dateChangeRdEmpty: false,
    dateChangeEmpty: false,
    invalidDateChange: false,
    dateChangeOutOfBound: false,
    dateChangeBeforeEOF: false,

    // ========================================
    // CONFLICT VALIDATIONS (HARD ERRORS)
    // ========================================
    frequencyIncreaseConflict: false,
    frequencyDecreaseConflict: false,
    strengthIncreaseConflict: false,
    strengthDecreaseConflict: false,

    // ========================================
    // WARNING FLAGS
    // ========================================
    patternBeforeUnknownWarning: false,
    patternAfterUnknownWarning: false,
  };

  const [Q381ATechDetails, setQ381ATechDetails] = useState([Q381ATechRow]);

  const Q381ATalvRow = {
    teclistamatalquetamabdosefrequencyinfobridgeid: 0,
    cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0,
    discontinuationSoftError: false,
    // Column B - Type of change
    changeType: null, // 1=No changes, 2=Frequency change, 3=Strength change, 99=Unknown
    changeTypeDoseFrequency: null, // 1=Increase, 2=Decrease (only if changeType === 2)
    changeTypeDoseStrength: null, // 1=Increase, 2=Decrease (only if changeType === 3)

    // Column C - Reasons for change (multi-select)
    discontinuationReasons: [],
    adverseEventReasons: [],
    reasonOtherText: "",
    neurologicAEReasonList: [],

    // Column D - Pattern BEFORE change
    patterBeforeChangeDoseFrequency: null,
    patterBeforeChangeDoseStrength: null,

    patterBeforeChangeDoseFrequencyPerWeek: "",
    patterBeforeChangeDoseFrequencyEveryWeek: "",

    patterBeforeChangeDoseStrengthMg: "",
    patterBeforeChangeDoseStrengthMgKg: "",
    patterBeforeChangeDoseStrengthMgM2: "",

    // Column E - Pattern AFTER change
    patterAfterChangeDoseFrequency: null,
    patterAfterChangeDoseStrength: null,

    patterAfterChangeDoseStrengthMg: "",
    patterAfterChangeDoseStrengthMgKg: "",
    patterAfterChangeDoseStrengthMgM2: "",
    patterAfterChangeDoseFrequencyPerWeek: "",
    patterAfterChangeDoseFrequencyEveryWeek: "",
    // Column F - Date of change
    dateChangeRd: null, // 1=Date provided, 99=Unknown
    dateChange: "", // DateTime

    // Validation flags
    changeTypeEmpty: false,
    changeTypeDoseFrequencyEmpty: false,
    changeTypeDoseStrengthEmpty: false,
    reasonEmpty: false,
    reasonOtherTextEmpty: false,
    aeSubReasonEmpty: false,
    neuroReasonEmpty: false,
    neuroOtherTextEmpty: false,
    patternBeforeFrequencyEmpty: false,
    patternBeforeStrengthEmpty: false,
    patternAfterFrequencyEmpty: false,
    patternAfterStrengthEmpty: false,
    dateChangeEmpty: false,
    dateChangeRdEmpty: false,
    invalidDateChange: false,
    dateChangeOutOfBound: false,
    dateChangeBeforeEOF: false,

    // Conflict validations
    frequencyIncreaseConflict: false,
    frequencyDecreaseConflict: false,
    strengthIncreaseConflict: false,
    strengthDecreaseConflict: false,

    // Warning flags
    patternBeforeUnknownWarning: false,
    patternAfterUnknownWarning: false,
  };

  const [Q381ATalvDetails, setQ381ATalvDetails] = useState([Q381ATalvRow]);

  const Q382ARowDefault = {
    teclistamatalquetamabdosefrequencyinfobridgeid: 0,
    cohorttreatmentid: 0,
    discontinuationSoftError: false,
    // Column B - Type of change
    changeType: null, // 1=No changes, 2=Frequency, 3=Strength, 99=Unknown

    // Column C - Reasons (multi-select arrays)
    discontinuationReasons: [], // Array of bispecifictreatmentdiscontinuationreasonid
    adverseEventReasons: [], // Array of bispecifictreatmentdiscontinuationreasonaeid
    reasonOtherText: "", // For "Other" reason (ID=14)
    reasonOtherTextEmpty: false,
    neurologicAEReasonList: [],

    // start dose
    startDoseDt: null, // 1=times/week, 2=every X weeks, 99=Unknown
    startDoseDtRd: null,

    aeSubReasonEmpty: false,
    neuroReasonEmpty: false,
    neuroOtherTextEmpty: false,
    //end dose
    endDoseDt: null, // 1=times/week, 2=every X weeks, 99=Unknown
    endDoseDtRd: null,
    colBError: false,
    colCError: false,
    colDError: false,
    colFError: false,
    startDoseDtError: false,
    endDoseDtError: false,
    invalidEndDateChange: false,
    endDateChangeOutOfBound: false,
    invalidstartDateChange: false,
    startDateChangeOutOfBound: false,
    interruptionStartDateUnknownWarning: false,
    interruptionEndDateUnknownWarning: false,
  };

  const [Q382ATechDetails, setQ382ATechDetails] = useState([Q382ARowDefault]);

  const [dt_tec_2L_3L_date_conditions, setDt_tec_2L_3L_date_conditions] =
    useState(false);
  const [dt_tal_2L_3L_date_conditions, setDt_tal_2L_3L_date_conditions] =
    useState(false);

  const [Q382ATalvDetails, setQ382ATalvDetails] = useState([Q382ARowDefault]);

  const [hideQ381TechAdd, setHideQ381TechAdd] = useState(false);
  const [hideQ381TalvAdd, setHideQ381TalvAdd] = useState(false);

  const [hideQ382TechAdd, setHideQ382TechAdd] = useState(false);
  const [hideQ382TalvAdd, setHideQ382TalvAdd] = useState(false);

  const stateResolver = {
    "381A": {
      [RRMMCohortTreatment.TECVAYLI]: [Q381ATechDetails, setQ381ATechDetails],
      [RRMMCohortTreatment.TALVEY]: [Q381ATalvDetails, setQ381ATalvDetails],
    },
    "382A": {
      [RRMMCohortTreatment.TECVAYLI]: [Q382ATechDetails, setQ382ATechDetails],
      [RRMMCohortTreatment.TALVEY]: [Q382ATalvDetails, setQ382ATalvDetails],
    },
  };

  const DeleteQ381ATechRow = (id) => {
    const newArray = [...Q381ATechDetails];
    newArray.splice(id, 1);
    setQ381ATechDetails(newArray);
  };
  const DeleteQ382ATechRow = (id) => {
    const newArray = [...Q382ATechDetails];
    newArray.splice(id, 1);
    setQ382ATechDetails(newArray);
  };

  const DeleteQ382ATalvRow = (id) => {
    const newArray = [...Q382ATalvDetails];
    newArray.splice(id, 1);
    setQ382ATalvDetails(newArray);
  };

  const AddQ381ATechRow = () => {
    setQ381ATechDetails((prev) => [
      ...prev,
      {
        ...Q381ATechRow,
        cohorttreatmentid: isTechvayliSelected
          ? RRMMCohortTreatment.TECVAYLI
          : 0,
        adverseEventReasons: aeReasonsList.map((x) => ({ ...x })),
        discontinuationReasons: reasonsList.map((x) => ({ ...x })),
        neurologicAEReasonList: neurologicAEReasonList.map((x) => ({ ...x })),
      },
    ]);
  };

  const DeleteQ381ATalvRow = (id) => {
    const newArray = [...Q381ATalvDetails];
    newArray.splice(id, 1);
    setQ381ATalvDetails(newArray);
  };

  const AddQ381TalvRow = () => {
    setQ381ATalvDetails((prev) => [
      ...prev,
      {
        ...Q381ATalvRow,
        cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0,
        adverseEventReasons: aeReasonsList.map((x) => ({ ...x })),
        discontinuationReasons: reasonsList.map((x) => ({ ...x })),
        neurologicAEReasonList: neurologicAEReasonList.map((x) => ({ ...x })),
      },
    ]);
  };

  const AddQ382TechRow = () => {
    setQ382ATechDetails((prev) => [
      ...prev,
      {
        ...Q382ARowDefault,
        cohorttreatmentid: isTechvayliSelected
          ? RRMMCohortTreatment.TECVAYLI
          : 0,
        adverseEventReasons: aeReasonsList.map((x) => ({ ...x })),
        discontinuationReasons: reasonsListQ382A.map((x) => ({ ...x })),
        neurologicAEReasonList: neurologicAEReasonList.map((x) => ({ ...x })),
      },
    ]);
  };

  const AddQ382TalvRow = () => {
    setQ382ATalvDetails((prev) => [
      ...prev,
      {
        ...Q382ARowDefault,
        cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0,
        adverseEventReasons: aeReasonsList.map((x) => ({ ...x })),
        discontinuationReasons: reasonsListQ382A.map((x) => ({ ...x })),
        neurologicAEReasonList: neurologicAEReasonList.map((x) => ({ ...x })),
      },
    ]);
  };

  const AddQ401aTecRow = () => {
    setQ401aTecDetails((prev) => [
      ...prev,
      {
        ...Q401aTechRow,
      },
    ]);
  };

  const AddQ401aTalRow = () => {
    setQ401aTalDetails((prev) => [
      ...prev,
      {
        ...Q401aTalRow,
      },
    ]);
  };

  const DeleteQ401aTechvayliRow = (id) => {
    const newArray = [...Q401aTecDetails];
    newArray.splice(id, 1);
    setQ401aTecDetails(newArray);
  };

  const DeleteQ401aTalveyRow = (id) => {
    const newArray = [...Q401aTalDetails];
    newArray.splice(id, 1);
    setQ401aTalDetails(newArray);
  };

  // ADD/DELETE TECHVAYLI ROWS
  const DeleteTechvayliRow = (id) => {
    const newArray = [...techvayliDetails];
    newArray.splice(id, 1);
    setTechvayliDetails(newArray);
  };
  const AddTechvayliRow = () => {
    setTechvayliDetails((prev) => [
      ...prev,
      {
        ...TechvayliRow,
      },
    ]);
  };
  //36.1 Tec
  const DeleteTecHospRow = (id) => {
    const newArray = [...tecHospDetails];
    newArray.splice(id, 1);
    setTecHospDetails(newArray);
  };
  const AddTecHospRow = () => {
    setTecHospDetails((prev) => [
      ...prev,
      {
        ...HospitalizationRow,
        cohorttreatmentid: isTechvayliSelected
          ? RRMMCohortTreatment.TECVAYLI
          : 0, //GetLocalStorageData("techvayliID") || 0
      },
    ]);
  };

  // ADD/DELETE TALVEY ROWS
  const DeleteTalveyRow = (id) => {
    const newArray = [...talveyDetails];
    newArray.splice(id, 1);
    setTalveyDetails(newArray);
  };
  const AddTalveyRow = () => {
    setTalveyDetails((prev) => [
      ...prev,
      {
        ...TalveyRow,
      },
    ]);
  };
  //36.1 Tal
  const DeleteTalHospRow = (id) => {
    const newArray = [...talHospDetails];
    newArray.splice(id, 1);
    setTalHospDetails(newArray);
  };
  const AddTalHospRow = () => {
    setTalHospDetails((prev) => [
      ...prev,
      {
        ...HospitalizationRow,
        cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0, //GetLocalStorageData("talveyID") || 0
      },
    ]);
  };

  // Q38

  // ADD/DELETE TECHVAYLI ROWS
  const DeleteQ38TechvayliRow = (id) => {
    const newArray = [...Q38TechDetails];
    newArray.splice(id, 1);
    setQ38TechDetails(newArray);
  };
  const AddQ38TechvayliRow = () => {
    setQ38TechDetails((prev) => [
      ...prev,
      {
        ...Q38TechRow,
      },
    ]);
  };

  // ADD/DELETE TALVEY ROWS
  const DeleteQ38TalveyRow = (id) => {
    const newArray = [...Q38TalDetails];
    newArray.splice(id, 1);
    setQ38TalDetails(newArray);
  };
  const AddQ38TalveyRow = () => {
    setQ38TalDetails((prev) => [
      ...prev,
      {
        ...Q38TalRow,
      },
    ]);
  };

  //Q39.1.A
  const DeleteQ391ARow = (id, cohortId) => {
    if (!id || !cohortId) return;
    if (cohortId === RRMMCohortTreatment.TALVEY) {
      const newArray = [...q391ATalTocilzumabList];
      newArray.splice(id, 1);
      setQ391ATalTocilzumabList(newArray);
    } else if (cohortId === RRMMCohortTreatment.TECVAYLI) {
      const newArray = [...q391ATechTocilzumabList];
      newArray.splice(id, 1);
      setQ391ATechTocilzumabList(newArray);
    }
  };

  const AddQ391ARow = (cohortId) => {
    if (!cohortId) return;

    const baseRow =
      cohortId === RRMMCohortTreatment.TALVEY
        ? q391ATalRow
        : cohortId === RRMMCohortTreatment.TECVAYLI
          ? q391ATechRow
          : null;

    if (!baseRow) return;

    const newRow = {
      ...baseRow,
      patientid: pid,
    };

    cohortId === RRMMCohortTreatment.TALVEY
      ? setQ391ATalTocilzumabList((prev) => [...prev, newRow])
      : setQ391ATechTocilzumabList((prev) => [...prev, newRow]);
  };

  const SavePage = async (validate) => {
    try {
      ToggleLoader(true);

      let isValid = validate ? ValidateForm() : true;

      if (isValid) {
        setShowTopErrMsg(false);

        const TechvayliData = techvayliDetails.map((test) => ({
          Teclistamatalquetamabdosagebridgeid:
            test.teclistamatalquetamabdosagebridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,
          DoseAdministrationDate:
            test.dose_administration_tech_dt != "Invalid Date" &&
            test.dose_administration_tech_dt
              ? test.dose_administration_tech_dt
              : "",
          DoseAdministrationDateUnk:
            test.dose_administration_tech === 99 ? true : null,
          DosePhase: test.dosing_phase_tech,
          SiteOfCare: test.siteofcare_tech,
          DosingPhaseOthTxt: test.dosing_phase_oth_txt_tech,
          DoseStrengthmg: test.tech_dose_strength_mg,
          DoseStrengthmgkg: test.tech_dose_strength_mg_kg,
          DoseStrengthmgm: test.tech_dose_strength_mgm,
          DoseStrengthUnk: test.tech_dose_strength_rbl === 99 ? 99 : null,

          InpatientAdmissionDate: test.dt_admission_tech_dt
            ? test.dt_admission_tech_dt
            : "",

          InpatientDischargeDate: test.dt_discharge_tech_dt
            ? test.dt_discharge_tech_dt
            : "",
        }));
        //36.1 Tec
        const TechvayliHospitalData = tecHospDetails.map((test) => ({
          Teclistamatalquetamabhospitalizationbridgeid:
            test.teclistamatalquetamabhospitalizationbridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,

          HospitalizationAdmissionDate:
            test.dt_admission_dt && test.dt_admission_dt != "Invalid Date"
              ? test.dt_admission_dt
              : "",
          HospitalizationAdmissionDateUnk: test.dt_admission === 99,
          NoHospitalizationDosage: test.dt_admission === 2,
          HospitalizationDischargeDate:
            test.dt_discharge_dt && test.dt_discharge_dt != "Invalid Date"
              ? test.dt_discharge_dt
              : "",
          HospitalizationDischargeUnk: test.dt_discharge === 99,
          PatientStillHospitalized: test.dt_discharge === 2,
          HospitalizationReasonAdministrationTeclistamab: test.hospReason1,
          HospitalizationReasonMonitorAe: test.hospReason2,
          HospitalizationReasonCrs: test.hospReason3,
          HospitalizationReasonIcans: test.hospReason4,
          HospitalizationReasonOtherae: test.hospReason5,
          HospitalizationReasonOtnernonae: test.hospReason6,
          HospitalizationReasonUnknown: test.hospReasonUnk,
          HospitalizationReasonOthernonaeTxt: test.hosp_reason_oth_txt,
        }));
        const TalveyData = talveyDetails.map((test) => ({
          Teclistamatalquetamabdosagebridgeid:
            test.teclistamatalquetamabdosagebridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,

          DoseAdministrationDate:
            test.dose_administration_tal_dt &&
            test.dose_administration_tal_dt != "Invalid Date"
              ? test.dose_administration_tal_dt
              : "",
          DoseAdministrationDateUnk:
            test.dose_administration_tal === 99 ? true : null,
          DosePhase: test.dosing_phase_tal,
          SiteOfCare: test.siteofcare_tal,
          DosingPhaseOthTxt: test.dosing_phase_oth_txt_tal,
          DoseStrengthmg: test.tal_dose_strength_mg,
          DoseStrengthmgkg: test.tal_dose_strength_mg_kg,
          DoseStrengthmgm: test.tal_dose_strength_mgm,
          DoseStrengthUnk: test.tal_dose_strength_rbl === 99 ? 99 : null,
          InpatientAdmissionDate: test.dt_admission_tal_dt
            ? test.dt_admission_tal_dt
            : "",

          InpatientDischargeDate: test.dt_discharge_tal_dt
            ? test.dt_discharge_tal_dt
            : "",
        }));
        //36.1 Tal
        const TalveyHospitalData = talHospDetails.map((test) => ({
          Teclistamatalquetamabhospitalizationbridgeid:
            test.teclistamatalquetamabhospitalizationbridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,
          // Teclistamatalquetamabdosagebridgeid

          HospitalizationAdmissionDate:
            test.dt_admission_dt && test.dt_admission_dt != " Invalid Date"
              ? test.dt_admission_dt
              : "",
          HospitalizationAdmissionDateUnk: test.dt_admission === 99,
          NoHospitalizationDosage: test.dt_admission === 2,

          HospitalizationDischargeDate:
            test.dt_discharge_dt && test.dt_discharge_dt != "Invalid Date"
              ? test.dt_discharge_dt
              : "",
          HospitalizationDischargeUnk: test.dt_discharge === 99,
          PatientStillHospitalized: test.dt_discharge === 2,

          HospitalizationReasonAdministrationTeclistamab: test.hospReason1,
          HospitalizationReasonMonitorAe: test.hospReason2,
          HospitalizationReasonCrs: test.hospReason3,
          HospitalizationReasonIcans: test.hospReason4,
          HospitalizationReasonOtherae: test.hospReason5,
          HospitalizationReasonOtnernonae: test.hospReason6,
          HospitalizationReasonUnknown: test.hospReasonUnk,
          HospitalizationReasonOthernonaeTxt: test.hosp_reason_oth_txt,
        }));

        //Q37 and Q40 Payload
        const Q37TechDetail = Q37TechDetails.map((techRow) => ({
          Teclistamabcharacteristicsid: techRow.teclistamabcharacteristicsid,

          Cohorttreatmentid: isTechvayliSelected
            ? RRMMCohortTreatment.TECVAYLI
            : 0, //techRow.cohorttreatmentid,

          Dosefrequencyreduced: techRow.Q37TechvayliRd,

          TreatmentInitialDoseFrequency: techRow.q37_Tec_Dose_week_frquencyRd,
          TreatmentInitialDoseFrequencyText:
            techRow.q37_Tec_Dose_week_frquency_txt,

          //37
          TreatmentInitialDosage: techRow.q37_Tec_Dose_week_strengthRd,
          TreatmentInitialDosageOthtext: techRow.q37_Tec_Dose_week_strength_txt,

          //40

          IvigDosageFrequency: techRow.Q40dosingfreqRd,
          LastIgglevel: techRow.Q40IgILevelRd,
          IvigInitiationDateUnk: techRow.Q40init_dt_Rd === 99 ? true : null,
          IvigInitiationDate:
            techRow.Q40init_dt && techRow.Q40init_dt != "Invalid Date"
              ? techRow.Q40init_dt
              : "",
          MedicationReasonPrimaryProphylactic: techRow.primaryProf,
          MedicationReasonSecondaryProphylactic: techRow.secondaryProf,
          MedicationReasonOth: techRow.otherReson,

          IvigDosageFrequencyOthTxt: techRow.dosing_freq_oth_txt,

          //39

          MedicationTocilizumab: techRow.tocilizumab_tech,
          MedicationGcsf: techRow.granulocyte_tech,
          MedicationNone: techRow.noneoftheabove_tech,
          MedicationSteroids: techRow.steroids_tech,
          //39 - 1.1
          DosageusageReasonProphylacticCrs: techRow.cytokin_tech,
          DosageusageReasonSecondaryProphylacticCrs:
            techRow.secondary_prophylactic_crs_tech,
          DosagusageReasonTreatmentsupportiveCrs: techRow.crs_tech,
          DosagusageReasonProphylacticneurotoxicity: techRow.neurotoxicity_tech,
          DosageusageReasonSecondaryProphylacticNeurologic:
            techRow.secondary_neurotoxicity_tech,
          DosagusageReasonTreatmentsupportiveNeurotoxicity:
            techRow.tmt_neurotoxicity_tech,
          DosagusageReasonTreatmentUnknown: techRow.tmt_tech_unknown,
          //39 - 1.3
          GcsfUsageReasonProphylactic: techRow.prophylactic_use_tech,
          GcsfUsageReasonSecondaryProphylactic:
            techRow.secondary_prophylactic_use_tech,
          GcsfUsageReasonOth: techRow.oth_use_tech,
          GcsfUsageReasonUnk: techRow.unknown_tech === 99 ? true : null,

          SteroidUsageReasonTreatmentRecommendation:
            techRow.steroid_pre_tmt_tech,

          SteroidsUsageReasonProphylacticCrs: techRow.cytokin_tech_steroids,
          SteroidsUsageReasonSecondaryProphylacticCrs:
            techRow.secondary_prophylactic_tech_steroids,
          SteroidsUsageReasonSecondaryProphylacticNeurologic:
            techRow.secondary_neurotoxicity_tech_steroids,
          SteroidsUsageReasonTreatmentsupportiveCrs: techRow.crs_tech_steroids,
          SteroidsUsageReasonProphylacticneurotoxicity:
            techRow.neurotoxicity_tech_steroids,
          SteroidsUsageReasonTreatmentsupportiveNeurotoxicity:
            techRow.tmt_neurotoxicity_tech_steroids,

          SteroidUsageReasonUnknown: techRow.tmt_steroids_tech_unknown,

          SteroidNameBetamethasone: techRow.betamethasone_tech,
          SteroidDoseBetamethasone: techRow.betamethasone_techNum,

          SteroidNameDexamethasone: techRow.dexamethasone_tech,
          SteroidDoseDexamethasone: techRow.dexamethasone_techNum,

          SteroidNameHydrocortisone: techRow.hydrocortisone_tech,
          SteroidDoseHydrocortisone: techRow.hydrocortisone_techNum,

          SteroidNameMethylprednisolone: techRow.methylprednisolone,
          SteroidDoseMethylprednisolone: techRow.methylprednisoloneNum,

          SteroidNamePrednisolone: techRow.prednisolone_tech,
          SteroidDosePrednisolone: techRow.prednisolone_techNum,

          SteroidNamePrednisone: techRow.prednisone_tech,
          SteroidDosePrednisone: techRow.prednisone_techNum,

          SteroidNameTriamcinolone: techRow.triamcinolone_tech,
          SteroidDoseTriamcinolone: techRow.triamcinolone_techNum,

          SteroidDoseNameUnknown: techRow.dose_name_tech_unknown,
        }));

        const Q37TalDetail = Q37TalDetails.map((talRow) => ({
          Teclistamabcharacteristicsid: talRow.teclistamabcharacteristicsid,

          Cohorttreatmentid: isTalveySelected ? RRMMCohortTreatment.TALVEY : 0, //talRow.cohorttreatmentid,

          Dosefrequencyreduced: talRow.Q37TalveyRd,

          TreatmentInitialDoseFrequency: talRow.q37_Tal_Dose_week_frquencyRd,

          TreatmentInitialDoseFrequencyText:
            talRow.q37_Tal_Dose_week_frquency_txt,

          //37
          TreatmentInitialDosage: talRow.q37_Tal_Dose_week_strengthRd,
          TreatmentInitialDosageOthtext: talRow.q37_Tal_Dose_week_strength_txt,

          //39
          MedicationTocilizumab: talRow.tocilizumab_tal,
          MedicationSteroids: talRow.steroids_tal,
          MedicationGcsf: talRow.granulocyte_tal,
          MedicationNone: talRow.noneoftheabove_tal,

          //Q39.1
          DosageusageReasonProphylacticCrs: talRow.cytokin_tal,
          DosageusageReasonSecondaryProphylacticCrs:
            talRow.secondary_prophylactic_crs_tal,

          DosagusageReasonTreatmentsupportiveCrs: talRow.crs_tal,
          DosagusageReasonProphylacticneurotoxicity: talRow.neurotoxicity_tal,
          DosageusageReasonSecondaryProphylacticNeurologic:
            talRow.secondary_neurotoxicity_tal,
          DosagusageReasonTreatmentsupportiveNeurotoxicity:
            talRow.tmt_neurotoxicity_tal,
          DosagusageReasonTreatmentUnknown: talRow.tmt_talvey_unknown,

          //Q39.3
          GcsfUsageReasonProphylactic: talRow.prophylactic_use_tal,
          GcsfUsageReasonSecondaryProphylactic:
            talRow.secondary_prophylactic_use_tal,
          GcsfUsageReasonOth: talRow.oth_use_tal,
          GcsfUsageReasonUnk: talRow.unknown_tal === 99 ? true : null,

          //Q39.2
          SteroidUsageReasonTreatmentRecommendation: talRow.steroid_pre_tmt_tal,
          SteroidsUsageReasonProphylacticCrs: talRow.cytokin_tal_steroids,
          SteroidsUsageReasonTreatmentsupportiveCrs: talRow.crs_tal_steroids,
          SteroidsUsageReasonProphylacticneurotoxicity:
            talRow.neurotoxicity_tal_steroids,
          SteroidsUsageReasonTreatmentsupportiveNeurotoxicity:
            talRow.tmt_neurotoxicity_tal_steroids,
          SteroidUsageReasonUnknown: talRow.tmt_tal_unknown,
          SteroidsUsageReasonSecondaryProphylacticCrs:
            talRow.secondary_prophylactic_tal_steroids,
          SteroidsUsageReasonSecondaryProphylacticNeurologic:
            talRow.secondary_neurotoxicity_tal_steroids,

          SteroidNameBetamethasone: talRow.betamethasone_tal,
          SteroidDoseBetamethasone: talRow.betamethasone_talNum,

          SteroidNameDexamethasone: talRow.dexamethasone_tal,
          SteroidDoseDexamethasone: talRow.dexamethasone_talNum,

          SteroidNameHydrocortisone: talRow.hydrocortisone_tal,
          SteroidDoseHydrocortisone: talRow.hydrocortisone_talNum,

          SteroidNameMethylprednisolone: talRow.methylprednisolone_tal,
          SteroidDoseMethylprednisolone: talRow.methylprednisolone_talNum,

          SteroidNamePrednisolone: talRow.prednisolone_tal,
          SteroidDosePrednisolone: talRow.prednisolone_talNum,

          SteroidNamePrednisone: talRow.prednisone_tal,
          SteroidDosePrednisone: talRow.prednisone_talNum,

          SteroidNameTriamcinolone: talRow.triamcinolone_tal,
          SteroidDoseTriamcinolone: talRow.triamcinolone_talNum,

          SteroidDoseNameUnknown: talRow.dose_name_tal_unknown,

          //40
          IvigDosageFrequency: talRow.Q40dosingfreqRd_Tal,
          LastIgglevel: talRow.Q40IgILevelRd_Tal,
          IvigInitiationDateUnk: talRow.Q40init_dt_Rd_Tal === 99 ? true : null,
          IvigInitiationDate:
            talRow.Q40init_dt_Tal && talRow.Q40init_dt_Tal != "Invalid Date"
              ? talRow.Q40init_dt_Tal
              : "",
          MedicationReasonPrimaryProphylactic: talRow.primaryProf_Tal,
          MedicationReasonSecondaryProphylactic: talRow.secondaryProf_Tal,
          MedicationReasonOth: talRow.otherReson_Tal,

          IvigDosageFrequencyOthTxt: talRow.dosing_freq_oth_txt_Tal,
        }));

        // Q38Tech payload
        const q38TechvayliData = Q38TechDetails.map((test) => ({
          Teclistamatalquetamabdosefrequencybridgeid:
            test.teclistamatalquetamabdosefrequencybridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,

          DosefreqReductionDateUnk: test.Q38TechvayliRd,
          DosefreqReductionDate:
            test.dt_dosefreq_tech_dt != "Invalid Date" &&
            test.dt_dosefreq_tech_dt
              ? test.dt_dosefreq_tech_dt
              : "",

          TreatmentInitialDoseFrequency: test.q38_Tec_Dose_week_frquencyRd,

          TreatmentInitialDoseFrequencyText:
            test.q38_Tec_Dose_week_frquency_txt,
        }));

        // Q38talveyData
        const q38TalveyData = Q38TalDetails.map((test) => ({
          Teclistamatalquetamabdosefrequencybridgeid:
            test.teclistamatalquetamabdosefrequencybridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,

          DosefreqReductionDateUnk: test.Q38TalveyRd,
          DosefreqReductionDate:
            test.dt_dosefreq_tal_dt != "Invalid Date" && test.dt_dosefreq_tal_dt
              ? test.dt_dosefreq_tal_dt
              : "",

          TreatmentInitialDoseFrequency: test.q38_Tal_Dose_week_frquencyRd,
          TreatmentInitialDoseFrequencyText:
            test.q38_Tal_Dose_week_frquency_txt,
          TreatmentInitialDosageOthtext: test.q38_Tal_Dosage_OtherTxt,
          TreatmentInitialDosage: test.q38_Tal_Dosage_Rd,
        }));

        //38.1.A
        const combinedQ38oneTalTechList = [
          ...(isTechvayliSelected ? Q381ATechDetails : []),
          ...(isTalveySelected ? Q381ATalvDetails : []),
        ];

        //38.2.A
        const combinedQ38TwoTalTechList = [
          ...(isTechvayliSelected
            ? Q382ATechDetails.map((item) => ({
                ...item,
                cohorttreatmentid: RRMMCohortTreatment.TECVAYLI,
              }))
            : []),

          ...(isTalveySelected
            ? Q382ATalvDetails.map((item) => ({
                ...item,
                cohorttreatmentid: RRMMCohortTreatment.TALVEY,
              }))
            : []),
        ];

        const tecvayliQ391AData =
          isTechvayliSelected && q391ATechTocilzumabList.length > 0
            ? q391ATechTocilzumabList.map((itm) => ({
                Tocilizumabmedicationid: itm.tocilizumabmedicationid ?? 0,
                Cohorttreatmentid: itm.cohorttreatmentid,
                Patientid: itm.patientid,
                TocilizumabAdministrationDate:
                  itm.administrationDate_tech &&
                  itm.administrationDate_tech !== "Invalid Date"
                    ? itm.administrationDate_tech
                    : "",
                TocilizumabAdministrationDateUnk:
                  itm.administrationDateRD_tech === 99,
                PrimaryProphylacticCrs: itm.primaryProphylacticCrs_tech,
                SecondaryProphylacticCrs: itm.secondaryProphylacticCrs_tech,
                SupportiveCareCrs: itm.supportiveCareCrs_tech,
                PrimaryProphylacticNeurologic:
                  itm.primaryProphylacticNeurologic_tech,
                SecondaryProphylacticNeurologic:
                  itm.secondaryProphylacticNeurologic_tech,
                SupportiveCareNeurologic: itm.supportiveCareNeurologic_tech,
                MedicationReasonUnk: itm.medicationReasonUnk_tech,
              }))
            : [];

        const talveyQ391AData =
          isTalveySelected && q391ATalTocilzumabList.length > 0
            ? q391ATalTocilzumabList.map((itm) => ({
                Tocilizumabmedicationid: itm.tocilizumabmedicationid ?? 0,
                Cohorttreatmentid: itm.cohorttreatmentid,
                Patientid: itm.patientid,
                TocilizumabAdministrationDate:
                  itm.administrationDate_tal &&
                  itm.administrationDate_tal !== "Invalid Date"
                    ? itm.administrationDate_tal
                    : "",
                TocilizumabAdministrationDateUnk:
                  itm.administrationDateRD_tal === 99,
                PrimaryProphylacticCrs: itm.primaryProphylacticCrs_tal,
                SecondaryProphylacticCrs: itm.secondaryProphylacticCrs_tal,
                SupportiveCareCrs: itm.supportiveCareCrs_tal,
                PrimaryProphylacticNeurologic:
                  itm.primaryProphylacticNeurologic_tal,
                SecondaryProphylacticNeurologic:
                  itm.secondaryProphylacticNeurologic_tal,
                SupportiveCareNeurologic: itm.supportiveCareNeurologic_tal,
                MedicationReasonUnk: itm.medicationReasonUnk_tal,
              }))
            : [];

        const q40DosingFrequencyTec = Q37TechDetails?.[0]?.Q40dosingfreqRd;
        const shouldShowQ401BTec =
          q40DosingFrequencyTec != null && q40DosingFrequencyTec !== 1;

        const q40DosingFrequencyTal =
          Q37TalDetails?.[0]?.Q40dosingfreqRd ||
          Q37TalDetails[0]?.Q40dosingfreqRd_Tal;

        const shouldShowQ401BTal =
          q40DosingFrequencyTal != null && q40DosingFrequencyTal !== 1;

        //Q40.1.B
        const q401aTecDetails =
          isNewEcrfB && shouldShowQ401BTec && Q401aTecDetails?.length > 0
            ? Q401aTecDetails.map((test) => ({
                Tectalivigreceivedbridgeid: test.tectalivigreceivedbridgeid,
                Cohorttreatmentid: RRMMCohortTreatment.TECVAYLI,

                Ivig_date_selection: test.Q401ainit_dt_Rd_Tec,
                Ivig_date:
                  test.Q401ainit_Tec_dt !== "Invalid Date" &&
                  test.Q401ainit_Tec_dt
                    ? test.Q401ainit_Tec_dt
                    : "",

                Intended_dosing_frequency: test.Q401aIntendedDosing_Tec,
                Intended_dosing_frequency_value:
                  test.Q401aIntendedDosing_Tec === 1
                    ? test.Q401aIntendedDosing_Tec_WeekValue
                    : test.Q401aIntendedDosing_Tec === 2
                      ? test.Q401aIntendedDosing_Tec_MonthValue
                      : test.Q401aIntendedDosing_Tec === 3
                        ? test.Q401aIntendedDosing_Tec_OnceWeekValue
                        : test.Q401aIntendedDosing_Tec === 4
                          ? test.Q401aIntendedDosing_Tec_OnceMonthValue
                          : test.Q401aIntendedDosing_Tec_OtherValue,
                Primary_reason: test.Q401aPrimaryProf_Tec,
                Secondary_reason: test.Q401aSecProf_Tec,
                Other_reason: test.Q401aOtherProf_Tec,
                Unknown_reason: test.Q401aUnknownProf_Tec,
                Dosing_type: test.Q401aDosingType_Tec,
                Dosage: test.Q401aDosage_Tec,
                Dosage_value:
                  test.Q401aDosage_Tec === 1
                    ? test.Q401aDosage_Tec_GValue
                    : test.Q401aDosage_Tec === 2
                      ? test.Q401aDosage_Tec_MgValue
                      : "",
                Body_weight: test.Q401aWeight_Tec,
                Body_weight_value:
                  test.Q401aWeight_Tec === 1
                    ? test.Q401aWeight_Value_KgTec
                    : test.Q401aWeight_Tec === 2
                      ? test.Q401aWeight_Value_LbsTec
                      : "",
                Weight_date_selection: test.Q401aWeight_Asses_Tec,
                Weight_date:
                  test.Q401aWeight_Asses_Tec_dt !== "Invalid Date" &&
                  test.Q401aWeight_Asses_Tec_dt
                    ? test.Q401aWeight_Asses_Tec_dt
                    : "",
              }))
            : [];

        const q401aTalDetails =
          isNewEcrfB && shouldShowQ401BTal && Q401aTalDetails?.length > 0
            ? Q401aTalDetails.map((test) => ({
                Tectalivigreceivedbridgeid: test.tectalivigreceivedbridgeid,
                Cohorttreatmentid: RRMMCohortTreatment.TALVEY,

                Ivig_date_selection: test.Q401ainit_dt_Rd_Tal,
                Ivig_date:
                  test.Q401ainit_Tal_dt !== "Invalid Date" &&
                  test.Q401ainit_Tal_dt
                    ? test.Q401ainit_Tal_dt
                    : "",

                Intended_dosing_frequency: test.Q401aIntendedDosing_Tal,
                Intended_dosing_frequency_value:
                  test.Q401aIntendedDosing_Tal === 1
                    ? test.Q401aIntendedDosing_Tal_WeekValue
                    : test.Q401aIntendedDosing_Tal === 2
                      ? test.Q401aIntendedDosing_Tal_MonthValue
                      : test.Q401aIntendedDosing_Tal === 3
                        ? test.Q401aIntendedDosing_Tal_OnceWeekValue
                        : test.Q401aIntendedDosing_Tal === 4
                          ? test.Q401aIntendedDosing_Tal_OnceMonthValue
                          : test.Q401aIntendedDosing_Tal_OtherValue,
                Primary_reason: test.Q401aPrimaryProf_Tal,
                Secondary_reason: test.Q401aSecProf_Tal,
                Other_reason: test.Q401aOtherProf_Tal,
                Unknown_reason: test.Q401aUnknownProf_Tal,
                Dosing_type: test.Q401aDosingType_Tal,
                Dosage: test.Q401aDosage_Tal,
                Dosage_value:
                  test.Q401aDosage_Tal === 1
                    ? test.Q401aDosage_Tal_GValue
                    : test.Q401aDosage_Tal === 2
                      ? test.Q401aDosage_Tal_MgValue
                      : "",
                Body_weight: test.Q401aWeight_Tal,
                Body_weight_value:
                  test.Q401aWeight_Tal === 1
                    ? test.Q401aWeight_Value_KgTal
                    : test.Q401aWeight_Tal === 2
                      ? test.Q401aWeight_Value_LbsTal
                      : "",
                Weight_date_selection: test.Q401aWeight_Asses_Tal,
                Weight_date:
                  test.Q401aWeight_Asses_Tal_dt !== "Invalid Date" &&
                  test.Q401aWeight_Asses_Tal_dt
                    ? test.Q401aWeight_Asses_Tal_dt
                    : "",
              }))
            : [];
        //Q40.2.B
        const q402aTecDetails =
          isNewEcrfB && Q402aTecDetails?.length > 0
            ? Q402aTecDetails.map((test) => ({
                Tectaliggdetailbridgeid: test.tectaliggdetailbridgeid,
                Cohorttreatmentid: RRMMCohortTreatment.TECVAYLI,

                Igg_assessment_selection: test.Q402aIgg_assessment_Tec,
                Igg_assessment_date:
                  test.Q402aIgg_assessment_Tec_dt != "Invalid Date" &&
                  test.Q402aIgg_assessment_Tec_dt
                    ? test.Q402aIgg_assessment_Tec_dt
                    : "",

                Igg_level_selection: test.Q402aIgg_level_Tec,
                Igg_level_value:
                  test.Q402aIgg_level_Tec === 1
                    ? test.Q402aIgg_level_Tec_MgValue
                    : test.Q402aIgg_level_Tec_GValue,
              }))
            : [];

        const q402aTalDetails =
          isNewEcrfB && Q402aTalDetails?.length > 0
            ? Q402aTalDetails.map((test) => ({
                Tectaliggdetailbridgeid: test.tectaliggdetailbridgeid,
                Cohorttreatmentid: RRMMCohortTreatment.TALVEY,

                Igg_assessment_selection: test.Q402aIgg_assessment_Tal,
                Igg_assessment_date:
                  test.Q402aIgg_assessment_Tal_dt !== "Invalid Date" &&
                  test.Q402aIgg_assessment_Tal_dt
                    ? test.Q402aIgg_assessment_Tal_dt
                    : "",

                Igg_level_selection: test.Q402aIgg_level_Tal,
                Igg_level_value:
                  test.Q402aIgg_level_Tal === 1
                    ? test.Q402aIgg_level_Tal_MgValue
                    : test.Q402aIgg_level_Tal_GValue,
              }))
            : [];

        //Q40.3.B
        const q403aTecDetails =
          isNewEcrfB && shouldShowQ401BTec && Q403aTecDetails?.length > 0
            ? Q403aTecDetails.map((test) => ({
                Tectaliggdetailbridgeid: test.tectaliggdetailbridgeid,
                Cohorttreatmentid: RRMMCohortTreatment.TECVAYLI,

                Igg_assessment_selection: test.Q403aIgg_assessment_Tec,
                Igg_assessment_date:
                  test.Q403aIgg_assessment_Tec_dt !== "Invalid Date" &&
                  test.Q403aIgg_assessment_Tec_dt
                    ? test.Q403aIgg_assessment_Tec_dt
                    : "",

                Igg_level_selection: test.Q403aIgg_level_Tec,
                Igg_level_value:
                  test.Q403aIgg_level_Tec === 1
                    ? test.Q403aIgg_level_Tec_MgValue
                    : test.Q403aIgg_level_Tec_GValue,
              }))
            : [];

        const q403aTalDetails =
          isNewEcrfB && shouldShowQ401BTal && Q403aTalDetails?.length > 0
            ? Q403aTalDetails.map((test) => ({
                Tectaliggdetailbridgeid: test.tectaliggdetailbridgeid,
                Cohorttreatmentid: RRMMCohortTreatment.TALVEY,

                Igg_assessment_selection: test.Q403aIgg_assessment_Tal,
                Igg_assessment_date:
                  test.Q403aIgg_assessment_Tal_dt !== "Invalid Date" &&
                  test.Q403aIgg_assessment_Tal_dt
                    ? test.Q403aIgg_assessment_Tal_dt
                    : "",

                Igg_level_selection: test.Q403aIgg_level_Tal,
                Igg_level_value:
                  test.Q403aIgg_level_Tal === 1
                    ? test.Q403aIgg_level_Tal_MgValue
                    : test.Q403aIgg_level_Tal_GValue,
              }))
            : [];

        const TTCharModel = {
          Patientid: pid,
          UserId: GetLoggedInUserID(),
          isValidated: validate,
          IsAdmin: IsAdmin(),
          Editedby: GetLoggedInUserID(),
          //36
          TechvayliData: TechvayliData,
          TalveyData: TalveyData,
          //36.1
          TechvayliHospitalData,
          TalveyHospitalData,

          //37
          TTcharTechvayliModelList: Q37TechDetail,
          TTcharTalveyliModelList: Q37TalDetail,

          //38
          Q38TechvayliData: q38TechvayliData,
          Q38TalveyData: q38TalveyData,
          TTDoseFrequencyList: combinedQ38oneTalTechList,
          TTDoseDelayList: combinedQ38TwoTalTechList,

          //39.1.A
          TalveyTocilizumabData: talveyQ391AData,

          TecvayliTocilizumabData: tecvayliQ391AData,

          //Q40.1.B
          Q401aTechvayliData: isTechvayliSelected ? q401aTecDetails : [],
          Q401aTalveyData: isTalveySelected ? q401aTalDetails : [],

          //Q40.2.B
          Q402aTechvayliData: isTechvayliSelected ? q402aTecDetails : [],
          Q402aTalveyData: isTalveySelected ? q402aTalDetails : [],

          //Q40.3.B
          Q403aTechvayliData: isTechvayliSelected ? q403aTecDetails : [],
          Q403aTalveyData: isTalveySelected ? q403aTalDetails : [],
        };

        if (pid > 0) {
          let response =
            await AdditionalTreatmentService.SaveTTCharacteristicData(
              TTCharModel,
            );

          if (response.status !== HTTPResponse.OK) {
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else throw response.error;
          } else {
            ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
            await LoadData();
          }

          ToggleLoader(false);
        }
        return true;
      } else {
        ToggleLoader(false);
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      ToggleLoader(false);
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const mapQ381A2ACohortList = (list, cohortTreatmentId, responseData) => {
    return list.map((cohortItem) => ({
      ...cohortItem,
      cohorttreatmentid: cohortTreatmentId,
      adverseEventReasons: responseData?.adverseEventReasons.map((ae) => ({
        ...ae,
      })),
      discontinuationReasons: responseData?.discontinuationReasons.map(
        (dr) => ({
          ...dr,
        }),
      ),
      neurologicAEReasonList: responseData?.neurologicAEReasonList.map(
        (neuro) => ({
          ...neuro,
        }),
      ),
    }));
  };

  const LoadData = async () => {
    try {
      if (pid > 0) {
        const response =
          await AdditionalTreatmentService.LoadTTCharacteristicData(pid);
        if (response?.status === HTTPResponse.OK) {
          const { data } = response;

          const nextLotLookup = buildNextLotStartDatesLookup(
            data.cohortNextLotDatesList ?? [],
          );
          setCohortNextLotDatesList(nextLotLookup);

          const isNewEcrfAChecked = data.isNewEcrfA ?? false;

          setIsNewEcrfA(isNewEcrfAChecked);
          setIsNewEcrfB(data.isNewEcrfB ?? false);
          setDeathDate(data.deathDate);
          setTecvayliDateRRMM(
            data.rrmmTecvayliDate !== ""
              ? data.rrmmTecvayliDate
              : data.rrmmTecvayliDate === "" && data.endofFollowUpDate != ""
                ? data.endofFollowUpDate
                : "[Bispecifics/CAR-T end of follow up]",
          );

          setTalveyDateRRMM(
            data.rrmmTalveyDate !== ""
              ? data.rrmmTalveyDate
              : data.rrmmTalveyDate === "" && data.endofFollowUpDate != ""
                ? data.endofFollowUpDate
                : "[Bispecifics/CAR-T end of follow up]",
          );
          setTechLOTStartDate(data.tecvayliLOTStartDate ?? "");
          setTalLOTStartDate(data.talveyLOTStartDate ?? "");

          setTecNumberofAdministrator(data.tecNoOfAdministration);
          setTalNumberofAdministrator(data.talNoOfAdministration);

          setBispecificQ26Data(data.bispecificQ26Data);
          setBispecificQ331AData(data.bispecificQ331AData);
          setBispecificQ31Q32Data(data.bispecificQ31Q32Data);
          setNdmmLotData(data.ndmmLotData);

          setEndOfFollowUpDate(data.endofFollowUpDate);
          setIndexDateRRMM_techHard(false);
          setIndexDateRRMM_talHard(false);

          setTecNumberofAdministratorMatching(false);
          setTalNumberofAdministratorMatching(false);

          setIsTecLastAdminDateValid(true);
          setIsTalLastAdminDateValid(true);

          setQ40Tec_WarningHard(false);
          setQ40Tal_WarningHard(false);

          let cohortTreatmentModelListt = [];
          if (storedData) {
            const parsedData = JSON.parse(storedData);
            cohortTreatmentModelListt = parsedData.filter(
              (item) => item.ndmm === false && item.isEligible,
            );
          }
          let modelList = [];
          if (storedData) {
            const parseData = JSON.parse(storedData);
            modelList = parseData.filter(
              (item) => item.ndmm === true && item.isEligible,
            );
          }
          if (modelList.length > 0) {
            setNdmmAvailable(true);
          }

          if (cohortTreatmentModelListt.length > 0) {
            const isElrorLin = cohortTreatmentModelListt.some(
              (a) =>
                a.cohortTreatmentID === RRMMCohortTreatment.ELREXFIO ||
                a.cohortTreatmentID === RRMMCohortTreatment.Linvoseltamab,
            );

            if (isElrorLin) {
              setRRMMElLinAvailable(true);
            }

            const isAbeOrCar = cohortTreatmentModelListt.some(
              (a) =>
                a.cohortTreatmentID === RRMMCohortTreatment.ABECMA ||
                a.cohortTreatmentID === RRMMCohortTreatment.CARVYKTI,
            );
            if (isAbeOrCar) {
              setRRMMAvailable(true);
            }
          }

          const techCohort = cohortTreatmentModelListt.find(
            (item) => item.cohortTreatmentID === RRMMCohortTreatment.TECVAYLI,
          );
          let isTACSelected = false;

          // Set the state based on the filtered data
          if (techCohort) {
            isTACSelected = true;
            setTechvayliSelected(true);
            setTechIndexDate(data.tecvayliIndexDate);
          }
          const talCohort = cohortTreatmentModelListt.find(
            (item) => item.cohortTreatmentID === RRMMCohortTreatment.TALVEY,
          );
          let isTALSelected = false;
          if (talCohort) {
            isTALSelected = true;
            setTalveySelected(true);

            setTalIndexDate(data.talveyIndexDate);
          }

          const cohortTreatmentMap = new Map();
          let techvayliData = [];
          if (data.techvayliData && data.techvayliData.length > 0) {
            techvayliData = data.techvayliData.map((item) => {
              return {
                cohorttreatmentid: item.cohorttreatmentid,

                teclistamatalquetamabdosagebridgeid:
                  item.teclistamatalquetamabdosagebridgeid,

                dose_administration_tech_dt: item.doseAdministrationDate,
                dose_administration_tech:
                  item.doseAdministrationDateUnk === true
                    ? 99
                    : item.doseAdministrationDate
                      ? 1
                      : null,

                dosing_phase_tech: item.dosePhase,
                siteofcare_tech: item.siteOfCare,

                tech_dose_strength_rbl: item.doseStrengthmg
                  ? 1
                  : item.doseStrengthmgkg
                    ? 2
                    : item.doseStrengthmgm
                      ? 3
                      : item.doseStrengthUnk
                        ? 99
                        : null,
                tech_dose_strength_mg: item.doseStrengthmg
                  ? item.doseStrengthmg
                  : "",
                tech_dose_strength_mg_kg: item.doseStrengthmgkg
                  ? item.doseStrengthmgkg
                  : "",
                tech_dose_strength_mgm: item.doseStrengthmgm
                  ? item.doseStrengthmgm
                  : "",

                dosing_phase_oth_txt_tech: item.dosingPhaseOthTxt,

                dt_admission_tech_dt: item.inpatientAdmissionDate,

                dosing_phase_oth_txt_tal: item.dosingPhaseOthTxt,

                dt_discharge_tech_dt: item.inpatientDischargeDate,
                Q36TechConditionMet:
                  (item.dosePhase === 1 ||
                    item.dosePhase === 2 ||
                    item.dosePhase === 3) &&
                  (item.siteOfCare === 1 || item.siteOfCare === 3)
                    ? true
                    : false,

                // //Q38

                dose_administration_techHard: false,
                dosing_phase_techHard: false,
                dosing_phase_techHard_othEmpty: false,
                siteofcare_techHard: false,
                tech_dose_strength_mg_kgHard: false,
                dt_admission_techHard: false,
                dt_discharge_techHard: false,
                tech_dose_strength_mg_kgRange: false,

                dose_administration_techHard_dt: false,
                Invalid_dose_administration_tech_dt: false,
                dt_admission_techHard_dt: false,
                dt_discharge_techHard_dt: false,
                dt_admission_techHard_dt_check: false,
                dt_discharge_techHard_dt_check: false,
                dose_administration_tech_dt_before_eof: false,
                // dt_tech_greater_prevCheck: false,
                dt_tech_date_out_of_bound: false,
              };
            });

            setTechvayliDetails(techvayliData);
            setDt_tec_2L_3L_date_conditions(false);

            const setupstec = techvayliData
              .map((r) => r.dosing_phase_tech)
              .filter((v) => v != null && v !== 4);
            const hasDuplicateSetupstTec =
              new Set(setupstec).size !== setupstec.length;
            setSetupTec_WarningHard(hasDuplicateSetupstTec);

            const allAreThree =
              setupstec.length > 0 && setupstec.every((v) => v === 3);
            setNosetupTec_WarningHard(allAreThree);
          } else {
            const cohortTreatmentid = isTACSelected
              ? RRMMCohortTreatment.TECVAYLI //GetLocalStorageData("techvayliID")
              : 0;

            // Update TechvayliRow with cohorttreatmentid only
            TechvayliRow.cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            TechvayliRow.teclistamatalquetamabdosagebridgeid =
              TechvayliRow.teclistamatalquetamabdosagebridgeid || 0;
            TechvayliRow.dose_administration_tech =
              TechvayliRow.dose_administration_tech || null;
            TechvayliRow.dosing_phase_tech =
              TechvayliRow.dosing_phase_tech || null;
            TechvayliRow.siteofcare_tech = TechvayliRow.siteofcare_tech || null;

            TechvayliRow.tech_dose_strength_mg_kg =
              TechvayliRow.tech_dose_strength_mg_kg || null;
            TechvayliRow.tech_dose_strength_mg =
              TechvayliRow.tech_dose_strength_mg || null;
            TechvayliRow.tech_dose_strength_mgm =
              TechvayliRow.tech_dose_strength_mgm || null;
            // TechvayliRow.dt_discharge_tech =
            //   TechvayliRow.dt_discharge_tech || null;
            TechvayliRow.dose_administration_tech_dt =
              TechvayliRow.dose_administration_tech_dt || "";
            TechvayliRow.dt_admission_tech_dt =
              TechvayliRow.dt_admission_tech_dt || "";
            TechvayliRow.dt_discharge_tech_dt =
              TechvayliRow.dt_discharge_tech_dt || "";

            TechvayliRow.dose_administration_techHard =
              TechvayliRow.dose_administration_techHard || false;
            TechvayliRow.dosing_phase_techHard =
              TechvayliRow.dosing_phase_techHard || false;
            TechvayliRow.siteofcare_techHard =
              TechvayliRow.siteofcare_techHard || false;
            TechvayliRow.dt_admission_techHard =
              TechvayliRow.dt_admission_techHard || false;
            TechvayliRow.dt_discharge_techHard =
              TechvayliRow.dt_discharge_techHard || false;

            TechvayliRow.dosing_phase_techHard_othEmpty = false;
            TechvayliRow.tech_dose_strength_mg_kgHard = false;
            TechvayliRow.tech_dose_strength_mg_kgRange = false;
          }
          //36.1 Tec start
          if (
            data.techvayliHospitalData &&
            data.techvayliHospitalData.length > 0
          ) {
            const tecHospData = data.techvayliHospitalData.map((item) => {
              return {
                ...HospitalizationRow,
                teclistamatalquetamabhospitalizationbridgeid:
                  item.teclistamatalquetamabhospitalizationbridgeid,
                cohorttreatmentid: item.cohorttreatmentid,
                //B
                dt_admission: item.hospitalizationAdmissionDateUnk
                  ? 99
                  : item.noHospitalizationDosage
                    ? 2
                    : item.hospitalizationAdmissionDate
                      ? 1
                      : null,
                dt_admission_dt: item.hospitalizationAdmissionDate,
                //C
                dt_discharge: item.hospitalizationDischargeUnk
                  ? 99
                  : item.patientStillHospitalized
                    ? 2
                    : item.hospitalizationDischargeDate
                      ? 1
                      : null,
                dt_discharge_dt: item.hospitalizationDischargeDate,
                //D
                hospReason1:
                  item.hospitalizationReasonAdministrationTeclistamab,
                hospReason2: item.hospitalizationReasonMonitorAe,
                hospReason3: item.hospitalizationReasonCrs,
                hospReason4: item.hospitalizationReasonIcans,
                hospReason5: item.hospitalizationReasonOtherae,
                hospReason6: item.hospitalizationReasonOtnernonae,
                hosp_reason_oth_txt: item.hospitalizationReasonOthernonaeTxt,
                hospReasonUnk: item.hospitalizationReasonUnknown,
              };
            });

            if (techvayliData?.length > 0 && tecHospData?.length > 0)
              updateQ361HospitalizationWarning(
                RRMMCohortTreatment.TECVAYLI,
                tecHospData,
                techvayliData,
              );

            setTecHospDetails(tecHospData);
          } else {
            const cohorttreatmentid = isTACSelected
              ? RRMMCohortTreatment.TECVAYLI //GetLocalStorageData("techvayliID")
              : 0;

            setTecHospDetails([
              {
                ...HospitalizationRow,
                cohorttreatmentid,
              },
            ]);
          }
          //end

          // Process TalveyData
          let talveyData = [];
          if (data.talveyData && data.talveyData.length > 0) {
            talveyData = data.talveyData.map((item) => {
              return {
                cohorttreatmentid: item.cohorttreatmentid,

                teclistamatalquetamabdosagebridgeid:
                  item.teclistamatalquetamabdosagebridgeid,

                dose_administration_tal_dt: item.doseAdministrationDate,
                dose_administration_tal:
                  item.doseAdministrationDateUnk === true
                    ? 99
                    : item.doseAdministrationDate
                      ? 1
                      : null,

                dosing_phase_tal: item.dosePhase,
                siteofcare_tal: item.siteOfCare,
                dosing_phase_oth_txt_tal: item.dosingPhaseOthTxt,
                tal_dose_strength_rbl: item.doseStrengthmg
                  ? 1
                  : item.doseStrengthmgkg
                    ? 2
                    : item.doseStrengthmgm
                      ? 3
                      : item.doseStrengthUnk
                        ? 99
                        : null,
                tal_dose_strength_mg: item.doseStrengthmg
                  ? item.doseStrengthmg
                  : "",
                tal_dose_strength_mg_kg: item.doseStrengthmgkg
                  ? item.doseStrengthmgkg
                  : "",
                tal_dose_strength_mgm: item.doseStrengthmgm
                  ? item.doseStrengthmgm
                  : "",

                dt_admission_tal_dt: item.inpatientAdmissionDate,

                dt_discharge_tal_dt: item.inpatientDischargeDate,
                dose_administration_talHard: false,
                Invalid_dose_administration_tal_dt: false,
                dosing_phase_talHard: false,
                siteofcare_talHard: false,
                dt_admission_talHard: false,
                dt_discharge_talHard: false,
                dosing_phase_talHard_othEmpty: false,
                tal_dose_strength_mg_kgHard: false,
                tal_dose_strength_mg_kgRange: false,

                dose_administration_talHard_dt: false,
                dt_admission_talHard_dt: false,
                dt_discharge_talHard_dt: false,

                dt_admission_talHard_dt_check: false,
                dt_discharge_talHard_dt_check: false,

                dt_tal_date_out_of_bound: false,
              };
            });
            setTalveyDetails(talveyData);
            setDt_tal_2L_3L_date_conditions(false);

            const setupstal = talveyData
              .map((r) => r.dosing_phase_tal)
              .filter((v) => v != null && v !== 5);
            const hasDuplicateSetupsTal =
              new Set(setupstal).size !== setupstal.length;
            setSetupTal_WarningHard(hasDuplicateSetupsTal);
            const allAreFour =
              setupstal.length > 0 && setupstal.every((v) => v === 4);
            setNosetupTal_WarningHard(allAreFour);
          } else {
            const cohortTreatmentid = isTALSelected
              ? RRMMCohortTreatment.TALVEY //GetLocalStorageData("talveyID")
              : 0;

            // Update TechvayliRow with cohorttreatmentid only
            TalveyRow.cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            TalveyRow.teclistamatalquetamabdosagebridgeid =
              TalveyRow.teclistamatalquetamabdosagebridgeid || 0;
            TalveyRow.dose_administration_tal =
              TalveyRow.dose_administration_tal || null;
            TalveyRow.dosing_phase_tal = TalveyRow.dosing_phase_tal || null;
            TalveyRow.siteofcare_tal = TalveyRow.siteofcare_tal || null;
            TalveyRow.dose_administration_tal_dt =
              TalveyRow.dose_administration_tal_dt || "";
            TalveyRow.dt_admission_tal_dt = TalveyRow.dt_admission_tal_dt || "";
            TalveyRow.dt_discharge_tal_dt = TalveyRow.dt_discharge_tal_dt || "";
            TalveyRow.dose_administration_talHard =
              TalveyRow.dose_administration_talHard || false;
            TalveyRow.dosing_phase_talHard =
              TalveyRow.dosing_phase_talHard || false;
            TalveyRow.siteofcare_talHard =
              TalveyRow.siteofcare_talHard || false;
            TalveyRow.dt_admission_talHard =
              TalveyRow.dt_admission_talHard || false;
            TalveyRow.dt_discharge_talHard =
              TalveyRow.dt_discharge_talHard || false;
            TalveyRow.Invalid_dose_administration_tal_dt =
              TalveyRow.Invalid_dose_administration_tal_dt || false;

            TalveyRow.dosing_phase_talHard_othEmpty = false;
            TalveyRow.tal_dose_strength_mg_kg =
              TalveyRow.tal_dose_strength_mg_kg || null;
            TalveyRow.tal_dose_strength_mg =
              TalveyRow.tal_dose_strength_mg || null;
            TalveyRow.tal_dose_strength_mgm =
              TalveyRow.tal_dose_strength_mgm || null;
            TalveyRow.tal_dose_strength_mg_kgHard = false;
            TalveyRow.tal_dose_strength_mg_kgRange = false;
          }
          //36.1 Tal start
          if (data.talveyHospitalData && data.talveyHospitalData.length > 0) {
            const talHospData = data.talveyHospitalData.map((item) => {
              return {
                ...HospitalizationRow,
                teclistamatalquetamabhospitalizationbridgeid:
                  item.teclistamatalquetamabhospitalizationbridgeid,
                cohorttreatmentid: item.cohorttreatmentid,
                //B
                dt_admission: item.hospitalizationAdmissionDateUnk
                  ? 99
                  : item.noHospitalizationDosage
                    ? 2
                    : item.hospitalizationAdmissionDate
                      ? 1
                      : null,
                dt_admission_dt: item.hospitalizationAdmissionDate,
                //C
                dt_discharge: item.hospitalizationDischargeUnk
                  ? 99
                  : item.patientStillHospitalized
                    ? 2
                    : item.hospitalizationDischargeDate
                      ? 1
                      : null,
                dt_discharge_dt: item.hospitalizationDischargeDate,
                //D
                hospReason1:
                  item.hospitalizationReasonAdministrationTeclistamab,
                hospReason2: item.hospitalizationReasonMonitorAe,
                hospReason3: item.hospitalizationReasonCrs,
                hospReason4: item.hospitalizationReasonIcans,
                hospReason5: item.hospitalizationReasonOtherae,
                hospReason6: item.hospitalizationReasonOtnernonae,
                hosp_reason_oth_txt: item.hospitalizationReasonOthernonaeTxt,
                hospReasonUnk: item.hospitalizationReasonUnknown,
              };
            });

            if (talveyData?.length > 0 && talHospData?.length > 0)
              updateQ361HospitalizationWarning(
                RRMMCohortTreatment.TALVEY,
                talHospData,
                talveyData,
              );

            setTalHospDetails(talHospData);
          } else {
            const cohorttreatmentid = isTALSelected
              ? RRMMCohortTreatment.TALVEY //GetLocalStorageData("talveyID")
              : 0;
            setTalHospDetails([
              {
                ...HospitalizationRow,
                cohorttreatmentid,
              },
            ]);
          }
          //end

          //37 LoadData -Techvayli

          if (
            data.tTcharTechvayliModelList &&
            data.tTcharTechvayliModelList.length > 0
          ) {
            const Q37TechDetails = data.tTcharTechvayliModelList.map((item) => {
              return {
                cohorttreatmentid: item.cohorttreatmentid,

                teclistamabcharacteristicsid: item.teclistamabcharacteristicsid,

                Q37TechvayliRd: item.dosefrequencyreduced,

                q37_Tec_Dose_week_frquency_txt:
                  item.treatmentInitialDoseFrequencyText,
                q37_Tec_Dose_week_frquencyRd:
                  item.treatmentInitialDoseFrequency,

                q37_Tec_Dose_week_strengthRd: item.treatmentInitialDosage,
                q37_Tec_Dose_week_strength_txt:
                  item.treatmentInitialDosageOthtext,

                showDateRedFreqTec:
                  item.dosefrequencyreduced === 1 ? true : false,

                Q40dosingfreqRd: item.ivigDosageFrequency,
                dosing_freq_oth_txt: item.ivigDosageFrequencyOthTxt,

                Q40IgILevelRd: item.lastIgglevel,

                Q40init_dt: item.ivigInitiationDate,
                Q40init_dt_Rd:
                  item.ivigInitiationDateUnk === true
                    ? 99
                    : item.ivigInitiationDate
                      ? 1
                      : null,
                primaryProf: item.medicationReasonPrimaryProphylactic,
                secondaryProf: item.medicationReasonSecondaryProphylactic,
                otherReson: item.medicationReasonOth,

                //39

                tocilizumab_tech: item.medicationTocilizumab,
                granulocyte_tech: item.medicationGcsf,
                noneoftheabove_tech: item.medicationNone === true ? 99 : null,
                steroids_tech: item.medicationSteroids,

                //39 - 1.1
                cytokin_tech: item.dosageusageReasonProphylacticCrs,
                secondary_prophylactic_crs_tech:
                  item.dosageusageReasonSecondaryProphylacticCrs,
                crs_tech: item.dosagusageReasonTreatmentsupportiveCrs,
                neurotoxicity_tech:
                  item.dosagusageReasonProphylacticneurotoxicity,
                secondary_neurotoxicity_tech:
                  item.dosageusageReasonSecondaryProphylacticNeurologic,
                tmt_neurotoxicity_tech:
                  item.dosagusageReasonTreatmentsupportiveNeurotoxicity,
                tmt_tech_unknown: item.dosagusageReasonTreatmentUnknown,
                q39TechReasonHard: false,

                //Q39.3
                prophylactic_use_tech: item.gcsfUsageReasonProphylactic,
                secondary_prophylactic_use_tech:
                  item.gcsfUsageReasonSecondaryProphylactic,
                oth_use_tech: item.gcsfUsageReasonOth,
                unknown_tech: item.gcsfUsageReasonUnk === true ? 99 : null,

                // Steroids Usage Reasons
                steroid_pre_tmt_tech:
                  item.steroidUsageReasonTreatmentRecommendation,

                cytokin_tech_steroids: item.steroidsUsageReasonProphylacticCrs,
                crs_tech_steroids:
                  item.steroidsUsageReasonTreatmentsupportiveCrs,
                neurotoxicity_tech_steroids:
                  item.steroidsUsageReasonProphylacticneurotoxicity,
                tmt_neurotoxicity_tech_steroids:
                  item.steroidsUsageReasonTreatmentsupportiveNeurotoxicity,
                tmt_steroids_tech_unknown: item.steroidUsageReasonUnknown,
                secondary_prophylactic_tech_steroids:
                  item.steroidsUsageReasonSecondaryProphylacticCrs,
                secondary_neurotoxicity_tech_steroids:
                  item.steroidsUsageReasonSecondaryProphylacticNeurologic,

                betamethasone_tech: item.steroidNameBetamethasone,
                betamethasone_techNum: item.steroidDoseBetamethasone,

                dexamethasone_tech: item.steroidNameDexamethasone,
                dexamethasone_techNum: item.steroidDoseDexamethasone,

                hydrocortisone_tech: item.steroidNameHydrocortisone,
                hydrocortisone_techNum: item.steroidDoseHydrocortisone,

                methylprednisolone: item.steroidNameMethylprednisolone,
                methylprednisoloneNum: item.steroidDoseMethylprednisolone,

                prednisolone_tech: item.steroidNamePrednisolone,
                prednisolone_techNum: item.steroidDosePrednisolone,

                prednisone_tech: item.steroidNamePrednisone,
                prednisone_techNum: item.steroidDosePrednisone,

                triamcinolone_tech: item.steroidNameTriamcinolone,
                triamcinolone_techNum: item.steroidDoseTriamcinolone,

                dose_name_tech_unknown: item.steroidDoseNameUnknown,

                name_dose_steroidsHardEmpty: false,

                steroids_tech_txtEmpty: false,
                //ConditionMet

                q39TechEmptyHard: false,

                q37TechvayliEmpty: false,
                Q40DosingFreqEmptyHard: false,
                Q40DosingFreqTxtEmptyHard: false,
                Q40IgGEmptyHard: false,
                Q40Init_dtHard: false,
                InvalidQ40init_dt: false,
                init_dt_before_eof: false,
                Q40Init_RdHard: false,
                Q40ReasonEmptyHard: false,
                q37_Tec_Dose_week_frquency_txt_Empty: false,
                q37TecDoseWeekFrequencyRangeError: false,
                q37_Tec_Dose_week_frquencyRd_Empty: false,

                q37_Tec_Dose_week_strength_txt_Empty: false,
                q37_Tec_Dose_week_strengthRd_Empty: false,
                q37_atleasetOneAdministrationTecWarningHard: false,

                q39TechGranulocyteEmptyHard: false,

                q39TechSteroidsEmptyHard: false,
              };
            });

            setQ37TechDetails(Q37TechDetails);
          }

          //37 LoadData -Talvey

          if (
            data.tTcharTalveyliModelList &&
            data.tTcharTalveyliModelList.length > 0
          ) {
            const Q37TalDetails = data.tTcharTalveyliModelList.map((item) => {
              return {
                cohorttreatmentid: item.cohorttreatmentid,
                teclistamabcharacteristicsid: item.teclistamabcharacteristicsid,

                Q37TalveyRd: item.dosefrequencyreduced,

                showDateRedFreqTal:
                  item.dosefrequencyreduced === 1 ? true : false,

                //37 Talvey
                q37_Tal_Dose_week_frquency_txt:
                  item.treatmentInitialDoseFrequencyText,
                q37_Tal_Dose_week_frquencyRd:
                  item.treatmentInitialDoseFrequency,
                q37_Tal_Dose_week_strengthRd: item.treatmentInitialDosage,
                q37_Tal_Dose_week_strength_txt:
                  item.treatmentInitialDosageOthtext,

                //39 Talvey data

                // Medications
                tocilizumab_tal: item.medicationTocilizumab,
                steroids_tal: item.medicationSteroids,
                granulocyte_tal: item.medicationGcsf,
                noneoftheabove_tal: item.medicationNone === true ? 99 : null,

                //Q39.3 - Granulocyte
                prophylactic_use_tal: item.gcsfUsageReasonProphylactic,
                secondary_prophylactic_use_tal:
                  item.gcsfUsageReasonSecondaryProphylactic,
                oth_use_tal: item.gcsfUsageReasonOth,
                unknown_tal: item.gcsfUsageReasonUnk === true ? 99 : null,
                q39TalGranulocyteEmptyHard: false,

                // Q39.1 - Dosage Usage Reasons
                cytokin_tal: item.dosageusageReasonProphylacticCrs,
                secondary_prophylactic_crs_tal:
                  item.dosageusageReasonSecondaryProphylacticCrs,
                crs_tal: item.dosagusageReasonTreatmentsupportiveCrs,
                neurotoxicity_tal:
                  item.dosagusageReasonProphylacticneurotoxicity,
                secondary_neurotoxicity_tal:
                  item.dosageusageReasonSecondaryProphylacticNeurologic,
                tmt_neurotoxicity_tal:
                  item.dosagusageReasonTreatmentsupportiveNeurotoxicity,
                tmt_talvey_unknown: item.dosagusageReasonTreatmentUnknown,
                q39TalReasonHard: false,

                // Q39.2 - Steroids Usage Reasons
                cytokin_tal_steroids: item.steroidsUsageReasonProphylacticCrs,
                crs_tal_steroids:
                  item.steroidsUsageReasonTreatmentsupportiveCrs,
                neurotoxicity_tal_steroids:
                  item.steroidsUsageReasonProphylacticneurotoxicity,
                tmt_neurotoxicity_tal_steroids:
                  item.steroidsUsageReasonTreatmentsupportiveNeurotoxicity,
                tmt_tal_unknown: item.steroidUsageReasonUnknown,
                steroid_pre_tmt_tal:
                  item.steroidUsageReasonTreatmentRecommendation,
                secondary_prophylactic_tal_steroids:
                  item.steroidsUsageReasonSecondaryProphylacticCrs,
                secondary_neurotoxicity_tal_steroids:
                  item.steroidsUsageReasonSecondaryProphylacticNeurologic,

                betamethasone_tal: item.steroidNameBetamethasone,
                betamethasone_talNum: item.steroidDoseBetamethasone,

                dexamethasone_tal: item.steroidNameDexamethasone,
                dexamethasone_talNum: item.steroidDoseDexamethasone,

                hydrocortisone_tal: item.steroidNameHydrocortisone,
                hydrocortisone_talNum: item.steroidDoseHydrocortisone,

                methylprednisolone_tal: item.steroidNameMethylprednisolone,
                methylprednisolone_talNum: item.steroidDoseMethylprednisolone,

                prednisolone_tal: item.steroidNamePrednisolone,
                prednisolone_talNum: item.steroidDosePrednisolone,

                prednisone_tal: item.steroidNamePrednisone,
                prednisone_talNum: item.steroidDosePrednisone,

                triamcinolone_tal: item.steroidNameTriamcinolone,
                triamcinolone_talNum: item.steroidDoseTriamcinolone,

                dose_name_tal_unknown: item.steroidDoseNameUnknown,

                name_dose_steroids_talHardEmpty: false,
                steroids_tal_txtEmpty: false,

                q37TalveyEmpty: false,
                q39TalEmptyHard: false,
                q39TalSteroidsEmptyHard: false,
                q37_Tal_Dose_week_frquencyRd_Empty: false,
                q37_Tal_Dose_week_frquency_txt_Empty: false,
                q37TalDoseWeekFrequencyRangeError: false,
                q37_Tal_Dose_week_strengthRd_Empty: false,
                q37_Tal_Dose_week_strength_txt_Empty: false,
                q37_atleasetOneAdministrationTalWarningHard: false,

                //Q40
                Q40dosingfreqRd_Tal: item.ivigDosageFrequency,
                dosing_freq_oth_txt_Tal: item.ivigDosageFrequencyOthTxt,
                Q40IgILevelRd_Tal: item.lastIgglevel,
                Q40init_dt_Tal: item.ivigInitiationDate,
                Q40init_dt_Rd_Tal:
                  item.ivigInitiationDateUnk === true
                    ? 99
                    : item.ivigInitiationDate
                      ? 1
                      : null,
                primaryProf_Tal: item.medicationReasonPrimaryProphylactic,
                secondaryProf_Tal: item.medicationReasonSecondaryProphylactic,
                otherReson_Tal: item.medicationReasonOth,

                InvalidQ40init_dt_Tal: false,
                init_dt_before_eof_Tal: false,
                showDateRedFreqTec_Tal: false,
                Q40TalDosingFreqEmptyHard: false,
                Q40TalDosingFreqTxtEmptyHard: false,
                Q40TalIgGEmptyHard: false,
                Q40TalInit_dtHard: false,
                Q40TalInit_RdHard: false,
                Q40TalReasonEmptyHard: false,
              };
            });

            setQ37TalDetails(Q37TalDetails);
          }

          // Q38
          // Process TalveyData
          if (data.q38TalveyData && data.q38TalveyData.length > 0) {
            const Q38TalDetails = data.q38TalveyData.map((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohorttreatmentid) || {};

              return {
                cohorttreatmentid: item.cohorttreatmentid,

                teclistamatalquetamabdosefrequencybridgeid:
                  item.teclistamatalquetamabdosefrequencybridgeid,

                Q38TalveyRd: item.dosefreqReductionDate
                  ? 1
                  : item.dosefreqReductionDateUnk === true
                    ? 99
                    : null,
                dt_dosefreq_tal_dt: item.dosefreqReductionDate,

                Q38TalEmptyHard: false,
                Q38TalDateEmpty: false,
                Q38TalDateInvalid: false,
                InvalidQ38Talveydate: false,
                q38_Tal_Dose_week_frquencyRd_Empty: false,
                q38_Tal_Dose_week_frquency_txt_Empty: false,
                q38_Tal_Dosage_Rd_Empty: false,
                q38_Tal_Dosage_OtherTxt_Empty: false,

                q38_Tal_Dose_week_frquency_txt:
                  item.treatmentInitialDoseFrequencyText,

                q38_Tal_Dose_week_frquencyRd:
                  item.treatmentInitialDoseFrequency,

                q38_Tal_Dosage_OtherTxt: item.treatmentInitialDosageOthtext,
                q38_Tal_Dosage_Rd: item.treatmentInitialDosage,
                q38TalDoseFrequencyConflict: false,
              };
            });

            setQ38TalDetails(Q38TalDetails);
          } else {
            const cohortTreatmentid = isTALSelected
              ? RRMMCohortTreatment.TALVEY //GetLocalStorageData("talveyID")
              : 0;

            // Update TechvayliRow with cohorttreatmentid only
            Q38TalRow.cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q38TalRow.teclistamatalquetamabdosefrequencybridgeid =
              Q38TalRow.teclistamatalquetamabdosefrequencybridgeid || 0;

            Q38TalRow.Q38TalveyRd = Q38TalRow.Q38TalveyRd || null;
            Q38TalRow.dt_dosefreq_tal_dt = Q38TalRow.dt_dosefreq_tal_dt || "";
          }

          //38
          // Process Techvaley Data
          if (data.q38TechvayliData && data.q38TechvayliData.length > 0) {
            const Q38TechDetails = data.q38TechvayliData.map((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohorttreatmentid) || {};

              return {
                cohorttreatmentid: item.cohorttreatmentid,

                teclistamatalquetamabdosagebridgeid:
                  item.teclistamatalquetamabdosagebridgeid,

                Q38TechvayliRd: item.dosefreqReductionDate
                  ? 1
                  : item.dosefreqReductionDateUnk === true
                    ? 99
                    : null,
                dt_dosefreq_tech_dt: item.dosefreqReductionDate,

                Q38TechEmptyHard: false,
                Q38DateEmpty: false,
                Q38TechDateInvalid: false,
                Invalid_dt_dosefreq_tech_dt: false,

                q38_Tec_Dose_week_frquencyRd_Empty: false,
                q38_Tec_Dose_week_frquency_txt_Empty: false,

                q38_Tec_Dose_week_frquency_txt:
                  item.treatmentInitialDoseFrequencyText,
                q38_Tec_Dose_week_frquencyRd:
                  item.treatmentInitialDoseFrequency,
                q38TecDoseFrequencyConflict: false,
              };
            });

            setQ38TechDetails(Q38TechDetails);
          } else {
            const cohortTreatmentid = isTACSelected
              ? RRMMCohortTreatment.TECVAYLI //GetLocalStorageData("techvayliID")
              : 0;

            // Update TechvayliRow with cohorttreatmentid only
            Q38TechRow.cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q38TechRow.teclistamatalquetamabdosefrequencybridgeid =
              Q38TechRow.teclistamatalquetamabdosefrequencybridgeid || 0;

            Q38TechRow.Q38TechvayliRd = Q38TechRow.Q38TechvayliRd || null;
            Q38TechRow.dt_dosefreq_tech_dt =
              Q38TechRow.dt_dosefreq_tech_dt || "";
          }
          setDiscontinuationReasonsList(data.discontinuationReasons);
          setQ382ADiscontinuationReasonsList(
            data.discontinuationReasonsQ382A ?? [],
          );
          setAEReasonsList(data.adverseEventReasons);

          if (data.neurologicAEReasonList?.length > 0)
            setNeurologicAEReasonList(data.neurologicAEReasonList);

          // load q38.1.a
          if (data.ttDoseFrequencyList?.length > 0) {
            data.ttDoseFrequencyList = data.ttDoseFrequencyList.map(
              (cohortItem) => {
                return {
                  ...cohortItem,
                  changeTypeEmpty: false,
                  changeTypeDoseFrequencyEmpty: false,
                  changeTypeDoseStrengthEmpty: false,
                  reasonEmpty: false,
                  reasonOtherTextEmpty: false,
                  aeSubReasonEmpty: false,
                  neuroReasonEmpty: false,
                  neuroOtherTextEmpty: false,
                  patternBeforeFrequencyEmpty: false,
                  patternBeforeFrequencyRangeInvalid: false,
                  patternBeforeStrengthEmpty: false,
                  patternAfterFrequencyEmpty: false,
                  patternAfterFrequencyRangeInvalid: false,
                  patternAfterStrengthEmpty: false,
                  patternAfterStrengthRangeInvalid: false,
                  frequencyIncreaseConflict: false,
                  frequencyDecreaseConflict: false,
                  strengthIncreaseConflict: false,
                  strengthDecreaseConflict: false,
                  dateChangeRdEmpty: false,
                  invalidDateChange: false,
                  dateChangeBeforeEOF: false,
                  dateChangeEmpty: false,
                  dateChangeOutOfBound: false,
                  adverseEventReasons: cohortItem.adverseEventReasons,
                  discontinuationReasons: cohortItem.discontinuationReasons,
                  patternBeforeStrengthRangeInvalid: false,
                  patternBeforeUnknownWarning:
                    cohortItem.patterBeforeChangeDoseFrequency === 99 ||
                    cohortItem.patterBeforeChangeDoseStrength === 99,
                  patternAfterUnknownWarning:
                    cohortItem.patterAfterChangeDoseFrequency === 99 ||
                    cohortItem.patterAfterChangeDoseStrength === 99,
                  neurologicAEReasonList:
                    cohortItem.neurologicAEReasonList ?? [],
                };
              },
            );

            const techDetailsList = data.ttDoseFrequencyList.filter(
              (x) => x.cohortTreatmentId === RRMMCohortTreatment.TECVAYLI,
            );
            const talvDetailsList = data.ttDoseFrequencyList.filter(
              (x) => x.cohortTreatmentId === RRMMCohortTreatment.TALVEY,
            );
            setQ381ATechDetails(
              techDetailsList.length > 0
                ? techDetailsList
                : mapQ381A2ACohortList(
                    Q381ATechDetails,
                    RRMMCohortTreatment.TECVAYLI,
                    data,
                  ),
            );
            setQ381ATalvDetails(
              talvDetailsList.length > 0
                ? talvDetailsList
                : mapQ381A2ACohortList(
                    Q381ATalvDetails,
                    RRMMCohortTreatment.TALVEY,
                    data,
                  ),
            );
          } else {
            const updatedTechList = mapQ381A2ACohortList(
              Q381ATechDetails,
              RRMMCohortTreatment.TECVAYLI,
              data,
            );
            setQ381ATechDetails(updatedTechList);
            const updatedTalvList = mapQ381A2ACohortList(
              Q381ATalvDetails,
              RRMMCohortTreatment.TALVEY,
              data,
            );
            setQ381ATalvDetails(updatedTalvList);
          }

          //load Q38.2.A

          if (data.ttDoseDelayList?.length > 0) {
            data.ttDoseDelayList = data.ttDoseDelayList.map((cohortItem) => {
              return {
                ...cohortItem,
                adverseEventReasons: cohortItem.adverseEventReasons,
                discontinuationReasons: cohortItem.discontinuationReasons,
                colBError: false,
                colCError: false,
                aeSubReasonEmpty: false,
                neuroReasonEmpty: false,
                neuroOtherTextEmpty: false,
                colDError: false,
                colFError: false,
                startDoseDtError: false,
                endDoseDtError: false,
                reasonOtherTextEmpty: false,
                invalidEndDateChange: false,
                endDateChangeOutOfBound: false,
                invalidstartDateChange: false,
                startDateChangeOutOfBound: false,
                interruptionStartDateUnknownWarning:
                  cohortItem.startDoseDtRd === 99,
                interruptionEndDateUnknownWarning:
                  cohortItem.endDoseDtRd === 99,
                neurologicAEReasonList: cohortItem.neurologicAEReasonList ?? [],
              };
            });

            const techDetailsList = data.ttDoseDelayList.filter(
              (x) => x.cohortTreatmentId === RRMMCohortTreatment.TECVAYLI,
            );
            const talvDetailsList = data.ttDoseDelayList.filter(
              (x) => x.cohortTreatmentId === RRMMCohortTreatment.TALVEY,
            );

            setQ382ATechDetails(
              techDetailsList.length > 0
                ? techDetailsList
                : mapQ381A2ACohortList(
                    Q382ATechDetails,
                    RRMMCohortTreatment.TECVAYLI,
                    data,
                  ),
            );
            setQ382ATalvDetails(
              talvDetailsList.length > 0
                ? talvDetailsList
                : mapQ381A2ACohortList(
                    Q382ATalvDetails,
                    RRMMCohortTreatment.TALVEY,
                    data,
                  ),
            );
          } else {
            const updatedTechList = mapQ381A2ACohortList(
              Q382ATechDetails,
              RRMMCohortTreatment.TECVAYLI,
              data,
            );
            setQ382ATechDetails(updatedTechList);
            const updatedTalvList = mapQ381A2ACohortList(
              Q382ATalvDetails,
              RRMMCohortTreatment.TALVEY,
              data,
            );
            setQ382ATalvDetails(updatedTalvList);
          }

          //Q40.1.B
          // Process Techvaley Data
          if (data.q401aTechvayliData && data.q401aTechvayliData.length > 0) {
            const q401aTechvayliDetails = data.q401aTechvayliData.map(
              (item) => {
                return {
                  cohorttreatmentid: item.cohorttreatmentid,
                  tectalivigreceivedbridgeid: item.tectalivigreceivedbridgeid,

                  Q401ainit_dt_Rd_Tec: item.ivig_date_selection,
                  Q401ainit_Tec_dt: item.ivig_date,
                  Q401aInit_Tec_RdHard: false,
                  Q401aInit_Tec_dtHard: false,
                  Q401aInvalidQ401ainit_Tec_dt: false,
                  Q401aInit_Tec_dt_before_eof: false,

                  Q401aIntendedDosing_Tec: item.intended_dosing_frequency,
                  Q401aIntendedDosing_Tec_WeekValue:
                    item.intended_dosing_frequency === 1
                      ? item.intended_dosing_frequency_value
                      : null,
                  Q401aIntendedDosing_Tec_MonthValue:
                    item.intended_dosing_frequency === 2
                      ? item.intended_dosing_frequency_value
                      : null,
                  Q401aIntendedDosing_Tec_OnceWeekValue:
                    item.intended_dosing_frequency === 3
                      ? item.intended_dosing_frequency_value
                      : null,
                  Q401aIntendedDosing_Tec_OnceMonthValue:
                    item.intended_dosing_frequency === 4
                      ? item.intended_dosing_frequency_value
                      : null,
                  Q401aIntendedDosing_Tec_OtherValue:
                    item.intended_dosing_frequency === 5
                      ? item.intended_dosing_frequency_value
                      : null,
                  Q401aIntendedDosingEmpty_Tec: false,
                  Q401aIntendedDosingRangeInvalid_Tec: false,

                  Q401aPrimaryProf_Tec: item.primary_reason,
                  Q401aSecProf_Tec: item.secondary_reason,
                  Q401aOtherProf_Tec: item.other_reason,
                  Q401aUnknownProf_Tec: item.unknown_reason,
                  Q401aReasonIvigEmptyHard_Tec: false,

                  Q401aDosingType_Tec: item.dosing_type,
                  Q401aDosingType_TecEmptyHard: false,

                  Q401aDosage_Tec: item.dosage,
                  Q401aDosage_Tec_GValue:
                    item.dosage === 1 ? item.dosage_value : null,
                  Q401aDosage_Tec_MgValue:
                    item.dosage === 2 ? item.dosage_value : null,
                  Q401aDosageFrequencyEmpty_Tec: false,
                  Q401aDosageRangeInvalid_Tec: false,

                  Q401aWeight_Tec: item.body_weight,
                  Q401aWeight_Value_KgTec:
                    item.body_weight === 1 ? item.body_weight_value : null,
                  Q401aWeight_Value_LbsTec:
                    item.body_weight === 2 ? item.body_weight_value : null,
                  Q401aWeightEmpty_Tec: false,
                  Q401aWeightRangeInvalid_Tec: false,

                  Q401aWeight_Asses_Tec: item.weight_date_selection,
                  Q401aWeight_Asses_Tec_dt: item.weight_date,
                  Q401aWeight_AssesEmptyHard_Tec: false,
                  Q401aWeight_AssesDtEmptyHard_Tec: false,
                  Q401aWeight_AssesDtInvalid_Tec: false,
                  Q401aWeight_Asses_dt_before_eof_Tec: false,
                };
              },
            );

            setQ401aTecDetails(q401aTechvayliDetails);
          } else {
            const cohortTreatmentid = isTACSelected
              ? RRMMCohortTreatment.TECVAYLI //GetLocalStorageData("techvayliID")
              : 0;

            // Update TechvayliRow with cohorttreatmentid only
            Q401aTecDetails[0].cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q401aTecDetails[0].tectalivigreceivedbridgeid =
              Q401aTecDetails[0].tectalivigreceivedbridgeid || 0;

            Q401aTecDetails[0].Q401ainit_dt_Rd_Tec =
              Q401aTecDetails[0].Q401ainit_dt_Rd_Tec || null;
            Q401aTecDetails[0].Q401ainit_Tec_dt =
              Q401aTecDetails[0].Q401ainit_Tec_dt || "";
          }

          //Q40.1.B
          // Process TALVEY Data
          if (data.q401aTalveyData && data.q401aTalveyData.length > 0) {
            const q401aTalveyDetails = data.q401aTalveyData.map((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohorttreatmentid) || {};

              return {
                cohorttreatmentid: item.cohorttreatmentid,
                tectalivigreceivedbridgeid: item.tectalivigreceivedbridgeid,

                Q401ainit_dt_Rd_Tal: item.ivig_date_selection,
                Q401ainit_Tal_dt: item.ivig_date,
                Q401aInit_Tal_RdHard: false,
                Q401aInit_Tal_dtHard: false,
                Q401aInvalidQ401ainit_Tal_dt: false,
                Q401aInit_Tal_dt_before_eof: false,

                Q401aIntendedDosing_Tal: item.intended_dosing_frequency,
                Q401aIntendedDosing_Tal_WeekValue:
                  item.intended_dosing_frequency === 1
                    ? item.intended_dosing_frequency_value
                    : null,
                Q401aIntendedDosing_Tal_MonthValue:
                  item.intended_dosing_frequency === 2
                    ? item.intended_dosing_frequency_value
                    : null,
                Q401aIntendedDosing_Tal_OnceWeekValue:
                  item.intended_dosing_frequency === 3
                    ? item.intended_dosing_frequency_value
                    : null,
                Q401aIntendedDosing_Tal_OnceMonthValue:
                  item.intended_dosing_frequency === 4
                    ? item.intended_dosing_frequency_value
                    : null,
                Q401aIntendedDosing_Tal_OtherValue:
                  item.intended_dosing_frequency === 5
                    ? item.intended_dosing_frequency_value
                    : null,
                Q401aIntendedDosingEmpty_Tal: false,
                Q401aIntendedDosingRangeInvalid_Tal: false,

                Q401aPrimaryProf_Tal: item.primary_reason,
                Q401aSecProf_Tal: item.secondary_reason,
                Q401aOtherProf_Tal: item.other_reason,
                Q401aUnknownProf_Tal: item.unknown_reason,
                Q401aReasonIvigEmptyHard_Tal: false,

                Q401aDosingType_Tal: item.dosing_type,
                Q401aDosingType_TalEmptyHard: false,

                Q401aDosage_Tal: item.dosage,
                Q401aDosage_Tal_GValue:
                  item.dosage === 1 ? item.dosage_value : null,
                Q401aDosage_Tal_MgValue:
                  item.dosage === 2 ? item.dosage_value : null,
                Q401aDosageFrequencyEmpty_Tal: false,
                Q401aDosageRangeInvalid_Tal: false,

                Q401aWeight_Tal: item.body_weight,
                Q401aWeight_Value_KgTal:
                  item.body_weight === 1 ? item.body_weight_value : null,
                Q401aWeight_Value_LbsTal:
                  item.body_weight === 2 ? item.body_weight_value : null,
                Q401aWeightEmpty_Tal: false,
                Q401aWeightRangeInvalid_Tal: false,

                Q401aWeight_Asses_Tal: item.weight_date_selection,
                Q401aWeight_Asses_Tal_dt: item.weight_date,
                Q401aWeight_AssesEmptyHard_Tal: false,
                Q401aWeight_AssesDtEmptyHard_Tal: false,
                Q401aWeight_AssesDtInvalid_Tal: false,
                Q401aWeight_Asses_dt_before_eof_Tal: false,
              };
            });

            setQ401aTalDetails(q401aTalveyDetails);
          } else {
            const cohortTreatmentid = isTALSelected
              ? RRMMCohortTreatment.TALVEY //GetLocalStorageData("techvayliID")
              : 0;

            // Update TechvayliRow with cohorttreatmentid only
            Q401aTalDetails.cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q401aTalDetails.tectalivigreceivedbridgeid =
              Q401aTalDetails.tectalivigreceivedbridgeid || 0;

            Q401aTalDetails.Q401ainit_dt_Rd_Tal =
              Q401aTalDetails.Q401ainit_dt_Rd_Tal || null;
            Q401aTalDetails.Q401ainit_Tal_dt =
              Q401aTalDetails.Q401ainit_Tal_dt || "";
          }

          // Warning for Q40.1.B
          const priEnabled = Q37TechDetails[0]?.primaryProf;
          const secEnabled = Q37TechDetails[0]?.secondaryProf;
          const otherEnabled = Q37TechDetails[0]?.otherReson;

          // Check individually
          const priMatch =
            !priEnabled ||
            Q401aTecDetails?.some((x) => x.Q401aPrimaryProf_Tec === true);
          const secMatch =
            !secEnabled ||
            Q401aTecDetails?.some((x) => x.Q401aSecProf_Tec === true);
          const otherMatch =
            !otherEnabled ||
            Q401aTecDetails?.some((x) => x.Q401aOtherProf_Tec === true);

          // Final condition
          const isMatch = priMatch && secMatch && otherMatch;

          if (!isMatch) setQ40Tec_WarningHard(true);
          else setQ40Tec_WarningHard(false);

          // Warning for Q40.1.B
          const priTalEnabled = Q37TalDetails[0]?.primaryProf_Tal;
          const secTalEnabled = Q37TalDetails[0]?.secondaryProf_Tal;
          const otherTalEnabled = Q37TalDetails[0]?.otherReson_Tal;

          // Check individually
          const priTalMatch =
            !priTalEnabled ||
            Q401aTalDetails?.some((x) => x.Q401aPrimaryProf_Tal === true);
          const secTalMatch =
            !secTalEnabled ||
            Q401aTalDetails?.some((x) => x.Q401aSecProf_Tal === true);
          const otherTalMatch =
            !otherTalEnabled ||
            Q401aTalDetails?.some((x) => x.Q401aOtherProf_Tal === true);

          // Final condition
          const isTalMatch = priTalMatch && secTalMatch && otherTalMatch;

          if (!isTalMatch) setQ40Tal_WarningHard(true);
          else setQ40Tal_WarningHard(false);

          //Q40.2.B
          // Process Techvaley Data
          if (data.q402aTechvayliData && data.q402aTechvayliData.length > 0) {
            const q402aTechvayliDetails = data.q402aTechvayliData.map(
              (item) => {
                return {
                  cohorttreatmentid: item.cohorttreatmentid,
                  tectaliggdetailbridgeid: item.tectaliggdetailbridgeid,

                  Q402aIgg_assessment_Tec: item.igg_assessment_selection,
                  Q402aIgg_assessment_Tec_dt: item.igg_assessment_date,
                  Q402aIgg_assessment_Tec_RdHard: false,
                  Q402aIgg_assessment_Tec_dtHard: false,
                  Q402aIgg_assessment_Tec_dtInvalid: false,
                  Q402aIgg_assessment_Tec_dt_before_eof: false,
                  Q402aIgg_level_Tec: item.igg_level_selection,
                  Q402aIgg_level_Tec_MgValue:
                    item.igg_level_selection === 1
                      ? item.igg_level_value
                      : null,
                  Q402aIgg_level_Tec_GValue:
                    item.igg_level_selection === 2
                      ? item.igg_level_value
                      : null,
                  Q402aIgg_level_Tec_Empty: false,
                  Q402aIgg_level_Tec_RangeInvalid: false,
                };
              },
            );

            setQ402aTecDetails(q402aTechvayliDetails);
          } else {
            const cohortTreatmentid = isTACSelected
              ? RRMMCohortTreatment.TECVAYLI //GetLocalStorageData("techvayliID")
              : 0;

            // Update TechvayliRow with cohorttreatmentid only
            Q402aTecDetails[0].cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q402aTecDetails[0].tectaliggdetailbridgeid =
              Q402aTecDetails[0].tectaliggdetailbridgeid || 0;

            Q402aTecDetails[0].Q402aIgg_assessment_Tec =
              Q402aTecDetails[0].Q402aIgg_assessment_Tec || null;
            Q402aTecDetails[0].Q402aIgg_assessment_Tec_dt =
              Q402aTecDetails[0].Q402aIgg_assessment_Tec_dt || "";
          }

          //Q40.2.B
          // Process Talvey Data
          if (data.q402aTalveyData && data.q402aTalveyData.length > 0) {
            const q402aTalveyDetails = data.q402aTalveyData.map((item) => {
              return {
                cohorttreatmentid: item.cohorttreatmentid,
                tectaliggdetailbridgeid: item.tectaliggdetailbridgeid,

                Q402aIgg_assessment_Tal: item.igg_assessment_selection,
                Q402aIgg_assessment_Tal_dt: item.igg_assessment_date,
                Q402aIgg_assessment_Tal_RdHard: false,
                Q402aIgg_assessment_Tal_dtHard: false,
                Q402aIgg_assessment_Tal_dtInvalid: false,
                Q402aIgg_assessment_Tal_dt_before_eof: false,
                Q402aIgg_level_Tal: item.igg_level_selection,
                Q402aIgg_level_Tal_MgValue:
                  item.igg_level_selection === 1 ? item.igg_level_value : null,
                Q402aIgg_level_Tal_GValue:
                  item.igg_level_selection === 2 ? item.igg_level_value : null,
                Q402aIgg_level_Tal_Empty: false,
                Q402aIgg_level_Tal_RangeInvalid: false,
              };
            });

            setQ402aTalDetails(q402aTalveyDetails);
          } else {
            const cohortTreatmentid = isTALSelected
              ? RRMMCohortTreatment.TALVEY //GetLocalStorageData("techvayliID")
              : 0;

            // Update TalveyRow with cohorttreatmentid only
            Q402aTalDetails[0].cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q402aTalDetails[0].tectaliggdetailbridgeid =
              Q402aTalDetails[0].tectaliggdetailbridgeid || 0;

            Q402aTalDetails[0].Q402aIgg_assessment_Tal =
              Q402aTalDetails[0].Q402aIgg_assessment_Tal || null;
            Q402aTalDetails[0].Q402aIgg_assessment_Tal_dt =
              Q402aTalDetails[0].Q402aIgg_assessment_Tal_dt || "";
          }

          //Q40.3.B
          // Process Techvaley Data
          if (data.q403aTechvayliData && data.q403aTechvayliData.length > 0) {
            const q403aTechvayliDetails = data.q403aTechvayliData.map(
              (item) => {
                return {
                  cohorttreatmentid: item.cohorttreatmentid,
                  tectaliggdetailbridgeid: item.tectaliggdetailbridgeid,

                  Q403aIgg_assessment_Tec: item.igg_assessment_selection,
                  Q403aIgg_assessment_Tec_dt: item.igg_assessment_date,
                  Q403aIgg_assessment_Tec_RdHard: false,
                  Q403aIgg_assessment_Tec_dtHard: false,
                  Q403aIgg_assessment_Tec_dtInvalid: false,
                  Q403aIgg_assessment_Tec_dt_before_eof: false,
                  Q403aIgg_level_Tec: item.igg_level_selection,
                  Q403aIgg_level_Tec_MgValue:
                    item.igg_level_selection === 1
                      ? item.igg_level_value
                      : null,
                  Q403aIgg_level_Tec_GValue:
                    item.igg_level_selection === 2
                      ? item.igg_level_value
                      : null,
                  Q403aIgg_level_Tec_Empty: false,
                  Q403aIgg_level_Tec_RangeInvalid: false,
                };
              },
            );

            setQ403aTecDetails(q403aTechvayliDetails);
          } else {
            const cohortTreatmentid = isTACSelected
              ? RRMMCohortTreatment.TECVAYLI //GetLocalStorageData("techvayliID")
              : 0;

            // Update TechvayliRow with cohorttreatmentid only
            Q403aTecDetails[0].cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q403aTecDetails[0].tectaliggdetailbridgeid =
              Q403aTecDetails[0].tectaliggdetailbridgeid || 0;

            Q403aTecDetails[0].Q403aIgg_assessment_Tec =
              Q403aTecDetails[0].Q403aIgg_assessment_Tec || null;
            Q403aTecDetails[0].Q403aIgg_assessment_Tec_dt =
              Q403aTecDetails[0].Q403aIgg_assessment_Tec_dt || "";
          }

          //Q40.3.B
          // Process Talvey Data
          if (data.q403aTalveyData && data.q403aTalveyData.length > 0) {
            const q403aTalveyDetails = data.q403aTalveyData.map((item) => {
              return {
                cohorttreatmentid: item.cohorttreatmentid,
                tectaliggdetailbridgeid: item.tectaliggdetailbridgeid,

                Q403aIgg_assessment_Tal: item.igg_assessment_selection,
                Q403aIgg_assessment_Tal_dt: item.igg_assessment_date,
                Q403aIgg_assessment_Tal_RdHard: false,
                Q403aIgg_assessment_Tal_dtHard: false,
                Q403aIgg_assessment_Tal_dtInvalid: false,
                Q403aIgg_assessment_Tal_dt_before_eof: false,
                Q403aIgg_level_Tal: item.igg_level_selection,
                Q403aIgg_level_Tal_MgValue:
                  item.igg_level_selection === 1 ? item.igg_level_value : null,
                Q403aIgg_level_Tal_GValue:
                  item.igg_level_selection === 2 ? item.igg_level_value : null,
                Q403aIgg_level_Tal_Empty: false,
                Q403aIgg_level_Tal_RangeInvalid: false,
              };
            });

            setQ403aTalDetails(q403aTalveyDetails);
          } else {
            const cohortTreatmentid = isTALSelected
              ? RRMMCohortTreatment.TALVEY
              : 0;

            // Update TalveyRow with cohorttreatmentid only
            Q403aTalDetails[0].cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q403aTalDetails[0].tectaliggdetailbridgeid =
              Q403aTalDetails[0].tectaliggdetailbridgeid || 0;

            Q403aTalDetails[0].Q403aIgg_assessment_Tal =
              Q403aTalDetails[0].Q403aIgg_assessment_Tal || null;
            Q403aTalDetails[0].Q403aIgg_assessment_Tal_dt =
              Q403aTalDetails[0].Q403aIgg_assessment_Tal_dt || "";
          }

          //Q39.1.A
          // TECVAYLI
          const techSource = data?.tecvayliTocilizumabData ?? [];

          const techTocilData =
            techSource.length > 0
              ? techSource.map((item) => ({
                  ...q391ATechRow,
                  tocilizumabmedicationid: item.tocilizumabmedicationid,
                  cohorttreatmentid: item.cohorttreatmentid,
                  patientid: item.patientid,

                  primaryProphylacticCrs_tech: item.primaryProphylacticCrs,
                  secondaryProphylacticCrs_tech: item.secondaryProphylacticCrs,
                  supportiveCareCrs_tech: item.supportiveCareCrs,
                  primaryProphylacticNeurologic_tech:
                    item.primaryProphylacticNeurologic,
                  secondaryProphylacticNeurologic_tech:
                    item.secondaryProphylacticNeurologic,
                  supportiveCareNeurologic_tech: item.supportiveCareNeurologic,
                  medicationReasonUnk_tech: item.medicationReasonUnk,
                  q39TechReasonEmpty: false,

                  // 39.1.A
                  administrationDate_tech: item.tocilizumabAdministrationDate,
                  administrationDateRD_tech:
                    item.tocilizumabAdministrationDateUnk
                      ? 99
                      : item.tocilizumabAdministrationDate
                        ? 1
                        : null,

                  q39TechInvalidAdministrationDate: false,
                  q39TechAdministrationDateEmpty: false,
                  q39TechAdministrationRDEmpty: false,
                }))
              : isNewEcrfAChecked
                ? [
                    {
                      ...q391ATechRow,
                      patientid: data?.patientid,
                    },
                  ]
                : [];

          setQ391ATechTocilzumabList(techTocilData);
          setQ391ATechAdministrationDateOutOfRange(false);

          // TALVEY
          const talSource = data?.talveyTocilizumabData ?? [];

          const talTocilData =
            talSource.length > 0
              ? talSource.map((item) => ({
                  ...q391ATalRow,
                  tocilizumabmedicationid: item.tocilizumabmedicationid,
                  cohorttreatmentid: item.cohorttreatmentid,
                  patientid: item.patientid,

                  primaryProphylacticCrs_tal: item.primaryProphylacticCrs,
                  secondaryProphylacticCrs_tal: item.secondaryProphylacticCrs,
                  supportiveCareCrs_tal: item.supportiveCareCrs,
                  primaryProphylacticNeurologic_tal:
                    item.primaryProphylacticNeurologic,
                  secondaryProphylacticNeurologic_tal:
                    item.secondaryProphylacticNeurologic,
                  supportiveCareNeurologic_tal: item.supportiveCareNeurologic,

                  medicationReasonUnk_tal: item.medicationReasonUnk,
                  q39TalReasonEmpty: false,

                  // 39.1.A
                  administrationDate_tal: item.tocilizumabAdministrationDate,
                  administrationDateRD_tal:
                    item.tocilizumabAdministrationDateUnk
                      ? 99
                      : item.tocilizumabAdministrationDate
                        ? 1
                        : null,

                  q39TalInvalidAdministrationDate: false,
                  q39TalAdministrationDateEmpty: false,
                  q39TalAdministrationRDEmpty: false,
                }))
              : isNewEcrfAChecked
                ? [
                    {
                      ...q391ATalRow,
                      patientid: data?.patientid,
                    },
                  ]
                : [];
          setQ391ATalAdministrationDateOutOfRange(false);
          setQ391ATalTocilzumabList(talTocilData);
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      console.log(error);
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  };

  useEffect(() => {
    async function FetchData() {
      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const resetNeurologicReasons = (neuroList) =>
    neuroList?.map((x) => ({
      ...x,
      isSelected: false,
      reasonUnk: false,
      reasonText: "",
    })) ?? [];

  const HandleRepeaterFieldChange = (e, reaonid = null, aeid = null) => {
    const { name, id, value } = e.target;
    const value_int = Number(value);

    switch (name) {
      //q38.2.a TALVAEY

      case "changeInterptTypeTalv" + id: {
        let updatedArray = [...Q382ATalvDetails];
        updatedArray[id].changeType = Number(value);
        updatedArray[id].interruptionStartDateUnknownWarning = false;
        updatedArray[id].interruptionEndDateUnknownWarning = false;

        updatedArray[id].colBError = false;
        // Reset columns C-F if radio change selected

        if (Number(value) == 1 || Number(value) == 99) {
          setHideQ382TalvAdd(true);
          updatedArray = updatedArray.slice(0, 1);
        } else {
          // If needed, show Add button for other values
          setHideQ382TalvAdd(false);
        }
        // Column C
        if (Number(value) != 2) {
          updatedArray[id].selectedReasons = [];
          updatedArray[id].selectedAEReasons = [];
          updatedArray[id].reasonOtherText = "";
          updatedArray[id].aeSubReasonEmpty = false;
          updatedArray[id].neuroReasonEmpty = false;
          updatedArray[id].neuroOtherTextEmpty = false;

          // Column D
          updatedArray[id].startDoseDt = null;
          updatedArray[id].startDoseDtRd = null;
          updatedArray[id].endDoseDt = null;
          updatedArray[id].endDoseDtRd = null;
          updatedArray[id].reasonOtherTextEmpty = false;
          updatedArray[id].colCError = false;
          updatedArray[id].colDError = false;
          updatedArray[id].colFError = false;
          updatedArray[id].invalidEndDateChange = false;
          updatedArray[id].endDateChangeOutOfBound = false;
          updatedArray[id].invalidstartDateChange = false;
          updatedArray[id].startDateChangeOutOfBound = false;

          updatedArray[id].discontinuationReasons = updatedArray[
            id
          ].discontinuationReasons.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: false,
            reasonText: "",
          }));
          updatedArray[id].adverseEventReasons = updatedArray[
            id
          ].adverseEventReasons.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: false,
            reasonText: "",
          }));
          updatedArray[id].neurologicAEReasonList =
            updatedArray[id].neurologicAEReasonList.map((r) => ({
              ...r,
              isSelected: false,
              reasonUnk: false,
              reasonText: "",
            })) ?? [];
        }

        setQ382ATalvDetails(updatedArray);
        break;
      }

      case "dateStrtChangeRdTalvInt" + id: {
        let updatedArray = [...Q382ATalvDetails];

        updatedArray[id].startDoseDtRd = Number(value);
        updatedArray[id].colDError = false;
        updatedArray[id].invalidstartDateChange = false;
        updatedArray[id].startDateChangeOutOfBound = false;
        if (Number(value) == 99) {
          updatedArray[id].startDoseDt = null;
        }

        updatedArray[id].interruptionStartDateUnknownWarning = true;

        setQ382ATalvDetails(updatedArray);
        break;
      }

      case "dateEndChangeRdTalvInt" + id: {
        let updatedArray = [...Q382ATalvDetails];
        const value_int = Number(value);
        updatedArray[id].endDoseDtRd = value_int;
        updatedArray[id].colFError = false;
        updatedArray[id].invalidEndDateChange = false;
        updatedArray[id].endDateChangeOutOfBound = false;
        if (value_int !== 2) {
          updatedArray[id].endDoseDt = null;
        }
        updatedArray[id].interruptionEndDateUnknownWarning = value_int === 99;

        setQ382ATalvDetails(updatedArray);
        break;
      }

      // Column C: Reason Checkboxes
      /* ---------- Reasons for discontinuation ---------- */
      case "talv_int_reason" + id: {
        let updatedArray = [...Q382ATalvDetails];
        const row = updatedArray[id];
        updatedArray[id].colCError = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;
        const reason = row.discontinuationReasons[reaonid];
        reason.isSelected = !reason.isSelected;

        // Patient death validation
        if (
          reason.reasonName === DiscontinuationReason.PatientDeath &&
          reason.isSelected &&
          !deathDate
        ) {
          row.discontinuationSoftError = true;
        } else {
          row.discontinuationSoftError = false;
        }
        // Clear adverse events if AE unchecked
        const neuroList = row.neurologicAEReasonList ?? [];
        if (
          reason.reasonName === DiscontinuationReason.AdverseEvent &&
          !reason.isSelected
        ) {
          row.adverseEventReasons?.forEach((ae) => (ae.isSelected = false));
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        }

        if (
          reason.reasonName === DiscontinuationReason.NeurologicalEvent &&
          !reason.isSelected
        ) {
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        }

        // Clear "Other" text
        if (reason.reasonName.includes("Other") && !reason.isSelected) {
          reason.reasonText = "";
        }

        // Clear unknown
        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;

        setQ382ATalvDetails(updatedArray);
        break;
      }

      case `discont_unk_Talv_int_` + id: {
        const updatedArray = [...Q382ATalvDetails];

        updatedArray[id] = {
          ...updatedArray[id],
          colCError: false,
          reasonOtherTextEmpty: false,
          aeSubReasonEmpty: false,
          neuroReasonEmpty: false,
          neuroOtherTextEmpty: false,
          discontinuationUnkSoftError: true,
          discontinuationReasons: updatedArray[id].discontinuationReasons.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: true,
            }),
          ),
          adverseEventReasons: updatedArray[id].adverseEventReasons.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: false,
            }),
          ),
          neurologicAEReasonList: updatedArray[id].neurologicAEReasonList.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: false,
            }),
          ),
        };

        setQ382ATalvDetails(updatedArray);
        break;
      }

      case "reasonOtherText_Talv_int_" + id: {
        let updatedArray = [...Q382ATalvDetails];
        updatedArray[id].colCError = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        const row = updatedArray[id];

        const reason = row.discontinuationReasons[reaonid];
        reason.isSelected = true;
        reason.reasonText = value.length <= 300 ? value : value.slice(0, 300);

        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;

        setQ382ATalvDetails(updatedArray);
        break;
      }

      case `talv_int_adverse_` + id: {
        let updatedArray = [...Q382ATalvDetails];
        const row = updatedArray[id];
        updatedArray[id].colCError = false;
        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;

        const aeList = row.adverseEventReasons;
        if (!aeList) break;

        const reason = row.discontinuationReasons[reaonid];
        const selectedAE = aeList[aeid];

        const isAEUnknown = selectedAE.reasonName === "AE type unknown";
        const isNeuroAE =
          selectedAE.reasonName === DiscontinuationReason.NeurologicalEvent;
        const neuroList = row.neurologicAEReasonList ?? [];
        if (isAEUnknown) {
          // Radio behavior
          aeList.forEach((ae) => (ae.isSelected = false));
          selectedAE.isSelected = true;
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        } else {
          // Checkbox behavior
          aeList.forEach((ae) => {
            if (ae.reasonName === "AE type unknown") {
              ae.isSelected = false;
            }
          });
          if (isNeuroAE) {
            row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
          }
          selectedAE.isSelected = !selectedAE.isSelected;
        }

        // Keep parent selected
        reason.isSelected = true;
        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;

        setQ382ATalvDetails(updatedArray);
        break;
      }
      // ========================================
      // Q38.2.A TECHVALEY HANDLERS
      // ========================================
      case "changeInterptTypeTech" + id: {
        let updatedArray = [...Q382ATechDetails];
        updatedArray[id].changeType = Number(value);
        updatedArray[id].colBError = false;
        updatedArray[id].interruptionStartDateUnknownWarning = false;
        updatedArray[id].interruptionEndDateUnknownWarning = false;

        // Reset columns C-F if radio change selected

        if (Number(value) == 1 || Number(value) == 99) {
          setHideQ382TechAdd(true);
          updatedArray = updatedArray.slice(0, 1);
        } else {
          // If needed, show Add button for other values
          setHideQ382TechAdd(false);
        }

        // Column C
        if (Number(value) != 2) {
          updatedArray[id].selectedReasons = [];
          updatedArray[id].selectedAEReasons = [];
          updatedArray[id].reasonOtherText = "";
          updatedArray[id].colCError = false;
          updatedArray[id].aeSubReasonEmpty = false;
          updatedArray[id].neuroReasonEmpty = false;
          updatedArray[id].neuroOtherTextEmpty = false;

          updatedArray[id].invalidEndDateChange = false;
          updatedArray[id].endDateChangeOutOfBound = false;
          updatedArray[id].invalidstartDateChange = false;
          updatedArray[id].startDateChangeOutOfBound = false;

          // Column D
          updatedArray[id].startDoseDt = null;
          updatedArray[id].startDoseDtRd = null;
          updatedArray[id].endDoseDt = null;
          updatedArray[id].endDoseDtRd = null;

          updatedArray[id].reasonOtherTextEmpty = false;
          updatedArray[id].colDError = false;
          updatedArray[id].colFError = false;

          updatedArray[id].discontinuationReasons = updatedArray[
            id
          ].discontinuationReasons.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: false,
            reasonText: "",
          }));
          updatedArray[id].adverseEventReasons = updatedArray[
            id
          ].adverseEventReasons.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: false,
            reasonText: "",
          }));
          updatedArray[id].neurologicAEReasonList =
            updatedArray[id].neurologicAEReasonList.map((r) => ({
              ...r,
              isSelected: false,
              reasonUnk: false,
              reasonText: "",
            })) ?? [];
        }

        setQ382ATechDetails(updatedArray);
        break;
      }

      case "dateStrtChangeRdTechInt" + id: {
        let updatedArray = [...Q382ATechDetails];

        updatedArray[id].startDoseDtRd = Number(value);
        updatedArray[id].colDError = false;

        updatedArray[id].invalidstartDateChange = false;
        updatedArray[id].startDateChangeOutOfBound = false;

        if (Number(value) == 99) {
          updatedArray[id].startDoseDt = null;
        }
        updatedArray[id].interruptionStartDateUnknownWarning =
          Number(value) === 99;

        updatedArray[id].colDError = false;
        setQ382ATechDetails(updatedArray);
        break;
      }

      case "dateEndChangeRdTechInt" + id: {
        let updatedArray = [...Q382ATechDetails];
        updatedArray[id].endDoseDtRd = Number(value);
        updatedArray[id].colFError = false;
        updatedArray[id].invalidEndDateChange = false;
        updatedArray[id].endDateChangeOutOfBound = false;
        if (Number(value) != 2) {
          updatedArray[id].endDoseDt = null;
        }

        updatedArray[id].interruptionEndDateUnknownWarning =
          Number(value) === 99;

        updatedArray[id].colFError = false;
        setQ382ATechDetails(updatedArray);
        break;
      }

      // Column C: Reason Checkboxes
      /* ---------- Reasons for discontinuation ---------- */
      case "tech_int_reason" + id: {
        let updatedArray = [...Q382ATechDetails];
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].colCError = false;

        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;
        const row = updatedArray[id];

        const reason = row.discontinuationReasons[reaonid];
        reason.isSelected = !reason.isSelected;

        // Patient death validation
        if (
          reason.reasonName === DiscontinuationReason.PatientDeath &&
          reason.isSelected &&
          !deathDate
        ) {
          row.discontinuationSoftError = true;
        } else {
          row.discontinuationSoftError = false;
        }
        // Clear adverse events if AE unchecked

        const neuroList = row.neurologicAEReasonList ?? [];
        if (
          reason.reasonName === DiscontinuationReason.AdverseEvent &&
          !reason.isSelected
        ) {
          row.adverseEventReasons?.forEach((ae) => (ae.isSelected = false));
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        }

        if (
          reason.reasonName === DiscontinuationReason.NeurologicalEvent &&
          !reason.isSelected
        ) {
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        }

        // Clear "Other" text
        if (reason.reasonName.includes("Other") && !reason.isSelected) {
          reason.reasonText = "";
        }

        // Clear unknown
        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;

        setQ382ATechDetails(updatedArray);
        break;
      }

      case `discont_unk_Tech_int_` + id: {
        const updatedArray = [...Q382ATechDetails];

        updatedArray[id] = {
          ...updatedArray[id],
          reasonOtherTextEmpty: false,
          colCError: false,
          aeSubReasonEmpty: false,
          neuroReasonEmpty: false,
          neuroOtherTextEmpty: false,
          discontinuationUnkSoftError: true,
          discontinuationReasons: updatedArray[id].discontinuationReasons.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: true,
            }),
          ),
          adverseEventReasons: updatedArray[id].adverseEventReasons.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: false,
            }),
          ),
          neurologicAEReasonList: updatedArray[id].neurologicAEReasonList.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: false,
            }),
          ),
        };

        setQ382ATechDetails(updatedArray);
        break;
      }

      case "reasonOtherText_Tec_int_" + id: {
        let updatedArray = [...Q382ATechDetails];
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].colCError = false;
        const row = updatedArray[id];

        const reason = row.discontinuationReasons[reaonid];
        reason.isSelected = true;
        reason.reasonText = value.length <= 300 ? value : value.slice(0, 300);

        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;

        setQ382ATechDetails(updatedArray);
        break;
      }

      case `tech_int_adverse_` + id: {
        let updatedArray = [...Q382ATechDetails];
        const row = updatedArray[id];
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].colCError = false;
        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;

        const aeList = row.adverseEventReasons;
        if (!aeList) break;

        const reason = row.discontinuationReasons[reaonid];
        const selectedAE = aeList[aeid];

        const isAEUnknown = selectedAE.reasonName === "AE type unknown";
        const isNeuroAE =
          selectedAE.reasonName === DiscontinuationReason.NeurologicalEvent;
        const neuroList = row.neurologicAEReasonList ?? [];
        if (isAEUnknown) {
          // Radio behavior
          aeList.forEach((ae) => (ae.isSelected = false));
          selectedAE.isSelected = true;
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        } else {
          // Checkbox behavior
          aeList.forEach((ae) => {
            if (ae.reasonName === "AE type unknown") {
              ae.isSelected = false;
            }
          });
          if (isNeuroAE) {
            row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
          }
          selectedAE.isSelected = !selectedAE.isSelected;
        }

        // Keep parent selected
        reason.isSelected = true;
        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;

        setQ382ATechDetails(updatedArray);
        break;
      }

      //q38.1.a
      // ========================================
      // Q38.1.A TECHVALEY HANDLERS
      // ========================================

      // Column B: Type of change (Main Radio)
      case "changeTypeTech" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].changeType = Number(value);
        updatedArray[id].changeTypeEmpty = false;
        if (Number(value) == 1 || Number(value) == 99) {
          setHideQ381TechAdd(true);
          updatedArray = updatedArray.slice(0, 1);
        } else {
          // If needed, show Add button for other values
          setHideQ381TechAdd(false);
        }

        // Reset sub-radio fields
        updatedArray[id].changeTypeDoseFrequency = null;
        updatedArray[id].changeTypeDoseStrength = null;
        updatedArray[id].changeTypeDoseFrequencyEmpty = false;
        updatedArray[id].changeTypeDoseStrengthEmpty = false;

        // Reset conflict flags
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].interruptionStartDateUnknownWarning = false;
        updatedArray[id].interruptionEndDateUnknownWarning = false;

        // Reset columns C-F if radio change selected

        // Column C
        // updatedArray[id].selectedReasons = [];
        // updatedArray[id].selectedAEReasons = [];
        updatedArray[id].reasonOtherText = "";
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;

        // Column D
        updatedArray[id].patterBeforeChangeDoseFrequency = null;
        updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = "";
        updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = "";
        updatedArray[id].patterBeforeChangeDoseStrength = null;
        updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeUnknownWarning = false;

        // Column E
        updatedArray[id].patterAfterChangeDoseFrequency = null;
        updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = "";
        updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = "";
        updatedArray[id].patterAfterChangeDoseStrength = null;
        updatedArray[id].patterAfterChangeDoseStrengthMg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterUnknownWarning = false;

        // Column F
        updatedArray[id].dateChangeRd = null;
        updatedArray[id].dateChange = "";
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;

        updatedArray[id].discontinuationReasons = updatedArray[
          id
        ].discontinuationReasons.map((r) => ({
          ...r,
          isSelected: false,
          reasonUnk: false,
          reasonText: "",
        }));
        updatedArray[id].adverseEventReasons = updatedArray[
          id
        ].adverseEventReasons.map((r) => ({
          ...r,
          isSelected: false,
          reasonUnk: false,
          reasonText: "",
        }));
        updatedArray[id].neurologicAEReasonList =
          updatedArray[id].neurologicAEReasonList.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: false,
            reasonText: "",
          })) ?? [];

        setQ381ATechDetails(updatedArray);
        break;
      }

      // Column B: Frequency sub-radio (Increase/Decrease)
      case "changeTypeDoseFrequencyTech" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].changeTypeDoseFrequency = Number(value);
        updatedArray[id].changeTypeDoseFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      // Column B: Strength sub-radio (Increase/Decrease)
      case "changeTypeDoseStrengthTech" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].changeTypeDoseStrength = Number(value);
        updatedArray[id].changeTypeDoseStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      // Column C: Reason Checkboxes
      /* ---------- Reasons for discontinuation ---------- */
      case "tech_reason" + id: {
        let updatedArray = [...Q381ATechDetails];
        const row = updatedArray[id];

        const reason = row.discontinuationReasons[reaonid];
        reason.isSelected = !reason.isSelected;

        // Patient death validation
        if (
          reason.reasonName === DiscontinuationReason.PatientDeath &&
          reason.isSelected &&
          !deathDate
        ) {
          row.discontinuationSoftError = true;
        } else {
          row.discontinuationSoftError = false;
        }
        // Clear adverse events if AE unchecked
        const neuroList = row.neurologicAEReasonList ?? [];
        if (
          reason.reasonName === DiscontinuationReason.AdverseEvent &&
          !reason.isSelected
        ) {
          row.adverseEventReasons?.forEach((ae) => (ae.isSelected = false));
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        }

        if (
          reason.reasonName === DiscontinuationReason.NeurologicalEvent &&
          !reason.isSelected
        ) {
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        }
        // Clear "Other" text
        if (reason.reasonName.includes("Other") && !reason.isSelected) {
          reason.reasonText = "";
        }

        // Clear unknown
        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;

        setQ381ATechDetails(updatedArray);
        break;
      }
      case `discont_unk_` + id: {
        const updatedArray = [...Q381ATechDetails];

        updatedArray[id] = {
          ...updatedArray[id],
          discontinuationUnkSoftError: true,
          reasonEmpty: false,
          reasonOtherTextEmpty: false,
          aeSubReasonEmpty: false,
          neuroReasonEmpty: false,
          neuroOtherTextEmpty: false,
          discontinuationReasons: updatedArray[id].discontinuationReasons.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: true,
            }),
          ),
          adverseEventReasons: updatedArray[id].adverseEventReasons.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: false,
            }),
          ),
          neurologicAEReasonList: updatedArray[id].neurologicAEReasonList.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: false,
            }),
          ),
        };

        setQ381ATechDetails(updatedArray);
        break;
      }

      case "reasonOtherText_" + id: {
        let updatedArray = [...Q381ATechDetails];
        const row = updatedArray[id];

        const reason = row.discontinuationReasons[reaonid];
        reason.isSelected = true;
        reason.reasonText = value.length <= 300 ? value : value.slice(0, 300);

        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      case `tech_adverse_` + id: {
        let updatedArray = [...Q381ATechDetails];
        const row = updatedArray[id];

        const aeList = row.adverseEventReasons;
        if (!aeList) break;

        const reason = row.discontinuationReasons[reaonid];
        const selectedAE = aeList[aeid];

        const isAEUnknown = selectedAE.reasonName === "AE type unknown";
        const isNeuroAE =
          selectedAE.reasonName === DiscontinuationReason.NeurologicalEvent;
        const neuroList = row.neurologicAEReasonList ?? [];
        if (isAEUnknown) {
          // Radio behavior
          aeList.forEach((ae) => (ae.isSelected = false));
          selectedAE.isSelected = true;
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        } else {
          // Checkbox behavior
          aeList.forEach((ae) => {
            if (ae.reasonName === "AE type unknown") {
              ae.isSelected = false;
            }
          });
          if (isNeuroAE) {
            row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
          }
          selectedAE.isSelected = !selectedAE.isSelected;
        }

        // Keep parent selected
        reason.isSelected = true;
        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;
        setQ381ATechDetails(updatedArray);
        break;
      }
      // ✅ Column D: Pattern BEFORE - Frequency Radio
      case "patternBeforeFrequencyTechPerWeekRd" + id: {
        let updatedArray = [...Q381ATechDetails];

        // updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 1; // Per week
          updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = ""; // clear every week
        }

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }
      case "patternBeforeFrequencyTechPerWeekTxt" + id: {
        let updatedArray = [...Q381ATechDetails];

        updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 1; // Per week
          updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = ""; // clear every week
        }
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      // =================================
      // Pattern Before – Every X Weeks Radio
      // =================================

      case "patternBeforeFrequencyTechEveryWeekRd" + id: {
        let updatedArray = [...Q381ATechDetails];

        // updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 2; // Every X weeks
          updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = ""; // clear per week
        }

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }
      case "patternBeforeFrequencyTechEveryWeekTxt" + id: {
        let updatedArray = [...Q381ATechDetails];

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 2; // Every X weeks
          updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = value; // set textbox value
          updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = "";
        }
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      // =======================
      // Pattern BEFORE – Unknown
      // =======================
      case "patternBeforeFrequencyTechUnk" + id: {
        let updatedArray = [...Q381ATechDetails];

        updatedArray[id].patterBeforeChangeDoseFrequency = 99;
        updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = "";
        updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = "";

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;

        updatedArray[id].patternBeforeUnknownWarning = true;

        setQ381ATechDetails(updatedArray);
        break;
      }

      // =====================
      //Before Dose Strength – MG
      // =====================

      case "patternBeforeChangeDoseStrengthTechMg" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterBeforeChangeDoseStrength = 1;
        // ✅ Clear ALL text fields when radio changes

        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      case "patternBeforeChangeDoseStrengthTechMgTxt" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterBeforeChangeDoseStrength = 1;
        updatedArray[id].patterBeforeChangeDoseStrengthMg = value;
        // ✅ Clear ALL text fields when radio changes

        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;

        setQ381ATechDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern Before - mg/kg text input
      case "patternBeforeChangeDoseStrengthTechKg" + id: {
        let updatedArray = [...Q381ATechDetails];
        //updatedArray[id].patterBeforeChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 2;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        }
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }
      case "patternBeforeChangeDoseStrengthTechKgTxt" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 2;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        }
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }
      // ✅ Column E: Pattern Before - mg/kg text input
      case "patternBeforeChangeDoseStrengthTechMM" + id: {
        let updatedArray = [...Q381ATechDetails];
        //   updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 3;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        }
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }
      case "patternBeforeChangeDoseStrengthTechMMTxt" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 3;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        }
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      case "patternBeforeChangeDoseStrengthTechUnk" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterBeforeChangeDoseStrength = 99;

        updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;

        updatedArray[id].patternBeforeUnknownWarning = true;

        setQ381ATechDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - Times per week input (NEW)
      case "patternAfterFrequencyTechPerWeekRd" + id: {
        let updatedArray = [...Q381ATechDetails];

        //updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 1; // Per week
          updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = ""; // clear every week
        }

        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }
      case "patternAfterFrequencyTechPerWeekTxt" + id: {
        let updatedArray = [...Q381ATechDetails];

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 1; // Every X weeks
          updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = value; // set textbox value
          updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = "";
        }

        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }
      // =================================
      // Pattern AFTER – Every X Weeks Radio
      // =================================
      case "patternAfterFrequencyTechEveryWeekRd" + id: {
        let updatedArray = [...Q381ATechDetails];

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 2; // Every X weeks
          updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = ""; // clear per week
        }

        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      case "patternAfterFrequencyTechEveryWeekText" + id: {
        let updatedArray = [...Q381ATechDetails];

        updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 2; // Every X weeks
          updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = ""; // clear per week
        }

        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }
      // =======================
      // Pattern AFTER – Unknown
      // =======================
      case "patternAfterFrequencyTechUnk" + id: {
        let updatedArray = [...Q381ATechDetails];

        updatedArray[id].patterAfterChangeDoseFrequency = 99;
        updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = "";
        updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = "";

        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;

        updatedArray[id].patternAfterUnknownWarning = true;

        setQ381ATechDetails(updatedArray);
        break;
      }

      // =====================
      //After Dose Strength – MG
      // =====================

      case "patternAfterChangeDoseStrengthTechMg" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterAfterChangeDoseStrength = 1;
        // updatedArray[id].patterAfterChangeDoseStrengthMg = Number(value);
        // ✅ Clear ALL text fields when radio changes

        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternAfterStrengthEmpty = false;

        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      case "patternAfterChangeDoseStrengthTechMgTxt" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterAfterChangeDoseStrength = 1;
        updatedArray[id].patterAfterChangeDoseStrengthMg = value;
        // ✅ Clear ALL text fields when radio changes

        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg/kg text input
      case "patternAfterChangeDoseStrengthTechKg" + id: {
        let updatedArray = [...Q381ATechDetails];
        // updatedArray[id].patterAfterChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 2;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        }
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      case "patternAfterChangeDoseStrengthTechKgTxt" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 2;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        }
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg/kg text input
      case "patternAfterChangeDoseStrengthTechMM" + id: {
        let updatedArray = [...Q381ATechDetails];
        // updatedArray[id].patterAfterChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 3;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        }
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      case "patternAfterChangeDoseStrengthTechMMTxt" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 3;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        }
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATechDetails(updatedArray);
        break;
      }

      case "patternAfterChangeDoseStrengthTechUnk" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].patterAfterChangeDoseStrength = 99;

        updatedArray[id].patterAfterChangeDoseStrengthMg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;

        updatedArray[id].patternAfterUnknownWarning = true;

        setQ381ATechDetails(updatedArray);
        break;
      }

      // Column F: Date Radio (Date provided / Unknown)
      case "dateChangeRdTech" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].dateChangeRd = Number(value);
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;

        if (Number(value) === 99) {
          updatedArray[id].dateChange = "";
        }

        setQ381ATechDetails(updatedArray);
        break;
      }

      // ========================================
      // Q38.1.A TALVALEY HANDLERS
      // ========================================
      // Column B: Type of change (Main Radio)
      case "changeTypeTalv" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].changeType = Number(value);
        updatedArray[id].changeTypeEmpty = false;
        if (Number(value) == 1 || Number(value) == 99) {
          setHideQ381TalvAdd(true);
          updatedArray = updatedArray.slice(0, 1);
        } else {
          // If needed, show Add button for other values
          setHideQ381TalvAdd(false);
        }
        // Reset sub-radio fields
        updatedArray[id].changeTypeDoseFrequency = null;
        updatedArray[id].changeTypeDoseStrength = null;
        updatedArray[id].changeTypeDoseFrequencyEmpty = false;
        updatedArray[id].changeTypeDoseStrengthEmpty = false;

        // Reset conflict flags
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;

        // Reset columns C-F if radio change selected

        // Column C
        // updatedArray[id].selectedReasons = [];
        // updatedArray[id].selectedAEReasons = [];
        updatedArray[id].reasonOtherText = "";
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;

        // Column D
        updatedArray[id].patterBeforeChangeDoseFrequency = null;
        updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = "";
        updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = "";
        updatedArray[id].patterBeforeChangeDoseStrength = null;
        updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeUnknownWarning = false;

        // Column E
        updatedArray[id].patterAfterChangeDoseFrequency = null;
        updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = "";
        updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = "";
        updatedArray[id].patterAfterChangeDoseStrength = null;
        updatedArray[id].patterAfterChangeDoseStrengthMg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterUnknownWarning = false;

        // Column F
        updatedArray[id].dateChangeRd = null;
        updatedArray[id].dateChange = "";
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;

        updatedArray[id].discontinuationReasons = updatedArray[
          id
        ].discontinuationReasons.map((r) => ({
          ...r,
          isSelected: false,
          reasonUnk: false,
          reasonText: "",
        }));
        updatedArray[id].adverseEventReasons = updatedArray[
          id
        ].adverseEventReasons.map((r) => ({
          ...r,
          isSelected: false,
          reasonUnk: false,
          reasonText: "",
        }));
        updatedArray[id].neurologicAEReasonList =
          updatedArray[id].neurologicAEReasonList.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: false,
            reasonText: "",
          })) ?? [];

        setQ381ATalvDetails(updatedArray);
        break;
      }

      // Column B: Frequency sub-radio (Increase/Decrease)
      case "changeTypeDoseFrequencyTalv" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].changeTypeDoseFrequency = Number(value);
        updatedArray[id].changeTypeDoseFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      // Column B: Strength sub-radio (Increase/Decrease)
      case "changeTypeDoseStrengthTalv" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].changeTypeDoseStrength = Number(value);
        updatedArray[id].changeTypeDoseStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      // Column C: Reason Checkboxes
      /* ---------- Reasons for discontinuation ---------- */
      case "talv_reason" + id: {
        let updatedArray = [...Q381ATalvDetails];
        const row = updatedArray[id];

        const reason = row.discontinuationReasons[reaonid];
        reason.isSelected = !reason.isSelected;

        // Patient death validation
        if (
          reason.reasonName === DiscontinuationReason.PatientDeath &&
          reason.isSelected &&
          !deathDate
        ) {
          row.discontinuationSoftError = true;
        } else {
          row.discontinuationSoftError = false;
        }
        const neuroList = row.neurologicAEReasonList ?? [];
        // Clear adverse events if AE unchecked
        if (
          reason.reasonName === DiscontinuationReason.AdverseEvent &&
          !reason.isSelected
        ) {
          row.adverseEventReasons?.forEach((ae) => (ae.isSelected = false));
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        }

        if (
          reason.reasonName === DiscontinuationReason.NeurologicalEvent &&
          !reason.isSelected
        ) {
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        }

        // Clear "Other" text
        if (reason.reasonName.includes("Other") && !reason.isSelected) {
          reason.reasonText = "";
        }

        // Clear unknown
        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }
      case `talv_discont_unk_` + id: {
        const updatedArray = [...Q381ATalvDetails];

        updatedArray[id] = {
          ...updatedArray[id],
          discontinuationReasons: updatedArray[id].discontinuationReasons.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: true,
            }),
          ),
          adverseEventReasons: updatedArray[id].adverseEventReasons.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: false,
            }),
          ),
          neurologicAEReasonList: updatedArray[id].neurologicAEReasonList.map(
            (r) => ({
              ...r,
              isSelected: false,
              reasonText: "",
              reasonUnk: false,
            }),
          ),
          discontinuationUnkSoftError: true,
          reasonEmpty: false,
          reasonOtherTextEmpty: false,
          aeSubReasonEmpty: false,
          neuroReasonEmpty: false,
          neuroOtherTextEmpty: false,
        };

        setQ381ATalvDetails(updatedArray);
        break;
      }

      case "talv_reasonOtherText_" + id: {
        let updatedArray = [...Q381ATalvDetails];
        const row = updatedArray[id];

        const reason = row.discontinuationReasons[reaonid];
        reason.isSelected = true;
        reason.reasonText = value.length <= 300 ? value : value.slice(0, 300);

        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      case `talv_adverse_` + id: {
        let updatedArray = [...Q381ATalvDetails];
        const row = updatedArray[id];

        const aeList = row.adverseEventReasons;
        if (!aeList) break;

        const reason = row.discontinuationReasons[reaonid];
        const selectedAE = aeList[aeid];

        const isAEUnknown = selectedAE.reasonName === "AE type unknown";
        const isNeuroAE =
          selectedAE.reasonName === DiscontinuationReason.NeurologicalEvent;
        const neuroList = row.neurologicAEReasonList ?? [];
        if (isAEUnknown) {
          // Radio behavior
          aeList.forEach((ae) => (ae.isSelected = false));
          selectedAE.isSelected = true;
          row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
        } else {
          // Checkbox behavior
          aeList.forEach((ae) => {
            if (ae.reasonName === "AE type unknown") {
              ae.isSelected = false;
            }
          });
          if (isNeuroAE) {
            row.neurologicAEReasonList = resetNeurologicReasons(neuroList);
          }

          selectedAE.isSelected = !selectedAE.isSelected;
        }

        // Keep parent selected
        reason.isSelected = true;
        row.discontinuationUnkSoftError = false;
        row.discontinuationReasons[0].reasonUnk = false;
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }
      // ✅ Column D: Pattern BEFORE - Frequency Radio
      case "patternBeforeFrequencyTalvPerWeekRd" + id: {
        let updatedArray = [...Q381ATalvDetails];

        // updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 1; // Per week
          updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = ""; // clear every week
        }

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }
      case "patternBeforeFrequencyTalvPerWeekTxt" + id: {
        let updatedArray = [...Q381ATalvDetails];

        updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 1; // Per week
          updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = ""; // clear every week
        }
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      // =================================
      // Pattern Before – Every X Weeks Radio
      // =================================

      case "patternBeforeFrequencyTalvEveryWeekRd" + id: {
        let updatedArray = [...Q381ATalvDetails];

        // updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 2; // Every X weeks
          updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = ""; // clear per week
        }

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }
      case "patternBeforeFrequencyTalvEveryWeekTxt" + id: {
        let updatedArray = [...Q381ATalvDetails];

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 2; // Every X weeks
          updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = value; // set textbox value
          updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = "";
        }
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;

        setQ381ATalvDetails(updatedArray);
        break;
      }

      // =======================
      // Pattern BEFORE – Unknown
      // =======================
      case "patternBeforeFrequencyTalvUnk" + id: {
        let updatedArray = [...Q381ATalvDetails];

        updatedArray[id].patterBeforeChangeDoseFrequency = 99;
        updatedArray[id].patterBeforeChangeDoseFrequencyEveryWeek = "";
        updatedArray[id].patterBeforeChangeDoseFrequencyPerWeek = "";

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;

        updatedArray[id].patternBeforeUnknownWarning = true;

        setQ381ATalvDetails(updatedArray);
        break;
      }

      // =====================
      //Before Dose Strength – MG
      // =====================

      case "patternBeforeChangeDoseStrengthTalvMg" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterBeforeChangeDoseStrength = 1;
        // ✅ Clear ALL text fields when radio changes

        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      case "patternBeforeChangeDoseStrengthTalvMgTxt" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterBeforeChangeDoseStrength = 1;
        updatedArray[id].patterBeforeChangeDoseStrengthMg = value;
        // ✅ Clear ALL text fields when radio changes

        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern Before - mg/kg text input
      case "patternBeforeChangeDoseStrengthTalvKg" + id: {
        let updatedArray = [...Q381ATalvDetails];
        //updatedArray[id].patterBeforeChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 2;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        }
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }
      case "patternBeforeChangeDoseStrengthTalvKgTxt" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 2;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        }
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }
      // ✅ Column E: Pattern Before - mg/kg text input
      case "patternBeforeChangeDoseStrengthTalvMM" + id: {
        let updatedArray = [...Q381ATalvDetails];
        //   updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 3;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        }
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }
      case "patternBeforeChangeDoseStrengthTalvMMTxt" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 3;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        }
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      case "patternBeforeChangeDoseStrengthTalvUnk" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterBeforeChangeDoseStrength = 99;

        updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternBeforeStrengthRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeUnknownWarning = true;

        setQ381ATalvDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - Times per week input (NEW)
      case "patternAfterFrequencyTalvPerWeekRd" + id: {
        let updatedArray = [...Q381ATalvDetails];

        //updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 1; // Per week
          updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = ""; // clear every week
        }

        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;

        setQ381ATalvDetails(updatedArray);
        break;
      }
      case "patternAfterFrequencyTalvPerWeekTxt" + id: {
        let updatedArray = [...Q381ATalvDetails];

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 1; // Every X weeks
          updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = value; // set textbox value
          updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = "";
        }

        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;

        setQ381ATalvDetails(updatedArray);
        break;
      }
      // =================================
      // Pattern AFTER – Every X Weeks Radio
      // =================================
      case "patternAfterFrequencyTalvEveryWeekRd" + id: {
        let updatedArray = [...Q381ATalvDetails];

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 2; // Every X weeks
          updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = ""; // clear per week
        }

        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      case "patternAfterFrequencyTalvEveryWeekText" + id: {
        let updatedArray = [...Q381ATalvDetails];

        updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 2; // Every X weeks
          updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = ""; // clear per week
        }

        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }
      // =======================
      // Pattern AFTER – Unknown
      // =======================
      case "patternAfterFrequencyTalvUnk" + id: {
        let updatedArray = [...Q381ATalvDetails];

        updatedArray[id].patterAfterChangeDoseFrequency = 99;
        updatedArray[id].patterAfterChangeDoseFrequencyEveryWeek = "";
        updatedArray[id].patterAfterChangeDoseFrequencyPerWeek = "";

        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;

        updatedArray[id].patternAfterUnknownWarning = true;

        setQ381ATalvDetails(updatedArray);
        break;
      }

      // =====================
      //After Dose Strength – MG
      // =====================

      case "patternAfterChangeDoseStrengthTalvMg" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterAfterChangeDoseStrength = 1;
        // updatedArray[id].patterAfterChangeDoseStrengthMg = Number(value);
        // ✅ Clear ALL text fields when radio changes

        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternAfterStrengthEmpty = false;

        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      case "patternAfterChangeDoseStrengthTalvMgTxt" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterAfterChangeDoseStrength = 1;
        updatedArray[id].patterAfterChangeDoseStrengthMg = value;
        // ✅ Clear ALL text fields when radio changes

        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg/kg text input
      case "patternAfterChangeDoseStrengthTalvKg" + id: {
        let updatedArray = [...Q381ATalvDetails];
        // updatedArray[id].patterAfterChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 2;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        }
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      case "patternAfterChangeDoseStrengthTalvKgTxt" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 2;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        }
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg/kg text input
      case "patternAfterChangeDoseStrengthTalvMM" + id: {
        let updatedArray = [...Q381ATalvDetails];
        // updatedArray[id].patterAfterChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 3;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        }
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      case "patternAfterChangeDoseStrengthTalvMMTxt" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 3;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        }
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ATalvDetails(updatedArray);
        break;
      }

      case "patternAfterChangeDoseStrengthTalvUnk" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].patterAfterChangeDoseStrength = 99;

        updatedArray[id].patterAfterChangeDoseStrengthMg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;

        updatedArray[id].patternAfterUnknownWarning = true;

        setQ381ATalvDetails(updatedArray);
        break;
      }

      // Column F: Date Radio (Date provided / Unknown)
      case "dateChangeRdTalv" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].dateChangeRd = Number(value);
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;

        if (Number(value) === 99) {
          updatedArray[id].dateChange = "";
        }

        setQ381ATalvDetails(updatedArray);
        break;
      }

      // Techvayli

      case "dose_administration_tech" + id: {
        let updatedArray = [...techvayliDetails];

        updatedArray[id].dose_administration_tech = value_int;
        updatedArray[id].dose_administration_tech_dt = "";

        updatedArray[id].dose_administration_techHard = false;

        updatedArray[id].dose_administration_techHard_dt = false;
        updatedArray[id].Invalid_dose_administration_tech_dt = false;
        updatedArray[id].dose_administration_tech_dt_before_eof = false;
        // updatedArray[id].dt_tech_greater_prevCheck = false;
        updatedArray[id].dt_tech_date_out_of_bound = false;
        // if(updatedArray[id].dose_administration_tech===99){
        // }
        setIndexDateRRMM_techHard(false);
        setTechvayliDetails(updatedArray);
        setDateRRMMTec_dupDateHard(false);
        setDt_tec_2L_3L_date_conditions(false);
        setIsTecLastAdminDateValid(true);
        break;
      }

      case "dosing_phase_tech" + id: {
        let updatedArray = [...techvayliDetails];
        // let UpdateArrayCondition = [...Q37TechDetails];

        updatedArray[id].dosing_phase_tech = value_int;

        updatedArray[id].dosing_phase_techHard = false;
        updatedArray[id].dosing_phase_oth_txt_tech = "";
        updatedArray[id].dosing_phase_techHard_othEmpty = false;

        if (
          (value_int === 1 || value_int === 2 || value_int === 3) &&
          (updatedArray[id].siteofcare_tech === 1 ||
            updatedArray[id].siteofcare_tech === 3)
        ) {
          updatedArray[id].Q36TechConditionMet = true;
        } else {
          updatedArray[id].Q36TechConditionMet = false;
        }

        let updatedArrayQ37 = [...Q37TechDetails];
        if (techvayliDetails.some((item) => item.dosing_phase_tech != 4)) {
          updatedArrayQ37[0].q37_Tec_Dose_week_frquencyRd = null;
          updatedArrayQ37[0].q37_Tec_Dose_week_frquency_txt = "";
          updatedArrayQ37[0].q37_Tec_Dose_week_frquencyRd_Empty = false;
          updatedArrayQ37[0].q37_Tec_Dose_week_frquency_txt_Empty = false;
          updatedArrayQ37[0].q37TecDoseWeekFrequencyRangeError = false;
        }
        setQ37TechDetails(updatedArrayQ37);
        setTechvayliDetails(updatedArray);
        setAtleastonesetupTec_WarningHard(false);

        const setups = techvayliDetails
          .map((r) => r.dosing_phase_tech)
          .filter((v) => v != null && v !== 4);
        const hasDuplicateSetups = new Set(setups).size !== setups.length;
        setSetupTec_WarningHard(hasDuplicateSetups);

        const allAreThree = setups.length > 0 && setups.every((v) => v === 3);
        setNosetupTec_WarningHard(allAreThree);

        // setQ37TechDetails(UpdateArrayCondition);
        break;
      }

      case "dosing_phase_oth_txt_tech" + id: {
        let updatedArray = [...techvayliDetails];

        updatedArray[id].dosing_phase_oth_txt_tech = value;
        updatedArray[id].dosing_phase_tech = 5;

        updatedArray[id].dosing_phase_techHard = false;
        updatedArray[id].dosing_phase_techHard_othEmpty = false;

        setTechvayliDetails(updatedArray);
        break;
      }

      case "tech_dose_strength_mg_kg" + id: {
        let updatedArray = [...techvayliDetails];

        updatedArray[id].tech_dose_strength_mg = "";
        updatedArray[id].tech_dose_strength_mg_kg = value;
        updatedArray[id].tech_dose_strength_mgm = "";
        updatedArray[id].tech_dose_strength_rbl = 2;
        updatedArray[id].tech_dose_strength_mg_kgHard = false;
        updatedArray[id].tech_dose_strength_mg_kgRange = false;

        setTechvayliDetails(updatedArray);
        break;
      }
      case "tech_dose_strength_mg" + id: {
        let updatedArray = [...techvayliDetails];
        updatedArray[id].tech_dose_strength_mg = value;
        updatedArray[id].tech_dose_strength_mg_kg = "";
        updatedArray[id].tech_dose_strength_mgm = "";
        updatedArray[id].tech_dose_strength_rbl = 1;
        updatedArray[id].tech_dose_strength_mg_kgHard = false;
        updatedArray[id].tech_dose_strength_mg_kgRange = false;
        setTechvayliDetails(updatedArray);
        break;
      }
      case "tech_dose_strength_mgm" + id: {
        let updatedArray = [...techvayliDetails];
        updatedArray[id].tech_dose_strength_mg = "";
        updatedArray[id].tech_dose_strength_mg_kg = "";
        updatedArray[id].tech_dose_strength_mgm = value;
        updatedArray[id].tech_dose_strength_rbl = 3;
        updatedArray[id].tech_dose_strength_mg_kgHard = false;
        updatedArray[id].tech_dose_strength_mg_kgRange = false;
        setTechvayliDetails(updatedArray);
        break;
      }
      case "tech_dose_strength_rbl" + id: {
        let updatedArray = [...techvayliDetails];
        updatedArray[id].tech_dose_strength_rbl = Number(value);
        updatedArray[id].tech_dose_strength_mg = "";
        updatedArray[id].tech_dose_strength_mg_kg = "";
        updatedArray[id].tech_dose_strength_mgm = "";
        updatedArray[id].tech_dose_strength_mg_kgHard = false;
        updatedArray[id].tech_dose_strength_mg_kgRange = false;
        setTechvayliDetails(updatedArray);
        break;
      }

      case "siteofcare_tech" + id: {
        let updatedArray = [...techvayliDetails];

        updatedArray[id].siteofcare_tech = value_int;

        updatedArray[id].siteofcare_techHard = false;

        // if (
        //   (value_int === 1 || value_int === 3) &&
        //   (updatedArray[id].dosing_phase_tech === 1 ||
        //     updatedArray[id].dosing_phase_tech === 2 ||
        //     updatedArray[id].dosing_phase_tech === 3)
        // ) {
        //   updatedArray[id].Q36TechConditionMet = true;
        // } else {
        //   updatedArray[id].Q36TechConditionMet = false;
        // }

        if (value_int === 2) {
          // updatedArray[id].dt_admission_tech = null;
          // updatedArray[id].dt_discharge_tech = null;
          updatedArray[id].dt_admission_tech_dt = null;
          updatedArray[id].dt_discharge_tech_dt = null;

          updatedArray[id].dt_discharge_techHard = false;
          updatedArray[id].dt_discharge_techHard_dt = false;
          updatedArray[id].dt_discharge_techHard_dt_check = false;
          updatedArray[id].dt_admission_techHard = false;
          updatedArray[id].dt_admission_techHard_dt = false;
          updatedArray[id].dt_admission_techHard_dt_check = false;
        }

        setTechvayliDetails(updatedArray);
        setAtleastonesetupTec_WarningHard(false);
        break;
      }

      //36.1 start
      //B
      case "dt_admission_tec" + id: {
        let updatedArray = [...tecHospDetails];

        updatedArray[id].dt_admission = value_int;
        updatedArray[id].dt_admission_dt = "";

        updatedArray[id].dt_admission_Hard = false;
        updatedArray[id].dt_admission_Hard_dt = false;
        updatedArray[id].Invalid_admission_Hard_dt = false;
        updatedArray[id].dt_admission_before_eof = false;
        updatedArray[id].dt_admission_out_of_bound = false;

        //Delete rows if "Patient had no hospitalizations during the step-up dosing phase" is selected
        //and Reset columns C n D of current row
        if (value_int === 2) {
          updatedArray[id].dt_discharge = null;
          updatedArray[id].dt_discharge_dt = "";
          updatedArray[id].dt_discharge_Hard = false;
          updatedArray[id].dt_discharge_Hard_dt = false;
          updatedArray[id].dt_discharge_Hard_dt_check = false;
          updatedArray[id].dt_discharge_out_of_bound = false;
          updatedArray[id].Invalid_dt_discharge_Hard = false;
          updatedArray[id].dt_discharge_before_eof = false;
          updatedArray[id].dateRangeThirty = false;
          updatedArray[id].dischargeMoreThanAdministrationWarning = false;

          updatedArray[id].hospReason1 = false;
          updatedArray[id].hospReason2 = false;
          updatedArray[id].hospReason3 = false;
          updatedArray[id].hospReason4 = false;
          updatedArray[id].hospReason5 = false;
          updatedArray[id].hospReason6 = false;
          updatedArray[id].hosp_reason_oth_txt = "";
          updatedArray[id].hospReasonUnk = false;
          updatedArray[id].hospReasonEmptyHard = false;
          updatedArray[id].hospReasonTxtEmpty = false;

          const deleteStartIndex = Number(id) + 1;
          if (deleteStartIndex >= 0 && deleteStartIndex < updatedArray.length) {
            updatedArray.splice(
              deleteStartIndex,
              updatedArray.length - deleteStartIndex,
            );
          }
        }
        setTecHospDetails(updatedArray);
        setAtleastonesetupTec_WarningHard(false);

        break;
      }
      //C
      case "dt_discharge_tec" + id: {
        let updatedArray = [...tecHospDetails];

        updatedArray[id].dt_discharge = value_int;
        updatedArray[id].dt_discharge_dt = "";
        updatedArray[id].Invalid_dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_before_eof = false;
        updatedArray[id].dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_Hard_dt = false;
        updatedArray[id].dt_discharge_Hard_dt_check = false;
        updatedArray[id].dt_discharge_out_of_bound = false;
        updatedArray[id].dateRangeThirty = false;
        updatedArray[id].dischargeMoreThanAdministrationWarning = false;

        setTecHospDetails(updatedArray);
        break;
      }
      //D
      case "hospReason1_tec" + id:
      case "hospReason2_tec" + id:
      case "hospReason3_tec" + id:
      case "hospReason4_tec" + id:
      case "hospReason5_tec" + id: {
        let updatedArray = [...tecHospDetails];

        const ctrlId = name.split("_")[0];

        updatedArray[id][ctrlId] = !updatedArray[id][ctrlId];
        updatedArray[id].hosp_reason_oth_txt = "";
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setTecHospDetails(updatedArray);
        break;
      }
      case "hospReason6_tec" + id: {
        let updatedArray = [...tecHospDetails];

        updatedArray[id].hospReason6 = !updatedArray[id].hospReason6;
        updatedArray[id].hosp_reason_oth_txt = "";
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setTecHospDetails(updatedArray);
        break;
      }
      case "hosp_reason_oth_txt_tec" + id: {
        let updatedArray = [...tecHospDetails];

        updatedArray[id].hosp_reason_oth_txt = value;
        updatedArray[id].hospReason6 = true;
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setTecHospDetails(updatedArray);
        break;
      }
      case "hospReasonUnk_tec" + id: {
        let updatedArray = [...tecHospDetails];

        updatedArray[id].hospReasonUnk = true;
        updatedArray[id].hospReason1 = false;
        updatedArray[id].hospReason2 = false;
        updatedArray[id].hospReason3 = false;
        updatedArray[id].hospReason4 = false;
        updatedArray[id].hospReason5 = false;
        updatedArray[id].hospReason6 = false;
        updatedArray[id].hosp_reason_oth_txt = "";

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setTecHospDetails(updatedArray);
        break;
      }
      //end

      //TALVEY
      case "dose_administration_tal" + id: {
        let updatedArray = [...talveyDetails];

        updatedArray[id].dose_administration_tal = value_int;
        updatedArray[id].dose_administration_tal_dt = "";

        updatedArray[id].dose_administration_talHard = false;
        updatedArray[id].Invalid_dose_administration_tal_dt = false;

        updatedArray[id].dose_administration_talHard_dt = false;

        // updatedArray[id].dt_tal_greater_prevCheck = false;
        updatedArray[id].dt_tal_date_out_of_bound = false;

        setIndexDateRRMM_talHard(false);
        setDateRRMMTal_dupDateHard(false);
        setDt_tal_2L_3L_date_conditions(false);
        setIsTalLastAdminDateValid(true);
        setTalveyDetails(updatedArray);

        break;
      }

      case "dosing_phase_tal" + id: {
        let updatedArray = [...talveyDetails];
        // let UpdateArrayCondition = [...Q37TalDetails];

        updatedArray[id].dosing_phase_tal = value_int;
        updatedArray[id].dosing_phase_talHard_othEmpty = false;

        updatedArray[id].dosing_phase_talHard = false;
        updatedArray[id].dosing_phase_oth_txt_tal = "";

        let updatedArrayQ37 = [...Q37TalDetails];
        if (talveyDetails.some((item) => item.dosing_phase_tal != 5)) {
          updatedArrayQ37[0].q37_Tal_Dose_week_frquencyRd = null;
          updatedArrayQ37[0].q37_Tal_Dose_week_frquency_txt = "";
          updatedArrayQ37[0].q37_Tal_Dose_week_frquencyRd_Empty = false;
          updatedArrayQ37[0].q37_Tal_Dose_week_frquency_txt_Empty = false;
          updatedArrayQ37[0].q37TalDoseWeekFrequencyRangeError = false;
        }

        setQ37TalDetails(updatedArrayQ37);
        setTalveyDetails(updatedArray);
        setAtleastonesetupTal_WarningHard(false);

        const setups = talveyDetails
          .map((r) => r.dosing_phase_tal)
          .filter((v) => v != null && v !== 5);
        const hasDuplicateSetups = new Set(setups).size !== setups.length;
        setSetupTal_WarningHard(hasDuplicateSetups);
        const allAreFour = setups.length > 0 && setups.every((v) => v === 4);

        setNosetupTal_WarningHard(allAreFour);

        break;
      }

      case "dosing_phase_oth_txt_tal" + id: {
        let updatedArray = [...talveyDetails];

        updatedArray[id].dosing_phase_oth_txt_tal = value;
        updatedArray[id].dosing_phase_tal = 6;
        updatedArray[id].dosing_phase_talHard = false;
        updatedArray[id].dosing_phase_talHard_othEmpty = false;

        setTalveyDetails(updatedArray);
        break;
      }

      case "tal_dose_strength_mg_kg" + id: {
        let updatedArray = [...talveyDetails];

        updatedArray[id].tal_dose_strength_mg = "";
        updatedArray[id].tal_dose_strength_mg_kg = value;
        updatedArray[id].tal_dose_strength_mgm = "";
        updatedArray[id].tal_dose_strength_rbl = 2;
        updatedArray[id].tal_dose_strength_mg_kgHard = false;
        updatedArray[id].tal_dose_strength_mg_kgRange = false;

        setTalveyDetails(updatedArray);
        break;
      }
      case "tal_dose_strength_mg" + id: {
        let updatedArray = [...talveyDetails];
        updatedArray[id].tal_dose_strength_mg = value;
        updatedArray[id].tal_dose_strength_mg_kg = "";
        updatedArray[id].tal_dose_strength_mgm = "";
        updatedArray[id].tal_dose_strength_rbl = 1;
        updatedArray[id].tal_dose_strength_mg_kgHard = false;
        updatedArray[id].tal_dose_strength_mg_kgRange = false;
        setTalveyDetails(updatedArray);
        break;
      }
      case "tal_dose_strength_mgm" + id: {
        let updatedArray = [...talveyDetails];
        updatedArray[id].tal_dose_strength_mg = "";
        updatedArray[id].tal_dose_strength_mg_kg = "";
        updatedArray[id].tal_dose_strength_mgm = value;
        updatedArray[id].tal_dose_strength_rbl = 3;
        updatedArray[id].tal_dose_strength_mg_kgHard = false;
        updatedArray[id].tal_dose_strength_mg_kgRange = false;
        setTalveyDetails(updatedArray);
        break;
      }
      case "tal_dose_strength_rbl" + id: {
        let updatedArray = [...talveyDetails];
        updatedArray[id].tal_dose_strength_rbl = Number(value);
        updatedArray[id].tal_dose_strength_mg = "";
        updatedArray[id].tal_dose_strength_mg_kg = "";
        updatedArray[id].tal_dose_strength_mgm = "";
        updatedArray[id].tal_dose_strength_mg_kgHard = false;
        updatedArray[id].tal_dose_strength_mg_kgRange = false;
        setTalveyDetails(updatedArray);
        break;
      }

      case "siteofcare_tal" + id: {
        let updatedArray = [...talveyDetails];

        updatedArray[id].siteofcare_tal = value_int;

        updatedArray[id].siteofcare_talHard = false;

        // if (
        //   (value_int == 1 || value_int === 3) &&
        //   (updatedArray[id].dosing_phase_tal === 1 ||
        //     updatedArray[id].dosing_phase_tal === 2 ||
        //     updatedArray[id].dosing_phase_tal === 3 ||
        //     updatedArray[id].dosing_phase_tal === 4)
        // ) {
        //   updatedArray[id].Q36TalConditionMet = true;
        // } else {
        //   updatedArray[id].Q36TalConditionMet = false;
        // }

        if (value_int === 2) {
          //updatedArray[id].dt_admission_tal = null;
          //updatedArray[id].dt_discharge_tal = null;
          updatedArray[id].dt_admission_tal_dt = null;
          updatedArray[id].dt_discharge_tal_dt = null;

          updatedArray[id].dt_discharge_talHard = false;
          updatedArray[id].dt_discharge_talHard_dt = false;
          updatedArray[id].dt_discharge_talHard_dt_check = false;
          updatedArray[id].dt_admission_talHard = false;
          updatedArray[id].dt_admission_talHard_dt = false;
          updatedArray[id].dt_admission_talHard_dt_check = false;
        }

        setTalveyDetails(updatedArray);
        setAtleastonesetupTal_WarningHard(false);
        break;
      }

      //36.1 start
      //B
      case "dt_admission_tal" + id: {
        let updatedArray = [...talHospDetails];

        updatedArray[id].dt_admission = value_int;
        updatedArray[id].dt_admission_dt = "";

        updatedArray[id].dt_admission_Hard = false;
        updatedArray[id].Invalid_admission_Hard_dt = false;
        updatedArray[id].dt_admission_before_eof = false;
        updatedArray[id].dt_admission_Hard_dt = false;
        // updatedArray[id].dt_admission_Hard_dt_check = false;
        updatedArray[id].dt_admission_out_of_bound = false;

        //Delete rows if "Patient had no hospitalizations during the step-up dosing phase" is selected
        //and Reset columns C n D of current row
        if (value_int === 2) {
          updatedArray[id].dt_discharge = null;
          updatedArray[id].dt_discharge_dt = "";
          updatedArray[id].dt_discharge_Hard = false;
          updatedArray[id].dt_discharge_Hard_dt = false;
          updatedArray[id].dt_discharge_Hard_dt_check = false;
          updatedArray[id].dt_discharge_out_of_bound = false;
          updatedArray[id].Invalid_dt_discharge_Hard = false;
          updatedArray[id].dt_discharge_before_eof = false;
          updatedArray[id].dateRangeThirty = false;
          updatedArray[id].dischargeMoreThanAdministrationWarning = false;

          updatedArray[id].hospReason1 = false;
          updatedArray[id].hospReason2 = false;
          updatedArray[id].hospReason3 = false;
          updatedArray[id].hospReason4 = false;
          updatedArray[id].hospReason5 = false;
          updatedArray[id].hospReason6 = false;
          updatedArray[id].hosp_reason_oth_txt = "";
          updatedArray[id].hospReasonUnk = false;
          updatedArray[id].hospReasonEmptyHard = false;
          updatedArray[id].hospReasonTxtEmpty = false;

          const deleteStartIndex = Number(id) + 1;
          if (deleteStartIndex >= 0 && deleteStartIndex < updatedArray.length) {
            updatedArray.splice(
              deleteStartIndex,
              updatedArray.length - deleteStartIndex,
            );
          }
        }
        setTalHospDetails(updatedArray);
        setAtleastonesetupTal_WarningHard(false);
        break;
      }
      //C
      case "dt_discharge_tal" + id: {
        let updatedArray = [...talHospDetails];

        updatedArray[id].dt_discharge = value_int;
        updatedArray[id].dt_discharge_dt = "";

        updatedArray[id].dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_Hard_dt = false;
        updatedArray[id].dt_discharge_Hard_dt_check = false;
        updatedArray[id].dt_discharge_out_of_bound = false;
        updatedArray[id].Invalid_dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_before_eof = false;
        updatedArray[id].dateRangeThirty = false;
        updatedArray[id].dischargeMoreThanAdministrationWarning = false;

        setTalHospDetails(updatedArray);
        break;
      }
      case "hospReason1_tal" + id:
      case "hospReason2_tal" + id:
      case "hospReason3_tal" + id:
      case "hospReason4_tal" + id:
      case "hospReason5_tal" + id: {
        let updatedArray = [...talHospDetails];

        const ctrlId = name.split("_")[0];

        updatedArray[id][ctrlId] = !updatedArray[id][ctrlId];
        updatedArray[id].hosp_reason_oth_txt = "";
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setTalHospDetails(updatedArray);
        break;
      }
      case "hospReason6_tal" + id: {
        let updatedArray = [...talHospDetails];

        updatedArray[id].hospReason6 = !updatedArray[id].hospReason6;
        updatedArray[id].hosp_reason_oth_txt = "";
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setTalHospDetails(updatedArray);
        break;
      }
      case "hosp_reason_oth_txt_tal" + id: {
        let updatedArray = [...talHospDetails];

        updatedArray[id].hosp_reason_oth_txt = value;
        updatedArray[id].hospReason6 = true;
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setTalHospDetails(updatedArray);
        break;
      }
      case "hospReasonUnk_tal" + id: {
        let updatedArray = [...talHospDetails];

        updatedArray[id].hospReasonUnk = true;
        updatedArray[id].hospReason1 = false;
        updatedArray[id].hospReason2 = false;
        updatedArray[id].hospReason3 = false;
        updatedArray[id].hospReason4 = false;
        updatedArray[id].hospReason5 = false;
        updatedArray[id].hospReason6 = false;
        updatedArray[id].hosp_reason_oth_txt = "";

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setTalHospDetails(updatedArray);
        break;
      }
      //end
      //Q38 Tech radio
      case "Q38TechvayliRd" + id: {
        let updatedArray = [...Q38TechDetails];

        updatedArray[id].Q38TechvayliRd = value_int;
        updatedArray[id].dt_dosefreq_tech_dt = "";

        updatedArray[id].Q38TechEmptyHard = false;
        updatedArray[id].Invalid_dt_dosefreq_tech_dt = false;

        updatedArray[id].Q38DateEmpty = false;
        updatedArray[id].Q38TechDateInvalid = false;
        setQ38TechDetails(updatedArray);
        break;
      }

      //Q38Talvey
      case "Q38TalveyRd" + id: {
        let updatedArray = [...Q38TalDetails];

        updatedArray[id].Q38TalveyRd = value_int;
        updatedArray[id].dt_dosefreq_tal_dt = "";

        // updatedArray[id].dt_discharge_talHard = false;
        updatedArray[id].Q38TalEmptyHard = false;
        updatedArray[id].Q38TalDateEmpty = false;
        updatedArray[id].Q38TalDateInvalid = false;
        updatedArray[id].InvalidQ38Talveydate = false;
        setQ38TalDetails(updatedArray);
        break;
      }

      //Q38 Tech for frequency dosage
      case "q38_Tec_Dose_week_frquencyRd" + id: {
        let updatedArray = [...Q38TechDetails];

        updatedArray[id].q38_Tec_Dose_week_frquencyRd = Number(value);
        updatedArray[id].q38_Tec_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q38_Tec_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q38_Tec_Dose_week_frquency_txt = "";
        setQ38TechDetails(updatedArray);
        break;
      }

      case "q38_Tec_Dose_week_frquency_txt" + id: {
        let updatedArray = [...Q38TechDetails];

        const reqValue = value;
        updatedArray[id].q38_Tec_Dose_week_frquency_txt = reqValue;
        updatedArray[id].q38_Tec_Dose_week_frquencyRd = 1;
        updatedArray[id].q38_Tec_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q38_Tec_Dose_week_frquency_txt_Empty = false;

        setQ38TechDetails(updatedArray);
        break;
      }

      case "q38_Tal_Dose_week_frquencyRd" + id: {
        let updatedArray = [...Q38TalDetails];

        updatedArray[id].q38_Tal_Dose_week_frquencyRd = Number(value);
        updatedArray[id].q38_Tal_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q38_Tal_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q38_Tal_Dose_week_frquency_txt = "";

        setQ38TalDetails(updatedArray);
        break;
      }

      case "q38_Tal_Dose_week_frquency_txt" + id: {
        let updatedArray = [...Q38TalDetails];

        const reqValue = value;
        updatedArray[id].q38_Tal_Dose_week_frquency_txt = reqValue;
        updatedArray[id].q38_Tal_Dose_week_frquencyRd = 1;
        updatedArray[id].q38_Tal_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q38_Tal_Dose_week_frquency_txt_Empty = false;

        setQ38TalDetails(updatedArray);
        break;
      }

      case "q38_Tal_Dosage_Rd" + id: {
        let updatedArray = [...Q38TalDetails];

        updatedArray[id].q38_Tal_Dosage_Rd = Number(value);
        updatedArray[id].q38_Tal_Dosage_OtherTxt = "";
        updatedArray[id].q38_Tal_Dosage_Rd_Empty = false;
        updatedArray[id].q38_Tal_Dosage_OtherTxt_Empty = false;

        setQ38TalDetails(updatedArray);
        break;
      }

      case "q38_Tal_Dosage_OtherTxt" + id: {
        let updatedArray = [...Q38TalDetails];

        const reqValue = value;
        updatedArray[id].q38_Tal_Dosage_Rd = 3;
        updatedArray[id].q38_Tal_Dosage_OtherTxt = reqValue;
        updatedArray[id].q38_Tal_Dosage_Rd_Empty = false;
        updatedArray[id].q38_Tal_Dosage_OtherTxt_Empty = false;

        setQ38TalDetails(updatedArray);
        break;
      }

      //39.1.A -- TECVAYLI

      case "primaryProphylacticCrs_tech" + id: {
        let updatedArray = [...q391ATechTocilzumabList];
        updatedArray[id].primaryProphylacticCrs_tech =
          !updatedArray[id].primaryProphylacticCrs_tech;

        updatedArray[id].medicationReasonUnk_tech = false;

        updatedArray[id].q39TechReasonEmpty = false;
        setQ391ATechTocilzumabList(updatedArray);
        break;
      }

      case "secondaryProphylacticCrs_tech" + id: {
        let updatedArray = [...q391ATechTocilzumabList];
        updatedArray[id].secondaryProphylacticCrs_tech =
          !updatedArray[id].secondaryProphylacticCrs_tech;
        updatedArray[id].medicationReasonUnk_tech = false;
        updatedArray[id].q39TechReasonEmpty = false;
        setQ391ATechTocilzumabList(updatedArray);
        break;
      }

      case "supportiveCareCrs_tech" + id: {
        let updatedArray = [...q391ATechTocilzumabList];
        updatedArray[id].supportiveCareCrs_tech =
          !updatedArray[id].supportiveCareCrs_tech;
        updatedArray[id].q39TechReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_tech = false;

        setQ391ATechTocilzumabList(updatedArray);
        break;
      }

      case "primaryProphylacticNeurologic_tech" + id: {
        let updatedArray = [...q391ATechTocilzumabList];
        updatedArray[id].primaryProphylacticNeurologic_tech =
          !updatedArray[id].primaryProphylacticNeurologic_tech;
        updatedArray[id].q39TechReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_tech = false;

        setQ391ATechTocilzumabList(updatedArray);
        break;
      }

      case "secondaryProphylacticNeurologic_tech" + id: {
        let updatedArray = [...q391ATechTocilzumabList];
        updatedArray[id].secondaryProphylacticNeurologic_tech =
          !updatedArray[id].secondaryProphylacticNeurologic_tech;
        updatedArray[id].q39TechReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_tech = false;
        setQ391ATechTocilzumabList(updatedArray);
        break;
      }

      case "supportiveCareNeurologic_tech" + id: {
        let updatedArray = [...q391ATechTocilzumabList];
        updatedArray[id].supportiveCareNeurologic_tech =
          !updatedArray[id].supportiveCareNeurologic_tech;
        updatedArray[id].q39TechReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_tech = false;
        setQ391ATechTocilzumabList(updatedArray);
        break;
      }

      case "medicationReasonUnk_tech" + id: {
        let updatedArray = [...q391ATechTocilzumabList];
        updatedArray[id].medicationReasonUnk_tech =
          !updatedArray[id].medicationReasonUnk_tech;
        updatedArray[id].q39TechReasonEmpty = false;

        updatedArray[id].supportiveCareCrs_tech = false;
        updatedArray[id].primaryProphylacticCrs_tech = false;
        updatedArray[id].secondaryProphylacticNeurologic_tech = false;
        updatedArray[id].secondaryProphylacticCrs_tech = false;
        updatedArray[id].supportiveCareNeurologic_tech = false;
        updatedArray[id].primaryProphylacticNeurologic_tech = false;
        setQ391ATechTocilzumabList(updatedArray);
        break;
      }

      case "administrationDateRD_tech" + id: {
        let updatedArray = [...q391ATechTocilzumabList];

        updatedArray[id].administrationDateRD_tech = value_int;
        updatedArray[id].administrationDate_tech = "";

        updatedArray[id].q39TechAdministrationDateEmpty = false;
        updatedArray[id].q39TechAdministrationRDEmpty = false;
        updatedArray[id].q39TechInvalidAdministrationDate = false;
        setQ391ATechAdministrationDateOutOfRange(false);

        setQ391ATechTocilzumabList(updatedArray);
        break;
      }

      //39.1.A -- linvo

      case "primaryProphylacticCrs_tal" + id: {
        let updatedArray = [...q391ATalTocilzumabList];
        updatedArray[id].primaryProphylacticCrs_tal =
          !updatedArray[id].primaryProphylacticCrs_tal;

        updatedArray[id].q39TalReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_tal = false;

        setQ391ATalTocilzumabList(updatedArray);
        break;
      }

      case "secondaryProphylacticCrs_tal" + id: {
        let updatedArray = [...q391ATalTocilzumabList];
        updatedArray[id].secondaryProphylacticCrs_tal =
          !updatedArray[id].secondaryProphylacticCrs_tal;

        updatedArray[id].q39TalReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_tal = false;

        setQ391ATalTocilzumabList(updatedArray);
        break;
      }

      case "supportiveCareCrs_tal" + id: {
        let updatedArray = [...q391ATalTocilzumabList];
        updatedArray[id].supportiveCareCrs_tal =
          !updatedArray[id].supportiveCareCrs_tal;

        updatedArray[id].medicationReasonUnk_tal = false;

        updatedArray[id].q39TalReasonEmpty = false;
        setQ391ATalTocilzumabList(updatedArray);
        break;
      }

      case "primaryProphylacticNeurologic_tal" + id: {
        let updatedArray = [...q391ATalTocilzumabList];
        updatedArray[id].primaryProphylacticNeurologic_tal =
          !updatedArray[id].primaryProphylacticNeurologic_tal;
        updatedArray[id].q39TalReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_tal = false;

        setQ391ATalTocilzumabList(updatedArray);
        break;
      }

      case "secondaryProphylacticNeurologic_tal" + id: {
        let updatedArray = [...q391ATalTocilzumabList];
        updatedArray[id].secondaryProphylacticNeurologic_tal =
          !updatedArray[id].secondaryProphylacticNeurologic_tal;
        updatedArray[id].q39TalReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_tal = false;

        setQ391ATalTocilzumabList(updatedArray);
        break;
      }

      case "supportiveCareNeurologic_tal" + id: {
        let updatedArray = [...q391ATalTocilzumabList];
        updatedArray[id].supportiveCareNeurologic_tal =
          !updatedArray[id].supportiveCareNeurologic_tal;
        updatedArray[id].q39TalReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_tal = false;
        setQ391ATalTocilzumabList(updatedArray);
        break;
      }

      case "medicationReasonUnk_tal" + id: {
        let updatedArray = [...q391ATalTocilzumabList];
        updatedArray[id].medicationReasonUnk_tal =
          !updatedArray[id].medicationReasonUnk_tal;
        updatedArray[id].q39TalReasonEmpty = false;

        updatedArray[id].supportiveCareNeurologic_tal = false;
        updatedArray[id].primaryProphylacticCrs_tal = false;
        updatedArray[id].secondaryProphylacticCrs_tal = false;
        updatedArray[id].secondaryProphylacticNeurologic_tal = false;

        updatedArray[id].primaryProphylacticNeurologic_tal = false;
        updatedArray[id].supportiveCareCrs_tal = false;
        setQ391ATalTocilzumabList(updatedArray);
        break;
      }

      case "administrationDateRD_tal" + id: {
        let updatedArray = [...q391ATalTocilzumabList];

        updatedArray[id].administrationDateRD_tal = value_int;
        updatedArray[id].administrationDate_tal = "";

        updatedArray[id].q39TalInvalidAdministrationDate = false;
        updatedArray[id].q39TalAdministrationDateEmpty = false;
        updatedArray[id].q39TalAdministrationRDEmpty = false;
        setQ391ATalAdministrationDateOutOfRange(false);
        setQ391ATalTocilzumabList(updatedArray);
        break;
      }

      default:
        break;
    }
  };

  const HandleNeuroRepeaterFieldChange = (
    e,
    questionKey,
    cohortId,
    aeNeuroId,
    rowIndex,
  ) => {
    if (isNaN(rowIndex)) return;

    const resolver = stateResolver[questionKey]?.[cohortId];
    if (!resolver) return;

    const [detailsArray, setState] = resolver;

    const { type, checked, value, tagName } = e.target;

    const updatedArray = [...detailsArray];
    const row = { ...updatedArray[rowIndex] };

    row.neurologicAEReasonList =
      row.neurologicAEReasonList?.map((item, index) => {
        if (index !== aeNeuroId) return item;

        // Checkbox change
        if (type === "checkbox") {
          return {
            ...item,
            isSelected: checked,
            reasonText: checked ? item.reasonText : "",
          };
        }

        // Textarea change
        if (tagName === "TEXTAREA") {
          return {
            ...item,
            isSelected: true,
            reasonText: value,
          };
        }

        return item;
      }) ?? [];

    row.aeSubReasonEmpty = false;
    row.neuroReasonEmpty = false;
    row.neuroOtherTextEmpty = false;

    updatedArray[rowIndex] = row;
    setState(updatedArray);
  };

  const HandleRepeaterDateChange = (name, date) => {
    const lastIndex = name.lastIndexOf("-");
    const id = name.slice(lastIndex + 1);
    switch (name) {
      case "dateStrtChangeTalvInt-" + id: {
        let updatedArray = [...Q382ATalvDetails];

        updatedArray[id].colDError = false;
        updatedArray[id].startDateChangeOutOfBound = false;
        updatedArray[id].invalidstartDateChange = false;

        updatedArray[id].startDoseDt = date;
        updatedArray[id].interruptionStartDateUnknownWarning = false;
        updatedArray[id].startDoseDtRd = 1;
        setQ382ATalvDetails(updatedArray);
        break;
      }

      //TAL
      case "dateEndChangeTalvInt-" + id: {
        let updatedArray = [...Q382ATalvDetails];
        updatedArray[id].colFError = false;
        updatedArray[id].endDateChangeOutOfBound = false;
        updatedArray[id].invalidEndDateChange = false;
        updatedArray[id].endDoseDt = date;
        updatedArray[id].interruptionEndDateUnknownWarning = false;
        updatedArray[id].endDoseDtRd = 2;
        setQ382ATalvDetails(updatedArray);
        break;
      }

      case "dateStrtChangeTechInt-" + id: {
        let updatedArray = [...Q382ATechDetails];
        updatedArray[id].colDError = false;
        updatedArray[id].startDateChangeOutOfBound = false;
        updatedArray[id].invalidstartDateChange = false;
        updatedArray[id].startDoseDt = date;
        updatedArray[id].interruptionStartDateUnknownWarning = false;
        updatedArray[id].startDoseDtRd = 1;
        setQ382ATechDetails(updatedArray);
        break;
      }

      //TAL
      case "dateEndChangeTechInt-" + id: {
        let updatedArray = [...Q382ATechDetails];
        updatedArray[id].colFError = false;
        updatedArray[id].endDateChangeOutOfBound = false;
        updatedArray[id].invalidEndDateChange = false;
        updatedArray[id].interruptionEndDateUnknownWarning = false;
        updatedArray[id].endDoseDt = date;

        updatedArray[id].endDoseDtRd = 2;
        setQ382ATechDetails(updatedArray);
        break;
      }

      case "dateChangeTalv-" + id: {
        let updatedArray = [...Q381ATalvDetails];
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChange = date;
        updatedArray[id].dateChangeEmpty = false;

        updatedArray[id].dateChangeRd = 1;
        setQ381ATalvDetails(updatedArray);
        break;
      }
      //TECHVAYLI
      case "dateChangeTech-" + id: {
        let updatedArray = [...Q381ATechDetails];
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].dateChange = date;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].invalidDateChange = false;

        updatedArray[id].dateChangeRd = 1;
        setQ381ATechDetails(updatedArray);
        break;
      }

      case "dose_administration_tech_dt-" + id: {
        let updatedArray = [...techvayliDetails];

        updatedArray[id].dose_administration_tech_dt = date;
        updatedArray[id].dose_administration_tech = 1;
        updatedArray[id].dose_administration_techHard = false;

        updatedArray[id].dose_administration_techHard_dt = false;
        updatedArray[id].Invalid_dose_administration_tech_dt = false;
        updatedArray[id].dose_administration_tech_dt_before_eof = false;
        // updatedArray[id].dt_tech_greater_prevCheck = false;
        updatedArray[id].dt_tech_date_out_of_bound = false;
        setIndexDateRRMM_techHard(false);
        setTechvayliDetails(updatedArray);
        setDateRRMMTec_dupDateHard(false);
        setDt_tec_2L_3L_date_conditions(false);
        setIsTecLastAdminDateValid(true);
        break;
      }

      //36.1 start
      //B
      case "dt_admission_dt_tec-" + id: {
        let updatedArray = [...tecHospDetails];
        updatedArray[id].dt_admission_dt = date;
        updatedArray[id].dt_admission = 1;
        updatedArray[id].dt_admission_Hard = false;
        updatedArray[id].dt_admission_Hard_dt = false;
        updatedArray[id].Invalid_admission_Hard_dt = false;
        updatedArray[id].dt_admission_before_eof = false;
        updatedArray[id].dt_admission_out_of_bound = false;

        if (
          updatedArray[id].dt_admission_dt &&
          updatedArray[id].dt_discharge_dt
        ) {
          const check = IsDateLessThanThirtyDays(
            updatedArray[id].dt_admission_dt,
            updatedArray[id].dt_discharge_dt,
          );
          if (!check) {
            updatedArray[id].dateRangeThirty = true;
          } else {
            updatedArray[id].dateRangeThirty = false;
          }
        }
        setTecHospDetails(updatedArray);
        break;
      }
      //C
      case "dt_discharge_dt_tec-" + id: {
        let updatedArray = [...tecHospDetails];
        updatedArray[id].dt_discharge_dt = date;
        updatedArray[id].dt_discharge = 1;
        updatedArray[id].dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_Hard_dt = false;
        updatedArray[id].dt_discharge_Hard_dt_check = false;
        updatedArray[id].dt_discharge_out_of_bound = false;
        updatedArray[id].Invalid_dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_before_eof = false;
        updatedArray[id].dischargeMoreThanAdministrationWarning = false;

        if (
          updatedArray[id].dt_admission_dt &&
          updatedArray[id].dt_discharge_dt
        ) {
          const check = IsDateLessThanThirtyDays(
            updatedArray[id].dt_admission_dt,
            updatedArray[id].dt_discharge_dt,
          );
          if (!check) {
            updatedArray[id].dateRangeThirty = true;
          } else {
            updatedArray[id].dateRangeThirty = false;
          }
        }
        setTecHospDetails(updatedArray);
        break;
      }
      //end
      //TALVEY
      case "dose_administration_tal_dt-" + id: {
        let updatedArray = [...talveyDetails];

        updatedArray[id].dose_administration_tal_dt = date;
        updatedArray[id].dose_administration_tal = 1;
        updatedArray[id].dose_administration_talHard = false;
        updatedArray[id].Invalid_dose_administration_tal_dt = false;
        // updatedArray[id].dt_admission_talHard_dt = false;
        // updatedArray[id].dt_admission_talHard_dt_check = false;

        // updatedArray[id].dt_tal_greater_prevCheck = false;
        updatedArray[id].dt_tal_date_out_of_bound = false;

        updatedArray[id].dt_admission_talHard_dt = false;
        setIndexDateRRMM_talHard(false);
        setDateRRMMTal_dupDateHard(false);
        setDt_tal_2L_3L_date_conditions(false);
        setIsTalLastAdminDateValid(true);
        setTalveyDetails(updatedArray);
        break;
      }

      //36.1 start
      //B
      case "dt_admission_dt_tal-" + id: {
        let updatedArray = [...talHospDetails];

        updatedArray[id].dt_admission_dt = date;
        updatedArray[id].dt_admission = 1;
        updatedArray[id].dt_admission_Hard = false;
        updatedArray[id].Invalid_admission_Hard_dt = false;
        updatedArray[id].dt_admission_before_eof = false;
        updatedArray[id].dt_admission_Hard_dt = false;
        // updatedArray[id].dt_admission_Hard_dt_check = false;
        updatedArray[id].dt_admission_out_of_bound = false;

        if (
          updatedArray[id].dt_admission_dt &&
          updatedArray[id].dt_discharge_dt
        ) {
          const check = IsDateLessThanThirtyDays(
            updatedArray[id].dt_admission_dt,
            updatedArray[id].dt_discharge_dt,
          );
          if (!check) {
            updatedArray[id].dateRangeThirty = true;
          } else {
            updatedArray[id].dateRangeThirty = false;
          }
        }
        setTalHospDetails(updatedArray);
        break;
      }
      //C
      case "dt_discharge_dt_tal-" + id: {
        let updatedArray = [...talHospDetails];

        updatedArray[id].dt_discharge_dt = date;
        updatedArray[id].dt_discharge = 1;

        updatedArray[id].dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_Hard_dt = false;
        updatedArray[id].dt_discharge_Hard_dt_check = false;
        updatedArray[id].dt_discharge_out_of_bound = false;
        updatedArray[id].Invalid_dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_before_eof = false;

        if (
          updatedArray[id].dt_admission_dt &&
          updatedArray[id].dt_discharge_dt
        ) {
          const check = IsDateLessThanThirtyDays(
            updatedArray[id].dt_admission_dt,
            updatedArray[id].dt_discharge_dt,
          );
          if (!check) {
            updatedArray[id].dateRangeThirty = true;
          } else {
            updatedArray[id].dateRangeThirty = false;
          }
        }

        updatedArray[id].dischargeMoreThanAdministrationWarning = false;
        setTalHospDetails(updatedArray);
        break;
      }
      //end

      //Q38 Tech date change
      case "dt_dosefreq_tech_dt-" + id: {
        let updatedArray = [...Q38TechDetails];

        updatedArray[id].dt_dosefreq_tech_dt = date;
        updatedArray[id].Q38TechvayliRd = 1;

        updatedArray[id].Q38TechEmptyHard = false;
        updatedArray[id].Invalid_dt_dosefreq_tech_dt = false;
        updatedArray[id].Q38DateEmpty = false;
        updatedArray[id].Q38TechDateInvalid = false;
        setQ38TechDetails(updatedArray);
        break;
      }

      //Q38 Talvey date change
      case "dt_dosefreq_tal_dt-" + id: {
        let updatedArray = [...Q38TalDetails];

        updatedArray[id].dt_dosefreq_tal_dt = date;
        updatedArray[id].Q38TalveyRd = 1;
        //  updatedArray[id].dt_discharge_talHard = false;
        updatedArray[id].Q38TalEmptyHard = false;
        updatedArray[id].Q38TalDateEmpty = false;
        updatedArray[id].Q38TalDateInvalid = false;
        updatedArray[id].InvalidQ38Talveydate = false;
        setQ38TalDetails(updatedArray);
        break;
      }

      //40
      case "Q40init_dt-" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].Q40init_dt = date;
        updatedArray[id].Q40init_dt_Rd = 1;
        updatedArray[id].InvalidQ40init_dt = false;
        updatedArray[id].Q40Init_dtHard = false;
        updatedArray[id].Q40Init_RdHard = false;
        updatedArray[id].init_dt_before_eof = false;

        setQ37TechDetails(updatedArray);
        break;
      }

      //40 - tal
      case "Q40init_dt_Tal-" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].Q40init_dt_Tal = date;
        updatedArray[id].Q40init_dt_Rd_Tal = 1;
        updatedArray[id].InvalidQ40init_dt_Tal = false;
        updatedArray[id].Q40TalInit_dtHard = false;
        updatedArray[id].Q40TalInit_RdHard = false;
        updatedArray[id].init_dt_before_eof_Tal = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      //Q39.1.A
      case "administrationDate_tal-" + id: {
        let updatedArray = [...q391ATalTocilzumabList];

        updatedArray[id].administrationDate_tal = date;
        updatedArray[id].administrationDateRD_tal = 1;
        updatedArray[id].q39TalInvalidAdministrationDate = false;
        updatedArray[id].q39TalAdministrationDateEmpty = false;
        updatedArray[id].q39TalAdministrationRDEmpty = false;
        setQ391ATalAdministrationDateOutOfRange(false);

        setQ391ATalTocilzumabList(updatedArray);
        break;
      }

      case "administrationDate_tech-" + id: {
        let updatedArray = [...q391ATechTocilzumabList];

        updatedArray[id].administrationDate_tech = date;
        updatedArray[id].administrationDateRD_tech = 1;
        updatedArray[id].q39TechInvalidAdministrationDate = false;
        updatedArray[id].q39TechAdministrationDateEmpty = false;
        updatedArray[id].q39TechAdministrationRDEmpty = false;

        setQ391ATechAdministrationDateOutOfRange(false);
        setQ391ATechTocilzumabList(updatedArray);
        break;
      }

      default:
        break;
    }
  };

  function isValidNumber(value) {
    // Convert value to a number
    const number = parseFloat(value);

    // Regular expression to match numbers with up to two decimal places
    const decimalRegex = /^\d{1,2}(\.\d{1,2})?$|^50(\.0{1,2})?$/;

    // Validate that the number is within the range and matches the decimal format
    return (
      !isNaN(number) && number >= 0 && number <= 50 && decimalRegex.test(value)
    );
  }

  const handleQ391AList = (setStateFn, rowTemplate, pid, isSelected) => {
    setStateFn((prev) => {
      if (!isSelected) return [];

      if (prev && prev.length > 0) return prev;

      return rowTemplate ? [{ ...rowTemplate, patientid: pid }] : [];
    });
  };

  const HandleFieldChange = (e) => {
    const { name, id, value } = e.target;
    // ;

    switch (name) {
      case "Q37TechvayliRd" + id: {
        let updatedArray = [...Q37TechDetails];
        // let updatedTechArray = [...Q38TechDetails]

        updatedArray[id].Q37TechvayliRd = Number(value);
        updatedArray[id].q37TechvayliEmpty = false;

        updatedArray[id].showDateRedFreqTec =
          Number(value) === 1 ? true : false;

        // setQ38TechDetails(updatedTechArray);

        setQ38TechDetails([
          {
            ...Q38TechRow,
          },
        ]);
        setQ37TechDetails(updatedArray);
        break;
      }

      case "Q37TalveyRd" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].Q37TalveyRd = Number(value);
        updatedArray[id].q37TalveyEmpty = false;

        updatedArray[id].showDateRedFreqTal =
          Number(value) === 1 ? true : false;
        //  updatedArray[id].dose_administration_techHard = false;

        setQ38TalDetails([
          {
            ...Q38TalRow,
          },
        ]);

        setQ37TalDetails(updatedArray);
        break;
      }

      case "q37_Tec_Dose_week_frquencyRd" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].q37_Tec_Dose_week_frquencyRd = Number(value);
        updatedArray[id].q37_Tec_Dose_week_frquency_txt = "";
        updatedArray[id].q37_Tec_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q37_Tec_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q37TecDoseWeekFrequencyRangeError = false;

        if (Number(value) === 1) {
          updatedArray[id].Q37TechvayliRd = null;
          updatedArray[id].q37TechvayliEmpty = false;
          updatedArray[id].showDateRedFreqTec = false;
          updatedArray[id].q37_Tec_Dose_week_strengthRd = null;
          updatedArray[id].q37_Tec_Dose_week_strength_txt = "";
          updatedArray[id].q37_Tec_Dose_week_strengthRd_Empty = false;
          updatedArray[id].q37_Tec_Dose_week_strength_txt_Empty = false;
          updatedArray[id].q37_atleasetOneAdministrationTecWarningHard = false;

          setQ38TechDetails([
            {
              ...Q38TechRow,
            },
          ]);
        }
        setQ37TechDetails(updatedArray);
        break;
      }

      case "q37_Tec_Dose_week_frquency_txt" + id: {
        let updatedArray = [...Q37TechDetails];

        const reqValue = value;
        updatedArray[id].q37_Tec_Dose_week_frquency_txt = reqValue;
        updatedArray[id].q37_Tec_Dose_week_frquencyRd = 2;
        updatedArray[id].q37_Tec_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q37_Tec_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q37TecDoseWeekFrequencyRangeError = false;

        setQ37TechDetails(updatedArray);
        break;
      }

      case "q37_Tal_Dose_week_frquencyRd" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].q37_Tal_Dose_week_frquencyRd = Number(value);
        updatedArray[id].q37_Tal_Dose_week_frquency_txt = "";
        updatedArray[id].q37_Tal_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q37_Tal_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q37TalDoseWeekFrequencyRangeError = false;

        if (Number(value) === 1) {
          updatedArray[id].Q37TalveyRd = null;
          updatedArray[id].q37TalveyEmpty = false;
          updatedArray[id].showDateRedFreqTal = false;
          updatedArray[id].q37_Tal_Dose_week_strengthRd = null;
          updatedArray[id].q37_Tal_Dose_week_strength_txt = "";
          updatedArray[id].q37_Tal_Dose_week_strengthRd_Empty = false;
          updatedArray[id].q37_Tal_Dose_week_strength_txt_Empty = false;

          updatedArray[id].q37_atleasetOneAdministrationTalWarningHard = false;
          updatedArray[id].showDateRedFreqTal = false;
          setQ38TalDetails([
            {
              ...Q38TalRow,
            },
          ]);
        }

        setQ37TalDetails(updatedArray);
        break;
      }

      case "q37_Tal_Dose_week_frquency_txt" + id: {
        let updatedArray = [...Q37TalDetails];

        const reqValue = value;
        updatedArray[id].q37_Tal_Dose_week_frquency_txt = reqValue;
        updatedArray[id].q37_Tal_Dose_week_frquencyRd = 2;
        updatedArray[id].q37_Tal_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q37_Tal_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q37TalDoseWeekFrequencyRangeError = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "q37_Tec_Dose_week_strengthRd" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].q37_Tec_Dose_week_strengthRd = Number(value);
        updatedArray[id].q37_Tec_Dose_week_strength_txt = "";
        updatedArray[id].q37_Tec_Dose_week_strengthRd_Empty = false;
        updatedArray[id].q37_Tec_Dose_week_strength_txt_Empty = false;

        setQ37TechDetails(updatedArray);
        break;
      }

      case "q37_Tec_Dose_week_strength_txt" + id: {
        let updatedArray = [...Q37TechDetails];

        const reqValue = value;
        updatedArray[id].q37_Tec_Dose_week_strength_txt = reqValue;
        updatedArray[id].q37_Tec_Dose_week_strengthRd = 4;
        updatedArray[id].q37_Tec_Dose_week_strengthRd_Empty = false;
        updatedArray[id].q37_Tec_Dose_week_strength_txt_Empty = false;

        setQ37TechDetails(updatedArray);
        break;
      }

      case "q37_Tal_Dose_week_strengthRd" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].q37_Tal_Dose_week_strengthRd = Number(value);
        updatedArray[id].q37_Tal_Dose_week_strength_txt = "";
        updatedArray[id].q37_Tal_Dose_week_strengthRd_Empty = false;
        updatedArray[id].q37_Tal_Dose_week_strength_txt_Empty = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "q37_Tal_Dose_week_strength_txt" + id: {
        let updatedArray = [...Q37TalDetails];
        const reqValue = value;
        updatedArray[id].q37_Tal_Dose_week_strength_txt = reqValue;
        updatedArray[id].q37_Tal_Dose_week_strengthRd = 4;
        updatedArray[id].q37_Tal_Dose_week_strengthRd_Empty = false;
        updatedArray[id].q37_Tal_Dose_week_strength_txt_Empty = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      //40

      case "Q40dosingfreqRd" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].Q40dosingfreqRd = Number(value);
        updatedArray[id].dosing_freq_oth_txt = "";

        updatedArray[id].Q40DosingFreqEmptyHard = false;
        updatedArray[id].Q40DosingFreqTxtEmptyHard = false;
        //Reset col C,D,E if 1
        if (Number(value) === 1) {
          updatedArray[id].Q40IgILevelRd = null;
          updatedArray[id].Q40IgGEmptyHard = false;

          updatedArray[id].Q40init_dt_Rd = null;
          updatedArray[id].Q40Init_RdHard = false;
          updatedArray[id].Q40init_dt = "";
          updatedArray[id].Q40Init_dtHard = false;
          updatedArray[id].InvalidQ40init_dt = false;
          updatedArray[id].init_dt_before_eof = false;

          updatedArray[id].primaryProf = false;
          updatedArray[id].secondaryProf = false;
          updatedArray[id].otherReson = false;
          updatedArray[id].Q40ReasonEmptyHard = false;

          setQ401aTecDetails([{ ...Q401aTechRow }]);
          setQ403aTecDetails([{ ...Q403aTechRow }]);
        }
        setQ37TechDetails(updatedArray);

        break;
      }

      case "Q40IgILevelRd" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].Q40IgILevelRd = Number(value);

        updatedArray[id].Q40IgGEmptyHard = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "Q40init_dt_Rd" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].Q40init_dt_Rd = Number(value);

        updatedArray[id].Q40Init_RdHard = false;
        updatedArray[id].Q40Init_dtHard = false;
        updatedArray[id].InvalidQ40init_dt = false;
        updatedArray[id].init_dt_before_eof = false;
        updatedArray[id].Q40init_dt = "";
        setQ37TechDetails(updatedArray);
        break;
      }

      //checkbox - primary prof
      case "primaryProf" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].primaryProf = !updatedArray[id].primaryProf;

        updatedArray[id].Q40ReasonEmptyHard = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "secondaryProf" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].secondaryProf = !updatedArray[id].secondaryProf;
        updatedArray[id].Q40ReasonEmptyHard = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "otherReson" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].otherReson = !updatedArray[id].otherReson;
        updatedArray[id].Q40ReasonEmptyHard = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      //39Tech

      case "tocilizumab_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        const isSelected = !updatedArray[id].tocilizumab_tech;
        updatedArray[id].tocilizumab_tech = isSelected;

        updatedArray[id].noneoftheabove_tech = null;

        updatedArray[id].q39TechReasonHard = false;
        updatedArray[id].crs_tech = false;
        updatedArray[id].neurotoxicity_tech = false;
        updatedArray[id].tmt_neurotoxicity_tech = false;
        updatedArray[id].tmt_tech_unknown = false;
        updatedArray[id].cytokin_tech = false;
        updatedArray[id].secondary_prophylactic_crs_tech = false;
        updatedArray[id].secondary_neurotoxicity_tech = false;

        updatedArray[id].q39TechEmptyHard = false;

        //39.1.A
        if (isNewEcrfA) {
          handleQ391AList(
            setQ391ATechTocilzumabList,
            q391ATechRow,
            pid,
            isSelected,
          );
        }

        setQ37TechDetails(updatedArray);
        break;
      }

      case "granulocyte_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].noneoftheabove_tech = null;
        updatedArray[id].granulocyte_tech = !updatedArray[id].granulocyte_tech;

        updatedArray[id].q39TechEmptyHard = false;
        updatedArray[id].prophylactic_use_tech = false;
        updatedArray[id].secondary_prophylactic_use_tech = false;
        updatedArray[id].oth_use_tech = false;
        updatedArray[id].unknown_tech = null;

        setQ37TechDetails(updatedArray);
        break;
      }

      case "steroids_tech" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].steroids_tech = !updatedArray[id].steroids_tech;
        updatedArray[id].noneoftheabove_tech = null;

        updatedArray[id].steroid_pre_tmt_tech = false;
        updatedArray[id].cytokin_tech_steroids = false;
        updatedArray[id].crs_tech_steroids = false;
        updatedArray[id].neurotoxicity_tech_steroids = false;
        updatedArray[id].tmt_neurotoxicity_tech_steroids = false;
        updatedArray[id].tmt_steroids_tech_unknown = false;
        updatedArray[id].secondary_neurotoxicity_tech_steroids = false;
        updatedArray[id].secondary_prophylactic_tech_steroids = false;

        updatedArray[id].q39TechSteroidsEmptyHard = false;
        updatedArray[id].q39TechEmptyHard = false;

        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].betamethasone_tech = false;
        updatedArray[id].betamethasone_techNum = "";

        updatedArray[id].dexamethasone_tech = false;
        updatedArray[id].dexamethasone_techNum = "";

        updatedArray[id].hydrocortisone_tech = false;
        updatedArray[id].hydrocortisone_techNum = "";

        updatedArray[id].methylprednisolone = false;
        updatedArray[id].methylprednisoloneNum = "";

        updatedArray[id].prednisolone_tech = false;
        updatedArray[id].prednisolone_techNum = "";

        updatedArray[id].prednisone_tech = false;
        updatedArray[id].prednisone_techNum = "";

        updatedArray[id].triamcinolone_tech = false;
        updatedArray[id].triamcinolone_techNum = "";

        setQ37TechDetails(updatedArray);
        break;
      }

      case "noneoftheabove_tech" + id: {
        let updatedArray = [...Q37TechDetails];

        const isSelected = Number(value);
        updatedArray[id].noneoftheabove_tech = isSelected;

        updatedArray[id].tocilizumab_tech = false;
        updatedArray[id].granulocyte_tech = false;

        updatedArray[id].q39TechReasonHard = false;
        updatedArray[id].q39TechGranulocyteEmptyHard = false;
        updatedArray[id].q39TechEmptyHard = false;
        updatedArray[id].steroids_tech = false;

        //39.1.A
        if (isNewEcrfA) {
          handleQ391AList(
            setQ391ATechTocilzumabList,
            q391ATechRow,
            pid,
            isSelected,
          );
        }

        setQ37TechDetails(updatedArray);
        break;
      }

      //39Talvey

      case "tocilizumab_tal" + id: {
        let updatedArray = [...Q37TalDetails];

        const isSelected = !updatedArray[id].tocilizumab_tal;
        updatedArray[id].tocilizumab_tal = isSelected;

        updatedArray[id].noneoftheabove_tal = null;

        updatedArray[id].cytokin_tal = false;
        updatedArray[id].crs_tal = false;

        updatedArray[id].neurotoxicity_tal = false;
        updatedArray[id].tmt_neurotoxicity_tal = false;
        updatedArray[id].tmt_talvey_unknown = false;
        updatedArray[id].secondary_neurotoxicity_tal = false;
        updatedArray[id].secondary_prophylactic_crs_tal = false;

        updatedArray[id].q39TalEmptyHard = false;

        updatedArray[id].q39TalReasonHard = false;

        //39.1.A
        if (isNewEcrfA) {
          handleQ391AList(
            setQ391ATalTocilzumabList,
            q391ATalRow,
            pid,
            isSelected,
          );
        }

        setQ37TalDetails(updatedArray);
        break;
      }

      case "granulocyte_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].noneoftheabove_tal = null;
        updatedArray[id].granulocyte_tal = !updatedArray[id].granulocyte_tal;

        updatedArray[id].q39TalEmptyHard = false;
        updatedArray[id].prophylactic_use_tal = false;
        updatedArray[id].secondary_prophylactic_use_tal = false;
        updatedArray[id].oth_use_tal = false;
        updatedArray[id].unknown_tal = null;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "steroids_tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].steroids_tal = !updatedArray[id].steroids_tal;
        updatedArray[id].noneoftheabove_tal = null;

        updatedArray[id].cytokin_tal_steroids = false;
        updatedArray[id].crs_tal_steroids = false;
        updatedArray[id].neurotoxicity_tal_steroids = false;
        updatedArray[id].tmt_neurotoxicity_tal_steroids = false;
        updatedArray[id].tmt_tal_unknown = false;
        updatedArray[id].steroid_pre_tmt_tal = false;
        updatedArray[id].secondary_prophylactic_tal_steroids = false;
        updatedArray[id].secondary_neurotoxicity_tal_steroids = false;

        updatedArray[id].dose_name_tal_unknown = false;
        updatedArray[id].betamethasone_tal = false;
        updatedArray[id].betamethasone_talNum = "";

        updatedArray[id].dexamethasone_tal = false;
        updatedArray[id].dexamethasone_talNum = "";

        updatedArray[id].hydrocortisone_tal = false;
        updatedArray[id].hydrocortisone_talNum = "";

        updatedArray[id].methylprednisolone_tal = false;
        updatedArray[id].methylprednisolone_talNum = "";

        updatedArray[id].prednisolone_tal = false;
        updatedArray[id].prednisolone_talNum = "";

        updatedArray[id].prednisone_tal = false;
        updatedArray[id].prednisone_talNum = "";

        updatedArray[id].triamcinolone_tal = false;
        updatedArray[id].triamcinolone_talNum = "";

        updatedArray[id].q39TalSteroidsEmptyHard = false;
        updatedArray[id].q39TalEmptyHard = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "noneoftheabove_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        const isSelected = !!Number(value);
        updatedArray[id].noneoftheabove_tal = Number(value);

        updatedArray[id].steroids_tal = false;
        updatedArray[id].tocilizumab_tal = false;
        updatedArray[id].granulocyte_tal = false;
        updatedArray[id].q39TalEmptyHard = false;

        updatedArray[id].q39TalReasonHard = false;

        updatedArray[id].q39TalSteroidsEmptyHard = false;
        updatedArray[id].q39TalGranulocyteEmptyHard = false;

        //39.1.A
        if (isNewEcrfA) {
          handleQ391AList(
            setQ391ATalTocilzumabList,
            q391ATalRow,
            pid,
            isSelected,
          );
        }

        setQ37TalDetails(updatedArray);
        break;
      }

      case "dosing_freq_oth_txt" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].Q40dosingfreqRd = 5;
        updatedArray[id].dosing_freq_oth_txt = value;

        updatedArray[id].Q40DosingFreqEmptyHard = false;
        updatedArray[id].Q40DosingFreqTxtEmptyHard = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      //39.1
      //tmt_tech_unknown
      case "cytokin_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].cytokin_tech = !updatedArray[id].cytokin_tech;

        updatedArray[id].tmt_tech_unknown = false;

        updatedArray[id].q39TechReasonHard = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_crs_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].secondary_prophylactic_crs_tech =
          !updatedArray[id].secondary_prophylactic_crs_tech;

        updatedArray[id].tmt_tech_unknown = false;

        updatedArray[id].q39TechReasonHard = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "crs_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].crs_tech = !updatedArray[id].crs_tech;
        updatedArray[id].q39TechReasonHard = false;
        updatedArray[id].tmt_tech_unknown = false;

        setQ37TechDetails(updatedArray);
        break;
      }

      case "neurotoxicity_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].neurotoxicity_tech =
          !updatedArray[id].neurotoxicity_tech;
        updatedArray[id].q39TechReasonHard = false;
        updatedArray[id].tmt_tech_unknown = false;

        setQ37TechDetails(updatedArray);
        break;
      }

      case "secondary_neurotoxicity_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].secondary_neurotoxicity_tech =
          !updatedArray[id].secondary_neurotoxicity_tech;
        updatedArray[id].q39TechReasonHard = false;
        updatedArray[id].tmt_tech_unknown = false;

        setQ37TechDetails(updatedArray);
        break;
      }

      case "tmt_neurotoxicity_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].tmt_neurotoxicity_tech =
          !updatedArray[id].tmt_neurotoxicity_tech;
        updatedArray[id].q39TechReasonHard = false;
        updatedArray[id].tmt_tech_unknown = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "tmt_tech_unknown" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].tmt_tech_unknown = !updatedArray[id].tmt_tech_unknown;
        updatedArray[id].q39TechReasonHard = false;

        updatedArray[id].crs_tech = false;
        updatedArray[id].cytokin_tech = false;
        updatedArray[id].secondary_prophylactic_crs_tech = false;
        updatedArray[id].secondary_neurotoxicity_tech = false;
        updatedArray[id].tmt_neurotoxicity_tech = false;
        updatedArray[id].neurotoxicity_tech = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      //Q39.3 - Tecvayli

      case "prophylactic_use_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].prophylactic_use_tech =
          !updatedArray[id].prophylactic_use_tech;

        updatedArray[id].q39TechGranulocyteEmptyHard = false;
        updatedArray[id].unknown_tech = null;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_use_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].secondary_prophylactic_use_tech =
          !updatedArray[id].secondary_prophylactic_use_tech;

        updatedArray[id].q39TechGranulocyteEmptyHard = false;
        updatedArray[id].unknown_tech = null;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "oth_use_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].oth_use_tech = !updatedArray[id].oth_use_tech;

        updatedArray[id].q39TechGranulocyteEmptyHard = false;
        updatedArray[id].unknown_tech = null;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "unknown_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].unknown_tech = Number(value);
        updatedArray[id].oth_use_tech = false;
        updatedArray[id].prophylactic_use_tech = false;
        updatedArray[id].secondary_prophylactic_use_tech = false;
        updatedArray[id].q39TechGranulocyteEmptyHard = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      //Q39.3 - Granulocyte - Talvey

      case "prophylactic_use_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].prophylactic_use_tal =
          !updatedArray[id].prophylactic_use_tal;

        updatedArray[id].q39TalGranulocyteEmptyHard = false;
        updatedArray[id].unknown_tal = null;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_use_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].secondary_prophylactic_use_tal =
          !updatedArray[id].secondary_prophylactic_use_tal;

        updatedArray[id].q39TalGranulocyteEmptyHard = false;
        updatedArray[id].unknown_tal = null;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "oth_use_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].oth_use_tal = !updatedArray[id].oth_use_tal;

        updatedArray[id].q39TalGranulocyteEmptyHard = false;
        updatedArray[id].unknown_tal = null;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "unknown_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].unknown_tal = Number(value);
        updatedArray[id].oth_use_tal = false;
        updatedArray[id].prophylactic_use_tal = false;
        updatedArray[id].secondary_prophylactic_use_tal = false;
        updatedArray[id].q39TalGranulocyteEmptyHard = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      //39.1 -  Talvey

      case "cytokin_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].cytokin_tal = !updatedArray[id].cytokin_tal;

        updatedArray[id].q39TalReasonHard = false;
        updatedArray[id].tmt_talvey_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_crs_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].secondary_prophylactic_crs_tal =
          !updatedArray[id].secondary_prophylactic_crs_tal;

        updatedArray[id].q39TalReasonHard = false;
        updatedArray[id].tmt_talvey_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "crs_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].crs_tal = !updatedArray[id].crs_tal;

        updatedArray[id].tmt_talvey_unknown = false;

        updatedArray[id].q39TalReasonHard = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "neurotoxicity_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].neurotoxicity_tal =
          !updatedArray[id].neurotoxicity_tal;
        updatedArray[id].q39TalReasonHard = false;
        updatedArray[id].tmt_talvey_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "secondary_neurotoxicity_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].secondary_neurotoxicity_tal =
          !updatedArray[id].secondary_neurotoxicity_tal;
        updatedArray[id].q39TalReasonHard = false;
        updatedArray[id].tmt_talvey_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "tmt_neurotoxicity_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].tmt_neurotoxicity_tal =
          !updatedArray[id].tmt_neurotoxicity_tal;
        updatedArray[id].q39TalReasonHard = false;
        updatedArray[id].tmt_talvey_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "tmt_talvey_unknown" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].tmt_talvey_unknown =
          !updatedArray[id].tmt_talvey_unknown;
        updatedArray[id].q39TalReasonHard = false;

        updatedArray[id].tmt_neurotoxicity_tal = false;
        updatedArray[id].cytokin_tal = false;
        updatedArray[id].neurotoxicity_tal = false;
        updatedArray[id].crs_tal = false;
        updatedArray[id].secondary_prophylactic_crs_tal = false;
        updatedArray[id].secondary_neurotoxicity_tal = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      //Q39.2 Talvey

      case "cytokin_tal_steroids" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].cytokin_tal_steroids =
          !updatedArray[id].cytokin_tal_steroids;

        updatedArray[id].q39TalSteroidsEmptyHard = false;
        updatedArray[id].tmt_tal_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_tal_steroids" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].secondary_prophylactic_tal_steroids =
          !updatedArray[id].secondary_prophylactic_tal_steroids;

        updatedArray[id].q39TalSteroidsEmptyHard = false;
        updatedArray[id].tmt_tal_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "crs_tal_steroids" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].crs_tal_steroids = !updatedArray[id].crs_tal_steroids;
        updatedArray[id].q39TalSteroidsEmptyHard = false;
        updatedArray[id].tmt_tal_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "neurotoxicity_tal_steroids" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].neurotoxicity_tal_steroids =
          !updatedArray[id].neurotoxicity_tal_steroids;
        updatedArray[id].q39TalSteroidsEmptyHard = false;
        updatedArray[id].tmt_tal_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "secondary_neurotoxicity_tal_steroids" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].secondary_neurotoxicity_tal_steroids =
          !updatedArray[id].secondary_neurotoxicity_tal_steroids;
        updatedArray[id].q39TalSteroidsEmptyHard = false;
        updatedArray[id].tmt_tal_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "tmt_neurotoxicity_tal_steroids" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].tmt_neurotoxicity_tal_steroids =
          !updatedArray[id].tmt_neurotoxicity_tal_steroids;
        updatedArray[id].q39TalSteroidsEmptyHard = false;
        updatedArray[id].tmt_tal_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "tmt_tal_unknown" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].tmt_tal_unknown = !updatedArray[id].tmt_tal_unknown;

        updatedArray[id].cytokin_tal_steroids = false;
        updatedArray[id].secondary_prophylactic_tal_steroids = false;
        updatedArray[id].secondary_neurotoxicity_tal_steroids = false;

        updatedArray[id].crs_tal_steroids = false;

        updatedArray[id].neurotoxicity_tal_steroids = false;

        updatedArray[id].tmt_neurotoxicity_tal_steroids = false;
        updatedArray[id].steroid_pre_tmt_tal = false;

        updatedArray[id].q39TalSteroidsEmptyHard = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "steroid_pre_tmt_tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].steroid_pre_tmt_tal =
          !updatedArray[id].steroid_pre_tmt_tal;

        updatedArray[id].q39TalSteroidsEmptyHard = false;
        updatedArray[id].tmt_tal_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "betamethasone_tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].betamethasone_tal =
          !updatedArray[id].betamethasone_tal;

        updatedArray[id].betamethasone_talNum = "";
        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        updatedArray[id].steroids_tal_txtEmpty = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "betamethasone_talNum" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].betamethasone_talNum = value;

        updatedArray[id].betamethasone_tal = true;

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "dexamethasone_tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].dexamethasone_tal =
          !updatedArray[id].dexamethasone_tal;

        updatedArray[id].dexamethasone_talNum = "";
        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;

        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "dexamethasone_talNum" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].dexamethasone_talNum = value;

        updatedArray[id].dexamethasone_tal = true;

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "hydrocortisone_tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].hydrocortisone_tal =
          !updatedArray[id].hydrocortisone_tal;

        updatedArray[id].hydrocortisone_talNum = "";

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "hydrocortisone_talNum" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].hydrocortisone_talNum = value;

        updatedArray[id].hydrocortisone_tal = true;

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      //

      case "methylprednisolone_tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].methylprednisolone_tal =
          !updatedArray[id].methylprednisolone_tal;

        updatedArray[id].methylprednisolone_talNum = "";

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "methylprednisolone_talNum" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].methylprednisolone_talNum = value;

        updatedArray[id].methylprednisolone_tal = true;

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "prednisolone_tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].prednisolone_tal = !updatedArray[id].prednisolone_tal;

        updatedArray[id].prednisolone_talNum = "";

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "prednisolone_talNum" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].prednisolone_talNum = value;

        updatedArray[id].prednisolone_tal = true;

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "prednisone_tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].prednisone_tal = !updatedArray[id].prednisone_tal;

        updatedArray[id].prednisone_talNum = "";

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "prednisone_talNum" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].prednisone_talNum = value;

        updatedArray[id].prednisone_tal = true;

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "triamcinolone_tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].triamcinolone_tal =
          !updatedArray[id].triamcinolone_tal;

        updatedArray[id].triamcinolone_talNum = "";

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "triamcinolone_talNum" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].triamcinolone_talNum = value;

        updatedArray[id].triamcinolone_tal = true;

        updatedArray[id].name_dose_steroids_talHardEmpty = false;
        updatedArray[id].steroids_tal_txtEmpty = false;
        updatedArray[id].dose_name_tal_unknown = false;

        setQ37TalDetails(updatedArray);
        break;
      }

      case "dose_name_tal_unknown" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].dose_name_tal_unknown =
          !updatedArray[id].dose_name_tal_unknown;

        updatedArray[id].name_dose_steroids_talHardEmpty = false;

        updatedArray[id].steroids_tal_txtEmpty = false;

        updatedArray[id].betamethasone_tal = false;
        updatedArray[id].betamethasone_talNum = "";

        updatedArray[id].dexamethasone_tal = false;
        updatedArray[id].dexamethasone_talNum = "";

        updatedArray[id].hydrocortisone_tal = false;
        updatedArray[id].hydrocortisone_talNum = "";

        updatedArray[id].methylprednisolone_tal = false;
        updatedArray[id].methylprednisolone_talNum = "";

        updatedArray[id].prednisolone_tal = false;
        updatedArray[id].prednisolone_talNum = "";

        updatedArray[id].prednisone_tal = false;
        updatedArray[id].prednisone_talNum = "";

        updatedArray[id].triamcinolone_tal = false;
        updatedArray[id].triamcinolone_talNum = "";

        setQ37TalDetails(updatedArray);
        break;
      }

      // New phase
      case "steroid_pre_tmt_tech" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].steroid_pre_tmt_tech =
          !updatedArray[id].steroid_pre_tmt_tech;

        updatedArray[id].q39TechSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_tech_unknown = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      //New tech column handlechange

      case "betamethasone_tech" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].betamethasone_tech =
          !updatedArray[id].betamethasone_tech;

        updatedArray[id].betamethasone_techNum = "";
        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].betamethasone_tech_txtEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "betamethasone_techNum" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].betamethasone_techNum = value;

        updatedArray[id].betamethasone_tech = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].betamethasone_tech_txtEmpty = false;

        setQ37TechDetails(updatedArray);
        break;
      }

      case "dexamethasone_tech" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].dexamethasone_tech =
          !updatedArray[id].dexamethasone_tech;

        updatedArray[id].dexamethasone_techNum = "";
        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].dexamethasone_tech_txtEmpty = false;

        setQ37TechDetails(updatedArray);
        break;
      }

      case "dexamethasone_techNum" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].dexamethasone_techNum = value;

        updatedArray[id].dexamethasone_tech = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].dexamethasone_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "hydrocortisone_tech" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].hydrocortisone_tech =
          !updatedArray[id].hydrocortisone_tech;

        updatedArray[id].hydrocortisone_techNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].hydrocortisone_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "hydrocortisone_techNum" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].hydrocortisone_techNum = value;

        updatedArray[id].hydrocortisone_tech = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].hydrocortisone_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      //

      case "methylprednisolone" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].methylprednisolone =
          !updatedArray[id].methylprednisolone;

        updatedArray[id].methylprednisoloneNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].methylprednisolone_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "methylprednisoloneNum" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].methylprednisoloneNum = value;

        updatedArray[id].methylprednisolone = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].methylprednisolone_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "prednisolone_tech" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].prednisolone_tech =
          !updatedArray[id].prednisolone_tech;

        updatedArray[id].prednisolone_techNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].prednisolone_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "prednisolone_techNum" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].prednisolone_techNum = value;

        updatedArray[id].prednisolone_tech = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].prednisolone_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "prednisone_tech" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].prednisone_tech = !updatedArray[id].prednisone_tech;

        updatedArray[id].prednisone_techNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].prednisone_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "prednisone_techNum" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].prednisone_techNum = value;

        updatedArray[id].prednisone_tech = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].prednisone_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "triamcinolone_tech" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].triamcinolone_tech =
          !updatedArray[id].triamcinolone_tech;

        updatedArray[id].triamcinolone_techNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].triamcinolone_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "triamcinolone_techNum" + id: {
        let updatedArray = [...Q37TechDetails];

        updatedArray[id].triamcinolone_techNum = value;

        updatedArray[id].triamcinolone_tech = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].dose_name_tech_unknown = false;
        updatedArray[id].triamcinolone_tech_txtEmpty = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "dose_name_tech_unknown" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].dose_name_tech_unknown =
          !updatedArray[id].dose_name_tech_unknown;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_tech_txtEmpty = false;
        updatedArray[id].betamethasone_tech_txtEmpty = false;
        updatedArray[id].dexamethasone_tech_txtEmpty = false;
        updatedArray[id].hydrocortisone_tech_txtEmpty = false;
        updatedArray[id].methylprednisolone_txtEmpty = false;
        updatedArray[id].prednisolone_tech_txtEmpty = false;
        updatedArray[id].prednisone_tech_txtEmpty = false;
        updatedArray[id].triamcinolone_tech_txtEmpty = false;

        updatedArray[id].betamethasone_tech = false;
        updatedArray[id].betamethasone_techNum = "";

        updatedArray[id].dexamethasone_tech = false;
        updatedArray[id].dexamethasone_techNum = "";

        updatedArray[id].hydrocortisone_tech = false;
        updatedArray[id].hydrocortisone_techNum = "";

        updatedArray[id].methylprednisolone = false;
        updatedArray[id].methylprednisoloneNum = "";

        updatedArray[id].prednisolone_tech = false;
        updatedArray[id].prednisolone_techNum = "";

        updatedArray[id].prednisone_tech = false;
        updatedArray[id].prednisone_techNum = "";

        updatedArray[id].triamcinolone_tech = false;
        updatedArray[id].triamcinolone_techNum = "";

        setQ37TechDetails(updatedArray);
        break;
      }

      case "cytokin_tech_steroids" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].cytokin_tech_steroids =
          !updatedArray[id].cytokin_tech_steroids;

        updatedArray[id].q39TechSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_tech_unknown = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_tech_steroids" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].secondary_prophylactic_tech_steroids =
          !updatedArray[id].secondary_prophylactic_tech_steroids;

        updatedArray[id].q39TechSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_tech_unknown = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "crs_tech_steroids" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].crs_tech_steroids =
          !updatedArray[id].crs_tech_steroids;
        updatedArray[id].q39TechSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_tech_unknown = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "neurotoxicity_tech_steroids" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].neurotoxicity_tech_steroids =
          !updatedArray[id].neurotoxicity_tech_steroids;
        updatedArray[id].q39TechSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_tech_unknown = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "secondary_neurotoxicity_tech_steroids" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].secondary_neurotoxicity_tech_steroids =
          !updatedArray[id].secondary_neurotoxicity_tech_steroids;
        updatedArray[id].q39TechSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_tech_unknown = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "tmt_neurotoxicity_tech_steroids" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].tmt_neurotoxicity_tech_steroids =
          !updatedArray[id].tmt_neurotoxicity_tech_steroids;
        updatedArray[id].q39TechSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_tech_unknown = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      case "tmt_steroids_tech_unknown" + id: {
        let updatedArray = [...Q37TechDetails];
        updatedArray[id].tmt_steroids_tech_unknown =
          !updatedArray[id].tmt_steroids_tech_unknown;

        updatedArray[id].cytokin_tech_steroids = false;

        updatedArray[id].steroid_pre_tmt_tech = false;
        updatedArray[id].crs_tech_steroids = false;

        updatedArray[id].neurotoxicity_tech_steroids = false;

        updatedArray[id].tmt_neurotoxicity_tech_steroids = false;
        updatedArray[id].secondary_neurotoxicity_tech_steroids = false;
        updatedArray[id].secondary_prophylactic_tech_steroids = false;

        updatedArray[id].q39TechSteroidsEmptyHard = false;
        setQ37TechDetails(updatedArray);
        break;
      }

      //Q40 - Tal

      case "Q40dosingfreqRd_Tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].Q40dosingfreqRd_Tal = Number(value);
        updatedArray[id].dosing_freq_oth_txt_Tal = "";

        updatedArray[id].Q40TalDosingFreqEmptyHard = false;
        updatedArray[id].Q40TalDosingFreqTxtEmptyHard = false;
        //Reset col C,D,E if 1
        if (Number(value) === 1) {
          updatedArray[id].Q40IgILevelRd_Tal = null;
          updatedArray[id].Q40TalIgGEmptyHard = false;

          updatedArray[id].Q40init_dt_Rd_Tal = null;
          updatedArray[id].Q40TalInit_RdHard = false;
          updatedArray[id].Q40init_dt_Tal = "";
          updatedArray[id].Q40TalInit_dtHard = false;
          updatedArray[id].InvalidQ40init_dt_Tal = false;
          updatedArray[id].init_dt_before_eof_Tal = false;

          updatedArray[id].primaryProf_Tal = false;
          updatedArray[id].secondaryProf_Tal = false;
          updatedArray[id].otherReson_Tal = false;
          updatedArray[id].Q40TalReasonEmptyHard = false;

          setQ401aTalDetails([{ ...Q401aTalRow }]);
          setQ403aTalDetails([{ ...Q403aTalRow }]);
        }
        setQ37TalDetails(updatedArray);
        break;
      }

      case "Q40IgILevelRd_Tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].Q40IgILevelRd_Tal = Number(value);

        updatedArray[id].Q40TalIgGEmptyHard = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "Q40init_dt_Rd_Tal" + id: {
        let updatedArray = [...Q37TalDetails];

        updatedArray[id].Q40init_dt_Rd_Tal = Number(value);

        updatedArray[id].Q40TalInit_RdHard = false;
        updatedArray[id].Q40TalInit_dtHard = false;
        updatedArray[id].InvalidQ40init_dt_Tal = false;
        updatedArray[id].init_dt_before_eof_Tal = false;
        updatedArray[id].Q40init_dt_Tal = "";
        setQ37TalDetails(updatedArray);
        break;
      }

      case "primaryProf_Tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].primaryProf_Tal = !updatedArray[id].primaryProf_Tal;

        updatedArray[id].Q40TalReasonEmptyHard = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "secondaryProf_Tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].secondaryProf_Tal =
          !updatedArray[id].secondaryProf_Tal;
        updatedArray[id].Q40TalReasonEmptyHard = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "otherReson_Tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].otherReson_Tal = !updatedArray[id].otherReson_Tal;
        updatedArray[id].Q40TalReasonEmptyHard = false;
        setQ37TalDetails(updatedArray);
        break;
      }

      case "dosing_freq_oth_txt_Tal" + id: {
        let updatedArray = [...Q37TalDetails];
        updatedArray[id].Q40dosingfreqRd_Tal = 5;
        updatedArray[id].dosing_freq_oth_txt_Tal = value;

        updatedArray[id].Q40TalDosingFreqEmptyHard = false;
        updatedArray[id].Q40TalDosingFreqTxtEmptyHard = false;
        setQ37TalDetails(updatedArray);
        break;
      }
      default:
        break;
    }
    //
  };

  const HandleQ401aRepeaterDateChange = (name, date) => {
    const lastIndex = name.lastIndexOf("-");
    const id = name.slice(lastIndex + 1);
    switch (name) {
      case "Q401ainit_Tec_dt-" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401ainit_dt_Rd_Tec = 1;
        updatedArray[id].Q401ainit_Tec_dt = date;
        updatedArray[id].Q401aInit_Tec_RdHard = false;
        updatedArray[id].Q401aInit_Tec_dtHard = false;
        updatedArray[id].Q401aInvalidQ401ainit_Tec_dt = false;
        updatedArray[id].Q401aInit_Tec_dt_before_eof = false;

        setQ401aTecDetails(updatedArray);
        break;
      }
      case "Q401ainit_Tal_dt-" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401ainit_dt_Rd_Tal = 1;
        updatedArray[id].Q401ainit_Tal_dt = date;
        updatedArray[id].Q401aInit_Tal_RdHard = false;
        updatedArray[id].Q401aInit_Tal_dtHard = false;
        updatedArray[id].Q401aInvalidQ401ainit_Tal_dt = false;
        updatedArray[id].Q401aInit_Tal_dt_before_eof = false;

        setQ401aTalDetails(updatedArray);
        break;
      }
      case "Q401aWeight_Asses_Tec_dt-" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aWeight_Asses_Tec = 1;
        updatedArray[id].Q401aWeight_Asses_Tec_dt = date;
        updatedArray[id].Q401aWeight_AssesEmptyHard_Tec = false;
        updatedArray[id].Q401aWeight_AssesDtEmptyHard_Tec = false;
        updatedArray[id].Q401aWeight_AssesDtInvalid_Tec = false;
        updatedArray[id].Q401aWeight_Asses_dt_before_eof_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }
      case "Q401aWeight_Asses_Tal_dt-" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aWeight_Asses_Tal = 1;
        updatedArray[id].Q401aWeight_Asses_Tal_dt = date;
        updatedArray[id].Q401aWeight_AssesEmptyHard_Tal = false;
        updatedArray[id].Q401aWeight_AssesDtEmptyHard_Tal = false;
        updatedArray[id].Q401aWeight_AssesDtInvalid_Tal = false;
        updatedArray[id].Q401aWeight_Asses_dt_before_eof_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      default:
        break;
    }
  };

  const HandleQ401aFieldChange = (e) => {
    const { name, id, value } = e.target;

    switch (name) {
      //Tec
      case "Q401ainit_dt_Rd_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401ainit_dt_Rd_Tec = Number(value);
        updatedArray[id].Q401ainit_Tec_dt =
          Number(value) === 1 ? updatedArray[id].Q401ainit_Tec_dt : "";
        updatedArray[id].Q401aInit_Tec_RdHard = false;
        updatedArray[id].Q401aInit_Tec_dtHard = false;
        updatedArray[id].Q401aInvalidQ401ainit_Tec_dt = false;
        updatedArray[id].Q401aInit_Tec_dt_before_eof = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aIntendedDosing_Tec = Number(value);
        updatedArray[id].Q401aIntendedDosing_Tec_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OtherValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tec = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tec_WeekValue" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aIntendedDosing_Tec = 1;
        updatedArray[id].Q401aIntendedDosing_Tec_WeekValue = value;
        updatedArray[id].Q401aIntendedDosing_Tec_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OtherValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tec = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tec_MonthValue" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aIntendedDosing_Tec = 2;
        updatedArray[id].Q401aIntendedDosing_Tec_MonthValue = value;
        updatedArray[id].Q401aIntendedDosing_Tec_OtherValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tec = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tec_OnceWeekValue" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aIntendedDosing_Tec = 3;
        updatedArray[id].Q401aIntendedDosing_Tec_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OtherValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceWeekValue = value;
        updatedArray[id].Q401aIntendedDosing_Tec_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tec = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tec_OnceMonthValue" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aIntendedDosing_Tec = 4;
        updatedArray[id].Q401aIntendedDosing_Tec_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OtherValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceMonthValue = value;
        updatedArray[id].Q401aIntendedDosingEmpty_Tec = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tec_OtherValue" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aIntendedDosing_Tec = 5;
        updatedArray[id].Q401aIntendedDosing_Tec_OtherValue = value;
        updatedArray[id].Q401aIntendedDosing_Tec_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tec_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tec = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aPrimaryProf_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aPrimaryProf_Tec =
          !updatedArray[id].Q401aPrimaryProf_Tec;
        updatedArray[id].Q401aUnknownProf_Tec = null;
        updatedArray[id].Q401aReasonIvigEmptyHard_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aSecProf_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aSecProf_Tec = !updatedArray[id].Q401aSecProf_Tec;
        updatedArray[id].Q401aUnknownProf_Tec = null;
        updatedArray[id].Q401aReasonIvigEmptyHard_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aOtherProf_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aOtherProf_Tec =
          !updatedArray[id].Q401aOtherProf_Tec;
        updatedArray[id].Q401aUnknownProf_Tec = null;
        updatedArray[id].Q401aReasonIvigEmptyHard_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aUnknownProf_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aUnknownProf_Tec = Number(value);
        updatedArray[id].Q401aPrimaryProf_Tec = false;
        updatedArray[id].Q401aSecProf_Tec = false;
        updatedArray[id].Q401aOtherProf_Tec = false;
        updatedArray[id].Q401aReasonIvigEmptyHard_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aDosingType_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aDosingType_Tec = Number(value);
        updatedArray[id].Q401aDosingType_TecEmptyHard = false;

        updatedArray[id].Q401aDosage_Tec = null;
        updatedArray[id].Q401aDosage_Tec_GValue = "";
        updatedArray[id].Q401aDosage_Tec_MgValue = "";
        updatedArray[id].Q401aDosageFrequencyEmpty_Tec = false;
        updatedArray[id].Q401aDosageRangeInvalid_Tec = false;

        updatedArray[id].Q401aWeight_Tec = null;
        updatedArray[id].Q401aWeight_Value_KgTec = "";
        updatedArray[id].Q401aWeight_Value_LbsTec = "";
        updatedArray[id].Q401aWeightEmpty_Tec = false;
        updatedArray[id].Q401aWeightRangeInvalid_Tec = false;

        updatedArray[id].Q401aWeight_Asses_Tec = null;
        updatedArray[id].Q401aWeight_Asses_Tec_dt = "";
        updatedArray[id].Q401aWeight_AssesEmptyHard_Tec = false;
        updatedArray[id].Q401aWeight_AssesDtEmptyHard_Tec = false;
        updatedArray[id].Q401aWeight_AssesDtInvalid_Tec = false;
        updatedArray[id].Q401aWeight_Asses_dt_before_eof_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aDosage_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aDosage_Tec = Number(value);
        updatedArray[id].Q401aDosage_Tec_GValue = "";
        updatedArray[id].Q401aDosage_Tec_MgValue = "";
        updatedArray[id].Q401aDosageFrequencyEmpty_Tec = false;
        updatedArray[id].Q401aDosageRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aDosage_Tec_GValue" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aDosage_Tec = 1;
        updatedArray[id].Q401aDosage_Tec_GValue = value;
        updatedArray[id].Q401aDosage_Tec_MgValue = "";
        updatedArray[id].Q401aDosageFrequencyEmpty_Tec = false;
        updatedArray[id].Q401aDosageRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aDosage_Tec_MgValue" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aDosage_Tec = 2;
        updatedArray[id].Q401aDosage_Tec_MgValue = value;
        updatedArray[id].Q401aDosage_Tec_GValue = "";
        updatedArray[id].Q401aDosageFrequencyEmpty_Tec = false;
        updatedArray[id].Q401aDosageRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aWeight_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aWeight_Tec = Number(value);
        updatedArray[id].Q401aWeight_Value_KgTec = "";
        updatedArray[id].Q401aWeight_Value_LbsTec = "";
        updatedArray[id].Q401aWeightEmpty_Tec = false;
        updatedArray[id].Q401aWeightRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aWeight_Value_KgTec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aWeight_Tec = 1;
        updatedArray[id].Q401aWeight_Value_KgTec = value;
        updatedArray[id].Q401aWeight_Value_LbsTec = "";
        updatedArray[id].Q401aWeightEmpty_Tec = false;
        updatedArray[id].Q401aWeightRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      case "Q401aWeight_Value_LbsTec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aWeight_Tec = 2;
        updatedArray[id].Q401aWeight_Value_KgTec = "";
        updatedArray[id].Q401aWeight_Value_LbsTec = value;
        updatedArray[id].Q401aWeightEmpty_Tec = false;
        updatedArray[id].Q401aWeightRangeInvalid_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }
      case "Q401aWeight_Asses_Tec" + id: {
        let updatedArray = [...Q401aTecDetails];

        updatedArray[id].Q401aWeight_Asses_Tec = Number(value);
        updatedArray[id].Q401aWeight_Asses_Tec_dt =
          Number(value) === 1 ? updatedArray[id].Q401aWeight_Asses_Tec_dt : "";
        updatedArray[id].Q401aWeight_AssesEmptyHard_Tec = false;
        updatedArray[id].Q401aWeight_AssesDtEmptyHard_Tec = false;
        updatedArray[id].Q401aWeight_AssesDtInvalid_Tec = false;
        updatedArray[id].Q401aWeight_Asses_dt_before_eof_Tec = false;

        setQ401aTecDetails(updatedArray);
        break;
      }

      //Tal
      case "Q401ainit_dt_Rd_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401ainit_dt_Rd_Tal = Number(value);
        updatedArray[id].Q401ainit_Tal_dt =
          Number(value) === 1 ? updatedArray[id].Q401ainit_Tal_dt : "";
        updatedArray[id].Q401aInit_Tal_RdHard = false;
        updatedArray[id].Q401aInit_Tal_dtHard = false;
        updatedArray[id].Q401aInvalidQ401ainit_Tal_dt = false;
        updatedArray[id].Q401aInit_Tal_dt_before_eof = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aIntendedDosing_Tal = Number(value);
        updatedArray[id].Q401aIntendedDosing_Tal_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OtherValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tal = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tal_WeekValue" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aIntendedDosing_Tal = 1;
        updatedArray[id].Q401aIntendedDosing_Tal_WeekValue = value;
        updatedArray[id].Q401aIntendedDosing_Tal_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OtherValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tal = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tal_MonthValue" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aIntendedDosing_Tal = 2;
        updatedArray[id].Q401aIntendedDosing_Tal_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_MonthValue = value;
        updatedArray[id].Q401aIntendedDosing_Tal_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OtherValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tal = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tal_OnceWeekValue" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aIntendedDosing_Tal = 3;
        updatedArray[id].Q401aIntendedDosing_Tal_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceWeekValue = value;
        updatedArray[id].Q401aIntendedDosing_Tal_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OtherValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tal = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tal_OnceMonthValue" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aIntendedDosing_Tal = 4;
        updatedArray[id].Q401aIntendedDosing_Tal_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceMonthValue = value;
        updatedArray[id].Q401aIntendedDosing_Tal_OtherValue = "";
        updatedArray[id].Q401aIntendedDosingEmpty_Tal = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aIntendedDosing_Tal_OtherValue" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aIntendedDosing_Tal = 5;
        updatedArray[id].Q401aIntendedDosing_Tal_WeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_MonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceWeekValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OnceMonthValue = "";
        updatedArray[id].Q401aIntendedDosing_Tal_OtherValue = value;
        updatedArray[id].Q401aIntendedDosingEmpty_Tal = false;
        updatedArray[id].Q401aIntendedDosingRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aPrimaryProf_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aPrimaryProf_Tal =
          !updatedArray[id].Q401aPrimaryProf_Tal;
        updatedArray[id].Q401aUnknownProf_Tal = null;
        updatedArray[id].Q401aReasonIvigEmptyHard_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aSecProf_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aSecProf_Tal = !updatedArray[id].Q401aSecProf_Tal;
        updatedArray[id].Q401aUnknownProf_Tal = null;
        updatedArray[id].Q401aReasonIvigEmptyHard_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aOtherProf_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aOtherProf_Tal =
          !updatedArray[id].Q401aOtherProf_Tal;
        updatedArray[id].Q401aUnknownProf_Tal = null;
        updatedArray[id].Q401aReasonIvigEmptyHard_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aUnknownProf_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aUnknownProf_Tal = Number(value);
        updatedArray[id].Q401aPrimaryProf_Tal = false;
        updatedArray[id].Q401aSecProf_Tal = false;
        updatedArray[id].Q401aOtherProf_Tal = false;
        updatedArray[id].Q401aReasonIvigEmptyHard_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aDosingType_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aDosingType_Tal = Number(value);
        updatedArray[id].Q401aDosingType_TalEmptyHard = false;

        updatedArray[id].Q401aDosage_Tal = null;
        updatedArray[id].Q401aDosage_Tal_GValue = "";
        updatedArray[id].Q401aDosage_Tal_MgValue = "";
        updatedArray[id].Q401aDosageFrequencyEmpty_Tal = false;
        updatedArray[id].Q401aDosageRangeInvalid_Tal = false;

        updatedArray[id].Q401aWeight_Tal = null;
        updatedArray[id].Q401aWeight_Value_KgTal = "";
        updatedArray[id].Q401aWeight_Value_LbsTal = "";
        updatedArray[id].Q401aWeightEmpty_Tal = false;
        updatedArray[id].Q401aWeightRangeInvalid_Tal = false;

        updatedArray[id].Q401aWeight_Asses_Tal = null;
        updatedArray[id].Q401aWeight_Asses_Tal_dt = "";
        updatedArray[id].Q401aWeight_AssesEmptyHard_Tal = false;
        updatedArray[id].Q401aWeight_AssesDtEmptyHard_Tal = false;
        updatedArray[id].Q401aWeight_AssesDtInvalid_Tal = false;
        updatedArray[id].Q401aWeight_Asses_dt_before_eof_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aDosage_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aDosage_Tal = Number(value);
        updatedArray[id].Q401aDosage_Tal_GValue = "";
        updatedArray[id].Q401aDosage_Tal_MgValue = "";
        updatedArray[id].Q401aDosageFrequencyEmpty_Tal = false;
        updatedArray[id].Q401aDosageRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aDosage_Tal_GValue" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aDosage_Tal = 1;
        updatedArray[id].Q401aDosage_Tal_GValue = value;
        updatedArray[id].Q401aDosage_Tal_MgValue = "";
        updatedArray[id].Q401aDosageFrequencyEmpty_Tal = false;
        updatedArray[id].Q401aDosageRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aDosage_Tal_MgValue" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aDosage_Tal = 2;
        updatedArray[id].Q401aDosage_Tal_GValue = "";
        updatedArray[id].Q401aDosage_Tal_MgValue = value;
        updatedArray[id].Q401aDosageFrequencyEmpty_Tal = false;
        updatedArray[id].Q401aDosageRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aWeight_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aWeight_Tal = Number(value);
        updatedArray[id].Q401aWeight_Value_KgTal = "";
        updatedArray[id].Q401aWeight_Value_LbsTal = "";
        updatedArray[id].Q401aWeightEmpty_Tal = false;
        updatedArray[id].Q401aWeightRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aWeight_Value_KgTal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aWeight_Tal = 1;
        updatedArray[id].Q401aWeight_Value_KgTal = value;
        updatedArray[id].Q401aWeight_Value_LbsTal = "";
        updatedArray[id].Q401aWeightEmpty_Tal = false;
        updatedArray[id].Q401aWeightRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aWeight_Value_LbsTal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aWeight_Tal = 2;
        updatedArray[id].Q401aWeight_Value_LbsTal = value;
        updatedArray[id].Q401aWeight_Value_KgTal = "";
        updatedArray[id].Q401aWeightEmpty_Tal = false;
        updatedArray[id].Q401aWeightRangeInvalid_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      case "Q401aWeight_Asses_Tal" + id: {
        let updatedArray = [...Q401aTalDetails];

        updatedArray[id].Q401aWeight_Asses_Tal = Number(value);
        updatedArray[id].Q401aWeight_Asses_Tal_dt =
          Number(value) === 1 ? updatedArray[id].Q401aWeight_Asses_Tal_dt : "";
        updatedArray[id].Q401aWeight_AssesEmptyHard_Tal = false;
        updatedArray[id].Q401aWeight_AssesDtEmptyHard_Tal = false;
        updatedArray[id].Q401aWeight_AssesDtInvalid_Tal = false;
        updatedArray[id].Q401aWeight_Asses_dt_before_eof_Tal = false;

        setQ401aTalDetails(updatedArray);
        break;
      }

      default:
        break;
    }
    //
  };

  const HandleQ402aRepeaterDateChange = (name, date) => {
    const lastIndex = name.lastIndexOf("-");
    const id = name.slice(lastIndex + 1);
    switch (name) {
      case "Q402aIgg_assessment_Tec_dt-" + id: {
        let updatedArray = [...Q402aTecDetails];

        updatedArray[id].Q402aIgg_assessment_Tec = 2;
        updatedArray[id].Q402aIgg_assessment_Tec_dt = date;
        updatedArray[id].Q402aIgg_assessment_Tec_RdHard = false;
        updatedArray[id].Q402aIgg_assessment_Tec_dtHard = false;
        updatedArray[id].Q402aIgg_assessment_Tec_dtInvalid = false;
        updatedArray[id].Q402aIgg_assessment_Tec_dt_before_eof = false;

        setQ402aTecDetails(updatedArray);
        break;
      }
      case "Q402aIgg_assessment_Tal_dt-" + id: {
        let updatedArray = [...Q402aTalDetails];

        updatedArray[id].Q402aIgg_assessment_Tal = 2;
        updatedArray[id].Q402aIgg_assessment_Tal_dt = date;
        updatedArray[id].Q402aIgg_assessment_Tal_RdHard = false;
        updatedArray[id].Q402aIgg_assessment_Tal_dtHard = false;
        updatedArray[id].Q402aIgg_assessment_Tal_dtInvalid = false;
        updatedArray[id].Q402aIgg_assessment_Tal_dt_before_eof = false;

        setQ402aTalDetails(updatedArray);
        break;
      }
      default:
        break;
    }
  };

  const HandleQ402aFieldChange = (e) => {
    const { name, id, value } = e.target;

    switch (name) {
      //Tec
      case "Q402aIgg_assessment_Tec" + id: {
        let updatedArray = [...Q402aTecDetails];

        updatedArray[id].Q402aIgg_assessment_Tec = Number(value);
        updatedArray[id].Q402aIgg_assessment_Tec_dt =
          Number(value) === 2
            ? updatedArray[id].Q402aIgg_assessment_Tec_dt
            : "";
        updatedArray[id].Q402aIgg_assessment_Tec_RdHard = false;
        updatedArray[id].Q402aIgg_assessment_Tec_dtHard = false;
        updatedArray[id].Q402aIgg_assessment_Tec_dtInvalid = false;
        updatedArray[id].Q402aIgg_assessment_Tec_dt_before_eof = false;
        updatedArray[id].Q402aIgg_level_Tec_MgValue = "";
        updatedArray[id].Q402aIgg_level_Tec_GValue = "";
        updatedArray[id].Q402aIgg_level_Tec = null;

        if (Number(value) === 1) {
          updatedArray[id].Q402aIgg_level_Tec = null;
          updatedArray[id].Q402aIgg_level_Tec_MgValue = "";
          updatedArray[id].Q402aIgg_level_Tec_GValue = "";
          updatedArray[id].Q402aIgg_level_Tec_Empty = false;
          updatedArray[id].Q402aIgg_level_Tec_RangeInvalid = false;
        }

        setQ402aTecDetails(updatedArray);
        break;
      }

      case "Q402aIgg_level_Tec" + id: {
        let updatedArray = [...Q402aTecDetails];

        updatedArray[id].Q402aIgg_level_Tec = Number(value);
        updatedArray[id].Q402aIgg_level_Tec_MgValue = "";
        updatedArray[id].Q402aIgg_level_Tec_GValue = "";
        updatedArray[id].Q402aIgg_level_Tec_Empty = false;
        updatedArray[id].Q402aIgg_level_Tec_RangeInvalid = false;

        setQ402aTecDetails(updatedArray);
        break;
      }

      case "Q402aIgg_level_Tec_MgValue" + id: {
        let updatedArray = [...Q402aTecDetails];

        updatedArray[id].Q402aIgg_level_Tec = 1;
        updatedArray[id].Q402aIgg_level_Tec_MgValue = value;
        updatedArray[id].Q402aIgg_level_Tec_GValue = "";
        updatedArray[id].Q402aIgg_level_Tec_Empty = false;
        updatedArray[id].Q402aIgg_level_Tec_RangeInvalid = false;

        setQ402aTecDetails(updatedArray);
        break;
      }

      case "Q402aIgg_level_Tec_GValue" + id: {
        let updatedArray = [...Q402aTecDetails];

        updatedArray[id].Q402aIgg_level_Tec = 2;
        updatedArray[id].Q402aIgg_level_Tec_GValue = value;
        updatedArray[id].Q402aIgg_level_Tec_MgValue = "";
        updatedArray[id].Q402aIgg_level_Tec_Empty = false;
        updatedArray[id].Q402aIgg_level_Tec_RangeInvalid = false;

        setQ402aTecDetails(updatedArray);
        break;
      }

      //Tal
      case "Q402aIgg_assessment_Tal" + id: {
        let updatedArray = [...Q402aTalDetails];

        updatedArray[id].Q402aIgg_assessment_Tal = Number(value);
        updatedArray[id].Q402aIgg_assessment_Tal_dt =
          Number(value) === 2
            ? updatedArray[id].Q402aIgg_assessment_Tal_dt
            : "";
        updatedArray[id].Q402aIgg_assessment_Tal_RdHard = false;
        updatedArray[id].Q402aIgg_assessment_Tal_dtHard = false;
        updatedArray[id].Q402aIgg_assessment_Tal_dtInvalid = false;
        updatedArray[id].Q402aIgg_assessment_Tal_dt_before_eof = false;

        if (Number(value) === 1) {
          updatedArray[id].Q402aIgg_level_Tal = null;
          updatedArray[id].Q402aIgg_level_Tal_MgValue = "";
          updatedArray[id].Q402aIgg_level_Tal_GValue = "";
          updatedArray[id].Q402aIgg_level_Tal_Empty = false;
          updatedArray[id].Q402aIgg_level_Tal_RangeInvalid = false;
        }

        setQ402aTalDetails(updatedArray);
        break;
      }

      case "Q402aIgg_level_Tal" + id: {
        let updatedArray = [...Q402aTalDetails];

        updatedArray[id].Q402aIgg_level_Tal = Number(value);
        updatedArray[id].Q402aIgg_level_Tal_MgValue = "";
        updatedArray[id].Q402aIgg_level_Tal_GValue = "";
        updatedArray[id].Q402aIgg_level_Tal_Empty = false;
        updatedArray[id].Q402aIgg_level_Tal_RangeInvalid = false;

        setQ402aTalDetails(updatedArray);
        break;
      }

      case "Q402aIgg_level_Tal_MgValue" + id: {
        let updatedArray = [...Q402aTalDetails];

        updatedArray[id].Q402aIgg_level_Tal = 1;
        updatedArray[id].Q402aIgg_level_Tal_MgValue = value;
        updatedArray[id].Q402aIgg_level_Tal_GValue = "";
        updatedArray[id].Q402aIgg_level_Tal_Empty = false;
        updatedArray[id].Q402aIgg_level_Tal_RangeInvalid = false;

        setQ402aTalDetails(updatedArray);
        break;
      }

      case "Q402aIgg_level_Tal_GValue" + id: {
        let updatedArray = [...Q402aTalDetails];

        updatedArray[id].Q402aIgg_level_Tal = 2;
        updatedArray[id].Q402aIgg_level_Tal_GValue = value;
        updatedArray[id].Q402aIgg_level_Tal_MgValue = "";
        updatedArray[id].Q402aIgg_level_Tal_Empty = false;
        updatedArray[id].Q402aIgg_level_Tal_RangeInvalid = false;

        setQ402aTalDetails(updatedArray);
        break;
      }
      default:
        break;
    }
    //
  };

  const HandleQ403aRepeaterDateChange = (name, date) => {
    const lastIndex = name.lastIndexOf("-");
    const id = name.slice(lastIndex + 1);
    switch (name) {
      case "Q403aIgg_assessment_Tec_dt-" + id: {
        let updatedArray = [...Q403aTecDetails];

        updatedArray[id].Q403aIgg_assessment_Tec = 2;
        updatedArray[id].Q403aIgg_assessment_Tec_dt = date;
        updatedArray[id].Q403aIgg_assessment_Tec_RdHard = false;
        updatedArray[id].Q403aIgg_assessment_Tec_dtHard = false;
        updatedArray[id].Q403aIgg_assessment_Tec_dtInvalid = false;
        updatedArray[id].Q403aIgg_assessment_Tec_dt_before_eof = false;

        setQ403aTecDetails(updatedArray);
        break;
      }
      case "Q403aIgg_assessment_Tal_dt-" + id: {
        let updatedArray = [...Q403aTalDetails];

        updatedArray[id].Q403aIgg_assessment_Tal = 2;
        updatedArray[id].Q403aIgg_assessment_Tal_dt = date;
        updatedArray[id].Q403aIgg_assessment_Tal_RdHard = false;
        updatedArray[id].Q403aIgg_assessment_Tal_dtHard = false;
        updatedArray[id].Q403aIgg_assessment_Tal_dtInvalid = false;
        updatedArray[id].Q403aIgg_assessment_Tal_dt_before_eof = false;

        setQ403aTalDetails(updatedArray);
        break;
      }
      default:
        break;
    }
  };

  const HandleQ403aFieldChange = (e) => {
    const { name, id, value } = e.target;

    switch (name) {
      //Tec
      case "Q403aIgg_assessment_Tec" + id: {
        let updatedArray = [...Q403aTecDetails];

        updatedArray[id].Q403aIgg_assessment_Tec = Number(value);
        updatedArray[id].Q403aIgg_assessment_Tec_dt =
          Number(value) === 2
            ? updatedArray[id].Q403aIgg_assessment_Tec_dt
            : "";
        updatedArray[id].Q403aIgg_assessment_Tec_RdHard = false;
        updatedArray[id].Q403aIgg_assessment_Tec_dtHard = false;
        updatedArray[id].Q403aIgg_assessment_Tec_dtInvalid = false;
        updatedArray[id].Q403aIgg_assessment_Tec_dt_before_eof = false;
        updatedArray[id].Q403aIgg_level_Tec_MgValue = "";
        updatedArray[id].Q403aIgg_level_Tec_GValue = "";
        updatedArray[id].Q403aIgg_level_Tec = null;

        if (Number(value) === 1) {
          updatedArray[id].Q403aIgg_level_Tec = null;
          updatedArray[id].Q403aIgg_level_Tec_MgValue = "";
          updatedArray[id].Q403aIgg_level_Tec_GValue = "";
          updatedArray[id].Q403aIgg_level_Tec_Empty = false;
          updatedArray[id].Q403aIgg_level_Tec_RangeInvalid = false;
        }

        setQ403aTecDetails(updatedArray);
        break;
      }

      case "Q403aIgg_level_Tec" + id: {
        let updatedArray = [...Q403aTecDetails];

        updatedArray[id].Q403aIgg_level_Tec = Number(value);
        updatedArray[id].Q403aIgg_level_Tec_MgValue = "";
        updatedArray[id].Q403aIgg_level_Tec_GValue = "";
        updatedArray[id].Q403aIgg_level_Tec_Empty = false;
        updatedArray[id].Q403aIgg_level_Tec_RangeInvalid = false;

        setQ403aTecDetails(updatedArray);
        break;
      }

      case "Q403aIgg_level_Tec_MgValue" + id: {
        let updatedArray = [...Q403aTecDetails];

        updatedArray[id].Q403aIgg_level_Tec = 1;
        updatedArray[id].Q403aIgg_level_Tec_MgValue = value;
        updatedArray[id].Q403aIgg_level_Tec_GValue = "";
        updatedArray[id].Q403aIgg_level_Tec_Empty = false;
        updatedArray[id].Q403aIgg_level_Tec_RangeInvalid = false;

        setQ403aTecDetails(updatedArray);
        break;
      }

      case "Q403aIgg_level_Tec_GValue" + id: {
        let updatedArray = [...Q403aTecDetails];

        updatedArray[id].Q403aIgg_level_Tec = 2;
        updatedArray[id].Q403aIgg_level_Tec_GValue = value;
        updatedArray[id].Q403aIgg_level_Tec_MgValue = "";
        updatedArray[id].Q403aIgg_level_Tec_Empty = false;
        updatedArray[id].Q403aIgg_level_Tec_RangeInvalid = false;

        setQ403aTecDetails(updatedArray);
        break;
      }

      //Tal
      case "Q403aIgg_assessment_Tal" + id: {
        let updatedArray = [...Q403aTalDetails];

        updatedArray[id].Q403aIgg_assessment_Tal = Number(value);
        updatedArray[id].Q403aIgg_assessment_Tal_dt =
          Number(value) === 2
            ? updatedArray[id].Q403aIgg_assessment_Tal_dt
            : "";
        updatedArray[id].Q403aIgg_assessment_Tal_RdHard = false;
        updatedArray[id].Q403aIgg_assessment_Tal_dtHard = false;
        updatedArray[id].Q403aIgg_assessment_Tal_dtInvalid = false;
        updatedArray[id].Q403aIgg_assessment_Tal_dt_before_eof = false;

        if (Number(value) === 1) {
          updatedArray[id].Q403aIgg_level_Tal = null;
          updatedArray[id].Q403aIgg_level_Tal_MgValue = "";
          updatedArray[id].Q403aIgg_level_Tal_GValue = "";
          updatedArray[id].Q403aIgg_level_Tal_Empty = false;
          updatedArray[id].Q403aIgg_level_Tal_RangeInvalid = false;
        }

        setQ403aTalDetails(updatedArray);
        break;
      }

      case "Q403aIgg_level_Tal" + id: {
        let updatedArray = [...Q403aTalDetails];

        updatedArray[id].Q403aIgg_level_Tal = Number(value);
        updatedArray[id].Q403aIgg_level_Tal_MgValue = "";
        updatedArray[id].Q403aIgg_level_Tal_GValue = "";
        updatedArray[id].Q403aIgg_level_Tal_Empty = false;
        updatedArray[id].Q403aIgg_level_Tal_RangeInvalid = false;

        setQ403aTalDetails(updatedArray);
        break;
      }

      case "Q403aIgg_level_Tal_MgValue" + id: {
        let updatedArray = [...Q403aTalDetails];

        updatedArray[id].Q403aIgg_level_Tal = 1;
        updatedArray[id].Q403aIgg_level_Tal_MgValue = value;
        updatedArray[id].Q403aIgg_level_Tal_GValue = "";
        updatedArray[id].Q403aIgg_level_Tal_Empty = false;
        updatedArray[id].Q403aIgg_level_Tal_RangeInvalid = false;

        setQ403aTalDetails(updatedArray);
        break;
      }

      case "Q403aIgg_level_Tal_GValue" + id: {
        let updatedArray = [...Q403aTalDetails];

        updatedArray[id].Q403aIgg_level_Tal = 2;
        updatedArray[id].Q403aIgg_level_Tal_GValue = value;
        updatedArray[id].Q403aIgg_level_Tal_MgValue = "";
        updatedArray[id].Q403aIgg_level_Tal_Empty = false;
        updatedArray[id].Q403aIgg_level_Tal_RangeInvalid = false;

        setQ402aTalDetails(updatedArray);
        break;
      }
      default:
        break;
    }
    //
  };

  const updateQ361HospitalizationWarning = (
    cohortType,
    hospDetails,
    treatmentDetails,
  ) => {
    if (
      !cohortType ||
      !hospDetails?.length === 0 ||
      !treatmentDetails?.length === 0
    )
      return false;

    const hasHospitalizations = hospDetails.some(
      (v) => v.dt_admission !== null && v.dt_admission !== 2,
    );

    const hasInpatientDoses = treatmentDetails.some((v) => {
      if (cohortType === RRMMCohortTreatment.TALVEY) {
        return v.dosing_phase_tal !== 5 && v.siteofcare_tal === 1;
      }

      if (cohortType === RRMMCohortTreatment.TECVAYLI) {
        return v.dosing_phase_tech !== 4 && v.siteofcare_tech === 1;
      }

      return false;
    });

    const showWarning = hasInpatientDoses && !hasHospitalizations;

    if (cohortType === RRMMCohortTreatment.TALVEY) {
      setAtleastonesetupTal_WarningHard(showWarning);
    } else if (cohortType === RRMMCohortTreatment.TECVAYLI) {
      setAtleastonesetupTec_WarningHard(showWarning);
    }
    return showWarning;
  };

  const ValidateForm = () => {
    let isValid = true;
    let count = 0;
    let count_tal = 0;

    if (
      isTechvayliSelected &&
      techvayliDetails &&
      techvayliDetails.length > 0
    ) {
      if (
        techvayliDetails.length != tecNumberofAdministrator &&
        tecNumberofAdministrator != 0
      ) {
        setTecNumberofAdministratorMatching(true);
      } else {
        setTecNumberofAdministratorMatching(false);
      }
    }

    if (isTalveySelected && talveyDetails && talveyDetails.length > 0) {
      if (
        talveyDetails.length != talNumberofAdministrator &&
        talNumberofAdministrator != 0
      ) {
        setTalNumberofAdministratorMatching(true);
      } else {
        setTalNumberofAdministratorMatching(false);
      }
    }

    if (bispecificQ26Data?.length > 0) {
      const isTecValid = ValidateQ26LastAdministrationMatch({
        isSelected: isTechvayliSelected,
        details: techvayliDetails,
        cohortId: RRMMCohortTreatment.TECVAYLI,
        dateField: "dose_administration_tech_dt",
        q26Data: bispecificQ26Data,
      });

      setIsTecLastAdminDateValid(isTecValid);

      const isTalValid = ValidateQ26LastAdministrationMatch({
        isSelected: isTalveySelected,
        details: talveyDetails,
        cohortId: RRMMCohortTreatment.TALVEY,
        dateField: "dose_administration_tal_dt",
        q26Data: bispecificQ26Data,
      });

      setIsTalLastAdminDateValid(isTalValid);

      if (!isTecValid || !isTalValid) isValid = false;
    }

    //36 Techvayli
    if (
      isTechvayliSelected &&
      techvayliDetails &&
      techvayliDetails.length > 0
    ) {
      const updatedArray = techvayliDetails.map((item, index) => {
        let dose_administration_techHard = false;
        if (item.dose_administration_tech == null) {
          dose_administration_techHard = true;
        }

        let dose_administration_techHard_dt = false;
        let dt_tech_date_out_of_bound = false;
        let Invalid_dose_administration_tech_dt = false;
        let dose_administration_tech_dt_before_eof = false;
        if (item.dose_administration_tech === 1) {
          if (item.dose_administration_tech_dt === "") {
            dose_administration_techHard_dt = true;
          } else if (item.dose_administration_tech_dt === "Invalid Date") {
            Invalid_dose_administration_tech_dt = true;
          } else if (
            item.dose_administration_tech_dt !== "Invalid Date" &&
            !DateInRange(
              item.dose_administration_tech_dt,
              dayjs("01-01-1920"),
              dayjs(),
            )
          ) {
            Invalid_dose_administration_tech_dt = true;
          } else {
            const dates = techvayliDetails
              .map((r) => r.dose_administration_tech_dt)
              .filter(Boolean); // remove null/undefined
            const hasDuplicateDates = new Set(dates).size !== dates.length;
            if (hasDuplicateDates) setDateRRMMTec_dupDateHard(true);

            if (
              (techIndexDate !== "" &&
                IsDateAfter(techIndexDate, item.dose_administration_tech_dt)) ||
              (tecvayliDateRRMM !== "" &&
                IsDateAfter(item.dose_administration_tech_dt, tecvayliDateRRMM)) // ||
            ) {
              dt_tech_date_out_of_bound = true;
            } else {
              if (
                endOfFollowUpDate !== null &&
                endOfFollowUpDate !== "" &&
                endOfFollowUpDate !== "Invalid Date"
              ) {
                const EOFDateAfter = IsDateAfter(
                  item.dose_administration_tech_dt,
                  endOfFollowUpDate,
                );
                if (EOFDateAfter) {
                  dose_administration_tech_dt_before_eof = true;
                }
              }
            }
          }
        }

        let dosing_phase_techHard = false;
        if (item.dosing_phase_tech == null) {
          dosing_phase_techHard = true;
        }

        let siteofcare_techHard = false;
        if (item.siteofcare_tech == null) {
          siteofcare_techHard = true;
        }

        let dosing_phase_techHard_othEmpty = false;
        if (
          item.dosing_phase_tech === 5 &&
          item.dosing_phase_oth_txt_tech == ""
        ) {
          dosing_phase_techHard_othEmpty = true;
        }

        let tech_dose_strength_mg_kgHard = false;
        if (
          item.tech_dose_strength_rbl == null ||
          (item.tech_dose_strength_mg === "" &&
            item.tech_dose_strength_mg_kg === "" &&
            item.tech_dose_strength_mgm === "" &&
            item.tech_dose_strength_rbl !== 99)
        ) {
          tech_dose_strength_mg_kgHard = true;
        }

        let tech_dose_strength_mg_kgRange = false;
        if (
          !tech_dose_strength_mg_kgHard &&
          item.tech_dose_strength_rbl !== 99 &&
          ((item.tech_dose_strength_mg_kg != "" &&
            !isValidNumberRange(item.tech_dose_strength_mg_kg)) ||
            (item.tech_dose_strength_mg != "" &&
              !isValidNumberRange(item.tech_dose_strength_mg)) ||
            (item.tech_dose_strength_mgm != "" &&
              !isValidNumberRange(item.tech_dose_strength_mgm)))
        ) {
          tech_dose_strength_mg_kgRange = true;
        }

        if (!isStringEmpty(item.dose_administration_tech_dt) && techIndexDate) {
          if (techIndexDate === item.dose_administration_tech_dt) {
            count++;
          }
        } else if (
          isStringEmpty(item.dose_administration_tech) ||
          item.dose_administration_tech === 99
        ) {
          count++;
        }

        if (
          dose_administration_techHard ||
          dose_administration_techHard_dt ||
          dosing_phase_techHard ||
          siteofcare_techHard ||
          dosing_phase_techHard_othEmpty ||
          tech_dose_strength_mg_kgHard ||
          tech_dose_strength_mg_kgRange ||
          dt_tech_date_out_of_bound ||
          Invalid_dose_administration_tech_dt ||
          dose_administration_tech_dt_before_eof
        ) {
          isValid = false;
        }

        return {
          ...item,
          dose_administration_techHard,
          dose_administration_techHard_dt,
          Invalid_dose_administration_tech_dt,
          dose_administration_tech_dt_before_eof,
          dosing_phase_techHard,
          siteofcare_techHard,
          dosing_phase_techHard_othEmpty,
          tech_dose_strength_mg_kgHard,
          tech_dose_strength_mg_kgRange,
          dt_tech_date_out_of_bound,
        };
      });
      if (count === 0) {
        setIndexDateRRMM_techHard(true);
        isValid = false;
      } else {
        setIndexDateRRMM_techHard(false);
      }
      setTechvayliDetails(updatedArray);

      const isDateValid = ValidateForDateCondition(techvayliDetails);

      if (!isDateValid) {
        setDt_tec_2L_3L_date_conditions(true);
        isValid = false;
      }
    }

    //36.1 Techvayli
    if (isTechvayliSelected && tecHospDetails && tecHospDetails.length > 0) {
      const updatedArray = tecHospDetails.map((item, index) => {
        let dt_admission_Hard = false;
        let dt_admission_Hard_dt = false;
        let Invalid_admission_Hard_dt = false;
        let Invalid_dt_discharge_Hard = false;
        let dt_admission_before_eof = false;
        // let dt_admission_Hard_dt_check = false;
        let dt_admission_out_of_bound = false;

        let dt_discharge_Hard = false;
        let dt_discharge_Hard_dt = false;
        let dt_discharge_Hard_dt_check = false;
        let dt_discharge_out_of_bound = false;

        let dischargeMoreThanAdministrationWarning = false;
        let dt_discharge_before_eof = false;

        let hospReasonEmptyHard = false;
        let hospReasonTxtEmpty = false;

        dt_admission_Hard = item.dt_admission == null;

        if (item.dt_admission === 1) {
          if (item.dt_admission_dt === "") {
            dt_admission_Hard_dt = true;
          } else if (item.dt_admission_dt === "Invalid Date") {
            Invalid_admission_Hard_dt = true;
          } else if (
            item.dt_admission_dt !== "Invalid Date" &&
            !DateInRange(item.dt_admission_dt, dayjs("01-01-1920"), dayjs())
          ) {
            Invalid_admission_Hard_dt = true;
          } else {
            if (
              (techIndexDate !== "" &&
                IsDateAfter(techIndexDate, item.dt_admission_dt)) ||
              (tecvayliDateRRMM !== "" &&
                IsDateAfter(item.dt_admission_dt, tecvayliDateRRMM))
            ) {
              dt_admission_out_of_bound = true;
            } else {
              if (
                endOfFollowUpDate !== null &&
                endOfFollowUpDate !== "" &&
                endOfFollowUpDate !== "Invalid Date"
              ) {
                const EOFDateAfter = IsDateAfter(
                  item.dt_admission_dt,
                  endOfFollowUpDate,
                );
                if (EOFDateAfter) {
                  dt_admission_before_eof = true;
                }
              }
            }
          }
        }

        if (item.dt_admission != null && item.dt_admission !== 2) {
          dt_discharge_Hard = item.dt_discharge == null;

          if (item.dt_discharge === 1) {
            if (item.dt_discharge_dt === "") {
              dt_discharge_Hard_dt = true;
            } else if (item.dt_discharge_dt === "Invalid Date") {
              Invalid_dt_discharge_Hard = true;
            } else if (
              item.dt_discharge_dt !== "Invalid Date" &&
              !DateInRange(item.dt_discharge_dt, dayjs("01-01-1920"), dayjs())
            ) {
              Invalid_dt_discharge_Hard = true;
            } else {
              if (
                (techIndexDate !== "" &&
                  IsDateAfter(techIndexDate, item.dt_discharge_dt)) ||
                (tecvayliDateRRMM !== "" &&
                  IsDateAfter(item.dt_discharge_dt, tecvayliDateRRMM))
              ) {
                dt_discharge_out_of_bound = true;
              } else {
                if (
                  endOfFollowUpDate !== null &&
                  endOfFollowUpDate !== "" &&
                  endOfFollowUpDate !== "Invalid Date"
                ) {
                  const EOFDateAfter = IsDateAfter(
                    item.dt_discharge_dt,
                    endOfFollowUpDate,
                  );
                  if (EOFDateAfter) {
                    dt_discharge_before_eof = true;
                  }
                }
              }
            }

            if (item.dt_discharge_dt !== "") {
              const latestDoseDate = techvayliDetails
                .map((r) => r.dose_administration_tech_dt)
                .filter(Boolean)
                .reduce(
                  (latest, curr) =>
                    new Date(curr) > new Date(latest) ? curr : latest,
                  null,
                );
              if (latestDoseDate != "" && latestDoseDate != null) {
                const check = IsDateAfter(item.dt_discharge_dt, latestDoseDate);
                if (check) {
                  dischargeMoreThanAdministrationWarning = true;
                } else dischargeMoreThanAdministrationWarning = false;
              }
            }
          }
          if (
            item.dt_admission_dt &&
            DateInRange(item.dt_discharge_dt, dayjs("01-01-1920"), dayjs()) &&
            IsDateAfter(item.dt_admission_dt, item.dt_discharge_dt) // item.dt_admission_dt > item.dt_discharge_dt
          ) {
            dt_discharge_Hard_dt_check = true;
          }
          hospReasonEmptyHard =
            !item.hospReason1 &&
            !item.hospReason2 &&
            !item.hospReason3 &&
            !item.hospReason4 &&
            !item.hospReason5 &&
            !item.hospReason6 &&
            !item.hospReasonUnk;
          hospReasonTxtEmpty =
            item.hospReason6 && isStringEmpty(item.hosp_reason_oth_txt);
        }

        if (
          dt_admission_Hard ||
          dt_admission_Hard_dt ||
          // dt_admission_Hard_dt_check ||
          dt_admission_out_of_bound ||
          dt_discharge_Hard ||
          dt_discharge_Hard_dt ||
          dt_discharge_Hard_dt_check ||
          dt_discharge_out_of_bound ||
          hospReasonEmptyHard ||
          hospReasonTxtEmpty ||
          Invalid_admission_Hard_dt ||
          Invalid_dt_discharge_Hard ||
          dt_admission_before_eof ||
          dt_discharge_before_eof
        ) {
          isValid = false;
        }

        return {
          ...item,
          dt_admission_Hard,
          dt_admission_Hard_dt,
          // dt_admission_Hard_dt_check,
          dt_admission_out_of_bound,
          dt_discharge_Hard,
          dt_discharge_Hard_dt,
          dt_discharge_Hard_dt_check,
          dt_discharge_out_of_bound,
          hospReasonEmptyHard,
          hospReasonTxtEmpty,
          Invalid_admission_Hard_dt,
          Invalid_dt_discharge_Hard,
          dt_admission_before_eof,
          dt_discharge_before_eof,
          dischargeMoreThanAdministrationWarning,
        };
      });

      setTecHospDetails(updatedArray);
    }

    if (isTechvayliSelected && techvayliDetails?.length > 0) {
      const isTecInpatientWarning = updateQ361HospitalizationWarning(
        RRMMCohortTreatment.TECVAYLI,
        tecHospDetails,
        techvayliDetails,
      );
      if (isTecInpatientWarning) {
        isValid = false;
      }
    }

    //end
    //36 Talvey
    if (isTalveySelected && talveyDetails && talveyDetails.length > 0) {
      const updatedArray = talveyDetails.map((item, index) => {
        let dose_administration_talHard = false;
        if (item.dose_administration_tal == null) {
          dose_administration_talHard = true;
        }

        let Invalid_dose_administration_tal_dt = false;

        let dose_administration_talHard_dt = false;
        let dt_tal_date_out_of_bound = false;
        if (item.dose_administration_tal === 1) {
          if (item.dose_administration_tal_dt === "") {
            dose_administration_talHard_dt = true;
          } else if (item.dose_administration_tal_dt === "Invalid Date") {
            Invalid_dose_administration_tal_dt = true;
          } else if (
            item.dose_administration_tal_dt !== "Invalid Date" &&
            !DateInRange(
              item.dose_administration_tal_dt,
              dayjs("01-01-1920"),
              dayjs(),
            )
          ) {
            Invalid_dose_administration_tal_dt = true;
          } else {
            const dates = talveyDetails
              .map((r) => r.dose_administration_tal_dt)
              .filter(Boolean); // remove null/undefined
            const hasDuplicateDates = new Set(dates).size !== dates.length;
            if (hasDuplicateDates) setDateRRMMTal_dupDateHard(true);

            if (
              (talIndexDate !== "" &&
                IsDateAfter(talIndexDate, item.dose_administration_tal_dt)) ||
              (talveyDateRRMM !== "" &&
                IsDateAfter(item.dose_administration_tal_dt, talveyDateRRMM)) // ||
            ) {
              dt_tal_date_out_of_bound = true;
            }
          }
        }

        let dosing_phase_talHard = false;
        if (item.dosing_phase_tal == null) {
          dosing_phase_talHard = true;
        }

        let siteofcare_talHard = false;
        if (item.siteofcare_tal == null) {
          siteofcare_talHard = true;
        }

        let dosing_phase_talHard_othEmpty = false;
        if (
          item.dosing_phase_tal === 6 &&
          item.dosing_phase_oth_txt_tal == ""
        ) {
          dosing_phase_talHard_othEmpty = true;
        }

        let tal_dose_strength_mg_kgHard = false;
        if (
          item.tal_dose_strength_rbl === null ||
          (item.tal_dose_strength_mg === "" &&
            item.tal_dose_strength_mg_kg === "" &&
            item.tal_dose_strength_mgm === "" &&
            item.tal_dose_strength_rbl !== 99)
        ) {
          tal_dose_strength_mg_kgHard = true;
        }

        let tal_dose_strength_mg_kgRange = false;
        if (
          !tal_dose_strength_mg_kgHard &&
          item.tal_dose_strength_rbl !== 99 &&
          ((item.tal_dose_strength_mg_kg != "" &&
            !isValidNumberRange(item.tal_dose_strength_mg_kg)) ||
            (item.tal_dose_strength_mg != "" &&
              !isValidNumberRange(item.tal_dose_strength_mg)) ||
            (item.tal_dose_strength_mgm != "" &&
              !isValidNumberRange(item.tal_dose_strength_mgm)))
        ) {
          tal_dose_strength_mg_kgRange = true;
        }

        if (!isStringEmpty(item.dose_administration_tal_dt) && talIndexDate) {
          if (talIndexDate === item.dose_administration_tal_dt) {
            count_tal++;
          }
        } else if (
          isStringEmpty(item.dose_administration_tal) ||
          item.dose_administration_tal === 99
        ) {
          count_tal++;
        }

        if (
          dose_administration_talHard ||
          dose_administration_talHard_dt ||
          dosing_phase_talHard ||
          siteofcare_talHard ||
          dosing_phase_talHard_othEmpty ||
          tal_dose_strength_mg_kgHard ||
          tal_dose_strength_mg_kgRange ||
          dt_tal_date_out_of_bound ||
          Invalid_dose_administration_tal_dt
        ) {
          isValid = false;
        }

        return {
          ...item,

          dose_administration_talHard,
          dose_administration_talHard_dt,
          dosing_phase_talHard,
          siteofcare_talHard,

          dosing_phase_talHard_othEmpty,
          tal_dose_strength_mg_kgHard,
          tal_dose_strength_mg_kgRange,
          dt_tal_date_out_of_bound,
          Invalid_dose_administration_tal_dt,
        };
      });

      if (count_tal === 0) {
        setIndexDateRRMM_talHard(true);
        isValid = false;
      } else {
        setIndexDateRRMM_talHard(false);
      }
      setTalveyDetails(updatedArray);

      const isDateValid = ValidateForDateCondition(talveyDetails);
      if (!isDateValid) {
        setDt_tal_2L_3L_date_conditions(true);
        isValid = false;
      }
    }

    //36.1 Talvey
    if (isTalveySelected && talHospDetails && talHospDetails.length > 0) {
      const updatedArray = talHospDetails.map((item, index) => {
        let dt_admission_Hard = false;
        let dt_admission_Hard_dt = false;

        let dt_discharge_Hard = false;
        let dt_discharge_Hard_dt = false;
        let dt_discharge_Hard_dt_check = false;
        let dt_discharge_out_of_bound = false;
        let dt_admission_out_of_bound = false;
        let Invalid_admission_Hard_dt = false;
        let dt_admission_before_eof = false;
        let dt_discharge_before_eof = false;
        let dischargeMoreThanAdministrationWarning = false;
        let hospReasonEmptyHard = false;
        let hospReasonTxtEmpty = false;

        dt_admission_Hard = item.dt_admission == null;
        if (item.dt_admission === 1) {
          if (item.dt_admission_dt === "") {
            dt_admission_Hard_dt = true;
          } else if (item.dt_admission_dt === "Invalid Date") {
            Invalid_admission_Hard_dt = true;
          } else if (
            item.dt_admission_dt !== "Invalid Date" &&
            !DateInRange(item.dt_admission_dt, dayjs("01-01-1920"), dayjs())
          ) {
            Invalid_admission_Hard_dt = true;
          } else {
            if (
              (talIndexDate !== "" &&
                IsDateAfter(talIndexDate, item.dt_admission_dt)) ||
              (talveyDateRRMM !== "" &&
                IsDateAfter(item.dt_admission_dt, talveyDateRRMM))
            ) {
              dt_admission_out_of_bound = true;
            } else {
              if (
                endOfFollowUpDate !== null &&
                endOfFollowUpDate !== "" &&
                endOfFollowUpDate !== "Invalid Date"
              ) {
                const EOFDateAfter = IsDateAfter(
                  item.dt_admission_dt,
                  endOfFollowUpDate,
                );
                if (EOFDateAfter) {
                  dt_admission_before_eof = true;
                }
              }
            }
          }
        }

        let Invalid_dt_discharge_Hard = false;
        if (item.dt_admission != null && item.dt_admission !== 2) {
          dt_discharge_Hard = item.dt_discharge == null;

          if (item.dt_discharge === 1) {
            if (item.dt_discharge_dt === "") {
              dt_discharge_Hard_dt = true;
            } else if (item.dt_discharge_dt === "Invalid Date") {
              Invalid_dt_discharge_Hard = true;
            } else if (
              item.dt_discharge_dt !== "Invalid Date" &&
              !DateInRange(item.dt_discharge_dt, dayjs("01-01-1920"), dayjs())
            ) {
              Invalid_dt_discharge_Hard = true;
            } else {
              if (
                (talIndexDate !== "" &&
                  IsDateAfter(talIndexDate, item.dt_discharge_dt)) ||
                (talveyDateRRMM !== "" &&
                  IsDateAfter(item.dt_discharge_dt, talveyDateRRMM))
              ) {
                dt_discharge_out_of_bound = true;
              } else {
                if (
                  endOfFollowUpDate !== null &&
                  endOfFollowUpDate !== "" &&
                  endOfFollowUpDate !== "Invalid Date"
                ) {
                  const EOFDateAfter = IsDateAfter(
                    item.dt_discharge_dt,
                    endOfFollowUpDate,
                  );
                  if (EOFDateAfter) {
                    dt_discharge_before_eof = true;
                  }
                }
              }
            }
            if (item.dt_discharge_dt !== "") {
              const latestDoseDate = talveyDetails
                .map((r) => r.dose_administration_tal_dt)
                .filter(Boolean)
                .reduce(
                  (latest, curr) =>
                    new Date(curr) > new Date(latest) ? curr : latest,
                  null,
                );

              if (latestDoseDate != "" && latestDoseDate != null) {
                const check = IsDateAfter(item.dt_discharge_dt, latestDoseDate);
                if (check) {
                  dischargeMoreThanAdministrationWarning = true;
                } else dischargeMoreThanAdministrationWarning = false;
              }
            }
          }

          if (
            item.dt_admission_dt &&
            item.dt_discharge_dt &&
            DateInRange(item.dt_discharge_dt, dayjs("01-01-1920"), dayjs()) &&
            IsDateAfter(item.dt_admission_dt, item.dt_discharge_dt) //item.dt_admission_dt > item.dt_discharge_dt
          ) {
            dt_discharge_Hard_dt_check = true;
          }
          hospReasonEmptyHard =
            !item.hospReason1 &&
            !item.hospReason2 &&
            !item.hospReason3 &&
            !item.hospReason4 &&
            !item.hospReason5 &&
            !item.hospReason6 &&
            !item.hospReasonUnk;
          hospReasonTxtEmpty =
            item.hospReason6 && isStringEmpty(item.hosp_reason_oth_txt);
        }

        if (
          dt_admission_Hard ||
          dt_admission_Hard_dt ||
          // dt_admission_Hard_dt_check ||
          dt_admission_out_of_bound ||
          dt_discharge_Hard ||
          dt_discharge_Hard_dt ||
          dt_discharge_Hard_dt_check ||
          dt_discharge_out_of_bound ||
          hospReasonEmptyHard ||
          hospReasonTxtEmpty ||
          Invalid_admission_Hard_dt ||
          Invalid_dt_discharge_Hard ||
          dt_admission_before_eof ||
          dt_discharge_before_eof
        ) {
          isValid = false;
        }

        return {
          ...item,
          dt_admission_Hard,
          dt_admission_Hard_dt,
          // dt_admission_Hard_dt_check,
          dt_admission_out_of_bound,
          dt_discharge_Hard,
          dt_discharge_Hard_dt,
          dt_discharge_Hard_dt_check,
          dt_discharge_out_of_bound,
          hospReasonEmptyHard,
          hospReasonTxtEmpty,
          Invalid_admission_Hard_dt,
          Invalid_dt_discharge_Hard,
          dt_admission_before_eof,
          dt_discharge_before_eof,
          dischargeMoreThanAdministrationWarning,
        };
      });

      setTalHospDetails(updatedArray);
    }
    if (isTalveySelected && talveyDetails?.length > 0) {
      const isTalInpatientWarning = updateQ361HospitalizationWarning(
        RRMMCohortTreatment.TALVEY,
        talHospDetails,
        talveyDetails,
      );
      if (isTalInpatientWarning) {
        isValid = false;
      }
    }

    //end

    //Q39 - Q40
    if (isTechvayliSelected && Q37TechDetails && Q37TechDetails.length > 0) {
      const updatedArray = Q37TechDetails.map((item) => {
        let Q40DosingFreqEmptyHard = false;
        let Q40DosingFreqTxtEmptyHard = false;

        let Q40IgGEmptyHard = false;
        let Q40ReasonEmptyHard = false;
        let Q40Init_RdHard = false;
        let Q40Init_dtHard = false;
        let InvalidQ40init_dt = false;
        let init_dt_before_eof = false;

        if (item.Q40dosingfreqRd == null) {
          Q40DosingFreqEmptyHard = true;
        }

        if (item.Q40dosingfreqRd === 5 && item.dosing_freq_oth_txt === "") {
          Q40DosingFreqTxtEmptyHard = true;
        }

        if (item.Q40dosingfreqRd !== 1) {
          if (item.Q40IgILevelRd === null) {
            Q40IgGEmptyHard = true;
          }

          if (
            item.primaryProf === false &&
            item.secondaryProf === false &&
            item.otherReson === false
          ) {
            Q40ReasonEmptyHard = true;
          }

          if (item.Q40init_dt_Rd === null) {
            Q40Init_RdHard = true;
          }
          if (!Q40Init_RdHard && item.Q40init_dt_Rd === 1) {
            if (isStringEmpty(item.Q40init_dt)) {
              Q40Init_dtHard = true;
            } else if (!IsDateValid(item.Q40init_dt)) {
              InvalidQ40init_dt = true;
            } else if (
              !ValidateIndexDAndLOTDateChain(
                item.Q40init_dt,
                RRMMCohortTreatment.TECVAYLI,
              )
            ) {
              init_dt_before_eof = true;
            }
          }
        }

        //37Tech

        let q37_Tec_Dose_week_frquencyRd_Empty = false;

        let q37TechvayliEmpty = false;
        let q37_Tec_Dose_week_frquency_txt_Empty = false;
        let q37_atleasetOneAdministrationTecWarningHard = false;
        let q37_Tec_Dose_week_strengthRd_Empty = false;
        let q37_Tec_Dose_week_strength_txt_Empty = false;
        let q37TecDoseWeekFrequencyRangeError = false;
        if (isNewEcrfA === false) {
          //B
          q37_Tec_Dose_week_frquencyRd_Empty =
            item.q37_Tec_Dose_week_frquencyRd == null;

          if (!q37_Tec_Dose_week_frquencyRd_Empty) {
            //37-warning
            let isSubsequentOptionSelected =
              techvayliDetails &&
              techvayliDetails.length > 0 &&
              techvayliDetails.some((item) => item.dosing_phase_tech === 4);
            if (
              isSubsequentOptionSelected &&
              item.q37_Tec_Dose_week_frquencyRd === 1
            ) {
              q37_atleasetOneAdministrationTecWarningHard = true;
            }

            if (item.q37_Tec_Dose_week_frquencyRd === 2) {
              if (isStringEmpty(item.q37_Tec_Dose_week_frquency_txt)) {
                q37_Tec_Dose_week_frquency_txt_Empty = true;
              } else {
                const checkValue = isValidNumber(
                  item.q37_Tec_Dose_week_frquency_txt,
                );
                if (!checkValue) {
                  q37TecDoseWeekFrequencyRangeError = true;
                }
              }
            }
          }

          //C-D
          if (item.q37_Tec_Dose_week_frquencyRd !== 1) {
            //C
            q37TechvayliEmpty = item.Q37TechvayliRd === null;

            //37-strength
            q37_Tec_Dose_week_strengthRd_Empty =
              item.q37_Tec_Dose_week_strengthRd == null;
            if (
              !q37_Tec_Dose_week_strengthRd_Empty &&
              item.q37_Tec_Dose_week_strengthRd === 4 &&
              isStringEmpty(item.q37_Tec_Dose_week_strength_txt)
            ) {
              q37_Tec_Dose_week_strength_txt_Empty = true;
            }
          }
        }

        let q39TechEmptyHard = false;
        let q39TechReasonHard = false;
        let q39TechGranulocyteEmptyHard = false;
        let q39TechSteroidsEmptyHard = false;

        let name_dose_steroidsHardEmpty = false;
        let steroids_tech_txtEmpty = false;

        if (
          item.tocilizumab_tech === false &&
          item.granulocyte_tech === false &&
          item.steroids_tech === false &&
          item.noneoftheabove_tech !== 99
        ) {
          q39TechEmptyHard = true;
        }

        if (item.tocilizumab_tech === true && !isNewEcrfA) {
          if (
            item.cytokin_tech === false &&
            item.secondary_prophylactic_crs_tech === false &&
            item.crs_tech === false &&
            item.neurotoxicity_tech === false &&
            item.secondary_neurotoxicity_tech === false &&
            item.tmt_neurotoxicity_tech === false &&
            item.tmt_tech_unknown === false
          ) {
            q39TechReasonHard = true;
          }
        }

        if (item.granulocyte_tech === true) {
          if (
            item.prophylactic_use_tech !== true &&
            item.secondary_prophylactic_use_tech !== true &&
            item.oth_use_tech !== true &&
            item.unknown_tech === null
          ) {
            q39TechGranulocyteEmptyHard = true;
          }
        }

        if (item.steroids_tech === true) {
          if (
            item.cytokin_tech_steroids === false &&
            item.secondary_prophylactic_tech_steroids === false &&
            item.crs_tech_steroids === false &&
            item.neurotoxicity_tech_steroids === false &&
            item.secondary_neurotoxicity_tech_steroids === false &&
            item.tmt_neurotoxicity_tech_steroids === false &&
            item.tmt_steroids_tech_unknown === false &&
            item.steroid_pre_tmt_tech === false
          ) {
            q39TechSteroidsEmptyHard = true;
          }

          if (
            item.betamethasone_tech === false &&
            item.dexamethasone_tech === false &&
            item.hydrocortisone_tech === false &&
            item.methylprednisolone === false &&
            item.prednisolone_tech === false &&
            item.prednisone_tech === false &&
            item.triamcinolone_tech === false &&
            item.dose_name_tech_unknown === false
          ) {
            name_dose_steroidsHardEmpty = true;
          }

          if (
            (item.betamethasone_tech === true &&
              (!item.betamethasone_techNum ||
                item.betamethasone_techNum === "")) ||
            (item.dexamethasone_tech === true &&
              (!item.dexamethasone_techNum ||
                item.dexamethasone_techNum === "")) ||
            (item.hydrocortisone_tech === true &&
              (!item.hydrocortisone_techNum ||
                item.hydrocortisone_techNum === "")) ||
            (item.methylprednisolone === true &&
              (!item.methylprednisoloneNum ||
                item.methylprednisoloneNum === "")) ||
            (item.prednisolone_tech === true &&
              (!item.prednisolone_techNum ||
                item.prednisolone_techNum === "")) ||
            (item.prednisone_tech === true &&
              (!item.prednisone_techNum || item.prednisone_techNum === "")) ||
            (item.triamcinolone_tech === true &&
              (!item.triamcinolone_techNum ||
                item.triamcinolone_techNum === ""))
          ) {
            steroids_tech_txtEmpty = true;
          }
        }

        //39.1.A TECVAYLI
        if (
          isNewEcrfA &&
          item.tocilizumab_tech === true &&
          q391ATechTocilzumabList?.length > 0
        ) {
          let techIsValid = true;

          const updatedArray = q391ATechTocilzumabList.map((techRow) => {
            const hasAnyReason =
              techRow.primaryProphylacticCrs_tech === true ||
              techRow.secondaryProphylacticCrs_tech === true ||
              techRow.supportiveCareCrs_tech === true ||
              techRow.primaryProphylacticNeurologic_tech === true ||
              techRow.secondaryProphylacticNeurologic_tech === true ||
              techRow.supportiveCareNeurologic_tech === true ||
              techRow.medicationReasonUnk_tech === true;

            const q39TechReasonEmpty = !hasAnyReason;

            const q39TechAdministrationRDEmpty =
              !techRow.administrationDateRD_tech;

            let q39TechAdministrationDateEmpty = false;
            let q39TechInvalidAdministrationDate = false;

            if (techRow.administrationDateRD_tech === 1) {
              if (!techRow.administrationDate_tech) {
                q39TechAdministrationDateEmpty = true;
              } else if (
                techRow.administrationDate_tech === "Invalid Date" ||
                !DateInRange(
                  techRow.administrationDate_tech,
                  dayjs("01-01-1920"),
                  dayjs(),
                )
              ) {
                q39TechInvalidAdministrationDate = true;
              } else {
              }
            }

            // ---- Aggregate validity ----
            if (
              q39TechReasonEmpty ||
              q39TechAdministrationRDEmpty ||
              q39TechAdministrationDateEmpty ||
              q39TechInvalidAdministrationDate
            ) {
              techIsValid = false;
            }

            return {
              ...techRow,
              q39TechReasonEmpty,
              q39TechAdministrationRDEmpty,
              q39TechAdministrationDateEmpty,
              q39TechInvalidAdministrationDate,
            };
          });

          let techDateIsValid = true;
          const adminDates = q391ATechTocilzumabList
            .filter(
              (row) =>
                row.administrationDateRD_tech === 1 &&
                row.administrationDate_tech &&
                IsValidDateValue(row.administrationDate_tech),
            )
            .map((row) => row.administrationDate_tech);
          const earliestAdminDate =
            adminDates.length > 0
              ? adminDates.reduce((min, d) => (IsLessOrEqual(d, min) ? d : min))
              : null;

          const latestAdminDate =
            adminDates.length > 0
              ? adminDates.reduce((max, d) => (IsLessOrEqual(max, d) ? d : max))
              : null;

          // initiation date ≤ earliest admin date
          if (
            earliestAdminDate &&
            IsValidDateValue(earliestAdminDate) &&
            !IsLessOrEqual(techIndexDate, earliestAdminDate)
          ) {
            techDateIsValid = false;
          }

          // latest admin date ≤ subsequent LOT (if exists)
          if (
            latestAdminDate &&
            IsValidDateValue(latestAdminDate) &&
            techLOTStartDate &&
            IsValidDateValue(techLOTStartDate) &&
            !IsLessOrEqual(latestAdminDate, techLOTStartDate)
          ) {
            techDateIsValid = false;
          }

          // latest admin date ≤ end of follow-up
          if (
            latestAdminDate &&
            endOfFollowUpDate &&
            IsValidDateValue(endOfFollowUpDate) &&
            !IsLessOrEqual(latestAdminDate, endOfFollowUpDate)
          ) {
            techDateIsValid = false;
          }

          setQ391ATechAdministrationDateOutOfRange(!techDateIsValid);

          if (!techIsValid || !techDateIsValid) {
            isValid = false;
          }

          setQ391ATechTocilzumabList(updatedArray);
        }

        if (
          Q40DosingFreqEmptyHard ||
          Q40DosingFreqTxtEmptyHard ||
          Q40IgGEmptyHard ||
          Q40ReasonEmptyHard ||
          Q40Init_RdHard ||
          Q40Init_dtHard ||
          q37TechvayliEmpty ||
          q39TechEmptyHard ||
          q39TechReasonHard ||
          q39TechGranulocyteEmptyHard ||
          q39TechSteroidsEmptyHard ||
          name_dose_steroidsHardEmpty ||
          steroids_tech_txtEmpty ||
          q37_Tec_Dose_week_frquencyRd_Empty ||
          q37_Tec_Dose_week_frquency_txt_Empty ||
          q37TecDoseWeekFrequencyRangeError ||
          InvalidQ40init_dt ||
          init_dt_before_eof ||
          q37_atleasetOneAdministrationTecWarningHard ||
          q37_Tec_Dose_week_strengthRd_Empty ||
          q37_Tec_Dose_week_strength_txt_Empty
        ) {
          isValid = false;
        }
        return {
          ...item,
          Q40DosingFreqEmptyHard,
          Q40DosingFreqTxtEmptyHard,
          Q40IgGEmptyHard,
          Q40ReasonEmptyHard,
          Q40Init_RdHard,
          Q40Init_dtHard,
          q37TechvayliEmpty,
          q39TechEmptyHard,
          q39TechReasonHard,
          q39TechGranulocyteEmptyHard,
          q39TechSteroidsEmptyHard,
          name_dose_steroidsHardEmpty,
          steroids_tech_txtEmpty,
          q37_Tec_Dose_week_frquencyRd_Empty,
          q37_Tec_Dose_week_frquency_txt_Empty,
          q37TecDoseWeekFrequencyRangeError,
          InvalidQ40init_dt,
          init_dt_before_eof,
          q37_atleasetOneAdministrationTecWarningHard,
          q37_Tec_Dose_week_strengthRd_Empty,
          q37_Tec_Dose_week_strength_txt_Empty,
        };
      });
      setQ37TechDetails(updatedArray);
    }

    //37tal
    if (isTalveySelected) {
      if (Q37TalDetails && Q37TalDetails.length > 0) {
        const updatedArray = Q37TalDetails.map((item) => {
          //Q40 - Tal
          let Q40TalDosingFreqEmptyHard = false;
          let Q40TalDosingFreqTxtEmptyHard = false;

          let Q40TalIgGEmptyHard = false;
          let Q40TalReasonEmptyHard = false;
          let Q40TalInit_RdHard = false;
          let Q40TalInit_dtHard = false;
          let InvalidQ40init_dt_Tal = false;
          let init_dt_before_eof_Tal = false;

          if (item.Q40dosingfreqRd_Tal == null) {
            Q40TalDosingFreqEmptyHard = true;
          }

          if (
            item.Q40dosingfreqRd_Tal === 5 &&
            item.dosing_freq_oth_txt_Tal === ""
          ) {
            Q40TalDosingFreqTxtEmptyHard = true;
          }

          if (item.Q40dosingfreqRd_Tal !== 1) {
            if (item.Q40IgILevelRd_Tal === null) {
              Q40TalIgGEmptyHard = true;
            }

            if (
              (item.primaryProf_Tal === null &&
                item.secondaryProf_Tal === null &&
                item.otherReson_Tal === null) ||
              (item.primaryProf_Tal === false &&
                item.secondaryProf_Tal === false &&
                item.otherReson_Tal === false)
            ) {
              Q40TalReasonEmptyHard = true;
            }

            if (item.Q40init_dt_Rd_Tal === null) {
              Q40TalInit_RdHard = true;
            }

            if (!Q40TalInit_RdHard && item.Q40init_dt_Rd_Tal === 1) {
              if (isStringEmpty(item.Q40init_dt_Tal)) {
                Q40TalInit_dtHard = true;
              } else if (!IsDateValid(item.Q40init_dt_Tal)) {
                InvalidQ40init_dt_Tal = true;
              } else if (
                !ValidateIndexDAndLOTDateChain(
                  item.Q40init_dt_Tal,
                  RRMMCohortTreatment.TALVEY,
                )
              ) {
                init_dt_before_eof_Tal = true;
              }
            }
          }

          //Q37

          let q37TalveyEmpty = false;
          let q37_Tal_Dose_week_frquencyRd_Empty = false;
          let q37_Tal_Dose_week_frquency_txt_Empty = false;
          let q37_atleasetOneAdministrationTalWarningHard = false;
          let q37_Tal_Dose_week_strengthRd_Empty = false;
          let q37_Tal_Dose_week_strength_txt_Empty = false;
          let q37TalDoseWeekFrequencyRangeError = false;

          if (isNewEcrfA === false) {
            //B
            q37_Tal_Dose_week_frquencyRd_Empty =
              item.q37_Tal_Dose_week_frquencyRd == null;

            //B- second option
            if (!q37_Tal_Dose_week_frquencyRd_Empty) {
              //37-warning
              let isSubsequentOptionSelected =
                talveyDetails &&
                talveyDetails.length > 0 &&
                talveyDetails.some((item) => item.dosing_phase_tal === 5);
              if (
                isSubsequentOptionSelected &&
                item.q37_Tal_Dose_week_frquencyRd === 1
              ) {
                q37_atleasetOneAdministrationTalWarningHard = true;
              }

              if (item.q37_Tal_Dose_week_frquencyRd === 2) {
                if (isStringEmpty(item.q37_Tal_Dose_week_frquency_txt)) {
                  q37_Tal_Dose_week_frquency_txt_Empty = true;
                } else {
                  const checkValue = isValidNumber(
                    item.q37_Tal_Dose_week_frquency_txt,
                  );
                  if (!checkValue) {
                    q37TalDoseWeekFrequencyRangeError = true;
                  }
                }
              }
            }

            //C-D
            if (item.q37_Tal_Dose_week_frquencyRd !== 1) {
              //c
              q37TalveyEmpty = item.Q37TalveyRd === null;

              //D - 37-strength
              q37_Tal_Dose_week_strengthRd_Empty =
                item.q37_Tal_Dose_week_strengthRd == null;

              if (!q37_Tal_Dose_week_strengthRd_Empty) {
                //Other Text
                if (
                  item.q37_Tal_Dose_week_strengthRd === 4 &&
                  isStringEmpty(item.q37_Tal_Dose_week_strength_txt)
                ) {
                  q37_Tal_Dose_week_strength_txt_Empty = true;
                }
              }
            }
          }

          let q39TalEmptyHard = false;

          let q39TalSteroidsEmptyHard = false;
          let name_dose_steroids_talHardEmpty = false;
          let steroids_tal_txtEmpty = false;

          let q39TalReasonHard = false;

          //39tal
          let q39TalGranulocyteEmptyHard = false;
          if (
            item.tocilizumab_tal !== true &&
            item.granulocyte_tal !== true &&
            item.steroids_tal !== true &&
            item.noneoftheabove_tal !== 99
          ) {
            q39TalEmptyHard = true;
          }

          if (item.tocilizumab_tal === true && !isNewEcrfA) {
            if (
              item.cytokin_tal === false &&
              item.secondary_prophylactic_crs_tal === false &&
              item.crs_tal === false &&
              item.neurotoxicity_tal === false &&
              item.secondary_neurotoxicity_tal === false &&
              item.tmt_neurotoxicity_tal === false &&
              item.tmt_talvey_unknown === false
            ) {
              q39TalReasonHard = true;
            }
          }

          if (item.granulocyte_tal === true) {
            if (
              item.prophylactic_use_tal !== true &&
              item.secondary_prophylactic_use_tal !== true &&
              item.oth_use_tal !== true &&
              item.unknown_tal === null
            ) {
              q39TalGranulocyteEmptyHard = true;
            }
          }

          if (item.steroids_tal === true) {
            if (
              item.cytokin_tal_steroids === false &&
              item.secondary_prophylactic_tal_steroids === false &&
              item.crs_tal_steroids === false &&
              item.neurotoxicity_tal_steroids === false &&
              item.secondary_neurotoxicity_tal_steroids === false &&
              item.tmt_neurotoxicity_tal_steroids === false &&
              item.tmt_tal_unknown === false &&
              item.steroid_pre_tmt_tal === false
            ) {
              q39TalSteroidsEmptyHard = true;
            }

            if (
              item.betamethasone_tal === false &&
              item.dexamethasone_tal === false &&
              item.hydrocortisone_tal === false &&
              item.methylprednisolone_tal === false &&
              item.prednisolone_tal === false &&
              item.prednisone_tal === false &&
              item.triamcinolone_tal === false &&
              item.dose_name_tal_unknown === false
            ) {
              name_dose_steroids_talHardEmpty = true;
            }

            if (
              (item.betamethasone_tal === true &&
                (!item.betamethasone_talNum ||
                  item.betamethasone_talNum === "")) ||
              (item.dexamethasone_tal === true &&
                (!item.dexamethasone_talNum ||
                  item.dexamethasone_talNum === "")) ||
              (item.hydrocortisone_tal === true &&
                (!item.hydrocortisone_talNum ||
                  item.hydrocortisone_talNum === "")) ||
              (item.methylprednisolone_tal === true &&
                (!item.methylprednisolone_talNum ||
                  item.methylprednisolone_talNum === "")) ||
              (item.prednisolone_tal === true &&
                (!item.prednisolone_talNum ||
                  item.prednisolone_talNum === "")) ||
              (item.prednisone_tal === true && item.prednisone_talNum === "") ||
              (item.triamcinolone_tal === true &&
                (!item.triamcinolone_talNum ||
                  item.triamcinolone_talNum === ""))
            ) {
              steroids_tal_txtEmpty = true;
            }
          }

          //39.1.A TALVEY
          if (
            isNewEcrfA &&
            item.tocilizumab_tal === true &&
            q391ATalTocilzumabList?.length > 0
          ) {
            let talIsValid = true;

            const updatedArray = q391ATalTocilzumabList.map((talRow) => {
              const hasAnyReason =
                talRow.primaryProphylacticCrs_tal === true ||
                talRow.secondaryProphylacticCrs_tal === true ||
                talRow.supportiveCareCrs_tal === true ||
                talRow.primaryProphylacticNeurologic_tal === true ||
                talRow.secondaryProphylacticNeurologic_tal === true ||
                talRow.supportiveCareNeurologic_tal === true ||
                talRow.medicationReasonUnk_tal === true;

              const q39TalReasonEmpty = !hasAnyReason;

              const q39TalAdministrationRDEmpty =
                !talRow.administrationDateRD_tal;

              let q39TalAdministrationDateEmpty = false;
              let q39TalInvalidAdministrationDate = false;

              if (talRow.administrationDateRD_tal === 1) {
                if (!talRow.administrationDate_tal) {
                  q39TalAdministrationDateEmpty = true;
                } else if (
                  talRow.administrationDate_tal === "Invalid Date" ||
                  !DateInRange(
                    talRow.administrationDate_tal,
                    dayjs("01-01-1920"),
                    dayjs(),
                  )
                ) {
                  q39TalInvalidAdministrationDate = true;
                }
              }

              // ---- Aggregate validity ----
              if (
                q39TalReasonEmpty ||
                q39TalAdministrationRDEmpty ||
                q39TalAdministrationDateEmpty ||
                q39TalInvalidAdministrationDate
              ) {
                talIsValid = false;
              }

              return {
                ...talRow,
                q39TalReasonEmpty,
                q39TalAdministrationRDEmpty,
                q39TalAdministrationDateEmpty,
                q39TalInvalidAdministrationDate,
              };
            });

            let talDateIsValid = true;
            const adminDates = q391ATalTocilzumabList
              .filter(
                (row) =>
                  row.administrationDateRD_tal === 1 &&
                  row.administrationDate_tal &&
                  IsValidDateValue(row.administrationDate_tal),
              )
              .map((row) => row.administrationDate_tal);
            const earliestAdminDate =
              adminDates.length > 0
                ? adminDates.reduce((min, d) =>
                    IsLessOrEqual(d, min) ? d : min,
                  )
                : null;

            const latestAdminDate =
              adminDates.length > 0
                ? adminDates.reduce((max, d) =>
                    IsLessOrEqual(max, d) ? d : max,
                  )
                : null;

            // initiation date ≤ earliest admin date
            if (
              earliestAdminDate &&
              IsValidDateValue(earliestAdminDate) &&
              !IsLessOrEqual(talIndexDate, earliestAdminDate)
            ) {
              talDateIsValid = false;
            }

            // latest admin date ≤ subsequent LOT (if exists)
            if (
              latestAdminDate &&
              talLOTStartDate &&
              IsValidDateValue(talLOTStartDate) &&
              !IsLessOrEqual(latestAdminDate, talLOTStartDate)
            ) {
              talDateIsValid = false;
            }

            // latest admin date ≤ end of follow-up
            if (
              latestAdminDate &&
              endOfFollowUpDate &&
              IsValidDateValue(endOfFollowUpDate) &&
              !IsLessOrEqual(latestAdminDate, endOfFollowUpDate)
            ) {
              talDateIsValid = false;
            }

            setQ391ATalAdministrationDateOutOfRange(!talDateIsValid);

            if (!talIsValid || !talDateIsValid) {
              isValid = false;
            }

            setQ391ATalTocilzumabList(updatedArray);
          }

          if (
            Q40TalDosingFreqEmptyHard ||
            Q40TalDosingFreqTxtEmptyHard ||
            Q40TalIgGEmptyHard ||
            Q40TalReasonEmptyHard ||
            Q40TalInit_RdHard ||
            init_dt_before_eof_Tal ||
            InvalidQ40init_dt_Tal ||
            Q40TalInit_dtHard ||
            q39TalEmptyHard ||
            q39TalReasonHard ||
            q39TalSteroidsEmptyHard ||
            name_dose_steroids_talHardEmpty ||
            steroids_tal_txtEmpty ||
            q37TalveyEmpty ||
            q37_Tal_Dose_week_frquencyRd_Empty ||
            q37_Tal_Dose_week_frquency_txt_Empty ||
            q37TalDoseWeekFrequencyRangeError ||
            q37_Tal_Dose_week_strengthRd_Empty ||
            q37_Tal_Dose_week_strength_txt_Empty ||
            q37_atleasetOneAdministrationTalWarningHard ||
            q39TalGranulocyteEmptyHard
          ) {
            isValid = false;
          }

          return {
            ...item,
            Q40TalDosingFreqEmptyHard,
            Q40TalDosingFreqTxtEmptyHard,
            Q40TalIgGEmptyHard,
            Q40TalReasonEmptyHard,
            Q40TalInit_RdHard,
            init_dt_before_eof_Tal,
            InvalidQ40init_dt_Tal,
            Q40TalInit_dtHard,
            q39TalEmptyHard,
            q39TalReasonHard,
            q39TalSteroidsEmptyHard,
            name_dose_steroids_talHardEmpty,
            steroids_tal_txtEmpty,
            q37TalveyEmpty,
            q37_Tal_Dose_week_frquency_txt_Empty,
            q37TalDoseWeekFrequencyRangeError,
            q37_Tal_Dose_week_frquencyRd_Empty,
            q37_Tal_Dose_week_strength_txt_Empty,
            q37_Tal_Dose_week_strengthRd_Empty,
            q37_atleasetOneAdministrationTalWarningHard,
            q39TalGranulocyteEmptyHard,
          };
        });
        setQ37TalDetails(updatedArray);
      }
    }

    //38tech

    if (
      isNewEcrfA === false &&
      isTechvayliSelected &&
      Q37TechDetails[0].Q37TechvayliRd === 1 &&
      Q38TechDetails &&
      Q38TechDetails.length > 0
    ) {
      const updatedArray = Q38TechDetails.map((item, index) => {
        let Q38TechEmptyHard = false;
        if (item.Q38TechvayliRd === null) {
          Q38TechEmptyHard = true;
        }

        let Q38DateEmpty = false;
        if (item.Q38TechvayliRd === 1 && item.dt_dosefreq_tech_dt === "") {
          Q38DateEmpty = true;
        }

        let Invalid_dt_dosefreq_tech_dt = false;
        if (
          item.Q38TechvayliRd === 1 &&
          item.dt_dosefreq_tech_dt === "Invalid Date"
        ) {
          Invalid_dt_dosefreq_tech_dt = true;
        }

        if (
          item.Q38TechvayliRd === 1 &&
          item.dt_dosefreq_tech_dt != "Invalid Date" &&
          !DateInRange(item.dt_dosefreq_tech_dt, dayjs("01-01-1920"), dayjs())
        ) {
          Invalid_dt_dosefreq_tech_dt = true;
        }

        let Q38TechDateInvalid = false;
        if (
          item.Q38TechvayliRd === 1 &&
          item.dt_dosefreq_tech_dt !== "" &&
          DateInRange(item.dt_dosefreq_tech_dt, dayjs("01-01-1920"), dayjs()) &&
          techIndexDate != "" &&
          tecvayliDateRRMM != "[Bispecifics/CAR-T end of follow up]"
        ) {
          Q38TechDateInvalid = !CheckDateValidation(
            techIndexDate,
            item.dt_dosefreq_tech_dt,
            tecvayliDateRRMM,
          );
        }

        // let Q38TechDateValidationcheck1 =false;

        //Q38Tech New Column Validation

        let q38TechvayliEmpty = false;
        if (item.Q38TechvayliRd === null) {
          q38TechvayliEmpty = true;
        }

        let q38_Tec_Dose_week_frquencyRd_Empty = false;
        if (item.q38_Tec_Dose_week_frquencyRd == null) {
          q38_Tec_Dose_week_frquencyRd_Empty = true;
        }

        let q38_Tec_Dose_week_frquency_txt_Empty = false;
        if (
          item.q38_Tec_Dose_week_frquencyRd == 1 &&
          (item.q38_Tec_Dose_week_frquency_txt === "" ||
            item.q38_Tec_Dose_week_frquency_txt === null)
        ) {
          q38_Tec_Dose_week_frquency_txt_Empty = true;
        }

        //invalid Number
        if (
          item.q38_Tec_Dose_week_frquencyRd == 1 &&
          (item.q38_Tec_Dose_week_frquency_txt !== "" ||
            item.q38_Tec_Dose_week_frquency_txt !== null)
        ) {
          const checkValue = isValidNumber(item.q38_Tec_Dose_week_frquency_txt);
          if (item.q38_Tec_Dose_week_frquencyRd_Empty == false && !checkValue) {
            q38_Tec_Dose_week_frquency_txt_Empty = true;
          }
        }

        if (
          Q38TechEmptyHard ||
          Q38DateEmpty ||
          Q38TechDateInvalid ||
          q38TechvayliEmpty ||
          q38_Tec_Dose_week_frquencyRd_Empty ||
          q38_Tec_Dose_week_frquency_txt_Empty ||
          Invalid_dt_dosefreq_tech_dt
        ) {
          isValid = false;
        }

        return {
          ...item,

          Q38TechEmptyHard,
          Q38DateEmpty,
          Q38TechDateInvalid,
          q38TechvayliEmpty,
          q38_Tec_Dose_week_frquencyRd_Empty,
          q38_Tec_Dose_week_frquency_txt_Empty,
          Invalid_dt_dosefreq_tech_dt,
        };
      });

      setQ38TechDetails(updatedArray);
    }

    //38 tal
    if (
      isNewEcrfA === false &&
      isTalveySelected &&
      Q37TalDetails[0].Q37TalveyRd === 1 &&
      Q38TalDetails &&
      Q38TalDetails.length > 0
    ) {
      const updatedArray = Q38TalDetails.map((item, index) => {
        let Q38TalEmptyHard = false;
        if (item.Q38TalveyRd === null) {
          Q38TalEmptyHard = true;
        }

        let Q38TalDateEmpty = false;
        if (item.Q38TalveyRd === 1 && item.dt_dosefreq_tal_dt === "") {
          Q38TalDateEmpty = true;
        }

        let InvalidQ38Talveydate = false;

        if (
          item.Q38TalveyRd === 1 &&
          item.dt_dosefreq_tal_dt === "Invalid Date"
        ) {
          InvalidQ38Talveydate = true;
        }

        if (
          item.Q38TalveyRd === 1 &&
          item.dt_dosefreq_tal_dt != "Invalid Date" &&
          !DateInRange(item.dt_dosefreq_tal_dt, dayjs("01-01-1920"), dayjs())
        ) {
          InvalidQ38Talveydate = true;
        }

        let Q38TalDateInvalid = false;
        if (
          item.Q38TalveyRd === 1 &&
          item.dt_dosefreq_tal_dt !== "" &&
          DateInRange(item.dt_dosefreq_tal_dt, dayjs("01-01-1920"), dayjs()) &&
          talIndexDate != "" &&
          talveyDateRRMM != "[Bispecifics/CAR-T end of follow up]"
        ) {
          Q38TalDateInvalid = !CheckDateValidation(
            talIndexDate,
            item.dt_dosefreq_tal_dt,
            talveyDateRRMM,
          );
        }

        let q38_Tal_Dose_week_frquencyRd_Empty = false;
        if (item.q38_Tal_Dose_week_frquencyRd == null) {
          q38_Tal_Dose_week_frquencyRd_Empty = true;
        }

        let q38_Tal_Dose_week_frquency_txt_Empty = false;
        if (
          item.q38_Tal_Dose_week_frquencyRd == 1 &&
          (item.q38_Tal_Dose_week_frquency_txt === "" ||
            item.q38_Tal_Dose_week_frquency_txt === null)
        ) {
          q38_Tal_Dose_week_frquency_txt_Empty = true;
        }

        if (
          item.q38_Tal_Dose_week_frquencyRd == 1 &&
          (item.q38_Tal_Dose_week_frquency_txt !== "" ||
            item.q38_Tal_Dose_week_frquency_txt !== null)
        ) {
          const checkValue = isValidNumber(item.q38_Tal_Dose_week_frquency_txt);
          if (item.q38_Tal_Dose_week_frquencyRd_Empty == false && !checkValue) {
            q38_Tal_Dose_week_frquency_txt_Empty = true;
          }
        }

        let q38_Tal_Dosage_Rd_Empty = false;
        if (item.q38_Tal_Dosage_Rd == null) {
          q38_Tal_Dosage_Rd_Empty = true;
        }

        let q38_Tal_Dosage_OtherTxt_Empty = false;
        if (
          item.q38_Tal_Dosage_Rd == 3 &&
          (item.q38_Tal_Dosage_OtherTxt == "" ||
            item.q38_Tal_Dosage_OtherTxt == null)
        ) {
          q38_Tal_Dosage_OtherTxt_Empty = true;
        }

        if (
          Q38TalEmptyHard ||
          Q38TalDateEmpty ||
          Q38TalDateInvalid ||
          q38_Tal_Dosage_OtherTxt_Empty ||
          q38_Tal_Dosage_Rd_Empty ||
          q38_Tal_Dose_week_frquency_txt_Empty ||
          q38_Tal_Dose_week_frquencyRd_Empty ||
          InvalidQ38Talveydate
        ) {
          isValid = false;
        }

        return {
          ...item,

          Q38TalEmptyHard,
          Q38TalDateEmpty,
          Q38TalDateInvalid,
          q38_Tal_Dosage_Rd_Empty,
          q38_Tal_Dose_week_frquency_txt_Empty,
          q38_Tal_Dose_week_frquencyRd_Empty,
          q38_Tal_Dosage_OtherTxt_Empty,
          InvalidQ38Talveydate,
        };
      });

      setQ38TalDetails(updatedArray);
    }
    // ============================================
    // Q38.1.A Tech VALIDATION
    // ============================================
    if (isNewEcrfA && isTechvayliSelected) {
      Q381ATechDetails.forEach((row, index) => {
        let rowHasError = false;

        // ========================================
        // Column B: Type of change - HARD ERROR
        // ========================================
        if (row.changeType === null || row.changeType === undefined) {
          isValid = false;
          rowHasError = true;
          Q381ATechDetails[index].changeTypeEmpty = true;
        }

        // If changeType is "Frequency change" (2), validate sub-radio
        if (
          row.changeType === 2 &&
          (row.changeTypeDoseFrequency === null ||
            row.changeTypeDoseFrequency === undefined)
        ) {
          isValid = false;
          rowHasError = true;
          Q381ATechDetails[index].changeTypeDoseFrequencyEmpty = true;
        }

        // If changeType is "Strength change" (3), validate sub-radio
        if (
          row.changeType === 3 &&
          (row.changeTypeDoseStrength === null ||
            row.changeTypeDoseStrength === undefined)
        ) {
          isValid = false;
          rowHasError = true;
          Q381ATechDetails[index].changeTypeDoseStrengthEmpty = true;
        }

        // Skip columns C-F validation if "No changes" or "Unknown"
        if (row.changeType === 1 || row.changeType === 99) {
          return; // Skip rest of validations for this row
        }

        // ========================================
        // Column C: Reasons - HARD ERROR
        // ========================================
        const reasonList = row.discontinuationReasons ?? [];

        const hasSelectedReason = reasonList.some((r) => r.isSelected);
        const hasUnknown = reasonList.some((r) => r.reasonUnk);

        if (!hasSelectedReason && !hasUnknown) {
          isValid = false;
          rowHasError = true;
          Q381ATechDetails[index].reasonEmpty = true;
        }
        // If "Other" (ID=14) is selected, validate other text field

        const otherSelected = row.discontinuationReasons?.some(
          (r) =>
            r.isSelected &&
            r.reasonName.includes("Other") &&
            isStringEmpty(r.reasonText),
        );
        if (otherSelected) {
          isValid = false;
          rowHasError = true;
          Q381ATechDetails[index].reasonOtherTextEmpty = true;
        }

        // After checking if reasonEmpty
        const hasAdverseEventSelected = row.discontinuationReasons?.some(
          (r) =>
            r.reasonName === DiscontinuationReason.AdverseEvent && r.isSelected,
        );

        if (hasAdverseEventSelected) {
          // 2 = Adverse Event ID
          const selectedAEs =
            row.adverseEventReasons?.filter((ae) => ae.isSelected) || [];

          if (selectedAEs.length === 0) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].aeSubReasonEmpty = true;
          } else {
            const isNeuroSelected = selectedAEs.some(
              (ae) => ae.reasonName === DiscontinuationReason.NeurologicalEvent,
            );

            if (isNeuroSelected) {
              const selectedNeuroReasons =
                row.neurologicAEReasonList?.filter((n) => n.isSelected) || [];

              if (selectedNeuroReasons.length === 0) {
                isValid = false;
                rowHasError = true;
                Q381ATechDetails[index].neuroReasonEmpty = true;
              }

              selectedNeuroReasons.forEach((neuro) => {
                if (
                  neuro.reasonName?.includes("Other") &&
                  (!neuro.reasonText || !neuro.reasonText.trim())
                ) {
                  isValid = false;
                  rowHasError = true;
                  Q381ATechDetails[index].neuroOtherTextEmpty = true;
                }
              });
            }
          }
        }

        // ========================================
        // Column D: Pattern BEFORE change - HARD ERROR
        // ========================================
        // If changeType is "Frequency change" (2)
        if (row.changeType === 2) {
          // Frequency type required
          if (
            row.patterBeforeChangeDoseFrequency === null ||
            row.patterBeforeChangeDoseFrequency === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].patternBeforeFrequencyEmpty = true;
          }

          // Frequency value required if type is 1 (times/week) or 2 (every X weeks)
          if (
            (row.patterBeforeChangeDoseFrequency === 1 ||
              row.patterBeforeChangeDoseFrequency === 2) &&
            isStringEmpty(
              row.patterBeforeChangeDoseFrequency == 1
                ? row.patterBeforeChangeDoseFrequencyPerWeek
                : row.patterBeforeChangeDoseFrequencyEveryWeek,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].patternBeforeFrequencyEmpty = true;
          }

          // Range validation: Integer, >0 and ≤10
          if (
            !isStringEmpty(
              row.patterBeforeChangeDoseFrequency == 1
                ? row.patterBeforeChangeDoseFrequencyPerWeek
                : row.patterBeforeChangeDoseFrequencyEveryWeek,
            ) &&
            row.patterBeforeChangeDoseFrequency !== 99
          ) {
            const weekValue = Number(
              row.patterBeforeChangeDoseFrequency == 1
                ? row.patterBeforeChangeDoseFrequencyPerWeek
                : row.patterBeforeChangeDoseFrequencyEveryWeek,
            );
            if (
              !Number.isInteger(weekValue) ||
              weekValue <= 0 ||
              weekValue > 20
            ) {
              isValid = false;
              rowHasError = true;
              Q381ATechDetails[index].patternBeforeFrequencyRangeInvalid = true;
            }
          }
        }

        // If changeType is "Strength change" (3)
        if (row.changeType === 3) {
          // Strength type required
          if (
            row.patterBeforeChangeDoseStrength === null ||
            row.patterBeforeChangeDoseStrength === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].patternBeforeStrengthEmpty = true;
          }

          // Strength value required if type is 1 (mg), 2 (mg/kg), or 3 (mg/m²)
          if (
            (row.patterBeforeChangeDoseStrength === 1 ||
              row.patterBeforeChangeDoseStrength === 2 ||
              row.patterBeforeChangeDoseStrength === 3) &&
            isStringEmpty(
              row.patterBeforeChangeDoseStrength == 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength == 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].patternBeforeStrengthEmpty = true;
          }

          // Range validation: Decimal, >0.00 and ≤4000.00
          if (
            !isStringEmpty(
              row.patterBeforeChangeDoseStrength == 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength == 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            ) &&
            row.patterBeforeChangeDoseStrength !== 99
          ) {
            const strengthValue = Number(
              row.patterBeforeChangeDoseStrength == 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength == 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            );
            if (
              isNaN(strengthValue) ||
              strengthValue <= 0 ||
              strengthValue > 4000
            ) {
              isValid = false;
              rowHasError = true;
              Q381ATechDetails[index].patternBeforeStrengthRangeInvalid = true;
            }
          }
        }
        // ========================================
        // Column E: Pattern AFTER change - HARD ERROR
        // ========================================
        // If changeType is "Frequency change" (2)
        if (row.changeType === 2) {
          // Frequency type required
          if (
            row.patterAfterChangeDoseFrequency === null ||
            row.patterAfterChangeDoseFrequency === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].patternAfterFrequencyEmpty = true;
          }

          // Frequency value required if type is 1 or 2
          if (
            (row.patterAfterChangeDoseFrequency === 1 ||
              row.patterAfterChangeDoseFrequency === 2) &&
            isStringEmpty(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyPerWeek
                : row.patterAfterChangeDoseFrequencyEveryWeek,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].patternAfterFrequencyEmpty = true;
          }

          // Range validation: Integer, >0 and ≤10
          if (
            !isStringEmpty(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyPerWeek
                : row.patterAfterChangeDoseFrequencyEveryWeek,
            ) &&
            row.patterAfterChangeDoseFrequency !== 99
          ) {
            const weekValue = Number(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyPerWeek
                : row.patterAfterChangeDoseFrequencyEveryWeek,
            );
            if (
              !Number.isInteger(weekValue) ||
              weekValue <= 0 ||
              weekValue > 20
            ) {
              isValid = false;
              rowHasError = true;
              Q381ATechDetails[index].patternAfterFrequencyRangeInvalid = true;
            }
          }
        }

        // If changeType is "Strength change" (3)
        if (row.changeType === 3) {
          // Strength type required
          if (
            row.patterAfterChangeDoseStrength === null ||
            row.patterAfterChangeDoseStrength === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].patternAfterStrengthEmpty = true;
          }

          // Strength value required if type is 1, 2, or 3
          if (
            (row.patterAfterChangeDoseStrength === 1 ||
              row.patterAfterChangeDoseStrength === 2 ||
              row.patterAfterChangeDoseStrength === 3) &&
            isStringEmpty(
              row.patterAfterChangeDoseStrength == 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength == 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].patternAfterStrengthEmpty = true;
          }

          // Range validation: Decimal, >0.00 and ≤4000.00
          if (
            !isStringEmpty(
              row.patterAfterChangeDoseStrength == 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength == 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            ) &&
            row.patterAfterChangeDoseStrength !== 99
          ) {
            const strengthValue = Number(
              row.patterAfterChangeDoseStrength == 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength == 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            );
            if (
              isNaN(strengthValue) ||
              strengthValue <= 0 ||
              strengthValue > 4000
            ) {
              isValid = false;
              rowHasError = true;
              Q381ATechDetails[index].patternAfterStrengthRangeInvalid = true;
            }
          }
        }

        // ========================================
        // Conflict Validations: Before vs After
        // ========================================
        // Only validate if both BEFORE and AFTER are NOT "Unknown"
        // For FREQUENCY INCREASE
        if (
          row.changeType === 2 &&
          row.changeTypeDoseFrequency === 1 &&
          row.patterBeforeChangeDoseFrequency !== 99 &&
          row.patterAfterChangeDoseFrequency !== 99 &&
          row.patterBeforeChangeDoseFrequency ===
            row.patterAfterChangeDoseFrequency &&
          !isStringEmpty(
            row.patterBeforeChangeDoseFrequency === 1
              ? row.patterBeforeChangeDoseFrequencyPerWeek
              : row.patterBeforeChangeDoseFrequencyEveryWeek,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseFrequency === 1
              ? row.patterAfterChangeDoseFrequencyPerWeek
              : row.patterAfterChangeDoseFrequencyEveryWeek,
          )
        ) {
          const isTimesPerWeek = row.patterBeforeChangeDoseFrequency === 1;

          const beforeValue = Number(
            isTimesPerWeek
              ? row.patterBeforeChangeDoseFrequencyPerWeek
              : row.patterBeforeChangeDoseFrequencyEveryWeek,
          );

          const afterValue = Number(
            isTimesPerWeek
              ? row.patterAfterChangeDoseFrequencyPerWeek
              : row.patterAfterChangeDoseFrequencyEveryWeek,
          );

          let isConflict = false;

          if (isTimesPerWeek) {
            // Times per week → After must be greater
            if (afterValue <= beforeValue) {
              isConflict = true;
            }
          } else {
            // Once every X weeks → After must be smaller
            if (afterValue >= beforeValue) {
              isConflict = true;
            }
          }

          if (isConflict) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].frequencyIncreaseConflict = true;
          }
        }

        // For FREQUENCY DECREASE
        if (
          row.changeType === 2 &&
          row.changeTypeDoseFrequency === 2 &&
          row.patterBeforeChangeDoseFrequency !== 99 &&
          row.patterAfterChangeDoseFrequency !== 99 &&
          row.patterBeforeChangeDoseFrequency ===
            row.patterAfterChangeDoseFrequency &&
          !isStringEmpty(
            row.patterBeforeChangeDoseFrequency === 1
              ? row.patterBeforeChangeDoseFrequencyPerWeek
              : row.patterBeforeChangeDoseFrequencyEveryWeek,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseFrequency === 1
              ? row.patterAfterChangeDoseFrequencyPerWeek
              : row.patterAfterChangeDoseFrequencyEveryWeek,
          )
        ) {
          const isTimesPerWeek = row.patterBeforeChangeDoseFrequency === 1;

          const beforeValue = Number(
            isTimesPerWeek
              ? row.patterBeforeChangeDoseFrequencyPerWeek
              : row.patterBeforeChangeDoseFrequencyEveryWeek,
          );

          const afterValue = Number(
            isTimesPerWeek
              ? row.patterAfterChangeDoseFrequencyPerWeek
              : row.patterAfterChangeDoseFrequencyEveryWeek,
          );

          let isConflict = false;

          if (isTimesPerWeek) {
            // Times per week → After must be smaller
            if (afterValue >= beforeValue) {
              isConflict = true;
            }
          } else {
            // Once every X weeks → After must be larger
            if (afterValue <= beforeValue) {
              isConflict = true;
            }
          }

          if (isConflict) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].frequencyDecreaseConflict = true;
          }
        }

        // For STRENGTH INCREASE
        const BeforeChangeDoseStrengthUnit =
          row.patterBeforeChangeDoseStrengthMg ??
          row.patterBeforeChangeDoseStrengthMgKg ??
          row.patterBeforeChangeDoseStrengthMgM2;

        const AfterChangeDoseStrengthUnit =
          row.patterAfterChangeDoseStrengthMg ??
          row.patterAfterChangeDoseStrengthMgKg ??
          row.patterAfterChangeDoseStrengthMgM2;

        if (
          row.changeType === 3 &&
          row.changeTypeDoseStrength === 1 &&
          row.patterBeforeChangeDoseStrength !== 99 &&
          row.patterAfterChangeDoseStrength !== 99 &&
          row.patterBeforeChangeDoseStrength ===
            row.patterAfterChangeDoseStrength &&
          !isStringEmpty(BeforeChangeDoseStrengthUnit) &&
          !isStringEmpty(AfterChangeDoseStrengthUnit)
        ) {
          const beforeValue = Number(BeforeChangeDoseStrengthUnit);
          const afterValue = Number(AfterChangeDoseStrengthUnit);

          // After should be > Before
          if (afterValue <= beforeValue) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].strengthIncreaseConflict = true;
          }
        }

        // For STRENGTH DECREASE
        if (
          row.changeType === 3 &&
          row.changeTypeDoseStrength === 2 &&
          row.patterBeforeChangeDoseStrength !== 99 &&
          row.patterAfterChangeDoseStrength !== 99 &&
          row.patterBeforeChangeDoseStrength ===
            row.patterAfterChangeDoseStrength &&
          !isStringEmpty(BeforeChangeDoseStrengthUnit) &&
          !isStringEmpty(AfterChangeDoseStrengthUnit)
        ) {
          const beforeValue = Number(BeforeChangeDoseStrengthUnit);
          const afterValue = Number(AfterChangeDoseStrengthUnit);

          // After should be < Before
          if (afterValue >= beforeValue) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].strengthDecreaseConflict = true;
          }
        }

        // ========================================
        // Column F: Date - HARD ERROR
        // ========================================
        if (row.dateChangeRd === null || row.dateChangeRd === undefined) {
          isValid = false;
          rowHasError = true;
          Q381ATechDetails[index].dateChangeRdEmpty = true;
        }
        // If "Date provided" (1) is selected, validate the date
        if (row.dateChangeRd === 1) {
          if (isStringEmpty(row.dateChange)) {
            isValid = false;
            rowHasError = true;
            Q381ATechDetails[index].dateChangeEmpty = true;
          } else {
            // Date format validation
            if (!DateInRange(row.dateChange, dayjs("01-01-1920"), dayjs())) {
              isValid = false;
              rowHasError = true;
              Q381ATechDetails[index].invalidDateChange = true;
            } else {
              // ✅ Use the new date chain validation
              if (
                !ValidateQ381ADateChain(
                  row.dateChange,
                  RRMMCohortTreatment.TECVAYLI,
                )
              ) {
                isValid = false;
                rowHasError = true;
                Q381ATechDetails[index].dateChangeOutOfBound = true;
              }
            }
          }
        }
      });

      setQ381ATechDetails([...Q381ATechDetails]);
    }

    // ============================================
    // Q38.1.A Talv VALIDATION
    // ============================================
    if (isNewEcrfA && isTalveySelected) {
      Q381ATalvDetails.forEach((row, index) => {
        let rowHasError = false;

        // ========================================
        // Column B: Type of change - HARD ERROR
        // ========================================
        if (row.changeType === null || row.changeType === undefined) {
          isValid = false;
          rowHasError = true;
          Q381ATalvDetails[index].changeTypeEmpty = true;
        }

        // If changeType is "Frequency change" (2), validate sub-radio
        if (
          row.changeType === 2 &&
          (row.changeTypeDoseFrequency === null ||
            row.changeTypeDoseFrequency === undefined)
        ) {
          isValid = false;
          rowHasError = true;
          Q381ATalvDetails[index].changeTypeDoseFrequencyEmpty = true;
        }

        // If changeType is "Strength change" (3), validate sub-radio
        if (
          row.changeType === 3 &&
          (row.changeTypeDoseStrength === null ||
            row.changeTypeDoseStrength === undefined)
        ) {
          isValid = false;
          rowHasError = true;
          Q381ATalvDetails[index].changeTypeDoseStrengthEmpty = true;
        }

        // Skip columns C-F validation if "No changes" or "Unknown"
        if (row.changeType === 1 || row.changeType === 99) {
          return; // Skip rest of validations for this row
        }

        // ========================================
        // Column C: Reasons - HARD ERROR
        // ========================================
        const reasonList = row.discontinuationReasons ?? [];

        const hasSelectedReason = reasonList.some((r) => r.isSelected);
        const hasUnknown = reasonList.some((r) => r.reasonUnk);

        if (!hasSelectedReason && !hasUnknown) {
          isValid = false;
          rowHasError = true;
          Q381ATalvDetails[index].reasonEmpty = true;
        }

        // If "Other" (ID=14) is selected, validate other text field
        const otherSelected = row.discontinuationReasons?.some(
          (r) =>
            r.isSelected &&
            r.reasonName.includes("Other") &&
            isStringEmpty(r.reasonText),
        );
        if (otherSelected) {
          isValid = false;
          rowHasError = true;
          Q381ATalvDetails[index].reasonOtherTextEmpty = true;
        }

        // After checking if reasonEmpty
        const hasAdverseEventSelected = row.discontinuationReasons?.some(
          (r) =>
            r.reasonName === DiscontinuationReason.AdverseEvent && r.isSelected,
        );

        if (hasAdverseEventSelected) {
          // 2 = Adverse Event ID
          const selectedAEs =
            row.adverseEventReasons?.filter((ae) => ae.isSelected) || [];

          if (selectedAEs.length === 0) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].aeSubReasonEmpty = true;
          } else {
            const isNeuroSelected = selectedAEs.some(
              (ae) => ae.reasonName === DiscontinuationReason.NeurologicalEvent,
            );

            if (isNeuroSelected) {
              const selectedNeuroReasons =
                row.neurologicAEReasonList?.filter((n) => n.isSelected) || [];

              if (selectedNeuroReasons.length === 0) {
                isValid = false;
                rowHasError = true;
                Q381ATalvDetails[index].neuroReasonEmpty = true;
              }

              selectedNeuroReasons.forEach((neuro) => {
                if (
                  neuro.reasonName?.includes("Other") &&
                  (!neuro.reasonText || !neuro.reasonText.trim())
                ) {
                  isValid = false;
                  rowHasError = true;
                  Q381ATalvDetails[index].neuroOtherTextEmpty = true;
                }
              });
            }
          }
        }

        // ========================================
        // Column D: Pattern BEFORE change - HARD ERROR
        // ========================================
        // If changeType is "Frequency change" (2)
        if (row.changeType === 2) {
          // Frequency type required
          if (
            row.patterBeforeChangeDoseFrequency === null ||
            row.patterBeforeChangeDoseFrequency === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].patternBeforeFrequencyEmpty = true;
          }

          // Frequency value required if type is 1 (times/week) or 2 (every X weeks)
          if (
            (row.patterBeforeChangeDoseFrequency === 1 ||
              row.patterBeforeChangeDoseFrequency === 2) &&
            isStringEmpty(
              row.patterBeforeChangeDoseFrequency == 1
                ? row.patterBeforeChangeDoseFrequencyPerWeek
                : row.patterBeforeChangeDoseFrequencyEveryWeek,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].patternBeforeFrequencyEmpty = true;
          }

          // Range validation: Integer, >0 and ≤10
          if (
            !isStringEmpty(
              row.patterBeforeChangeDoseFrequency == 1
                ? row.patterBeforeChangeDoseFrequencyPerWeek
                : row.patterBeforeChangeDoseFrequencyEveryWeek,
            ) &&
            row.patterBeforeChangeDoseFrequency !== 99
          ) {
            const weekValue = Number(
              row.patterBeforeChangeDoseFrequency == 1
                ? row.patterBeforeChangeDoseFrequencyPerWeek
                : row.patterBeforeChangeDoseFrequencyEveryWeek,
            );
            if (
              !Number.isInteger(weekValue) ||
              weekValue <= 0 ||
              weekValue > 20
            ) {
              isValid = false;
              rowHasError = true;
              Q381ATalvDetails[index].patternBeforeFrequencyRangeInvalid = true;
            }
          }
        }

        // If changeType is "Strength change" (3)
        if (row.changeType === 3) {
          // Strength type required
          if (
            row.patterBeforeChangeDoseStrength === null ||
            row.patterBeforeChangeDoseStrength === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].patternBeforeStrengthEmpty = true;
          }

          // Strength value required if type is 1 (mg), 2 (mg/kg), or 3 (mg/m²)
          if (
            (row.patterBeforeChangeDoseStrength === 1 ||
              row.patterBeforeChangeDoseStrength === 2 ||
              row.patterBeforeChangeDoseStrength === 3) &&
            isStringEmpty(
              row.patterBeforeChangeDoseStrength == 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength == 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].patternBeforeStrengthEmpty = true;
          }

          // Range validation: Decimal, >0.00 and ≤4000.00
          if (
            !isStringEmpty(
              row.patterBeforeChangeDoseStrength == 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength == 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            ) &&
            row.patterBeforeChangeDoseStrength !== 99
          ) {
            const strengthValue = Number(
              row.patterBeforeChangeDoseStrength == 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength == 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            );
            if (
              isNaN(strengthValue) ||
              strengthValue <= 0 ||
              strengthValue > 4000
            ) {
              isValid = false;
              rowHasError = true;
              Q381ATalvDetails[index].patternBeforeStrengthRangeInvalid = true;
            }
          }
        }

        // ========================================
        // Column E: Pattern AFTER change - HARD ERROR
        // ========================================
        // If changeType is "Frequency change" (2)
        if (row.changeType === 2) {
          // Frequency type required
          if (
            row.patterAfterChangeDoseFrequency === null ||
            row.patterAfterChangeDoseFrequency === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].patternAfterFrequencyEmpty = true;
          }

          // Frequency value required if type is 1 or 2
          if (
            (row.patterAfterChangeDoseFrequency === 1 ||
              row.patterAfterChangeDoseFrequency === 2) &&
            isStringEmpty(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyPerWeek
                : row.patterAfterChangeDoseFrequencyEveryWeek,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].patternAfterFrequencyEmpty = true;
          }

          // Range validation: Integer, >0 and ≤10
          if (
            !isStringEmpty(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyPerWeek
                : row.patterAfterChangeDoseFrequencyEveryWeek,
            ) &&
            row.patterAfterChangeDoseFrequency !== 99
          ) {
            const weekValue = Number(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyPerWeek
                : row.patterAfterChangeDoseFrequencyEveryWeek,
            );
            if (
              !Number.isInteger(weekValue) ||
              weekValue <= 0 ||
              weekValue > 20
            ) {
              isValid = false;
              rowHasError = true;
              Q381ATalvDetails[index].patternAfterFrequencyRangeInvalid = true;
            }
          }
        }

        // If changeType is "Strength change" (3)
        if (row.changeType === 3) {
          // Strength type required
          if (
            row.patterAfterChangeDoseStrength === null ||
            row.patterAfterChangeDoseStrength === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].patternAfterStrengthEmpty = true;
          }

          // Strength value required if type is 1, 2, or 3
          if (
            (row.patterAfterChangeDoseStrength === 1 ||
              row.patterAfterChangeDoseStrength === 2 ||
              row.patterAfterChangeDoseStrength === 3) &&
            isStringEmpty(
              row.patterAfterChangeDoseStrength == 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength == 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].patternAfterStrengthEmpty = true;
          }

          // Range validation: Decimal, >0.00 and ≤4000.00
          if (
            !isStringEmpty(
              row.patterAfterChangeDoseStrength == 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength == 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            ) &&
            row.patterAfterChangeDoseStrength !== 99
          ) {
            const strengthValue = Number(
              row.patterAfterChangeDoseStrength == 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength == 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            );
            if (
              isNaN(strengthValue) ||
              strengthValue <= 0 ||
              strengthValue > 4000
            ) {
              isValid = false;
              rowHasError = true;
              Q381ATalvDetails[index].patternAfterStrengthRangeInvalid = true;
            }
          }
        }

        // ========================================
        // Conflict Validations: Before vs After
        // ========================================
        // Only validate if both BEFORE and AFTER are NOT "Unknown"
        // For FREQUENCY INCREASE
        if (
          row.changeType === 2 &&
          row.changeTypeDoseFrequency === 1 &&
          row.patterBeforeChangeDoseFrequency !== 99 &&
          row.patterAfterChangeDoseFrequency !== 99 &&
          row.patterBeforeChangeDoseFrequency ===
            row.patterAfterChangeDoseFrequency &&
          !isStringEmpty(
            row.patterBeforeChangeDoseFrequency === 1
              ? row.patterBeforeChangeDoseFrequencyPerWeek
              : row.patterBeforeChangeDoseFrequencyEveryWeek,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseFrequency === 1
              ? row.patterAfterChangeDoseFrequencyPerWeek
              : row.patterAfterChangeDoseFrequencyEveryWeek,
          )
        ) {
          const isTimesPerWeek = row.patterBeforeChangeDoseFrequency === 1;

          const beforeValue = Number(
            isTimesPerWeek
              ? row.patterBeforeChangeDoseFrequencyPerWeek
              : row.patterBeforeChangeDoseFrequencyEveryWeek,
          );

          const afterValue = Number(
            isTimesPerWeek
              ? row.patterAfterChangeDoseFrequencyPerWeek
              : row.patterAfterChangeDoseFrequencyEveryWeek,
          );

          let isConflict = false;

          if (isTimesPerWeek) {
            // Times per week → After must be greater
            if (afterValue <= beforeValue) {
              isConflict = true;
            }
          } else {
            // Once every X weeks → After must be smaller
            if (afterValue >= beforeValue) {
              isConflict = true;
            }
          }

          if (isConflict) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].frequencyIncreaseConflict = true;
          }
        }

        // For FREQUENCY DECREASE
        if (
          row.changeType === 2 &&
          row.changeTypeDoseFrequency === 2 &&
          row.patterBeforeChangeDoseFrequency !== 99 &&
          row.patterAfterChangeDoseFrequency !== 99 &&
          row.patterBeforeChangeDoseFrequency ===
            row.patterAfterChangeDoseFrequency &&
          !isStringEmpty(
            row.patterBeforeChangeDoseFrequency === 1
              ? row.patterBeforeChangeDoseFrequencyPerWeek
              : row.patterBeforeChangeDoseFrequencyEveryWeek,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseFrequency === 1
              ? row.patterAfterChangeDoseFrequencyPerWeek
              : row.patterAfterChangeDoseFrequencyEveryWeek,
          )
        ) {
          const isTimesPerWeek = row.patterBeforeChangeDoseFrequency === 1;

          const beforeValue = Number(
            isTimesPerWeek
              ? row.patterBeforeChangeDoseFrequencyPerWeek
              : row.patterBeforeChangeDoseFrequencyEveryWeek,
          );

          const afterValue = Number(
            isTimesPerWeek
              ? row.patterAfterChangeDoseFrequencyPerWeek
              : row.patterAfterChangeDoseFrequencyEveryWeek,
          );

          let isConflict = false;

          if (isTimesPerWeek) {
            // Times per week → After must be smaller
            if (afterValue >= beforeValue) {
              isConflict = true;
            }
          } else {
            // Once every X weeks → After must be larger
            if (afterValue <= beforeValue) {
              isConflict = true;
            }
          }

          if (isConflict) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].frequencyDecreaseConflict = true;
          }
        }

        // For STRENGTH INCREASE
        const BeforeChangeDoseStrengthUnit =
          row.patterBeforeChangeDoseStrengthMg ??
          row.patterBeforeChangeDoseStrengthMgKg ??
          row.patterBeforeChangeDoseStrengthMgM2;

        const AfterChangeDoseStrengthUnit =
          row.patterAfterChangeDoseStrengthMg ??
          row.patterAfterChangeDoseStrengthMgKg ??
          row.patterAfterChangeDoseStrengthMgM2;

        if (
          row.changeType === 3 &&
          row.changeTypeDoseStrength === 1 &&
          row.patterBeforeChangeDoseStrength !== 99 &&
          row.patterAfterChangeDoseStrength !== 99 &&
          row.patterBeforeChangeDoseStrength ===
            row.patterAfterChangeDoseStrength &&
          !isStringEmpty(BeforeChangeDoseStrengthUnit) &&
          !isStringEmpty(AfterChangeDoseStrengthUnit)
        ) {
          const beforeValue = Number(BeforeChangeDoseStrengthUnit);
          const afterValue = Number(AfterChangeDoseStrengthUnit);

          // After should be > Before
          if (afterValue <= beforeValue) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].strengthIncreaseConflict = true;
          }
        }

        // For STRENGTH DECREASE
        if (
          row.changeType === 3 &&
          row.changeTypeDoseStrength === 2 &&
          row.patterBeforeChangeDoseStrength !== 99 &&
          row.patterAfterChangeDoseStrength !== 99 &&
          row.patterBeforeChangeDoseStrength ===
            row.patterAfterChangeDoseStrength &&
          !isStringEmpty(BeforeChangeDoseStrengthUnit) &&
          !isStringEmpty(AfterChangeDoseStrengthUnit)
        ) {
          const beforeValue = Number(BeforeChangeDoseStrengthUnit);
          const afterValue = Number(AfterChangeDoseStrengthUnit);

          // After should be < Before
          if (afterValue >= beforeValue) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].strengthDecreaseConflict = true;
          }
        }

        // ========================================
        // Column F: Date - HARD ERROR
        // ========================================
        if (row.dateChangeRd === null || row.dateChangeRd === undefined) {
          isValid = false;
          rowHasError = true;
          Q381ATalvDetails[index].dateChangeRdEmpty = true;
        }
        // If "Date provided" (1) is selected, validate the date
        if (row.dateChangeRd === 1) {
          if (isStringEmpty(row.dateChange)) {
            isValid = false;
            rowHasError = true;
            Q381ATalvDetails[index].dateChangeEmpty = true;
          } else {
            // Date format validation
            if (!DateInRange(row.dateChange, dayjs("01-01-1920"), dayjs())) {
              isValid = false;
              rowHasError = true;
              Q381ATalvDetails[index].invalidDateChange = true;
            } else {
              // ✅ Use the new date chain validation
              if (
                !ValidateQ381ADateChain(
                  row.dateChange,
                  RRMMCohortTreatment.TALVEY,
                )
              ) {
                isValid = false;
                rowHasError = true;
                Q381ATalvDetails[index].dateChangeOutOfBound = true;
              }
            }
          }
        }
      });

      setQ381ATalvDetails([...Q381ATalvDetails]);
    }

    if (isNewEcrfA && isTechvayliSelected) {
      // validate q38.2 tech
      const updatedList = Q382ATechDetails.map((row) => {
        const updatedRow = { ...row };
        // Reset all errors
        updatedRow.colBError = false;
        updatedRow.colCError = false;
        updatedRow.reasonOtherTextEmpty = false;

        updatedRow.aeSubReasonEmpty = false;
        updatedRow.neuroReasonEmpty = false;
        updatedRow.neuroOtherTextEmpty = false;

        updatedRow.colDError = false;
        updatedRow.colFError = false;
        updatedRow.startDoseDtError = false;
        updatedRow.endDoseDtError = false;
        updatedRow.invalidEndDateChange = false;
        updatedRow.endDateChangeOutOfBound = false;
        updatedRow.invalidstartDateChange = false;
        updatedRow.startDateChangeOutOfBound = false;

        /* ---------------- Column B ---------------- */
        if (row.changeType === null) {
          updatedRow.colBError = true;
          isValid = false;
        }

        if (row.changeType !== 1 && row.changeType !== 99) {
          /* ---------------- Column C ---------------- */
          const reasonList = row.discontinuationReasons ?? [];

          const hasSelectedReason = reasonList.some((r) => r.isSelected);
          const hasUnknown = reasonList.some((r) => r.reasonUnk);

          if (!hasSelectedReason && !hasUnknown) {
            updatedRow.colCError = true;
            isValid = false;
          }

          const otherSelected = reasonList?.some(
            (r) =>
              r.isSelected &&
              r.reasonName.includes("Other") &&
              isStringEmpty(r.reasonText),
          );
          if (otherSelected) {
            isValid = false;
            updatedRow.reasonOtherTextEmpty = true;
          }

          const hasAdverseEventSelected = row.discontinuationReasons?.some(
            (r) =>
              r.reasonName === DiscontinuationReason.AdverseEvent &&
              r.isSelected,
          );

          if (hasAdverseEventSelected) {
            const selectedAEs =
              row.adverseEventReasons?.filter((ae) => ae.isSelected) || [];

            if (selectedAEs.length === 0) {
              isValid = false;
              updatedRow.aeSubReasonEmpty = true;
            } else {
              const isNeuroSelected = selectedAEs.some(
                (ae) =>
                  ae.reasonName === DiscontinuationReason.NeurologicalEvent,
              );

              if (isNeuroSelected) {
                const selectedNeuroReasons =
                  row.neurologicAEReasonList?.filter((n) => n.isSelected) || [];

                if (selectedNeuroReasons.length === 0) {
                  isValid = false;
                  updatedRow.neuroReasonEmpty = true;
                }

                selectedNeuroReasons.forEach((neuro) => {
                  if (
                    neuro.reasonName?.includes("Other") &&
                    (!neuro.reasonText || !neuro.reasonText.trim())
                  ) {
                    isValid = false;
                    updatedRow.neuroOtherTextEmpty = true;
                  }
                });
              }
            }
          }

          /* ---------------- Column D ---------------- */

          if (
            row.startDoseDtRd === null &&
            (row.startDoseDt == null || row.startDoseDt == "")
          ) {
            updatedRow.colDError = true;
            // updatedRow.startDoseDtError = true;
            isValid = false;
          } else if (
            row.startDoseDtRd == 1 &&
            (row.startDoseDt == null || row.startDoseDt == "")
          ) {
            updatedRow.colDError = true;
            isValid = false;
          } else {
            if (row.startDoseDtRd === 1) {
              if (isStringEmpty(row.startDoseDt)) {
                isValid = false;
                updatedRow.colDError = true;
              } else {
                // Date format validation
                if (
                  !DateInRange(row.startDoseDt, dayjs("01-01-1920"), dayjs())
                ) {
                  isValid = false;
                  updatedRow.invalidstartDateChange = true;
                } else {
                  // ✅ Use the new date chain validation
                  if (
                    !ValidateQ382ADateChain(
                      row.startDoseDt,
                      RRMMCohortTreatment.TECVAYLI,
                    )
                  ) {
                    isValid = false;
                    updatedRow.startDateChangeOutOfBound = true;
                  }
                }
              }
            }
          }

          /* ---------------- Column F ---------------- */
          if (
            row.endDoseDtRd === null &&
            (row.endDoseDt == null || row.endDoseDt == "")
          ) {
            updatedRow.colFError = true;
            // updatedRow.endDoseDtError = true;
            isValid = false;
          } else if (
            row.endDoseDtRd == 2 &&
            (row.endDoseDt == null || row.endDoseDt == "")
          ) {
            updatedRow.colFError = true;
            isValid = false;
          } else {
            if (row.endDoseDtRd === 2) {
              if (isStringEmpty(row.endDoseDt)) {
                isValid = false;
                updatedRow.colFError = true;
              } else {
                // Date format validation
                if (!DateInRange(row.endDoseDt, dayjs("01-01-1920"), dayjs())) {
                  isValid = false;
                  updatedRow.invalidEndDateChange = true;
                } else {
                  // ✅ Use the new date chain validation
                  if (
                    !ValidateQ382ADateChain(
                      row.endDoseDt,
                      RRMMCohortTreatment.TECVAYLI,
                    )
                  ) {
                    isValid = false;
                    updatedRow.endDateChangeOutOfBound = true;
                  }
                }
              }
            }
          }
        }

        return updatedRow;
      });

      setQ382ATechDetails(updatedList);
    }

    if (isNewEcrfA && isTalveySelected) {
      // validate q38.2 talv
      const updatedQ382TalvList = Q382ATalvDetails.map((row) => {
        const updatedRow = { ...row };

        // Reset all errors
        updatedRow.colBError = false;
        updatedRow.colCError = false;
        updatedRow.aeSubReasonEmpty = false;
        updatedRow.neuroReasonEmpty = false;
        updatedRow.neuroOtherTextEmpty = false;

        updatedRow.colDError = false;
        updatedRow.colFError = false;
        updatedRow.startDoseDtError = false;
        updatedRow.endDoseDtError = false;
        updatedRow.reasonOtherTextEmpty = false;

        /* ---------------- Column B ---------------- */
        if (row.changeType === null) {
          updatedRow.colBError = true;
          isValid = false;
        }

        if (row.changeType !== 1 && row.changeType !== 99) {
          /* ---------------- Column C ---------------- */
          const reasonList = row.discontinuationReasons ?? [];

          const hasSelectedReason = reasonList.some((r) => r.isSelected);
          const hasUnknown = reasonList.some((r) => r.reasonUnk);

          if (!hasSelectedReason && !hasUnknown) {
            updatedRow.colCError = true;
            isValid = false;
          }

          const otherSelected = reasonList?.some(
            (r) =>
              r.isSelected &&
              r.reasonName.includes("Other") &&
              isStringEmpty(r.reasonText),
          );
          if (otherSelected) {
            isValid = false;
            updatedRow.reasonOtherTextEmpty = true;
          }

          const hasAdverseEventSelected = row.discontinuationReasons?.some(
            (r) =>
              r.reasonName === DiscontinuationReason.AdverseEvent &&
              r.isSelected,
          );

          if (hasAdverseEventSelected) {
            const selectedAEs =
              row.adverseEventReasons?.filter((ae) => ae.isSelected) || [];

            if (selectedAEs.length === 0) {
              isValid = false;
              updatedRow.aeSubReasonEmpty = true;
            } else {
              const isNeuroSelected = selectedAEs.some(
                (ae) =>
                  ae.reasonName === DiscontinuationReason.NeurologicalEvent,
              );

              if (isNeuroSelected) {
                const selectedNeuroReasons =
                  row.neurologicAEReasonList?.filter((n) => n.isSelected) || [];

                if (selectedNeuroReasons.length === 0) {
                  isValid = false;
                  updatedRow.neuroReasonEmpty = true;
                }

                selectedNeuroReasons.forEach((neuro) => {
                  if (
                    neuro.reasonName?.includes("Other") &&
                    (!neuro.reasonText || !neuro.reasonText.trim())
                  ) {
                    isValid = false;
                    updatedRow.neuroOtherTextEmpty = true;
                  }
                });
              }
            }
          }

          /* ---------------- Column D ---------------- */
          if (
            row.startDoseDtRd === null &&
            (row.startDoseDt == null || row.startDoseDt == "")
          ) {
            updatedRow.colDError = true;
            // updatedRow.startDoseDtError = true;
            isValid = false;
          } else if (
            row.startDoseDtRd == 1 &&
            (row.startDoseDt == null || row.startDoseDt == "")
          ) {
            updatedRow.colDError = true;
            isValid = false;
          } else {
            if (row.startDoseDtRd === 1) {
              if (isStringEmpty(row.startDoseDt)) {
                isValid = false;
                updatedRow.colDError = true;
              } else {
                // Date format validation
                if (
                  !DateInRange(row.startDoseDt, dayjs("01-01-1920"), dayjs())
                ) {
                  isValid = false;
                  updatedRow.invalidstartDateChange = true;
                } else {
                  // ✅ Use the new date chain validation
                  if (
                    !ValidateQ382ADateChain(
                      row.startDoseDt,
                      RRMMCohortTreatment.TALVEY,
                    )
                  ) {
                    isValid = false;
                    updatedRow.startDateChangeOutOfBound = true;
                  }
                }
              }
            }
          }
          /* ---------------- Column F ---------------- */
          if (
            row.endDoseDtRd === null &&
            (row.endDoseDt == null || row.endDoseDt == "")
          ) {
            updatedRow.colFError = true;
            // updatedRow.endDoseDtError = true;
            isValid = false;
          } else if (
            row.endDoseDtRd == 2 &&
            (row.endDoseDt == null || row.endDoseDt == "")
          ) {
            updatedRow.colFError = true;
            isValid = false;
          } else {
            if (row.endDoseDtRd === 2) {
              if (isStringEmpty(row.endDoseDt)) {
                isValid = false;
                updatedRow.colFError = true;
              } else {
                // Date format validation
                if (!DateInRange(row.endDoseDt, dayjs("01-01-1920"), dayjs())) {
                  isValid = false;
                  updatedRow.invalidEndDateChange = true;
                } else {
                  // ✅ Use the new date chain validation
                  if (
                    !ValidateQ382ADateChain(
                      row.endDoseDt,
                      RRMMCohortTreatment.TALVEY,
                    )
                  ) {
                    isValid = false;
                    updatedRow.endDateChangeOutOfBound = true;
                  }
                }
              }
            }
          }
        }

        return updatedRow;
      });

      setQ382ATalvDetails(updatedQ382TalvList);
    }

    //Q40.1.B Validate
    if (
      isNewEcrfB &&
      isTechvayliSelected &&
      Q37TechDetails[0]?.Q40dosingfreqRd != null &&
      Q37TechDetails[0]?.Q40dosingfreqRd !== 1
    ) {
      const updatedQ401aTecList = Q401aTecDetails.map((row, index) => {
        let Q401aInit_Tec_RdHard = false;
        let Q401aInit_Tec_dtHard = false;
        let Q401aInvalidQ401ainit_Tec_dt = false;
        let Q401aInit_Tec_dt_before_eof = false;
        let Q401aIntendedDosingEmpty_Tec = false;
        let Q401aIntendedDosingRangeInvalid_Tec = false;
        let Q401aReasonIvigEmptyHard_Tec = false;
        let Q401aDosingType_TecEmptyHard = false;
        let Q401aDosageFrequencyEmpty_Tec = false;
        let Q401aDosageRangeInvalid_Tec = false;
        let Q401aWeightEmpty_Tec = false;
        let Q401aWeightRangeInvalid_Tec = false;
        let Q401aWeight_AssesEmptyHard_Tec = false;
        let Q401aWeight_AssesDtEmptyHard_Tec = false;
        let Q401aWeight_AssesDtInvalid_Tec = false;
        let Q401aWeight_Asses_dt_before_eof_Tec = false;

        /* ---------------- Column B ---------------- */
        if (row.Q401ainit_dt_Rd_Tec === null) {
          Q401aInit_Tec_RdHard = true;
        }

        if (!Q401aInit_Tec_RdHard && row.Q401ainit_dt_Rd_Tec === 1) {
          if (isStringEmpty(row.Q401ainit_Tec_dt)) {
            Q401aInit_Tec_dtHard = true;
          } else if (!IsDateValid(row.Q401ainit_Tec_dt)) {
            Q401aInvalidQ401ainit_Tec_dt = true;
          } else if (
            !ValidateIndexDAndLOTDateChain(
              row.Q401ainit_Tec_dt,
              RRMMCohortTreatment.TECVAYLI,
            )
          ) {
            Q401aInit_Tec_dt_before_eof = true;
          }
        }

        /* ---------------- Column C ---------------- */
        if (
          row.Q401aIntendedDosing_Tec === null &&
          isStringEmpty(row.Q401aIntendedDosing_Tec_WeekValue) &&
          isStringEmpty(row.Q401aIntendedDosing_Tec_MonthValue) &&
          isStringEmpty(row.Q401aIntendedDosing_Tec_OnceWeekValue) &&
          isStringEmpty(row.Q401aIntendedDosing_Tec_OnceMonthValue) &&
          isStringEmpty(row.Q401aIntendedDosing_Tec_OtherValue)
        ) {
          Q401aIntendedDosingEmpty_Tec = true;
        }

        if (
          (row.Q401aIntendedDosing_Tec === 1 &&
            isStringEmpty(row.Q401aIntendedDosing_Tec_WeekValue)) ||
          (row.Q401aIntendedDosing_Tec === 2 &&
            isStringEmpty(row.Q401aIntendedDosing_Tec_MonthValue)) ||
          (row.Q401aIntendedDosing_Tec === 3 &&
            isStringEmpty(row.Q401aIntendedDosing_Tec_OnceWeekValue)) ||
          (row.Q401aIntendedDosing_Tec === 4 &&
            isStringEmpty(row.Q401aIntendedDosing_Tec_OnceMonthValue))
        ) {
          Q401aIntendedDosingRangeInvalid_Tec = true;
        }

        /* ---------------- Column D ---------------- */
        if (
          row.Q401aPrimaryProf_Tec === false &&
          row.Q401aSecProf_Tec === false &&
          row.Q401aOtherProf_Tec === false &&
          row.Q401aUnknownProf_Tec === null
        ) {
          Q401aReasonIvigEmptyHard_Tec = true;
        }

        /* ---------------- Column E ---------------- */
        if (row.Q401aDosingType_Tec === null) {
          Q401aDosingType_TecEmptyHard = true;
        }

        /* ---------------- Column F ---------------- */
        if (
          row.Q401aDosage_Tec === null &&
          isStringEmpty(row.Q401aDosage_Tec_GValue) &&
          isStringEmpty(row.Q401aDosage_Tec_MgValue)
        ) {
          Q401aDosageFrequencyEmpty_Tec = true;
        }

        if (
          (row.Q401aDosage_Tec === 1 &&
            isStringEmpty(row.Q401aDosage_Tec_GValue)) ||
          (row.Q401aDosage_Tec === 2 &&
            isStringEmpty(row.Q401aDosage_Tec_MgValue)) ||
          (!isStringEmpty(row.Q401aDosage_Tec_GValue) &&
            (parseInt(row.Q401aDosage_Tec_GValue) < 1 ||
              parseInt(row.Q401aDosage_Tec_GValue) > 200)) ||
          (!isStringEmpty(row.Q401aDosage_Tec_MgValue) &&
            (parseInt(row.Q401aDosage_Tec_MgValue) < 1 ||
              parseInt(row.Q401aDosage_Tec_MgValue) > 2000))
        ) {
          Q401aDosageRangeInvalid_Tec = true;
        }

        /* ---------------- Column G ---------------- */
        if (
          row.Q401aDosingType_Tec == 2 &&
          row.Q401aWeight_Tec === null &&
          isStringEmpty(row.Q401aWeight_Value_KgTec) &&
          isStringEmpty(row.Q401aWeight_Value_LbsTec)
        ) {
          Q401aWeightEmpty_Tec = true;
        }

        if (
          (row.Q401aDosingType_Tec == 2 &&
            row.Q401aWeight_Tec === 1 &&
            isStringEmpty(row.Q401aWeight_Value_KgTec)) ||
          (row.Q401aWeight_Tec === 2 &&
            isStringEmpty(row.Q401aWeight_Value_LbsTec)) ||
          (!isStringEmpty(row.Q401aWeight_Value_KgTec) &&
            (parseInt(row.Q401aWeight_Value_KgTec) < 2 ||
              parseInt(row.Q401aWeight_Value_KgTec) > 630)) ||
          (!isStringEmpty(row.Q401aWeight_Value_LbsTec) &&
            (parseInt(row.Q401aWeight_Value_LbsTec) < 2 ||
              parseInt(row.Q401aWeight_Value_LbsTec) > 1400))
        ) {
          Q401aWeightRangeInvalid_Tec = true;
        }

        /* ---------------- Column H ---------------- */
        if (
          row.Q401aDosingType_Tec == 2 &&
          row.Q401aWeight_Asses_Tec === null &&
          isStringEmpty(row.Q401aWeight_Asses_Tec_dt)
        ) {
          Q401aWeight_AssesEmptyHard_Tec = true;
        }

        if (row.Q401aDosingType_Tec === 2 && row.Q401aWeight_Asses_Tec === 1) {
          if (isStringEmpty(row.Q401aWeight_Asses_Tec_dt)) {
            Q401aWeight_AssesDtEmptyHard_Tec = true;
          } else if (!IsDateValid(row.Q401aWeight_Asses_Tec_dt)) {
            Q401aWeight_AssesDtInvalid_Tec = true;
          } else if (
            !ValidateIndexDAndLOTDateChain(
              row.Q401aWeight_Asses_Tec_dt,
              RRMMCohortTreatment.TECVAYLI,
            )
          ) {
            Q401aWeight_Asses_dt_before_eof_Tec = true;
          }
        }

        if (
          Q401aInit_Tec_RdHard ||
          Q401aInit_Tec_dtHard ||
          Q401aInvalidQ401ainit_Tec_dt ||
          Q401aInit_Tec_dt_before_eof ||
          Q401aIntendedDosingEmpty_Tec ||
          Q401aIntendedDosingRangeInvalid_Tec ||
          Q401aReasonIvigEmptyHard_Tec ||
          Q401aDosingType_TecEmptyHard ||
          Q401aDosageFrequencyEmpty_Tec ||
          Q401aDosageRangeInvalid_Tec ||
          Q401aWeightEmpty_Tec ||
          Q401aWeightRangeInvalid_Tec ||
          Q401aWeight_AssesEmptyHard_Tec ||
          Q401aWeight_AssesDtEmptyHard_Tec ||
          Q401aWeight_AssesDtInvalid_Tec ||
          Q401aWeight_Asses_dt_before_eof_Tec
        ) {
          isValid = false;
        }

        return {
          ...row,
          Q401aInit_Tec_RdHard,
          Q401aInit_Tec_dtHard,
          Q401aInvalidQ401ainit_Tec_dt,
          Q401aInit_Tec_dt_before_eof,
          Q401aIntendedDosingEmpty_Tec,
          Q401aIntendedDosingRangeInvalid_Tec,
          Q401aReasonIvigEmptyHard_Tec,
          Q401aDosingType_TecEmptyHard,
          Q401aDosageFrequencyEmpty_Tec,
          Q401aDosageRangeInvalid_Tec,
          Q401aWeightEmpty_Tec,
          Q401aWeightRangeInvalid_Tec,
          Q401aWeight_AssesEmptyHard_Tec,
          Q401aWeight_AssesDtEmptyHard_Tec,
          Q401aWeight_AssesDtInvalid_Tec,
          Q401aWeight_Asses_dt_before_eof_Tec,
        };
      });

      setQ401aTecDetails(updatedQ401aTecList);

      // Warning for Q40.1.B
      const priEnabled = Q37TechDetails[0]?.primaryProf;
      const secEnabled = Q37TechDetails[0]?.secondaryProf;
      const otherEnabled = Q37TechDetails[0]?.otherReson;

      // Check individually
      const priMatch =
        !priEnabled ||
        updatedQ401aTecList?.some((x) => x.Q401aPrimaryProf_Tec === true);
      const secMatch =
        !secEnabled ||
        updatedQ401aTecList?.some((x) => x.Q401aSecProf_Tec === true);
      const otherMatch =
        !otherEnabled ||
        updatedQ401aTecList?.some((x) => x.Q401aOtherProf_Tec === true);

      // Final condition
      const isMatch = priMatch && secMatch && otherMatch;

      if (!isMatch) setQ40Tec_WarningHard(true);
      else setQ40Tec_WarningHard(false);
    }

    //Q40.1.B Validate
    if (
      isNewEcrfB &&
      isTalveySelected &&
      Q37TalDetails[0]?.Q40dosingfreqRd_Tal != null &&
      Q37TalDetails[0]?.Q40dosingfreqRd_Tal !== 1
    ) {
      const updatedQ401aTalList = Q401aTalDetails.map((row, index) => {
        let Q401aInit_Tal_RdHard = false;
        let Q401aInit_Tal_dtHard = false;
        let Q401aInvalidQ401ainit_Tal_dt = false;
        let Q401aInit_Tal_dt_before_eof = false;
        let Q401aIntendedDosingEmpty_Tal = false;
        let Q401aIntendedDosingRangeInvalid_Tal = false;
        let Q401aReasonIvigEmptyHard_Tal = false;
        let Q401aDosingType_TalEmptyHard = false;
        let Q401aDosageFrequencyEmpty_Tal = false;
        let Q401aDosageRangeInvalid_Tal = false;
        let Q401aWeightEmpty_Tal = false;
        let Q401aWeightRangeInvalid_Tal = false;
        let Q401aWeight_AssesEmptyHard_Tal = false;
        let Q401aWeight_AssesDtEmptyHard_Tal = false;
        let Q401aWeight_AssesDtInvalid_Tal = false;
        let Q401aWeight_Asses_dt_before_eof_Tal = false;

        /* ---------------- Column B ---------------- */
        if (row.Q401ainit_dt_Rd_Tal === null) {
          Q401aInit_Tal_RdHard = true;
        }

        if (!Q401aInit_Tal_RdHard && row.Q401ainit_dt_Rd_Tal === 1) {
          if (isStringEmpty(row.Q401ainit_Tal_dt)) {
            Q401aInit_Tal_dtHard = true;
          } else if (!IsDateValid(row.Q401ainit_Tal_dt)) {
            Q401aInvalidQ401ainit_Tal_dt = true;
          } else if (
            !ValidateIndexDAndLOTDateChain(
              row.Q401ainit_Tal_dt,
              RRMMCohortTreatment.TALVEY,
            )
          ) {
            Q401aInit_Tal_dt_before_eof = true;
          }
        }

        /* ---------------- Column C ---------------- */
        if (
          row.Q401aIntendedDosing_Tal === null &&
          isStringEmpty(row.Q401aIntendedDosing_Tal_WeekValue) &&
          isStringEmpty(row.Q401aIntendedDosing_Tal_MonthValue) &&
          isStringEmpty(row.Q401aIntendedDosing_Tal_OnceWeekValue) &&
          isStringEmpty(row.Q401aIntendedDosing_Tal_OnceMonthValue) &&
          isStringEmpty(row.Q401aIntendedDosing_Tal_OtherValue)
        ) {
          Q401aIntendedDosingEmpty_Tal = true;
        }

        if (
          (row.Q401aIntendedDosing_Tal === 1 &&
            isStringEmpty(row.Q401aIntendedDosing_Tal_WeekValue)) ||
          (row.Q401aIntendedDosing_Tal === 2 &&
            isStringEmpty(row.Q401aIntendedDosing_Tal_MonthValue)) ||
          (row.Q401aIntendedDosing_Tal === 3 &&
            isStringEmpty(row.Q401aIntendedDosing_Tal_OnceWeekValue)) ||
          (row.Q401aIntendedDosing_Tal === 4 &&
            isStringEmpty(row.Q401aIntendedDosing_Tal_OnceMonthValue)) ||
          (row.Q401aIntendedDosing_Tal === 5 &&
            isStringEmpty(row.Q401aIntendedDosing_Tal_OtherValue))
        ) {
          Q401aIntendedDosingRangeInvalid_Tal = true;
        }

        /* ---------------- Column D ---------------- */
        if (
          row.Q401aPrimaryProf_Tal === false &&
          row.Q401aSecProf_Tal === false &&
          row.Q401aOtherProf_Tal === false &&
          row.Q401aUnknownProf_Tal === null
        ) {
          Q401aReasonIvigEmptyHard_Tal = true;
        }

        /* ---------------- Column E ---------------- */
        if (row.Q401aDosingType_Tal === null) {
          Q401aDosingType_TalEmptyHard = true;
        }

        /* ---------------- Column F ---------------- */
        if (
          row.Q401aDosage_Tal === null &&
          isStringEmpty(row.Q401aDosage_Tal_GValue) &&
          isStringEmpty(row.Q401aDosage_Tal_MgValue)
        ) {
          Q401aDosageFrequencyEmpty_Tal = true;
        }

        if (
          (row.Q401aDosage_Tal === 1 &&
            isStringEmpty(row.Q401aDosage_Tal_GValue)) ||
          (row.Q401aDosage_Tal === 2 &&
            isStringEmpty(row.Q401aDosage_Tal_MgValue)) ||
          (!isStringEmpty(row.Q401aDosage_Tal_GValue) &&
            (parseInt(row.Q401aDosage_Tal_GValue) < 1 ||
              parseInt(row.Q401aDosage_Tal_GValue) > 200)) ||
          (!isStringEmpty(row.Q401aDosage_Tal_MgValue) &&
            (parseInt(row.Q401aDosage_Tal_MgValue) < 1 ||
              parseInt(row.Q401aDosage_Tal_MgValue) > 2000))
        ) {
          Q401aDosageRangeInvalid_Tal = true;
        }

        /* ---------------- Column G ---------------- */
        if (
          row.Q401aDosingType_Tal == 2 &&
          row.Q401aWeight_Tal === null &&
          isStringEmpty(row.Q401aWeight_Value_KgTal) &&
          isStringEmpty(row.Q401aWeight_Value_LbsTal)
        ) {
          Q401aWeightEmpty_Tal = true;
        }

        if (
          (row.Q401aDosingType_Tal == 2 &&
            row.Q401aWeight_Tal === 1 &&
            isStringEmpty(row.Q401aWeight_Value_KgTal)) ||
          (row.Q401aWeight_Tal === 2 &&
            isStringEmpty(row.Q401aWeight_Value_LbsTal)) ||
          (!isStringEmpty(row.Q401aWeight_Value_KgTal) &&
            (parseInt(row.Q401aWeight_Value_KgTal) < 2 ||
              parseInt(row.Q401aWeight_Value_KgTal) > 630)) ||
          (!isStringEmpty(row.Q401aWeight_Value_LbsTal) &&
            (parseInt(row.Q401aWeight_Value_LbsTal) < 2 ||
              parseInt(row.Q401aWeight_Value_LbsTal) > 1400))
        ) {
          Q401aWeightRangeInvalid_Tal = true;
        }

        /* ---------------- Column H ---------------- */
        if (
          row.Q401aDosingType_Tal == 2 &&
          row.Q401aWeight_Asses_Tal === null &&
          isStringEmpty(row.Q401aWeight_Asses_Tal_dt)
        ) {
          Q401aWeight_AssesEmptyHard_Tal = true;
        }

        if (row.Q401aDosingType_Tal === 2 && row.Q401aWeight_Asses_Tal === 1) {
          if (isStringEmpty(row.Q401aWeight_Asses_Tal_dt)) {
            Q401aWeight_AssesDtEmptyHard_Tal = true;
          } else if (!IsDateValid(row.Q401aWeight_Asses_Tal_dt)) {
            Q401aWeight_AssesDtInvalid_Tal = true;
          } else if (
            !ValidateIndexDAndLOTDateChain(
              row.Q401aWeight_Asses_Tal_dt,
              RRMMCohortTreatment.TALVEY,
            )
          ) {
            Q401aWeight_Asses_dt_before_eof_Tal = true;
          }
        }

        if (
          Q401aInit_Tal_RdHard ||
          Q401aInit_Tal_dtHard ||
          Q401aInvalidQ401ainit_Tal_dt ||
          Q401aInit_Tal_dt_before_eof ||
          Q401aIntendedDosingEmpty_Tal ||
          Q401aIntendedDosingRangeInvalid_Tal ||
          Q401aReasonIvigEmptyHard_Tal ||
          Q401aDosingType_TalEmptyHard ||
          Q401aDosageFrequencyEmpty_Tal ||
          Q401aDosageRangeInvalid_Tal ||
          Q401aWeightEmpty_Tal ||
          Q401aWeightRangeInvalid_Tal ||
          Q401aWeight_AssesEmptyHard_Tal ||
          Q401aWeight_AssesDtEmptyHard_Tal ||
          Q401aWeight_AssesDtInvalid_Tal ||
          Q401aWeight_Asses_dt_before_eof_Tal
        ) {
          isValid = false;
        }

        return {
          ...row,
          Q401aInit_Tal_RdHard,
          Q401aInit_Tal_dtHard,
          Q401aInvalidQ401ainit_Tal_dt,
          Q401aInit_Tal_dt_before_eof,
          Q401aIntendedDosingEmpty_Tal,
          Q401aIntendedDosingRangeInvalid_Tal,
          Q401aReasonIvigEmptyHard_Tal,
          Q401aDosingType_TalEmptyHard,
          Q401aDosageFrequencyEmpty_Tal,
          Q401aDosageRangeInvalid_Tal,
          Q401aWeightEmpty_Tal,
          Q401aWeightRangeInvalid_Tal,
          Q401aWeight_AssesEmptyHard_Tal,
          Q401aWeight_AssesDtEmptyHard_Tal,
          Q401aWeight_AssesDtInvalid_Tal,
          Q401aWeight_Asses_dt_before_eof_Tal,
        };
      });

      setQ401aTalDetails(updatedQ401aTalList);

      // Warning for Q40.1.B
      const priEnabled = Q37TalDetails[0]?.primaryProf_Tal;
      const secEnabled = Q37TalDetails[0]?.secondaryProf_Tal;
      const otherEnabled = Q37TalDetails[0]?.otherReson_Tal;

      // Check individually
      const priMatch =
        !priEnabled ||
        updatedQ401aTalList?.some((x) => x.Q401aPrimaryProf_Tal === true);
      const secMatch =
        !secEnabled ||
        updatedQ401aTalList?.some((x) => x.Q401aSecProf_Tal === true);
      const otherMatch =
        !otherEnabled ||
        updatedQ401aTalList?.some((x) => x.Q401aOtherProf_Tal === true);

      // Final condition
      const isMatch = priMatch && secMatch && otherMatch;

      if (!isMatch) setQ40Tal_WarningHard(true);
      else setQ40Tal_WarningHard(false);
    }

    const tecNextLotStartDate =
      cohortNextLotDatesList
        ?.get(RRMMCohortTreatment.TECVAYLI)
        ?.get(TRPQuestionType.Q40) ?? "";

    const talNextLotStartDate =
      cohortNextLotDatesList
        ?.get(RRMMCohortTreatment.TALVEY)
        ?.get(TRPQuestionType.Q40) ?? "";

    //Q40.2.B Validate
    if (isNewEcrfB && isTechvayliSelected) {
      const updatedQ402aTecList = Q402aTecDetails.map((row) => {
        const updatedRow = { ...row };

        // Reset all errors
        updatedRow.Q402aIgg_assessment_Tec_RdHard = false;
        updatedRow.Q402aIgg_assessment_Tec_dtHard = false;
        updatedRow.Q402aIgg_assessment_Tec_dtInvalid = false;
        updatedRow.Q402aIgg_assessment_Tec_dt_before_eof = false;
        updatedRow.Q402aIgg_level_Tec_Empty = false;
        updatedRow.Q402aIgg_level_Tec_RangeInvalid = false;

        /* ---------------- Column B ---------------- */
        if (
          row.Q402aIgg_assessment_Tec === null &&
          isStringEmpty(row.Q402aIgg_assessment_Tec_dt)
        ) {
          updatedRow.Q402aIgg_assessment_Tec_RdHard = true;
          isValid = false;
        }

        if (row.Q402aIgg_assessment_Tec === 2) {
          if (isStringEmpty(row.Q402aIgg_assessment_Tec_dt)) {
            updatedRow.Q402aIgg_assessment_Tec_dtHard = true;
            isValid = false;
          } else if (row.Q402aIgg_assessment_Tec_dt === "Invalid Date") {
            updatedRow.Q402aIgg_assessment_Tec_dtInvalid = true;
            isValid = false;
          } else if (
            !DateInRange(
              row.Q402aIgg_assessment_Tec_dt,
              dayjs("01-01-1920"),
              dayjs(),
            )
          ) {
            updatedRow.Q402aIgg_assessment_Tec_dtInvalid = true;
            isValid = false;
          } else {
            let indexMinus91 = showTechDate91("validate");
            let indexPlus7 = getTecTalQ402BUpperLimitDate(
              "validate",
              RRMMCohortTreatment.TECVAYLI,
            );
            let dateValidationResult = ValidateQ402BDate(
              indexMinus91,
              row.Q402aIgg_assessment_Tec_dt,
              indexPlus7,
              tecNextLotStartDate,
              endOfFollowUpDate,
            );
            if (!dateValidationResult) {
              updatedRow.Q402aIgg_assessment_Tec_dt_before_eof = true;
              isValid = false;
            }
          }
        }

        /* ---------------- Column C ---------------- */
        if (
          row.Q402aIgg_assessment_Tec != 1 &&
          row.Q402aIgg_level_Tec === null &&
          isStringEmpty(row.Q402aIgg_level_Tec_MgValue) &&
          isStringEmpty(row.Q402aIgg_level_Tec_GValue)
        ) {
          updatedRow.Q402aIgg_level_Tec_Empty = true;
          isValid = false;
        }

        if (
          (row.Q402aIgg_assessment_Tec != 1 &&
            row.Q402aIgg_level_Tec === 1 &&
            isStringEmpty(row.Q402aIgg_level_Tec_MgValue)) ||
          (row.Q402aIgg_level_Tec === 2 &&
            isStringEmpty(row.Q402aIgg_level_Tec_GValue)) ||
          (!isStringEmpty(row.Q402aIgg_level_Tec_MgValue) &&
            (parseInt(row.Q402aIgg_level_Tec_MgValue) < 1 ||
              parseInt(row.Q402aIgg_level_Tec_MgValue) > 5000)) ||
          (!isStringEmpty(row.Q402aIgg_level_Tec_GValue) &&
            (parseInt(row.Q402aIgg_level_Tec_GValue) < 1 ||
              parseInt(row.Q402aIgg_level_Tec_GValue) > 50))
        ) {
          updatedRow.Q402aIgg_level_Tec_RangeInvalid = true;
          isValid = false;
        }

        return updatedRow;
      });

      setQ402aTecDetails(updatedQ402aTecList);
    }

    //Q40.2.B Validate
    if (isNewEcrfB && isTalveySelected) {
      const updatedQ402aTalList = Q402aTalDetails.map((row) => {
        const updatedRow = { ...row };

        // Reset all errors
        updatedRow.Q402aIgg_assessment_Tal_RdHard = false;
        updatedRow.Q402aIgg_assessment_Tal_dtHard = false;
        updatedRow.Q402aIgg_assessment_Tal_dtInvalid = false;
        updatedRow.Q402aIgg_assessment_Tal_dt_before_eof = false;
        updatedRow.Q402aIgg_level_Tal_Empty = false;
        updatedRow.Q402aIgg_level_Tal_RangeInvalid = false;

        /* ---------------- Column B ---------------- */
        if (
          row.Q402aIgg_assessment_Tal === null &&
          isStringEmpty(row.Q402aIgg_assessment_Tal_dt)
        ) {
          updatedRow.Q402aIgg_assessment_Tal_RdHard = true;
          isValid = false;
        }

        if (row.Q402aIgg_assessment_Tal === 2) {
          if (isStringEmpty(row.Q402aIgg_assessment_Tal_dt)) {
            updatedRow.Q402aIgg_assessment_Tal_dtHard = true;
            isValid = false;
          } else if (row.Q402aIgg_assessment_Tal_dt === "Invalid Date") {
            updatedRow.Q402aIgg_assessment_Tal_dtInvalid = true;
            isValid = false;
          } else if (
            !DateInRange(
              row.Q402aIgg_assessment_Tal_dt,
              dayjs("01-01-1920"),
              dayjs(),
            )
          ) {
            updatedRow.Q402aIgg_assessment_Tal_dtInvalid = true;
            isValid = false;
          } else {
            let indexMinus91 = showTalDate91("validate");
            let indexPlus7 = getTecTalQ402BUpperLimitDate(
              "validate",
              RRMMCohortTreatment.TALVEY,
            );
            let dateValidationResult = ValidateQ402BDate(
              indexMinus91,
              row.Q402aIgg_assessment_Tal_dt,
              indexPlus7,
              talNextLotStartDate,
              endOfFollowUpDate,
            );
            if (!dateValidationResult) {
              updatedRow.Q402aIgg_assessment_Tal_dt_before_eof = true;
              isValid = false;
            }
          }
        }

        /* ---------------- Column C ---------------- */
        if (
          row.Q402aIgg_assessment_Tal != 1 &&
          row.Q402aIgg_level_Tal === null &&
          isStringEmpty(row.Q402aIgg_level_Tal_MgValue) &&
          isStringEmpty(row.Q402aIgg_level_Tal_GValue)
        ) {
          updatedRow.Q402aIgg_level_Tal_Empty = true;
          isValid = false;
        }

        if (
          (row.Q402aIgg_assessment_Tal != 1 &&
            row.Q402aIgg_level_Tal === 1 &&
            isStringEmpty(row.Q402aIgg_level_Tal_MgValue)) ||
          (row.Q402aIgg_level_Tal === 2 &&
            isStringEmpty(row.Q402aIgg_level_Tal_GValue)) ||
          (!isStringEmpty(row.Q402aIgg_level_Tal_MgValue) &&
            (parseInt(row.Q402aIgg_level_Tal_MgValue) < 1 ||
              parseInt(row.Q402aIgg_level_Tal_MgValue) > 5000)) ||
          (!isStringEmpty(row.Q402aIgg_level_Tal_GValue) &&
            (parseInt(row.Q402aIgg_level_Tal_GValue) < 1 ||
              parseInt(row.Q402aIgg_level_Tal_GValue) > 50))
        ) {
          updatedRow.Q402aIgg_level_Tal_RangeInvalid = true;
          isValid = false;
        }

        return updatedRow; // ✅ CRITICAL FIX
      });

      setQ402aTalDetails(updatedQ402aTalList);
    }

    //Q40.3.B Validate
    if (
      isNewEcrfB &&
      isTechvayliSelected &&
      Q37TechDetails[0]?.Q40dosingfreqRd != null &&
      Q37TechDetails[0]?.Q40dosingfreqRd != 1
    ) {
      const updatedQ403aTecList = Q403aTecDetails.map((row) => {
        const updatedRow = { ...row };

        // Reset all errors
        updatedRow.Q403aIgg_assessment_Tec_RdHard = false;
        updatedRow.Q403aIgg_assessment_Tec_dtHard = false;
        updatedRow.Q403aIgg_assessment_Tec_dtInvalid = false;
        updatedRow.Q403aIgg_assessment_Tec_dt_before_eof = false;
        updatedRow.Q403aIgg_level_Tec_Empty = false;
        updatedRow.Q403aIgg_level_Tec_RangeInvalid = false;

        /* ---------------- Column B ---------------- */
        if (
          row.Q403aIgg_assessment_Tec === null &&
          isStringEmpty(row.Q403aIgg_assessment_Tec_dt)
        ) {
          updatedRow.Q403aIgg_assessment_Tec_RdHard = true;
          isValid = false;
        }

        if (row.Q403aIgg_assessment_Tec === 2) {
          if (isStringEmpty(row.Q403aIgg_assessment_Tec_dt)) {
            updatedRow.Q403aIgg_assessment_Tec_dtHard = true;
            isValid = false;
          } else if (row.Q403aIgg_assessment_Tec_dt === "Invalid Date") {
            updatedRow.Q403aIgg_assessment_Tec_dtInvalid = true;
            isValid = false;
          } else if (
            !DateInRange(
              row.Q403aIgg_assessment_Tec_dt,
              dayjs("01-01-1920"),
              dayjs(),
            )
          ) {
            updatedRow.Q403aIgg_assessment_Tec_dtInvalid = true;
            isValid = false;
          } else {
            let indexMinus91 = showTechDate91("validate");
            let Q40Minus91 = showTechQ40Date91("validate");
            let Q40Date = showTechQ40Date("validate");
            let dateValidationResult = ValidateQ403BDate(
              indexMinus91,
              Q40Minus91,
              row.Q403aIgg_assessment_Tec_dt,
              Q40Date,
              tecNextLotStartDate,
              endOfFollowUpDate,
            );

            if (!dateValidationResult) {
              updatedRow.Q403aIgg_assessment_Tec_dt_before_eof = true;
              isValid = false;
            }
          }
        }

        /* ---------------- Column C ---------------- */
        if (
          row.Q403aIgg_assessment_Tec != 1 &&
          row.Q403aIgg_level_Tec === null &&
          isStringEmpty(row.Q403aIgg_level_Tec_MgValue) &&
          isStringEmpty(row.Q403aIgg_level_Tec_GValue)
        ) {
          updatedRow.Q403aIgg_level_Tec_Empty = true;
          isValid = false;
        }

        if (
          (row.Q403aIgg_assessment_Tec != 1 &&
            row.Q403aIgg_level_Tec === 1 &&
            isStringEmpty(row.Q403aIgg_level_Tec_MgValue)) ||
          (row.Q403aIgg_level_Tec === 2 &&
            isStringEmpty(row.Q403aIgg_level_Tec_GValue)) ||
          (!isStringEmpty(row.Q403aIgg_level_Tec_MgValue) &&
            (parseInt(row.Q403aIgg_level_Tec_MgValue) < 1 ||
              parseInt(row.Q403aIgg_level_Tec_MgValue) > 5000)) ||
          (!isStringEmpty(row.Q403aIgg_level_Tec_GValue) &&
            (parseInt(row.Q403aIgg_level_Tec_GValue) < 1 ||
              parseInt(row.Q403aIgg_level_Tec_GValue) > 50))
        ) {
          updatedRow.Q403aIgg_level_Tec_RangeInvalid = true;
          isValid = false;
        }

        return updatedRow;
      });

      setQ403aTecDetails(updatedQ403aTecList);
    }

    //Q40.3.B Validate
    if (
      isNewEcrfB &&
      isTalveySelected &&
      Q37TalDetails[0]?.Q40dosingfreqRd_Tal != null &&
      Q37TalDetails[0]?.Q40dosingfreqRd_Tal != 1
    ) {
      const updatedQ403aTalList = Q403aTalDetails.map((row) => {
        const updatedRow = { ...row };

        // Reset all errors
        updatedRow.Q403aIgg_assessment_Tal_RdHard = false;
        updatedRow.Q403aIgg_assessment_Tal_dtHard = false;
        updatedRow.Q403aIgg_assessment_Tal_dtInvalid = false;
        updatedRow.Q403aIgg_assessment_Tal_dt_before_eof = false;
        updatedRow.Q403aIgg_level_Tal_Empty = false;
        updatedRow.Q403aIgg_level_Tal_RangeInvalid = false;

        /* ---------------- Column B ---------------- */
        if (
          row.Q403aIgg_assessment_Tal === null &&
          isStringEmpty(row.Q403aIgg_assessment_Tal_dt)
        ) {
          updatedRow.Q403aIgg_assessment_Tal_RdHard = true;
          isValid = false;
        }

        if (row.Q403aIgg_assessment_Tal === 2) {
          if (isStringEmpty(row.Q403aIgg_assessment_Tal_dt)) {
            updatedRow.Q403aIgg_assessment_Tal_dtHard = true;
            isValid = false;
          } else if (row.Q403aIgg_assessment_Tal_dt === "Invalid Date") {
            updatedRow.Q403aIgg_assessment_Tal_dtInvalid = true;
            isValid = false;
          } else if (
            !DateInRange(
              row.Q403aIgg_assessment_Tal_dt,
              dayjs("01-01-1920"),
              dayjs(),
            )
          ) {
            updatedRow.Q403aIgg_assessment_Tal_dtInvalid = true;
            isValid = false;
          } else {
            let indexMinus91 = showTalDate91("validate");
            let Q40Minus91 = showTalQ40Date91("validate");
            let Q40Date = showTalQ40Date("validate");
            let dateValidationResult = ValidateQ403BDate(
              indexMinus91,
              Q40Minus91,
              row.Q403aIgg_assessment_Tal_dt,
              Q40Date,
              talNextLotStartDate,
              endOfFollowUpDate,
            );

            if (!dateValidationResult) {
              updatedRow.Q403aIgg_assessment_Tal_dt_before_eof = true;
              isValid = false;
            }
          }
        }

        /* ---------------- Column C ---------------- */
        if (
          row.Q403aIgg_assessment_Tal != 1 &&
          row.Q403aIgg_level_Tal === null &&
          isStringEmpty(row.Q403aIgg_level_Tal_MgValue) &&
          isStringEmpty(row.Q403aIgg_level_Tal_GValue)
        ) {
          updatedRow.Q403aIgg_level_Tal_Empty = true;
          isValid = false;
        }

        if (
          (row.Q403aIgg_assessment_Tal != 1 &&
            row.Q403aIgg_level_Tal === 1 &&
            isStringEmpty(row.Q403aIgg_level_Tal_MgValue)) ||
          (row.Q403aIgg_level_Tal === 2 &&
            isStringEmpty(row.Q403aIgg_level_Tal_GValue)) ||
          (!isStringEmpty(row.Q403aIgg_level_Tal_MgValue) &&
            (parseInt(row.Q403aIgg_level_Tal_MgValue) < 1 ||
              parseInt(row.Q403aIgg_level_Tal_MgValue) > 5000)) ||
          (!isStringEmpty(row.Q403aIgg_level_Tal_GValue) &&
            (parseInt(row.Q403aIgg_level_Tal_GValue) < 1 ||
              parseInt(row.Q403aIgg_level_Tal_GValue) > 50))
        ) {
          updatedRow.Q403aIgg_level_Tal_RangeInvalid = true;
          isValid = false;
        }

        return updatedRow; // ✅ CRITICAL FIX
      });

      setQ403aTalDetails(updatedQ403aTalList);
    }
    return isValid;
  };

  const getLatestQ36ColumnBDate = (cohortType) => {
    // ✅ Q36 Dosage data - NOT Q36.1
    const dosageDetails =
      cohortType === RRMMCohortTreatment.TECVAYLI
        ? techvayliDetails
        : talveyDetails;

    // ✅ Column [B] = doseadministrationelrdt / doseadministrationlinvodt
    const validDates = dosageDetails
      .filter((row) => {
        const dateField =
          cohortType === RRMMCohortTreatment.TECVAYLI
            ? row.dose_administration_tech_dt
            : row.dose_administration_tal_dt;
        const radioField =
          cohortType === RRMMCohortTreatment.TECVAYLI
            ? row.dose_administration_tech
            : row.dose_administration_tal;

        return IsValidDateValue(dateField) && radioField === 1;
      })
      .map((row) => {
        const dateField =
          cohortType === RRMMCohortTreatment.TECVAYLI
            ? row.dose_administration_tech_dt
            : row.dose_administration_tal_dt;
        return dayjs(dateField);
      });

    if (validDates.length === 0) return null;

    // Return the latest (maximum) date as string
    return validDates
      .reduce((max, date) => (date.isAfter(max) ? date : max))
      .format("MM/DD/YYYY");
  };

  const ValidateQ381ADateChain = (date, cohortType) => {
    const indexDate =
      cohortType === RRMMCohortTreatment.TECVAYLI
        ? techIndexDate
        : talIndexDate;

    const latestQ36Date = getLatestQ36ColumnBDate(cohortType);

    const lotStartDate =
      cohortType === RRMMCohortTreatment.TECVAYLI
        ? techLOTStartDate
        : talLOTStartDate;

    const idx = IsValidDateValue(indexDate) ? indexDate : null;
    const q381ADate = IsValidDateValue(date) ? date : null;
    const q36Latest = IsValidDateValue(latestQ36Date) ? latestQ36Date : null;
    const lot = IsValidDateValue(lotStartDate) ? lotStartDate : null;
    const eof = IsValidDateValue(endOfFollowUpDate) ? endOfFollowUpDate : null;

    // Rule 1: index date ≤ [D]
    if (idx && q381ADate && !IsLessOrEqual(idx, q381ADate)) {
      return false;
    }

    // Rule 2: [D] ≤ latest Q36 [B] (if Q36 dates exist)
    if (q381ADate && q36Latest && !IsLessOrEqual(q381ADate, q36Latest)) {
      return false;
    }

    // Rule 3: latest Q36 [B] ≤ LOT (if both exist)
    if (q36Latest && lot && !IsLessOrEqual(q36Latest, lot)) {
      return false;
    }

    // Rule 4: [D] ≤ LOT (if LOT exists and no Q36 dates)
    if (q381ADate && lot && !q36Latest && !IsLessOrEqual(q381ADate, lot)) {
      return false;
    }

    // Rule 5: LOT ≤ EOF
    if (lot && eof && !IsLessOrEqual(lot, eof)) {
      return false;
    }

    // Rule 6: [D] ≤ EOF
    if (q381ADate && eof && !IsLessOrEqual(q381ADate, eof)) {
      return false;
    }

    return true;
  };

  const ValidateQ382ADateChain = (date, cohortType) => {
    const indexDate =
      cohortType === RRMMCohortTreatment.TECVAYLI
        ? techIndexDate
        : talIndexDate;

    const latestQ36Date = getLatestQ36ColumnBDate(cohortType);

    const lotStartDate =
      cohortType === RRMMCohortTreatment.TECVAYLI
        ? techLOTStartDate
        : talLOTStartDate;

    const cohortIndexDate = IsValidDateValue(indexDate) ? indexDate : null;
    const q382ADate = IsValidDateValue(date) ? date : null;
    //const q36Latest = IsValidDateValue(latestQ36Date) ? latestQ36Date : null;
    const lot = IsValidDateValue(lotStartDate) ? lotStartDate : null;
    const eof = IsValidDateValue(endOfFollowUpDate) ? endOfFollowUpDate : null;

    // Rule 1: index date ≤ [D]
    if (
      cohortIndexDate &&
      q382ADate &&
      !IsLessOrEqual(cohortIndexDate, q382ADate)
    ) {
      return false;
    }

    // Rule 2: [D] ≤ latest Q36 [B] (if Q36 dates exist)
    // if (q382ADate && q36Latest && !IsLessOrEqual(q382ADate, q36Latest)) {
    //   return false;
    // }

    // // Rule 3: latest Q36 [B] ≤ LOT (if both exist)
    // if (q36Latest && lot && !IsLessOrEqual(q36Latest, lot)) {
    //   return false;
    // }

    // Rule 4: [D] ≤ LOT (if LOT exists and no Q36 dates)
    if (q382ADate && lot && !IsLessOrEqual(q382ADate, lot)) {
      return false;
    }

    // Rule 5: LOT ≤ EOF
    // if (lot && eof && !IsLessOrEqual(lot, eof)) {
    //   return false;
    // }

    // Rule 6: [D] ≤ EOF
    if (q382ADate && eof && !IsLessOrEqual(q382ADate, eof)) {
      return false;
    }

    return true;
  };

  const ValidateForDateCondition = (Q36ListData) => {
    let isValid = true;
    let cohortId = Q36ListData[0].cohorttreatmentid;

    let techvayliData = techvayliDetails;
    let talveyData = talveyDetails;
    const bispecificQ26DataForQ36 = bispecificQ26Data;
    const bispecificQ331ADataForQ36 = bispecificQ331AData;
    const bispecificQ31Q32DataForQ36 = (bispecificQ31Q32Data ?? []).filter(
      (x) => x?.cohortTreatmentId === cohortId,
    );

    let listToCompare =
      cohortId === RRMMCohortTreatment.TECVAYLI ? techvayliData : talveyData;
    //Date 1: Fetch earliest Date from Q26 & Q26.1
    const earliestQ26Dt = bispecificQ26DataForQ36
      .filter(
        (row) =>
          row.firstAdministrationDt !== null &&
          row.firstAdministrationDt !== "",
      )
      .reduce((earliest, row) => {
        const currentDate = new Date(row.firstAdministrationDt);

        if (!earliest || currentDate < earliest) {
          return currentDate;
        }
        return earliest;
      }, null);

    const formattedEarliestQ26Dt = earliestQ26Dt
      ? earliestQ26Dt.toLocaleDateString("en-US")
      : null;

    //Date 2: Fetch Latest Date of Dose Administration
    const latestQ36Dt = Q36ListData.filter(
      (row) =>
        row.dose_administration_tech_dt !== null &&
        row.dose_administration_tech_dt !== "",
    ).reduce((latest, row) => {
      const currentDate = new Date(row.dose_administration_tech_dt);
      return !latest || currentDate > new Date(latest)
        ? currentDate.toLocaleDateString("en-US")
        : latest;
    }, null);

    const hasValue = (v) =>
      v !== null && v !== undefined && v.toString().trim() !== "";
    const safeFind = (data, predicate) =>
      (data ?? []).find((x) => x && predicate(x)) ?? null;

    //Check which lot to consider while validating based on Q26 data
    if (bispecificQ26DataForQ36.length === 1) {
      const lot = Number(bispecificQ26DataForQ36[0].lotNumber);
      let nextLotNumber = lot + 1;

      if (lot === 1) {
        const firstAdminDtLot1 =
          (bispecificQ331ADataForQ36 ?? []).find(
            (x) => x && Number(x.lotNumber) === lot,
          )?.firstAdministrationDt ?? null;

        // Latest Date of Dose Administration <= 1L of Q33.1.A <=  end of followup
        isValid = CheckDateValidationQ36(
          latestQ36Dt,
          null,
          firstAdminDtLot1,
          endOfFollowUpDate,
        );
      } else if (lot === 2) {
        //Date 3: Fetch earliest Date from Q26 & Q26.1

        //Q28 2L Discontinuation Date
        const ndmmDiscontinuationLot =
          safeFind(ndmmLotData, (x) => Number(x.lotNumber) === lot)?.endLotDt ??
          null;

        //Q33.1.A 2L Discontinuation Date
        const q331ALastAdminDtLot =
          safeFind(
            bispecificQ331ADataForQ36,
            (x) => Number(x.lotNumber) === lot,
          )?.lastAdministrationDt ?? null;

        //Q31 3L Start Date
        const q31FirstAdminDtLot =
          safeFind(
            bispecificQ31Q32DataForQ36,
            (x) => Number(x.lotNumber) === nextLotNumber,
          )?.firstAdministrationDt ?? null;

        const dateToCompare =
          ndmmDiscontinuationLot != null
            ? ndmmDiscontinuationLot
            : q331ALastAdminDtLot != null
              ? q331ALastAdminDtLot
              : q31FirstAdminDtLot != null
                ? q31FirstAdminDtLot
                : null;

        //Earliest date of 12,12.1 or 26, 26.1 <= Latest Date of Dose Administration <= 2L Q28 discontinuation date or 2L Q33.1.A discontinuation date or 3L start date in Q31 <= end of follow up
        isValid = CheckDateValidationQ36(
          formattedEarliestQ26Dt,
          latestQ36Dt,
          dateToCompare,
          endOfFollowUpDate,
        );
      }
    } else if (bispecificQ26DataForQ36.length > 1) {
      // const lotNumbers = bispecificQ26DataForQ36
      //   .map((x) => Number(x.lotNumber))
      //   .filter((x) => !isNaN(x))
      //   .sort((a, b) => a - b);
      const lotNumbers = listToCompare;

      for (let i = 0; i < lotNumbers.length; i++) {
        let isSequential = true;
        let lot = lotNumbers[i];
        let nextLotNumber = lot + 1;

        // Check if this is the last lot
        let isLastLot = i === lotNumbers.length - 1;

        // Check if not first and not last
        let isNotFirstOrLast = i !== 0 && i !== lotNumbers.length - 1;

        if (lotNumbers[i] !== lotNumbers[i - 1] + 1) {
          isSequential = false;
        }

        if (isSequential) {
          // LOTs are sequential

          //Q28, Q29 L Discontinuation Date
          const ndmmDiscontinuationLot =
            safeFind(ndmmLotData, (x) => Number(x.lotNumber) === lot)
              ?.endLotDt ?? null;

          //Q33.1.A L Discontinuation Date
          const q331ALastAdminDtLot =
            safeFind(
              bispecificQ331ADataForQ36,
              (x) => Number(x.lotNumber) === lot,
            )?.lastAdministrationDt ?? null;

          //Q26.1 L+1 Start Date
          const q26FirstAdminDtNextLot =
            safeFind(
              bispecificQ26DataForQ36,
              (x) => Number(x.lotNumber) === nextLotNumber,
            )?.firstAdministrationDt ?? null;

          //Q32 Discontinuation Date
          const q32LastAdminDtLot =
            safeFind(
              bispecificQ31Q32DataForQ36,
              (x) => Number(x.lotNumber) === lot,
            )?.lastAdministrationDt ?? null;

          //Q31 next Lot Start Date
          const q31FirstAdminDtNextLot =
            safeFind(
              bispecificQ31Q32DataForQ36,
              (x) => Number(x.lotNumber) === nextLotNumber,
            )?.firstAdministrationDt ?? null;

          const dateToCompare = hasValue(ndmmDiscontinuationLot)
            ? ndmmDiscontinuationLot
            : hasValue(q331ALastAdminDtLot)
              ? q331ALastAdminDtLot
              : hasValue(q26FirstAdminDtNextLot)
                ? q26FirstAdminDtNextLot
                : null;
          const dateToCompareLastLot = hasValue(q32LastAdminDtLot)
            ? q32LastAdminDtLot
            : hasValue(ndmmDiscontinuationLot)
              ? ndmmDiscontinuationLot
              : hasValue(q331ALastAdminDtLot)
                ? q331ALastAdminDtLot
                : hasValue(q31FirstAdminDtNextLot)
                  ? q31FirstAdminDtNextLot
                  : null;
          const dateToCompareMidlot = hasValue(q32LastAdminDtLot)
            ? q32LastAdminDtLot
            : lot === 3 && hasValue(ndmmDiscontinuationLot)
              ? ndmmDiscontinuationLot
              : hasValue(q331ALastAdminDtLot)
                ? q331ALastAdminDtLot
                : lot === 3 && hasValue(q26FirstAdminDtNextLot)
                  ? q26FirstAdminDtNextLot
                  : hasValue(q31FirstAdminDtNextLot)
                    ? q31FirstAdminDtNextLot
                    : null;

          if (isLastLot) {
            //if this is the last lotnumber of the list
            //Earliest of Q26, Q26.1 <= Latest Date of Dose Administration <= L end Q32 OR L end Q29 OR L end Q33.1.A OR L+1 Start Q31 <= end of follow up
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompareLastLot,
              endOfFollowUpDate,
            );
          } else if (isNotFirstOrLast) {
            //if this is not the first or last lotnumber of the list
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompareMidlot,
              endOfFollowUpDate,
            );
          } else {
            //if this is not the last lotnumber of the list
            //Earliest of Q26, Q26.1 <= Latest Date of Dose Administration <= L end Q28 OR L end Q33.1.A OR L+1 Start Q26, Q26.1 <= end of follow up
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompare,
              endOfFollowUpDate,
            );
          }
        } else if (!isSequential) {
          // LOTs are sequential

          //Q28, Q29 L Discontinuation Date
          const ndmmDiscontinuationLot =
            safeFind(ndmmLotData, (x) => Number(x.lotNumber) === lot)
              ?.endLotDt ?? null;

          //Q33.1.A L Discontinuation Date
          const q331ALastAdminDtLot =
            safeFind(
              bispecificQ331ADataForQ36,
              (x) => Number(x.lotNumber) === lot,
            )?.lastAdministrationDt ?? null;

          //Q31 L+1 Start Date
          const q31StartDateLot =
            safeFind(
              bispecificQ31Q32DataForQ36,
              (x) => Number(x.lotNumber) === nextLotNumber,
            )?.firstAdministrationDt ?? null;

          //Q27 L+1 Start Date
          const q27StartDateLot =
            safeFind(ndmmLotData, (x) => Number(x.lotNumber) === nextLotNumber)
              ?.startLotDt ?? null;

          //Q33.1.A L+1 Start Date
          const q331AStartAdminDtNextLot =
            safeFind(
              bispecificQ331ADataForQ36,
              (x) => Number(x.lotNumber) === nextLotNumber,
            )?.firstAdministrationDt ?? null;

          const dateToCompare = hasValue(ndmmDiscontinuationLot)
            ? ndmmDiscontinuationLot
            : hasValue(q331ALastAdminDtLot)
              ? q331ALastAdminDtLot
              : hasValue(q31StartDateLot)
                ? q31StartDateLot
                : hasValue(q27StartDateLot)
                  ? q27StartDateLot
                  : hasValue(q331AStartAdminDtNextLot)
                    ? q331AStartAdminDtNextLot
                    : null;
          const dateToCompareLastLot = hasValue(q331ALastAdminDtLot)
            ? q331ALastAdminDtLot
            : hasValue(q31StartDateLot)
              ? q31StartDateLot
              : null;
          const dateToCompareMidlot = hasValue(q331ALastAdminDtLot)
            ? q331ALastAdminDtLot
            : hasValue(q31StartDateLot)
              ? q31StartDateLot
              : hasValue(q331AStartAdminDtNextLot)
                ? q331AStartAdminDtNextLot
                : null;

          if (isLastLot) {
            //if this is the last lotnumber of the list
            //Earliest of Q26, Q26.1 <= Latest Date of Dose Administration <= L Q33.1.A DD OR L+1 Q31 SD <= end of follow up
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompareLastLot,
              endOfFollowUpDate,
            );
          } else if (isNotFirstOrLast) {
            //if this is not the first or last lotnumber of the list
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompareMidlot,
              endOfFollowUpDate,
            );
          } else {
            //if this is not the last lotnumber of the list
            //Earliest of Q26, Q26.1 <= Latest Date of Dose Administration <= L end Q28 DD OR L end Q33.1.A DD OR L+1 Q31 SD OR L+1 Q27 SD OR L+1 Q33.1.A SD <= end of follow up
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              dateToCompare,
              latestQ36Dt,
              endOfFollowUpDate,
            );
          }
          if (!isValid) return isValid;
        }
      }
    }

    return isValid;
  };

  const ValidateIndexDAndLOTDateChain = (date, cohortType) => {
    const indexDate =
      cohortType === RRMMCohortTreatment.TECVAYLI
        ? techIndexDate
        : talIndexDate;

    const nextLotStartDate =
      cohortNextLotDatesList?.get(cohortType)?.get(TRPQuestionType.Q40) ?? "";

    const idx = IsValidDateValue(indexDate) ? indexDate : null;
    const q40Date = IsValidDateValue(date) ? date : null;
    const lot = IsValidDateValue(nextLotStartDate) ? nextLotStartDate : null;
    const eof = IsValidDateValue(endOfFollowUpDate) ? endOfFollowUpDate : null;

    // index date ≤ [D]
    if (idx && q40Date && !IsLessOrEqual(idx, q40Date)) {
      return false;
    }

    // [D] ≤ LOT (if exists)
    if (q40Date && lot && !IsLessOrEqual(q40Date, lot)) {
      return false;
    }

    // [D] ≤ EOF
    if (q40Date && eof && !IsLessOrEqual(q40Date, eof)) {
      return false;
    }

    return true;
  };

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });

  const showTalDate = (validate) => {
    let varTalIndexDate = "";
    if (talIndexDate === null || "") {
      varTalIndexDate =
        validate == "validate" ? null : "[Bispecifics/CAR-T index date]";
    } else {
      varTalIndexDate = talIndexDate;
    }

    return varTalIndexDate;
  };

  const showTalDate91 = (validate) => {
    if (!talIndexDate) {
      return validate == "validate"
        ? null
        : "[Bispecifics/CAR-T index date – 91 days]";
    }

    const date = new Date(talIndexDate);

    // Subtract 91 days
    date.setDate(date.getDate() - 91);

    // Format to MM/DD/YYYY
    const formattedDate = `${String(date.getMonth() + 1).padStart(2, "0")}/${String(
      date.getDate(),
    ).padStart(2, "0")}/${date.getFullYear()}`;

    return formattedDate;
  };

  const showTechDate = (validate) => {
    let varTechIndexDate = "";
    if (techIndexDate === null || "") {
      varTechIndexDate =
        validate == "validate" ? null : "[Bispecifics/CAR-T index date]";
    } else {
      varTechIndexDate = techIndexDate;
    }

    return varTechIndexDate;
  };

  const showTechDate91 = (validate) => {
    if (!techIndexDate) {
      return validate == "validate"
        ? null
        : "[Bispecifics/CAR-T index date – 91 days]";
    }

    const date = new Date(techIndexDate);

    // Subtract 91 days
    date.setDate(date.getDate() - 91);

    // Format to MM/DD/YYYY
    const formattedDate = `${String(date.getMonth() + 1).padStart(2, "0")}/${String(
      date.getDate(),
    ).padStart(2, "0")}/${date.getFullYear()}`;

    return formattedDate;
  };

  const getTecTalQ402BUpperLimitDate = (type, cohortType) => {
    const indexDate =
      cohortType === RRMMCohortTreatment.TECVAYLI
        ? techIndexDate
        : RRMMCohortTreatment.TALVEY
          ? talIndexDate
          : null;
    if (!indexDate) {
      return type === "validate"
        ? null
        : "[the earliest of: (Bispecifics/CAR-T initiation date + 7 days) or (start of next LOT) or (end of follow-up)]";
    }

    const upperLimitDates = [];

    const nextLotStartDate =
      cohortNextLotDatesList?.get(cohortType)?.get(TRPQuestionType.Q40) ?? "";

    // Index Date + 7 days
    const indexPlus7 = new Date(indexDate);
    indexPlus7.setDate(indexPlus7.getDate() + 7);
    upperLimitDates.push(indexPlus7);

    if (type !== "validate") {
      // Start of next LOT
      if (nextLotStartDate) {
        upperLimitDates.push(new Date(nextLotStartDate));
      }

      // End of follow-up
      if (endOfFollowUpDate) {
        upperLimitDates.push(new Date(endOfFollowUpDate));
      }
    }
    // Get earliest date
    const earliestDate = new Date(
      Math.min(...upperLimitDates.map((d) => d.getTime())),
    );

    // Format MM/DD/YYYY
    return `${String(earliestDate.getMonth() + 1).padStart(2, "0")}/${String(
      earliestDate.getDate(),
    ).padStart(2, "0")}/${earliestDate.getFullYear()}`;
  };

  const showTechQ40Date = (validate) => {
    let varTechIndexDate = "";
    if (isStringEmpty(Q37TechDetails[0].Q40init_dt)) {
      varTechIndexDate =
        validate == "validate" ? null : "[Initiation date of IVIG]";
    } else {
      varTechIndexDate = Q37TechDetails[0].Q40init_dt;
    }

    return varTechIndexDate;
  };

  const showTechQ40Date91 = (validate) => {
    if (isStringEmpty(Q37TechDetails[0].Q40init_dt)) {
      return validate == "validate"
        ? null
        : "[Initiation date of IVIG – 91 days]";
    }

    const date = new Date(Q37TechDetails[0].Q40init_dt);

    // Subtract 91 days
    date.setDate(date.getDate() - 91);

    // Format to MM/DD/YYYY
    const formattedDate = `${String(date.getMonth() + 1).padStart(2, "0")}/${String(
      date.getDate(),
    ).padStart(2, "0")}/${date.getFullYear()}`;

    return formattedDate;
  };

  const showTalQ40Date = (validate) => {
    let varTechIndexDate = "";
    if (isStringEmpty(Q37TalDetails[0].Q40init_dt_Tal)) {
      varTechIndexDate =
        validate == "validate" ? null : "[Initiation date of IVIG]";
    } else {
      varTechIndexDate = Q37TalDetails[0].Q40init_dt_Tal;
    }

    return varTechIndexDate;
  };

  const showTalQ40Date91 = (validate) => {
    if (isStringEmpty(Q37TalDetails[0].Q40init_dt_Tal)) {
      return validate == "validate"
        ? null
        : "[Initiation date of IVIG – 91 days]";
    }

    const date = new Date(Q37TalDetails[0].Q40init_dt_Tal);

    // Subtract 91 days
    date.setDate(date.getDate() - 91);

    // Format to MM/DD/YYYY
    const formattedDate = `${String(date.getMonth() + 1).padStart(2, "0")}/${String(
      date.getDate(),
    ).padStart(2, "0")}/${date.getFullYear()}`;

    return formattedDate;
  };

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>
      <section className="main-survey-section">
        <div>
          <SideBarMenu activePageId={SideMenuItems.TTCharacteristics} />
          <div id="main" className="col-pad-left">
            <>
              <button
                className={isSideMenuActive ? "openbtn" : "openbtn active"}
                // onclick="toggleNav()"
                onClick={() => toggleNav()}
              >
                <i
                  id="arrowNavigation"
                  className="fa fa-arrow-left"
                  aria-hidden="true"
                ></i>
              </button>
            </>

            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>TECLISTAMAB AND TALQUETAMAB CHARACTERISTICS </h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}

              <div className="survey-question-section">
                <div className="survey-question-content">
                  <div className="question-answer">
                    {(isTalveySelected || isTechvayliSelected) && (
                      <>
                        <div>
                          <div className="question question-weight">
                            <span>Q36.</span>
                            <span className="quest-text-pad">
                              Provide dosing information for each administration
                              of
                              <>
                                {" "}
                                {isTechvayliSelected && isTalveySelected ? (
                                  <>
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      TECVAYLI® (teclistamab-cqyv)
                                    </span>{" "}
                                    from the initiation of treatment on
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {techIndexDate} until{" "}
                                      {tecvayliDateRRMM}{" "}
                                    </span>
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      and TALVEY
                                      <sup className="supscript">TM</sup>{" "}
                                      (talquetamab-tgvs)
                                    </span>{" "}
                                    from the initiation of treatment on
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {talIndexDate} until {talveyDateRRMM}
                                    </span>
                                    .{" "}
                                    <b>
                                      Please add additional rows to enter the
                                      date of each dose administration.
                                    </b>
                                    <br />
                                    <br />
                                  </>
                                ) : isTechvayliSelected ? (
                                  <>
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      TECVAYLI® (teclistamab-cqyv)
                                    </span>{" "}
                                    from the initiation of treatment on
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {showTechDate()} until {tecvayliDateRRMM}
                                    </span>
                                    .{" "}
                                    <b>
                                      Please add additional rows to enter the
                                      date of each dose administration.
                                    </b>
                                    <br />
                                    <br />
                                  </>
                                ) : isTalveySelected ? (
                                  <>
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      TALVEY
                                      <sup className="supscript">TM</sup>{" "}
                                      (talquetamab-tgvs)
                                    </span>{" "}
                                    from the initiation of treatment on
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {showTalDate()} until {talveyDateRRMM}
                                    </span>
                                    .{" "}
                                    <b>
                                      Please add additional rows to enter the
                                      date of each dose administration.
                                    </b>
                                    <br />
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}{" "}
                              </>
                              If the dosing phase is not documented, please
                              infer the dosing phase using the relevant dosing
                              label information provided.
                            </span>
                          </div>
                          <ErrorField
                            show={tecNumberofAdministratorMatching}
                            message={TTCharacteristics_MSGS.RRMMNotMatchingTech}
                            style={{ paddingLeft: "0px" }}
                          />

                          <ErrorField
                            show={talNumberofAdministratorMatching}
                            message={TTCharacteristics_MSGS.RRMMNotMatchingTal}
                            style={{ paddingLeft: "0px" }}
                          />

                          {isTechvayliSelected && (
                            <>
                              <div className="dependent-section">
                                <ErrorField
                                  show={indexDateRRMM_techHard}
                                  message={
                                    TTCharacteristics_MSGS.indexDateRRMMNotMatchingTech
                                  }
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={dateRRMMTec_dupDateHard}
                                  message={TTCharacteristics_MSGS.DuplicateDateNotAllowed.replace(
                                    "{value}",
                                    "TECVAYLI® (teclistamab-cqyv)",
                                  )}
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={setupTec_WarningHard}
                                  message={
                                    TTCharacteristics_MSGS.DuplicateStepUpNotAllowed
                                  }
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={nosetupTec_WarningHard}
                                  message={
                                    TTCharacteristics_MSGS.NoStepUpWarning
                                  }
                                  style={{ paddingLeft: "0px" }}
                                />
                                <ErrorField
                                  show={dt_tec_2L_3L_date_conditions}
                                  message={
                                    TTCharacteristics_MSGS.Q362L3LErrorMessage
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                  }}
                                />
                                <ErrorField
                                  show={!isTecLastAdminDateValid}
                                  message={
                                    TTCharacteristics_MSGS.DoseMustMatchLastAdministrationDateTec
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                    paddingBottom: "2px",
                                  }}
                                />

                                {techvayliDetails &&
                                  techvayliDetails.length > 0 &&
                                  techvayliDetails.map((data, idx) => (
                                    <div className="loop-section-ul" key={idx}>
                                      <div className="loop-head">
                                        <span
                                          className="question-weight"
                                          style={{ float: "inline-start" }}
                                        >
                                          {GetOrdinal(idx + 1)} TECVAYLI®
                                          (teclistamab-cqyv)
                                        </span>
                                        {idx != 0 && (
                                          <div
                                            className="delete-btn-div"
                                            style={{ float: "inline-end" }}
                                          >
                                            <img
                                              width="16px"
                                              src="../Assets/images/Icon-material-delete.png"
                                              alt=""
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                DeleteTechvayliRow(idx)
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>

                                      {/* TECVAYLI® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            className="date-picker-ttchar"
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Date of dose administration
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "20%",
                                                  }}
                                                >
                                                  {" "}
                                                  <span
                                                    data-tooltip-id="encounterTip"
                                                    className="modal-popup"
                                                    onClick={() =>
                                                      setShowHideHyperlinkModalQ36Tecvayli(
                                                        true,
                                                      )
                                                    }
                                                  >
                                                    Dosing phase
                                                  </span>
                                                  {showHideHyperlinkModalQ36Tecvayli && (
                                                    <InfoPopUp
                                                      description={
                                                        hyperlinkTextQ36Tecvayli
                                                      }
                                                      OkClick={() =>
                                                        setShowHideHyperlinkModalQ36Tecvayli(
                                                          false,
                                                        )
                                                      }
                                                    />
                                                  )}{" "}
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Site of care
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    minWidth: "280px",
                                                  }}
                                                >
                                                  Dose strength
                                                </th>

                                                {/* {data.Q36TechConditionMet && (
                                                <>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of inpatient admission
                                                    for this administration
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of inpatient discharge
                                                    for this administration
                                                  </th>
                                                </>
                                              )} */}
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    TECVAYLI® (teclistamab-cqyv)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "dose_administration_tech" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.dose_administration_tech ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                          marginLeft: "-5px",
                                                        }}
                                                      >
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "dose_administration_tech_dt-" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          // optionId={1}
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.dose_administration_tech_dt
                                                          }
                                                        />
                                                      </span>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dose_administration_tech" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.dose_administration_tech ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Date of dose
                                                          administration unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_techHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.administrationEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_techHard_dt
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.administrationEmptyDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    {/* <ErrorField
                                                      show={
                                                        data.dt_tech_greater_prevCheck
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q36DateGreaterThanPrevious
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    /> */}
                                                    <ErrorField
                                                      show={
                                                        data.dt_tech_date_out_of_bound
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q36DateOutOfBound
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Invalid_dose_administration_tech_dt
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_tech_dt_before_eof
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.DateBeforeEOF
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_tech" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dosing_phase_tech ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Step-up dose 1{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_tech" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.dosing_phase_tech ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Step-up dose 2
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_tech" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            data.dosing_phase_tech ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          1<sup>st</sup>{" "}
                                                          treatment dose
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_tech" +
                                                            idx
                                                          }
                                                          value={4}
                                                          checked={
                                                            data.dosing_phase_tech ===
                                                            4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Subsequent treatment
                                                          doses
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.dosing_phase_techHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.dosingphaseEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.dosing_phase_techHard_othEmpty
                                                      }
                                                      message={
                                                        "Please enter the text"
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "siteofcare_tech" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.siteofcare_tech ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Inpatient{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "siteofcare_tech" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.siteofcare_tech ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Outpatient
                                                        </span>
                                                      </label>
                                                    </div>

                                                    {/* <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "siteofcare_tech" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.siteofcare_tech ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />

                                                      <span
                                                        // className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Both inpatient and
                                                        outpatient
                                                      </span>
                                                    </label>
                                                  </div> */}
                                                    <ErrorField
                                                      show={
                                                        data.siteofcare_techHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.siteofcareEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tech_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.tech_dose_strength_rbl ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "tech_dose_strength_mg" +
                                                              idx
                                                            }
                                                            value={
                                                              data.tech_dose_strength_mg
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        mg
                                                      </label>
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tech_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.tech_dose_strength_rbl ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "tech_dose_strength_mg_kg" +
                                                              idx
                                                            }
                                                            value={
                                                              data.tech_dose_strength_mg_kg
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        mg/kg
                                                      </label>
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tech_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            data.tech_dose_strength_rbl ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "tech_dose_strength_mgm" +
                                                              idx
                                                            }
                                                            value={
                                                              data.tech_dose_strength_mgm
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        &nbsp; mg/m
                                                        <sup>2</sup>
                                                      </label>
                                                      {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                                    </div>
                                                    <div className="">
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "tech_dose_strength_rbl" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.tech_dose_strength_rbl ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    {/*                                                  
                                                    <ErrorField
                                                      show={
                                                        data.siteofcare_techHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.siteofcareEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    /> */}
                                                    <ErrorField
                                                      show={
                                                        data.tech_dose_strength_mg_kgHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.DecimalRange
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.tech_dose_strength_mg_kgRange
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.DecimalRange
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                {techvayliDetails &&
                                  techvayliDetails.length > 0 &&
                                  techvayliDetails.length < 550 && (
                                    <div className="sub-question-bot-sapce-ul mt-2">
                                      <div
                                        className="answer-list-text"
                                        onClick={AddTechvayliRow}
                                      >
                                        <a>
                                          <img
                                            width="18px"
                                            src="../Assets/images/plus.png"
                                            alt=""
                                          />
                                        </a>
                                        <a className="radio-text-padding">
                                          Click here to add another dose
                                          administration of Tecvayli
                                        </a>
                                      </div>
                                    </div>
                                  )}
                              </div>
                              {/* 36.1 Tecvayli start */}
                              <div>
                                <div className="dependent-section sub-question marginleft15">
                                  <ErrorField
                                    show={atleastonesetupTec_WarningHard}
                                    message={
                                      TTCharacteristics_MSGS.AtleastOneStepUpWarning
                                    }
                                    style={{ paddingLeft: "0px" }}
                                  />

                                  <div
                                    className="question question-weight"
                                    style={{ marginBottom: "10px" }}
                                  >
                                    <span>Q36.1.</span>
                                    <span className="quest-text-pad">
                                      Please list all hospitalizations that
                                      occurred during the step-up dosing phase.
                                      Please specify the date of admission, date
                                      of discharge, and reason for
                                      hospitalization.{" "}
                                    </span>
                                  </div>
                                  {tecHospDetails &&
                                    tecHospDetails.length > 0 &&
                                    tecHospDetails.map((data, idx) => (
                                      <div
                                        className="loop-section-ul"
                                        key={idx}
                                      >
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} TECVAYLI®
                                            (teclistamab-cqyv) Hospitalization
                                          </span>

                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  DeleteTecHospRow(idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        {/* TECVAYLI® */}
                                        <div className="question-bot-sapce">
                                          <div className="sub-question grid-overflow">
                                            <table
                                              style={{
                                                border: "1px solid black",
                                                borderCollapse: "collapse",
                                                width: "100%",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width: "25%"
                                                    }}
                                                  >
                                                    Treatment
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width: "20%"
                                                    }}
                                                  >
                                                    Date of admission
                                                  </th>
                                                  {data.dt_admission != null &&
                                                    data.dt_admission !== 2 && (
                                                      <>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            // width: "20%"
                                                          }}
                                                        >
                                                          Date of discharge
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            // width: "35%"
                                                          }}
                                                        >
                                                          Reason of
                                                          hospitalization
                                                        </th>
                                                      </>
                                                    )}
                                                </tr>
                                              </thead>

                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span className="quest-text-pad">
                                                      {GetOrdinal(idx + 1)}{" "}
                                                      TECVAYLI®
                                                      (teclistamab-cqyv)
                                                    </span>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dt_admission_tec" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dt_admission ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          {/* <DateControl
                                                            ctrlId={
                                                              "dt_admission_dt_tec-" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            date={
                                                              data.dt_admission_dt
                                                            }
                                                          /> */}
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "dt_admission_dt_tec-" +
                                                              idx
                                                            }
                                                            // selectedDate={selectedDate}
                                                            //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            // optionId={1}
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                            date={
                                                              data.dt_admission_dt
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "dt_admission_tec" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.dt_admission ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Date of admission
                                                            unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "dt_admission_tec" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.dt_admission ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Patient had no
                                                            hospitalizations
                                                            during the step-up
                                                            dosing phase
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_Hard
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.admissionEmpty_tal
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_Hard_dt
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.admissionEmptyDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Invalid_admission_Hard_dt
                                                        }
                                                        message={
                                                          CommonError_Msgs.InvalidDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_before_eof
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.DateBeforeEOF
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      {/* <ErrorField
                                show={
                                    data.dt_admission_Hard_dt_check
                                }
                                message={
                                    TTCharacteristics_MSGS.admissionDateCheck
                                }
                                style={{
                                    paddingLeft: "0px",
                                }}
                                /> */}
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_out_of_bound
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.Q36DateOutOfBound
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  {data.dt_admission != null &&
                                                    data.dt_admission !== 2 && (
                                                      <>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={idx}
                                                                name={
                                                                  "dt_discharge_tec" +
                                                                  idx
                                                                }
                                                                value={1}
                                                                checked={
                                                                  data.dt_discharge ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                {/* <DateControl
                                                                  ctrlId={
                                                                    "dt_discharge_dt_tec-" +
                                                                    idx
                                                                  }
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  date={
                                                                    data.dt_discharge_dt
                                                                  }
                                                                /> */}

                                                                <DatePickerComponent
                                                                  ctrlId={
                                                                    "dt_discharge_dt_tec-" +
                                                                    idx
                                                                  }
                                                                  // selectedDate={selectedDate}
                                                                  //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  // optionId={1}
                                                                  minDate={dayjs(
                                                                    "01-01-1920",
                                                                  )}
                                                                  maxDate={dayjs()}
                                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                                  date={
                                                                    data.dt_discharge_dt
                                                                  }
                                                                />
                                                              </span>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "dt_discharge_tec" +
                                                                    idx
                                                                  }
                                                                  value={99}
                                                                  checked={
                                                                    data.dt_discharge ===
                                                                    99
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />

                                                                <span
                                                                  className="radio-text-padding"
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  Date of
                                                                  discharge
                                                                  unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "dt_discharge_tec" +
                                                                    idx
                                                                  }
                                                                  value={2}
                                                                  checked={
                                                                    data.dt_discharge ===
                                                                    2
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />

                                                                <span
                                                                  className="radio-text-padding"
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  Patient is
                                                                  still
                                                                  hospitalized
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.dischargeEmpty_tal
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard_dt
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.dischargeEmptyDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard_dt_check
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.dischargeDateCheck
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_out_of_bound
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q36DateOutOfBound
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dateRangeThirty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.DateRangeThirty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dischargeMoreThanAdministrationWarning
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.DischargeMoreThanAdministrationWarning
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.Invalid_dt_discharge_Hard
                                                              }
                                                              message={
                                                                CommonError_Msgs.InvalidDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_before_eof
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.DateBeforeEOF
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason1_tec" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason1
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Administration
                                                                  of teclistamab
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason2_tec" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason2
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Monitoring of
                                                                  adverse event
                                                                  (AE) as part
                                                                  of the
                                                                  treatment
                                                                  plan{" "}
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason3_tec" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason3
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  cytokine
                                                                  release
                                                                  syndrome (CRS)
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason4_tec" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason4
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  immune
                                                                  effector
                                                                  cell-associated
                                                                  neurotoxicity
                                                                  syndrome
                                                                  (ICANS)
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason5_tec" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason5
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  other AE
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason6_tec" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason6
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "4px",
                                                                    paddingRight:
                                                                      "15px",
                                                                    marginBottom:
                                                                      "0px",
                                                                    padding:
                                                                      "0",
                                                                  }}
                                                                >
                                                                  Other non-AE
                                                                  related
                                                                  reasons,
                                                                  please
                                                                  specify:
                                                                  <div
                                                                    style={{
                                                                      paddingLeft:
                                                                        "15px",
                                                                      marginBottom:
                                                                        "0px",
                                                                      padding:
                                                                        "0",
                                                                    }}
                                                                  >
                                                                    <textarea
                                                                      name={
                                                                        "hosp_reason_oth_txt_tec" +
                                                                        idx
                                                                      }
                                                                      className="input-dash"
                                                                      type="text"
                                                                      value={
                                                                        data.hosp_reason_oth_txt
                                                                      }
                                                                      onChange={
                                                                        HandleRepeaterFieldChange
                                                                      }
                                                                      maxLength={
                                                                        300
                                                                      }
                                                                      id={idx}
                                                                    />
                                                                  </div>
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="radio"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReasonUnk_tec" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReasonUnk
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Unknown
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <ErrorField
                                                              show={
                                                                data.hospReasonEmptyHard
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q40ReasonEmptyHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.hospReasonTxtEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q36Point1ReasonTxtEmpty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                      </>
                                                    )}
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ))}

                                  {tecHospDetails &&
                                    tecHospDetails.length > 0 &&
                                    tecHospDetails.length < 550 &&
                                    tecHospDetails[tecHospDetails.length - 1]
                                      .dt_admission != null &&
                                    tecHospDetails[tecHospDetails.length - 1]
                                      .dt_admission !== 2 && (
                                      <div className="sub-question-bot-sapce-ul mt-2">
                                        <div
                                          className="answer-list-text"
                                          onClick={AddTecHospRow}
                                        >
                                          <a>
                                            <img
                                              width="18px"
                                              src="../Assets/images/plus.png"
                                              alt=""
                                            />
                                          </a>
                                          <a className="radio-text-padding">
                                            Click here to add another
                                            hospitalization of Tecvayli
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                              {/* 36.1 Tecvayli end */}
                            </>
                          )}
                          {/* Table 2 Talvey */}

                          {isTalveySelected && (
                            <>
                              <div className="dependent-section">
                                <ErrorField
                                  show={indexDateRRMM_talHard}
                                  message={
                                    TTCharacteristics_MSGS.indexDateRRMMNotMatchingTal
                                  }
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={dateRRMMTal_dupDateHard}
                                  message={(() => {
                                    const msg =
                                      TTCharacteristics_MSGS.DuplicateDateNotAllowed;
                                    const [before, after] =
                                      msg.split("{value}");
                                    return (
                                      <>
                                        {before}
                                        TALVEY
                                        <sup className="supscript">TM</sup>{" "}
                                        (talquetamab-tgvs)
                                        {after}
                                      </>
                                    );
                                  })()}
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={setupTal_WarningHard}
                                  message={
                                    TTCharacteristics_MSGS.DuplicateStepUpNotAllowed
                                  }
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={nosetupTal_WarningHard}
                                  message={
                                    TTCharacteristics_MSGS.NoStepUpWarning
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                    paddingTop: "10px",
                                  }}
                                />

                                <ErrorField
                                  show={dt_tal_2L_3L_date_conditions}
                                  message={
                                    TTCharacteristics_MSGS.Q362L3LErrorMessage
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                  }}
                                />
                                <ErrorField
                                  show={!isTalLastAdminDateValid}
                                  message={
                                    TTCharacteristics_MSGS.DoseMustMatchLastAdministrationDateTal
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                    paddingBottom: "2px",
                                  }}
                                />

                                {talveyDetails &&
                                  talveyDetails.length > 0 &&
                                  talveyDetails.map((data, idx) => (
                                    <div className="loop-section-ul" key={idx}>
                                      <div className="loop-head">
                                        <span
                                          className="question-weight"
                                          style={{ float: "inline-start" }}
                                        >
                                          {GetOrdinal(idx + 1)} TALVEY{" "}
                                          <sup className="supscript">TM</sup>{" "}
                                          (talquetamab-tgvs){" "}
                                          <sup className="supscript">TM</sup>
                                        </span>

                                        {idx != 0 && (
                                          <div
                                            className="delete-btn-div"
                                            style={{ float: "inline-end" }}
                                          >
                                            <img
                                              width="16px"
                                              src="../Assets/images/Icon-material-delete.png"
                                              alt=""
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                DeleteTalveyRow(idx)
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>

                                      {/* TECVAYLI® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Date of dose administration
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "20%",
                                                  }}
                                                >
                                                  {" "}
                                                  <span
                                                    data-tooltip-id="encounterTip"
                                                    className="modal-popup"
                                                    onClick={() =>
                                                      setShowHideHyperlinkModalQ36Talvey(
                                                        true,
                                                      )
                                                    }
                                                  >
                                                    Dosing phase
                                                  </span>
                                                  {showHideHyperlinkModalQ36Talvey && (
                                                    <InfoPopUp
                                                      description={
                                                        hyperlinkTextQ36Talvey
                                                      }
                                                      OkClick={() =>
                                                        setShowHideHyperlinkModalQ36Talvey(
                                                          false,
                                                        )
                                                      }
                                                    />
                                                  )}{" "}
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Site of care
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    minWidth: "280px",
                                                  }}
                                                >
                                                  Dose strength
                                                </th>
                                                {/* {data.Q36TalConditionMet && (
                                                <>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of inpatient admission
                                                    for this administration
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Date of inpatient discharge
                                                    for this administration
                                                  </th>
                                                </>
                                              )} */}
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    TALVEY
                                                    <sup className="supscript">
                                                      TM
                                                    </sup>{" "}
                                                    (talquetamab-tgvs)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "dose_administration_tal" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.dose_administration_tal ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                          marginLeft: "-5px",
                                                        }}
                                                      >
                                                        {/* <DateControl
                                                          ctrlId={
                                                            "dose_administration_tal_dt-" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          date={
                                                            data.dose_administration_tal_dt
                                                          }
                                                        /> */}
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "dose_administration_tal_dt-" +
                                                            idx
                                                          }
                                                          // selectedDate={selectedDate}
                                                          //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          // optionId={1}
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.dose_administration_tal_dt
                                                          }
                                                        />
                                                      </span>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dose_administration_tal" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.dose_administration_tal ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Date of dose
                                                          administration unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_talHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.administrationEmpty_tal
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_talHard_dt
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.administrationEmptyDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    {/* <ErrorField
                                                      show={
                                                        data.dt_tal_greater_prevCheck
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q36DateGreaterThanPrevious
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    /> */}
                                                    <ErrorField
                                                      show={
                                                        data.dt_tal_date_out_of_bound
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q36DateOutOfBound
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Invalid_dose_administration_tal_dt
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_tal" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dosing_phase_tal ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Step-up dose 1{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_tal" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.dosing_phase_tal ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Step-up dose 2
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_tal" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            data.dosing_phase_tal ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Step-up dose 3{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_tal" +
                                                            idx
                                                          }
                                                          value={4}
                                                          checked={
                                                            data.dosing_phase_tal ===
                                                            4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          1<sup>st</sup>{" "}
                                                          treatment dose
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_tal" +
                                                            idx
                                                          }
                                                          value={5}
                                                          checked={
                                                            data.dosing_phase_tal ===
                                                            5
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Subsequent treatment
                                                          doses
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.dosing_phase_talHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.dosingphaseEmpty_tal
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.dosing_phase_talHard_othEmpty
                                                      }
                                                      message={
                                                        "Please enter the text"
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "siteofcare_tal" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.siteofcare_tal ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Inpatient{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "siteofcare_tal" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.siteofcare_tal ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Outpatient
                                                        </span>
                                                      </label>
                                                    </div>

                                                    {/* <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "siteofcare_tal" + idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.siteofcare_tal === 3
                                                          
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        // className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Both inpatient and
                                                        outpatient
                                                      </span>
                                                    </label>
                                                  </div> */}
                                                    <ErrorField
                                                      show={
                                                        data.siteofcare_talHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.siteofcareEmpty_tal
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tal_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.tal_dose_strength_rbl ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "tal_dose_strength_mg" +
                                                              idx
                                                            }
                                                            value={
                                                              data.tal_dose_strength_mg
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        mg
                                                      </label>
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tal_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.tal_dose_strength_rbl ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "tal_dose_strength_mg_kg" +
                                                              idx
                                                            }
                                                            value={
                                                              data.tal_dose_strength_mg_kg
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        mg/kg
                                                      </label>
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tal_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            data.tal_dose_strength_rbl ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "tal_dose_strength_mgm" +
                                                              idx
                                                            }
                                                            value={
                                                              data.tal_dose_strength_mgm
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        &nbsp; mg/m
                                                        <sup>2</sup>
                                                      </label>
                                                      {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                                    </div>
                                                    <br />
                                                    <div className="">
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "tal_dose_strength_rbl" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.tal_dose_strength_rbl ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />

                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    {/*                                                  
                                                    <ErrorField
                                                      show={
                                                        data.siteofcare_techHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.siteofcareEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    /> */}

                                                    <ErrorField
                                                      show={
                                                        data.tal_dose_strength_mg_kgHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.DecimalRange
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.tal_dose_strength_mg_kgRange
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.DecimalRange
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                {/* {data.Q36TalConditionMet && (
                                                <>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dt_admission_tal" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dt_admission_tal ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          <DateControl
                                                            ctrlId={
                                                              "dt_admission_tal_dt-" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            date={
                                                              data.dt_admission_tal_dt
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dt_admission_tal" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.dt_admission_tal ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <label className="option-fbox">
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Date of admission
                                                            unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_talHard
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.admissionEmpty_tal
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_talHard_dt
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.admissionEmptyDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_talHard_dt_check
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.admissionDateCheck
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dt_discharge_tal" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dt_discharge_tal ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          <DateControl
                                                            ctrlId={
                                                              "dt_discharge_tal_dt-" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            date={
                                                              data.dt_discharge_tal_dt
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dt_discharge_tal" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.dt_discharge_tal ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <label className="option-fbox">
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Date of discharge
                                                            unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dt_discharge_tal" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            data.dt_discharge_tal ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <label>
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Patient is still
                                                            hospitalized
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.dt_discharge_talHard
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.dischargeEmpty_tal
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.dt_discharge_talHard_dt
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.dischargeEmptyDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.dt_discharge_talHard_dt_check
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.dischargeDateCheck
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              )} */}
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                {talveyDetails &&
                                  talveyDetails.length > 0 &&
                                  talveyDetails.length < 550 && (
                                    <div className="sub-question-bot-sapce-ul mt-2">
                                      <div
                                        className="answer-list-text"
                                        onClick={AddTalveyRow}
                                      >
                                        <a>
                                          <img
                                            width="18px"
                                            src="../Assets/images/plus.png"
                                            alt=""
                                          />
                                        </a>
                                        <a className="radio-text-padding">
                                          Click here to add another dose
                                          administration of Talvey
                                        </a>
                                      </div>
                                    </div>
                                  )}
                              </div>
                              {/* 36.1 Talvey start */}
                              <div>
                                <div className="dependent-section sub-question marginleft15">
                                  <ErrorField
                                    show={atleastonesetupTal_WarningHard}
                                    message={
                                      TTCharacteristics_MSGS.AtleastOneStepUpWarning
                                    }
                                    style={{ paddingLeft: "0px" }}
                                  />

                                  <div
                                    className="question question-weight"
                                    style={{ marginBottom: "10px" }}
                                  >
                                    <span>Q36.1.</span>
                                    <span className="quest-text-pad">
                                      Please list all hospitalizations that
                                      occurred during the step-up dosing phase.
                                      Please specify the date of admission, date
                                      of discharge, and reason for
                                      hospitalization.{" "}
                                    </span>
                                  </div>
                                  {talHospDetails &&
                                    talHospDetails.length > 0 &&
                                    talHospDetails.map((data, idx) => (
                                      <div
                                        className="loop-section-ul"
                                        key={idx}
                                      >
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} TALVEY{" "}
                                            <sup className="supscript">TM</sup>{" "}
                                            (talquetamab-tgvs) Hospitalization
                                          </span>

                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  DeleteTalHospRow(idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        {/* TECVAYLI® */}
                                        <div className="question-bot-sapce">
                                          <div className="sub-question grid-overflow">
                                            <table
                                              style={{
                                                border: "1px solid black",
                                                borderCollapse: "collapse",
                                                width: "100%",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width: "25%"
                                                    }}
                                                  >
                                                    Treatment
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width: "20%"
                                                    }}
                                                  >
                                                    Date of admission
                                                  </th>
                                                  {data.dt_admission != null &&
                                                    data.dt_admission !== 2 && (
                                                      <>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            // width: "20%"
                                                          }}
                                                        >
                                                          Date of discharge
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            // width: "35%"
                                                          }}
                                                        >
                                                          Reason of
                                                          hospitalization
                                                        </th>
                                                      </>
                                                    )}
                                                </tr>
                                              </thead>

                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span className="quest-text-pad">
                                                      TALVEY<sup>TM</sup>{" "}
                                                      (talquetamab-tgvs)
                                                    </span>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dt_admission_tal" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dt_admission ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          {/* <DateControl
                                                            ctrlId={
                                                              "dt_admission_dt_tal-" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            date={
                                                              data.dt_admission_dt
                                                            }
                                                          /> */}

                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "dt_admission_dt_tal-" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            // optionId={1}
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                            date={
                                                              data.dt_admission_dt
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "dt_admission_tal" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.dt_admission ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Date of admission
                                                            unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "dt_admission_tal" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.dt_admission ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Patient had no
                                                            hospitalizations
                                                            during the step-up
                                                            dosing phase
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_Hard
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.admissionEmpty_tal
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_Hard_dt
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.admissionEmptyDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      {/* <ErrorField
                                show={
                                    data.dt_admission_Hard_dt_check
                                }
                                message={
                                    TTCharacteristics_MSGS.admissionDateCheck
                                }
                                style={{
                                    paddingLeft: "0px",
                                }}
                                /> */}
                                                      <ErrorField
                                                        show={
                                                          data.Invalid_admission_Hard_dt
                                                        }
                                                        message={
                                                          CommonError_Msgs.InvalidDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_before_eof
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.DateBeforeEOF
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_out_of_bound
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.Q36DateOutOfBound
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  {data.dt_admission != null &&
                                                    data.dt_admission !== 2 && (
                                                      <>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={idx}
                                                                name={
                                                                  "dt_discharge_tal" +
                                                                  idx
                                                                }
                                                                value={1}
                                                                checked={
                                                                  data.dt_discharge ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                {/* <DateControl
                                                                  ctrlId={
                                                                    "dt_discharge_dt_tal-" +
                                                                    idx
                                                                  }
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  date={
                                                                    data.dt_discharge_dt
                                                                  }
                                                                /> */}

                                                                <DatePickerComponent
                                                                  ctrlId={
                                                                    "dt_discharge_dt_tal-" +
                                                                    idx
                                                                  }
                                                                  // selectedDate={selectedDate}
                                                                  //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  // optionId={1}
                                                                  minDate={dayjs(
                                                                    "01-01-1920",
                                                                  )}
                                                                  maxDate={dayjs()}
                                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                                  date={
                                                                    data.dt_discharge_dt
                                                                  }
                                                                />
                                                              </span>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "dt_discharge_tal" +
                                                                    idx
                                                                  }
                                                                  value={99}
                                                                  checked={
                                                                    data.dt_discharge ===
                                                                    99
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />

                                                                <span
                                                                  className="radio-text-padding"
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  Date of
                                                                  discharge
                                                                  unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "dt_discharge_tal" +
                                                                    idx
                                                                  }
                                                                  value={2}
                                                                  checked={
                                                                    data.dt_discharge ===
                                                                    2
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />

                                                                <span
                                                                  className="radio-text-padding"
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  Patient is
                                                                  still
                                                                  hospitalized
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.dischargeEmpty_tal
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard_dt
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.dischargeEmptyDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard_dt_check
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.dischargeDateCheck
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_out_of_bound
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q36DateOutOfBound
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dateRangeThirty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.DateRangeThirty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dischargeMoreThanAdministrationWarning
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.DischargeMoreThanAdministrationWarning
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.Invalid_dt_discharge_Hard
                                                              }
                                                              message={
                                                                CommonError_Msgs.InvalidDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_before_eof
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.DateBeforeEOF
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason1_tal" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason1
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Administration
                                                                  of talquetamab
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason2_tal" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason2
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Monitoring of
                                                                  adverse event
                                                                  (AE) as part
                                                                  of the
                                                                  treatment
                                                                  plan{" "}
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason3_tal" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason3
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  cytokine
                                                                  release
                                                                  syndrome (CRS)
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason4_tal" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason4
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  immune
                                                                  effector
                                                                  cell-associated
                                                                  neurotoxicity
                                                                  syndrome
                                                                  (ICANS)
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason5_tal" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason5
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  other AE
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason6_tal" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason6
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "4px",
                                                                    paddingRight:
                                                                      "15px",
                                                                    marginBottom:
                                                                      "0px",
                                                                    padding:
                                                                      "0",
                                                                  }}
                                                                >
                                                                  Other non-AE
                                                                  related
                                                                  reasons,
                                                                  please
                                                                  specify:
                                                                  <div
                                                                    style={{
                                                                      paddingLeft:
                                                                        "15px",
                                                                      marginBottom:
                                                                        "0px",
                                                                      padding:
                                                                        "0",
                                                                    }}
                                                                  >
                                                                    <textarea
                                                                      name={
                                                                        "hosp_reason_oth_txt_tal" +
                                                                        idx
                                                                      }
                                                                      className="input-dash"
                                                                      type="text"
                                                                      value={
                                                                        data.hosp_reason_oth_txt
                                                                      }
                                                                      onChange={
                                                                        HandleRepeaterFieldChange
                                                                      }
                                                                      maxLength={
                                                                        300
                                                                      }
                                                                      id={idx}
                                                                    />
                                                                  </div>
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="radio"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReasonUnk_tal" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReasonUnk
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Unknown
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <ErrorField
                                                              show={
                                                                data.hospReasonEmptyHard
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q40ReasonEmptyHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.hospReasonTxtEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q36Point1ReasonTxtEmpty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                      </>
                                                    )}
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  {talHospDetails &&
                                    talHospDetails.length > 0 &&
                                    talHospDetails.length < 550 &&
                                    talHospDetails[talHospDetails.length - 1]
                                      .dt_admission != null &&
                                    talHospDetails[talHospDetails.length - 1]
                                      .dt_admission !== 2 && (
                                      <div className="sub-question-bot-sapce-ul mt-2">
                                        <div
                                          className="answer-list-text"
                                          onClick={AddTalHospRow}
                                        >
                                          <a>
                                            <img
                                              width="18px"
                                              src="../Assets/images/plus.png"
                                              alt=""
                                            />
                                          </a>
                                          <a className="radio-text-padding">
                                            Click here to add another
                                            hospitalization of Talvey
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                              {/* 36.1 Talvey end */}
                            </>
                          )}
                        </div>

                        {/* Q37 start --------------------------------------- */}
                        {!isNewEcrfA && (
                          <div>
                            <div className="question question-weight">
                              <span>Q37.</span>
                              <span className="quest-text-pad">
                                Please indicate if any medication(s) had dose
                                frequency reductions during treatment with{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {isTechvayliSelected && isTalveySelected ? (
                                    <>
                                      TECVAYLI® (teclistamab-cqyv) and TALVEY
                                      <sup className="supscript">TM</sup>{" "}
                                      (talquetamab-tgvs).
                                    </>
                                  ) : isTechvayliSelected ? (
                                    "TECVAYLI® (teclistamab-cqyv)."
                                  ) : isTalveySelected ? (
                                    <>
                                      TALVEY
                                      <sup className="supscript">TM</sup>{" "}
                                      (talquetamab-tgvs).
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </span>{" "}
                              </span>
                            </div>

                            <div className="question-bot-sapce">
                              <div className="sub-question grid-overflow">
                                <table
                                  style={{
                                    border: "1px solid black",
                                    borderCollapse: "collapse",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        Treatment
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          width: "25%",
                                        }}
                                      >
                                        Initial dosing frequency after the
                                        step-up dose is completed
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          width: "25%",
                                        }}
                                      >
                                        Was the dosing frequency reduced for
                                        this medication at any point during the
                                        {/*                                   
                                   line of
                                  therapy */}
                                        <span
                                          data-tooltip-id="encounterTip"
                                          className="modal-popup"
                                          onClick={() =>
                                            setShowLineOfTherapyModal(true)
                                          }
                                        >
                                          {" "}
                                          {""} line of therapy
                                        </span>
                                        {showLineOfTherapyModal && (
                                          <InfoPopUp
                                            description={
                                              hyperlinkTextLineOfTherapy
                                            }
                                            OkClick={() =>
                                              setShowLineOfTherapyModal(false)
                                            }
                                          />
                                        )}{" "}
                                        ?
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          width: "25%",
                                        }}
                                      >
                                        Initial dosing strength after the
                                        step-up dosing phase was completed
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {/* Tecvayli */}
                                    {isTechvayliSelected && (
                                      <tr>
                                        {Q37TechDetails.length > 0 &&
                                          Q37TechDetails.map((data, idx) => (
                                            <React.Fragment key={idx}>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  TECVAYLI® (teclistamab-cqyv)
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "q37_Tec_Dose_week_frquencyRd" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.q37_Tec_Dose_week_frquencyRd ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      The patient has not
                                                      completed the step-up
                                                      dosing phase
                                                    </span>
                                                  </label>
                                                </div>

                                                {techvayliDetails &&
                                                  techvayliDetails.length > 0 &&
                                                  techvayliDetails.some(
                                                    (item) =>
                                                      item.dosing_phase_tech ===
                                                      4,
                                                  ) && (
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "q37_Tec_Dose_week_frquencyRd" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.q37_Tec_Dose_week_frquencyRd ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                            display:
                                                              "inline-flex",
                                                            alignItems:
                                                              "center",
                                                            whiteSpace:
                                                              "nowrap",
                                                            gap: "4px",
                                                          }}
                                                        >
                                                          <span>
                                                            Once every &nbsp;
                                                          </span>
                                                          <span>
                                                            <input
                                                              className="input-dash-custom"
                                                              id={idx}
                                                              name={
                                                                "q37_Tec_Dose_week_frquency_txt" +
                                                                idx
                                                              }
                                                              value={
                                                                data.q37_Tec_Dose_week_frquency_txt
                                                              }
                                                              type="text"
                                                              onKeyDown={(
                                                                e,
                                                              ) => {
                                                                // Allow backspace, arrow keys, and delete
                                                                if (
                                                                  [
                                                                    "Backspace",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Delete",
                                                                    "Tab",
                                                                  ].includes(
                                                                    e.key,
                                                                  )
                                                                ) {
                                                                  return;
                                                                }

                                                                // Prevent non-numeric characters, except '.'
                                                                if (
                                                                  !/[0-9.]/.test(
                                                                    e.key,
                                                                  )
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                const value =
                                                                  e.target
                                                                    .value;
                                                                const selectionStart =
                                                                  e.target
                                                                    .selectionStart;
                                                                const newValue =
                                                                  value.slice(
                                                                    0,
                                                                    selectionStart,
                                                                  ) +
                                                                  e.key +
                                                                  value.slice(
                                                                    e.target
                                                                      .selectionEnd,
                                                                  );

                                                                // Prevent multiple '.'
                                                                if (
                                                                  e.key ===
                                                                    "." &&
                                                                  value.includes(
                                                                    ".",
                                                                  )
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                // Prevent '.' as the first character
                                                                if (
                                                                  e.key ===
                                                                    "." &&
                                                                  value === ""
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                // Allow only one digit after decimal point
                                                                if (
                                                                  newValue.includes(
                                                                    ".",
                                                                  ) &&
                                                                  newValue.split(
                                                                    ".",
                                                                  )[1].length >
                                                                    2
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }
                                                              }}
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                            />
                                                          </span>
                                                          week
                                                        </span>
                                                      </label>
                                                    </div>
                                                  )}
                                                {/* new Unknown */}
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "q37_Tec_Dose_week_frquencyRd" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.q37_Tec_Dose_week_frquencyRd ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleFieldChange
                                                      }
                                                    />

                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.q37_atleasetOneAdministrationTecWarningHard
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.AtleasetOneAdministrationWarning
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />

                                                <ErrorField
                                                  show={
                                                    data.q37_Tec_Dose_week_frquencyRd_Empty
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.q37TechvayliEmpty
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />

                                                <ErrorField
                                                  show={
                                                    data.q37_Tec_Dose_week_frquency_txt_Empty
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.specifyDosageFrequency
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.q37TecDoseWeekFrequencyRangeError
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.allowedRange
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </td>

                                              {data.q37_Tec_Dose_week_frquencyRd !==
                                              1 ? (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            // id="Q37Techvayli_select_1"

                                                            id={idx}
                                                            //name="Q37TechvayliRd"
                                                            name={
                                                              "Q37TechvayliRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.Q37TechvayliRd ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            // className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            Yes
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            // id="Q37Techvayli_select_0"
                                                            // name="Q37TechvayliRd"
                                                            id={idx}
                                                            name={
                                                              "Q37TechvayliRd" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.Q37TechvayliRd ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />

                                                          <span
                                                            // className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            No
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            // id="Q37Techvayli_select_0"
                                                            // name="Q37TechvayliRd"
                                                            id={idx}
                                                            name={
                                                              "Q37TechvayliRd" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.Q37TechvayliRd ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />

                                                          <span
                                                            // className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.q37TechvayliEmpty
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.q37TechvayliEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </td>
                                              ) : (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    //alignContent: "flex-start",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                    //textAlign: 'start'
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                      verticalAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not applicable</b>
                                                  </span>
                                                </td>
                                              )}

                                              {data.q37_Tec_Dose_week_frquencyRd !==
                                              1 ? (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  {isTechvayliSelected && (
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "q37_Tec_Dose_week_strengthRd" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            data.q37_Tec_Dose_week_strengthRd ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                            display: "flex",
                                                          }}
                                                        >
                                                          1.50 mg/kg
                                                        </span>
                                                      </label>
                                                    </div>
                                                  )}

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "q37_Tec_Dose_week_strengthRd" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          data.q37_Tec_Dose_week_strengthRd ===
                                                          4
                                                        }
                                                        onChange={
                                                          HandleFieldChange
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          marginLeft: "4px",
                                                          paddingRight: "15px",
                                                          marginBottom: "0px",
                                                          padding: "0",
                                                        }}
                                                      >
                                                        Other frequency, please
                                                        specify:
                                                        <div
                                                          style={{
                                                            paddingLeft: "15px",
                                                            marginBottom: "0px",
                                                            padding: "0",
                                                          }}
                                                        >
                                                          <textarea
                                                            name={
                                                              "q37_Tec_Dose_week_strength_txt" +
                                                              idx
                                                            }
                                                            className="input-dash"
                                                            type="text"
                                                            value={
                                                              data.q37_Tec_Dose_week_strength_txt
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                            maxLength={300}
                                                            id={idx}
                                                          />
                                                        </div>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* new Unknown */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "q37_Tec_Dose_week_strengthRd" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.q37_Tec_Dose_week_strengthRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleFieldChange
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.q37_Tec_Dose_week_strengthRd_Empty
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.q37TechvayliEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.q37_Tec_Dose_week_strength_txt_Empty
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.specifyOtherText
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </td>
                                              ) : (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    //alignContent: "flex-start",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                    //textAlign: 'start'
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                      verticalAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not applicable</b>
                                                  </span>
                                                </td>
                                              )}
                                            </React.Fragment>
                                          ))}
                                      </tr>
                                    )}

                                    {/* Talvey */}
                                    {isTalveySelected && (
                                      <tr>
                                        {Q37TalDetails.length > 0 &&
                                          Q37TalDetails.map((data, idx) => (
                                            <React.Fragment key={idx}>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  TALVEY
                                                  <sup className="supscript">
                                                    TM
                                                  </sup>{" "}
                                                  (talquetamab-tgvs)
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "q37_Tal_Dose_week_frquencyRd" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.q37_Tal_Dose_week_frquencyRd ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleFieldChange
                                                      }
                                                    />

                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      The patient has not
                                                      completed the step-up
                                                      dosing phase
                                                    </span>
                                                  </label>
                                                </div>
                                                {talveyDetails &&
                                                  talveyDetails.length > 0 &&
                                                  talveyDetails.some(
                                                    (item) =>
                                                      item.dosing_phase_tal ===
                                                      5,
                                                  ) && (
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "q37_Tal_Dose_week_frquencyRd" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.q37_Tal_Dose_week_frquencyRd ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                            display:
                                                              "inline-flex",
                                                          }}
                                                        >
                                                          <span>
                                                            Once every &nbsp;
                                                          </span>
                                                          <span>
                                                            <input
                                                              className="input-dash-custom"
                                                              id={idx}
                                                              name={
                                                                "q37_Tal_Dose_week_frquency_txt" +
                                                                idx
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              value={
                                                                data.q37_Tal_Dose_week_frquency_txt
                                                              }
                                                              onKeyDown={(
                                                                e,
                                                              ) => {
                                                                // Allow backspace, arrow keys, and delete
                                                                if (
                                                                  [
                                                                    "Backspace",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Delete",
                                                                    "Tab",
                                                                  ].includes(
                                                                    e.key,
                                                                  )
                                                                ) {
                                                                  return;
                                                                }

                                                                // Prevent non-numeric characters, except '.'
                                                                if (
                                                                  !/[0-9.]/.test(
                                                                    e.key,
                                                                  )
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                const value =
                                                                  e.target
                                                                    .value;
                                                                const selectionStart =
                                                                  e.target
                                                                    .selectionStart;
                                                                const newValue =
                                                                  value.slice(
                                                                    0,
                                                                    selectionStart,
                                                                  ) +
                                                                  e.key +
                                                                  value.slice(
                                                                    e.target
                                                                      .selectionEnd,
                                                                  );

                                                                // Prevent multiple '.'
                                                                if (
                                                                  e.key ===
                                                                    "." &&
                                                                  value.includes(
                                                                    ".",
                                                                  )
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                // Prevent '.' as the first character
                                                                if (
                                                                  e.key ===
                                                                    "." &&
                                                                  value === ""
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                // Allow only one digit after decimal point
                                                                if (
                                                                  newValue.includes(
                                                                    ".",
                                                                  ) &&
                                                                  newValue.split(
                                                                    ".",
                                                                  )[1].length >
                                                                    2
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }
                                                              }}
                                                            />
                                                          </span>
                                                          week
                                                        </span>
                                                      </label>
                                                    </div>
                                                  )}
                                                {/* new Unknown */}
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "q37_Tal_Dose_week_frquencyRd" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.q37_Tal_Dose_week_frquencyRd ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleFieldChange
                                                      }
                                                    />

                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                //style={{paddingLeft:"25px"}}
                                                >
                                                  <ErrorField
                                                    show={
                                                      data.q37_atleasetOneAdministrationTalWarningHard
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.AtleasetOneAdministrationWarning
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.q37_Tal_Dose_week_frquencyRd_Empty
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.admissionEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.q37_Tal_Dose_week_frquency_txt_Empty
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.specifyDosageFrequency
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.q37TalDoseWeekFrequencyRangeError
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.allowedRange
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              </td>

                                              {data.q37_Tal_Dose_week_frquencyRd !==
                                              1 ? (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "Q37TalveyRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.Q37TalveyRd ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            Yes
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q37TalveyRd" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.Q37TalveyRd ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />

                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            No
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q37TalveyRd" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.Q37TalveyRd ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />

                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.q37TalveyEmpty
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.q37TalveyEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </td>
                                              ) : (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not applicable</b>
                                                  </span>
                                                </td>
                                              )}

                                              {data.q37_Tal_Dose_week_frquencyRd !==
                                              1 ? (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  {isTalveySelected && (
                                                    <>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "q37_Tal_Dose_week_strengthRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.q37_Tal_Dose_week_strengthRd ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            0.40 mg/kg
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "q37_Tal_Dose_week_strengthRd" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.q37_Tal_Dose_week_strengthRd ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            0.80 mg/kg
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </>
                                                  )}

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "q37_Tal_Dose_week_strengthRd" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          data.q37_Tal_Dose_week_strengthRd ===
                                                          4
                                                        }
                                                        onChange={
                                                          HandleFieldChange
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          marginLeft: "4px",
                                                          paddingRight: "15px",
                                                          marginBottom: "0px",
                                                          padding: "0",
                                                        }}
                                                      >
                                                        Other frequency, please
                                                        specify:
                                                        <div
                                                          style={{
                                                            paddingLeft: "15px",
                                                            marginBottom: "0px",
                                                            padding: "0",
                                                          }}
                                                        >
                                                          <textarea
                                                            name={
                                                              "q37_Tal_Dose_week_strength_txt" +
                                                              idx
                                                            }
                                                            className="input-dash"
                                                            type="text"
                                                            value={
                                                              data.q37_Tal_Dose_week_strength_txt
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                            maxLength={300}
                                                            id={idx}
                                                          />
                                                        </div>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* new Unknown */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "q37_Tal_Dose_week_strengthRd" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.q37_Tal_Dose_week_strengthRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleFieldChange
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.q37_Tal_Dose_week_strengthRd_Empty
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.q37TechvayliEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.q37_Tal_Dose_week_strength_txt_Empty
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.specifyOtherText
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </td>
                                              ) : (
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not applicable</b>
                                                  </span>
                                                </td>
                                              )}
                                            </React.Fragment>
                                          ))}
                                      </tr>
                                    )}
                                    {/* Talvey */}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* Q37 end---------------------------------------------------------- */}

                        {/* Q38 start */}

                        {!isNewEcrfA && (
                          <>
                            {(Q37TechDetails[0].Q37TechvayliRd === 1 ||
                              Q37TalDetails[0].Q37TalveyRd === 1) && (
                              <>
                                <div className="question question-weight">
                                  <span>Q38.</span>
                                  <span className="quest-text-pad">
                                    Please provide all dates of dose frequency
                                    reductions during treatment with{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {isTechvayliSelected &&
                                      Q37TechDetails[0].Q37TechvayliRd === 1 &&
                                      isTalveySelected &&
                                      Q37TalDetails[0].Q37TalveyRd === 1 ? (
                                        <>
                                          TECVAYLI® (teclistamab-cqyv) and
                                          TALVEY
                                          <sup className="supscript">
                                            TM
                                          </sup>{" "}
                                          (talquetamab-tgvs).
                                        </>
                                      ) : isTechvayliSelected &&
                                        Q37TechDetails[0].Q37TechvayliRd ===
                                          1 ? (
                                        "TECVAYLI® (teclistamab-cqyv)."
                                      ) : isTalveySelected &&
                                        Q37TalDetails[0].Q37TalveyRd === 1 ? (
                                        <>
                                          TALVEY
                                          <sup className="supscript">
                                            TM
                                          </sup>{" "}
                                          (talquetamab-tgvs).
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </span>{" "}
                                    <br />
                                    <span>
                                      Note that dose frequency reductions refers
                                      only to the frequency of administrations
                                      (i.e., weekly, biweekly, monthly, etc.)
                                      and note changes in dose strength.
                                    </span>
                                  </span>
                                </div>
                              </>
                            )}
                            {isTechvayliSelected &&
                              Q37TechDetails[0].showDateRedFreqTec && (
                                <div className="dependent-section">
                                  {Q38TechDetails &&
                                    Q38TechDetails.length > 0 &&
                                    Q38TechDetails.map((data, idx) => (
                                      <div
                                        className="loop-section-ul"
                                        key={idx}
                                      >
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} Dose frequency
                                            reductions
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  DeleteQ38TechvayliRow(idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        {/* TECVAYLI® */}
                                        <div className="question-bot-sapce">
                                          <div className="sub-question grid-overflow">
                                            <table
                                              style={{
                                                border: "1px solid black",
                                                borderCollapse: "collapse",
                                                width: "100%",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Treatment
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      width: "15%",
                                                    }}
                                                  >
                                                    Date of dose frequency
                                                    reduction
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Dose frequency after
                                                    reduction
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span className="quest-text-pad">
                                                      TECVAYLI®
                                                      (teclistamab-cqyv)
                                                    </span>
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "Q38TechvayliRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.Q38TechvayliRd ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            {/* <DateControl
                                                          ctrlId={
                                                            "dt_dosefreq_tech_dt-" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          date={
                                                            data.dt_dosefreq_tech_dt
                                                          }
                                                        /> */}

                                                            <DatePickerComponent
                                                              ctrlId={
                                                                "dt_dosefreq_tech_dt-" +
                                                                idx
                                                              }
                                                              // selectedDate={selectedDate}
                                                              //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                              HandleDateChange={
                                                                HandleRepeaterDateChange
                                                              }
                                                              // optionId={1}
                                                              minDate={dayjs(
                                                                "01-01-1920",
                                                              )}
                                                              maxDate={dayjs()}
                                                              locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                              date={
                                                                data.dt_dosefreq_tech_dt
                                                              }
                                                            />
                                                          </span>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="option-fbox">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              // id="Q37Techvayli_select_0"
                                                              // name="Q37TechvayliRd"
                                                              id={idx}
                                                              name={
                                                                "Q38TechvayliRd" +
                                                                idx
                                                              }
                                                              value={99}
                                                              checked={
                                                                data.Q38TechvayliRd ===
                                                                99
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />

                                                            <span
                                                              // className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              Date of dose
                                                              frequency
                                                              reduction unknown
                                                            </span>
                                                          </label>
                                                        </div>

                                                        <ErrorField
                                                          show={
                                                            data.Q38TechEmptyHard
                                                          }
                                                          message={
                                                            TTCharacteristics_MSGS.Q38TechEmptyHard
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.Q38TechDateInvalid
                                                          }
                                                          message={
                                                            TTCharacteristics_MSGS.Q38TechDateInvalid
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.Q38DateEmpty
                                                          }
                                                          message={
                                                            TTCharacteristics_MSGS.Q38DateEmpty
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />

                                                        <ErrorField
                                                          show={
                                                            data.Invalid_dt_dosefreq_tech_dt
                                                          }
                                                          message={
                                                            CommonError_Msgs.InvalidDate
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />

                                                        <ErrorField
                                                          show={
                                                            data.q38TecDoseFrequencyConflict
                                                          }
                                                          message={
                                                            TTCharacteristics_MSGS.Q38TTFrequencyConflict
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "q38_Tec_Dose_week_frquencyRd" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.q38_Tec_Dose_week_frquencyRd ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                            display:
                                                              "inline-flex",
                                                          }}
                                                        >
                                                          <span>
                                                            Once every &nbsp;
                                                          </span>
                                                          <span>
                                                            <input
                                                              className="input-dash-custom"
                                                              id={idx}
                                                              name={
                                                                "q38_Tec_Dose_week_frquency_txt" +
                                                                idx
                                                              }
                                                              value={
                                                                data.q38_Tec_Dose_week_frquency_txt
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={(
                                                                e,
                                                              ) => {
                                                                // Allow backspace, arrow keys, and delete
                                                                if (
                                                                  [
                                                                    "Backspace",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Delete",
                                                                    "Tab",
                                                                  ].includes(
                                                                    e.key,
                                                                  )
                                                                ) {
                                                                  return;
                                                                }

                                                                // Prevent non-numeric characters, except '.'
                                                                if (
                                                                  !/[0-9.]/.test(
                                                                    e.key,
                                                                  )
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                const value =
                                                                  e.target
                                                                    .value;
                                                                const selectionStart =
                                                                  e.target
                                                                    .selectionStart;
                                                                const newValue =
                                                                  value.slice(
                                                                    0,
                                                                    selectionStart,
                                                                  ) +
                                                                  e.key +
                                                                  value.slice(
                                                                    e.target
                                                                      .selectionEnd,
                                                                  );

                                                                // Prevent multiple '.'
                                                                if (
                                                                  e.key ===
                                                                    "." &&
                                                                  value.includes(
                                                                    ".",
                                                                  )
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                // Prevent '.' as the first character
                                                                if (
                                                                  e.key ===
                                                                    "." &&
                                                                  value === ""
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                // Allow only one digit after decimal point
                                                                if (
                                                                  newValue.includes(
                                                                    ".",
                                                                  ) &&
                                                                  newValue.split(
                                                                    ".",
                                                                  )[1].length >
                                                                    2
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }
                                                              }}
                                                            />
                                                          </span>
                                                          week
                                                        </span>
                                                      </label>
                                                    </div>
                                                    {/* new Unknown */}
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "q38_Tec_Dose_week_frquencyRd" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.q38_Tec_Dose_week_frquencyRd ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                            display: "flex",
                                                          }}
                                                        >
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.q38_Tec_Dose_week_frquencyRd_Empty
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.q37TechvayliEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.q38_Tec_Dose_week_frquency_txt_Empty
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.specifyDosageFrequency
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ))}

                                  {Q38TechDetails &&
                                    Q38TechDetails.length > 0 &&
                                    Q38TechDetails.length < 550 && (
                                      <div className="sub-question-bot-sapce-ul mt-2">
                                        <div
                                          className="answer-list-text"
                                          onClick={AddQ38TechvayliRow}
                                        >
                                          <a>
                                            <img
                                              width="18px"
                                              src="../Assets/images/plus.png"
                                              alt=""
                                            />
                                          </a>
                                          <a className="radio-text-padding">
                                            Click here to add another date of
                                            dose frequency reduction
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              )}

                            {/* Q38 end  */}

                            {/* Q38 Talvey */}
                            {isTalveySelected &&
                              Q37TalDetails[0].showDateRedFreqTal && (
                                <div className="dependent-section">
                                  {Q38TalDetails &&
                                    Q38TalDetails.length > 0 &&
                                    Q38TalDetails.map((data, idx) => (
                                      <div
                                        className="loop-section-ul"
                                        key={idx}
                                      >
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} Dose frequency
                                            reductions
                                          </span>
                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  DeleteQ38TalveyRow(idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        {/* TALVEY */}
                                        <div className="question-bot-sapce">
                                          <div className="sub-question grid-overflow">
                                            <table
                                              style={{
                                                border: "1px solid black",
                                                borderCollapse: "collapse",
                                                width: "100%",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Treatment
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      width: "15%",
                                                    }}
                                                  >
                                                    Date of dose frequency
                                                    reduction
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Dose frequency after
                                                    reduction
                                                  </th>
                                                </tr>
                                              </thead>

                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span className="quest-text-pad">
                                                      TALVEY
                                                      <sup className="supscript">
                                                        TM
                                                      </sup>{" "}
                                                      (talquetamab-tgvs)
                                                    </span>
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "Q38TalveyRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.Q38TalveyRd ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              marginLeft:
                                                                "-5px",
                                                            }}
                                                          >
                                                            {/* <DateControl
                                                          ctrlId={
                                                            "dt_dosefreq_tal_dt-" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          date={
                                                            data.dt_dosefreq_tal_dt
                                                          }
                                                        /> */}
                                                            <DatePickerComponent
                                                              ctrlId={
                                                                "dt_dosefreq_tal_dt-" +
                                                                idx
                                                              }
                                                              // selectedDate={selectedDate}
                                                              //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                              HandleDateChange={
                                                                HandleRepeaterDateChange
                                                              }
                                                              // optionId={1}
                                                              minDate={dayjs(
                                                                "01-01-1920",
                                                              )}
                                                              maxDate={dayjs()}
                                                              locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                              date={
                                                                data.dt_dosefreq_tal_dt
                                                              }
                                                            />
                                                          </span>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="option-fbox">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={idx}
                                                              name={
                                                                "Q38TalveyRd" +
                                                                idx
                                                              }
                                                              value={99}
                                                              checked={
                                                                data.Q38TalveyRd ===
                                                                99
                                                              }
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                            />

                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              Date of dose
                                                              frequency
                                                              reduction unknown
                                                            </span>
                                                          </label>
                                                        </div>

                                                        <ErrorField
                                                          show={
                                                            data.Q38TalEmptyHard
                                                          }
                                                          message={
                                                            TTCharacteristics_MSGS.Q38TalEmptyHard
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.Q38TalDateEmpty
                                                          }
                                                          message={
                                                            TTCharacteristics_MSGS.Q38TalDateEmpty
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />
                                                        <ErrorField
                                                          show={
                                                            data.Q38TalDateInvalid
                                                          }
                                                          message={
                                                            TTCharacteristics_MSGS.Q38TalDateInvalid
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />

                                                        <ErrorField
                                                          show={
                                                            data.InvalidQ38Talveydate
                                                          }
                                                          message={
                                                            CommonError_Msgs.InvalidDate
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />

                                                        <ErrorField
                                                          show={
                                                            data.q38TalDoseFrequencyConflict
                                                          }
                                                          message={
                                                            TTCharacteristics_MSGS.Q38TTFrequencyConflict
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "q38_Tal_Dose_week_frquencyRd" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.q38_Tal_Dose_week_frquencyRd ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                            display:
                                                              "inline-flex",
                                                          }}
                                                        >
                                                          <span>
                                                            Once every &nbsp;
                                                          </span>
                                                          <span>
                                                            <input
                                                              className="input-dash-custom"
                                                              id={idx}
                                                              name={
                                                                "q38_Tal_Dose_week_frquency_txt" +
                                                                idx
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              value={
                                                                data.q38_Tal_Dose_week_frquency_txt
                                                              }
                                                              onKeyDown={(
                                                                e,
                                                              ) => {
                                                                // Allow backspace, arrow keys, and delete
                                                                if (
                                                                  [
                                                                    "Backspace",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Delete",
                                                                    "Tab",
                                                                  ].includes(
                                                                    e.key,
                                                                  )
                                                                ) {
                                                                  return;
                                                                }

                                                                // Prevent non-numeric characters, except '.'
                                                                if (
                                                                  !/[0-9.]/.test(
                                                                    e.key,
                                                                  )
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                const value =
                                                                  e.target
                                                                    .value;
                                                                const selectionStart =
                                                                  e.target
                                                                    .selectionStart;
                                                                const newValue =
                                                                  value.slice(
                                                                    0,
                                                                    selectionStart,
                                                                  ) +
                                                                  e.key +
                                                                  value.slice(
                                                                    e.target
                                                                      .selectionEnd,
                                                                  );

                                                                // Prevent multiple '.'
                                                                if (
                                                                  e.key ===
                                                                    "." &&
                                                                  value.includes(
                                                                    ".",
                                                                  )
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                // Prevent '.' as the first character
                                                                if (
                                                                  e.key ===
                                                                    "." &&
                                                                  value === ""
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }

                                                                // Allow only one digit after decimal point
                                                                if (
                                                                  newValue.includes(
                                                                    ".",
                                                                  ) &&
                                                                  newValue.split(
                                                                    ".",
                                                                  )[1].length >
                                                                    2
                                                                ) {
                                                                  e.preventDefault();
                                                                  return;
                                                                }
                                                              }}
                                                            />
                                                          </span>
                                                          week
                                                        </span>
                                                      </label>
                                                    </div>
                                                    {/* new Unknown */}
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "q38_Tal_Dose_week_frquencyRd" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.q38_Tal_Dose_week_frquencyRd ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                            display: "flex",
                                                          }}
                                                        >
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      <ErrorField
                                                        show={
                                                          data.q38_Tal_Dose_week_frquencyRd_Empty
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.admissionEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.q38_Tal_Dose_week_frquency_txt_Empty
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.specifyDosageFrequency
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>

                                                    <strong>Dosage</strong>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        paddingLeft: "15px",
                                                      }}
                                                    >
                                                      <div
                                                        className="option-without-input"
                                                        //style={{ display: "flex" }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "q38_Tal_Dosage_Rd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.q38_Tal_Dosage_Rd ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            0.40 mg/kg{" "}
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={
                                                          {
                                                            // display: "flex",
                                                            // alignItems: "flex-start",
                                                          }
                                                        }
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "q38_Tal_Dosage_Rd" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.q38_Tal_Dosage_Rd ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />

                                                          <span
                                                            // className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            0.80 mg/kg
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={
                                                          {
                                                            //display: "flex",
                                                            //alignItems: "flex-start",
                                                          }
                                                        }
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "q38_Tal_Dosage_Rd" +
                                                              idx
                                                            }
                                                            value={3}
                                                            checked={
                                                              data.q38_Tal_Dosage_Rd ===
                                                              3
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />

                                                          <span
                                                            // className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Other, please
                                                            specify
                                                            <span>
                                                              <textarea
                                                                className="input-dash"
                                                                id={idx}
                                                                name={
                                                                  "q38_Tal_Dosage_OtherTxt" +
                                                                  idx
                                                                }
                                                                type="text"
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                                value={
                                                                  data.q38_Tal_Dosage_OtherTxt
                                                                }
                                                              />
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={
                                                          {
                                                            // display: "flex",
                                                            // alignItems: "flex-start",
                                                          }
                                                        }
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "q38_Tal_Dosage_Rd" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.q38_Tal_Dosage_Rd ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />

                                                          <span
                                                            // className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.q38_Tal_Dosage_Rd_Empty
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.admissionEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.q38_Tal_Dosage_OtherTxt_Empty
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.specifyOtherText
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                </tr>

                                                {/* Talvey */}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ))}

                                  {Q38TalDetails &&
                                    Q38TalDetails.length > 0 &&
                                    Q38TalDetails.length < 550 && (
                                      <div className="sub-question-bot-sapce-ul mt-2">
                                        <div
                                          className="answer-list-text"
                                          onClick={AddQ38TalveyRow}
                                        >
                                          <a>
                                            <img
                                              width="18px"
                                              src="../Assets/images/plus.png"
                                              alt=""
                                            />
                                          </a>
                                          <a className="radio-text-padding">
                                            Click here to add another date of
                                            dose frequency reduction
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              )}
                          </>
                        )}
                        {/* Q38Talvey */}

                        {/* Q38.1.A start Tech */}
                        {isTechvayliSelected && isNewEcrfA == true && (
                          <div className="question question-weight">
                            <span>Q38.1.A</span>
                            <span className="quest-text-pad">
                              Please provide information on any{" "}
                              <i>dose frequency, or dose strength</i>, changes
                              that occurred from completion of the step-up
                              dosing phase until the end of the line of therapy
                              with{" "}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isTechvayliSelected && (
                                  <>TECVAYLI® (teclistamab-cqyv)</>
                                )}
                              </span>{" "}
                              Add additional rows for each type of change that
                              occurred.
                            </span>
                          </div>
                        )}

                        {/* Q38.1.A TECVAYLI */}
                        {isTechvayliSelected && isNewEcrfA && (
                          <div className="dependent-section">
                            {Q381ATechDetails &&
                              Q381ATechDetails.length > 0 &&
                              Q381ATechDetails.map((data, idx) => (
                                <div className="loop-section-ul" key={idx}>
                                  <div className="loop-head">
                                    <span
                                      className="question-weight"
                                      style={{ float: "inline-start" }}
                                    >
                                      {GetOrdinal(idx + 1)} Dose/frequency
                                      change
                                    </span>
                                    {idx !== 0 && (
                                      <div
                                        className="delete-btn-div"
                                        style={{ float: "inline-end" }}
                                      >
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            DeleteQ381ATechRow(idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* ELREXFIO Table */}
                                  <div className="question-bot-sapce">
                                    <div className=" grid-overflow sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "150px",
                                              }}
                                            >
                                              Type of change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "280px",
                                              }}
                                            >
                                              Reason for change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Pattern <i>before</i> change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Pattern <i>after</i> change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of change
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            {/* Column A: Treatment */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                TECVAYLI® (teclistamab-cqyv)
                                              </span>
                                            </td>

                                            {/* Column B: Type of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {idx == 0 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "changeTypeTech" + idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.changeType === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      No dose frequency or dose
                                                      strength changes occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                {" "}
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "changeTypeTech" + idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.changeType === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose frequency change
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Sub-radio for Frequency Increase/Decrease */}
                                              {data.changeType === 2 && (
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseFrequencyTech" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.changeTypeDoseFrequency ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Frequency increase
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="option-without-input">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseFrequencyTech" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.changeTypeDoseFrequency ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Frequency decrease
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.changeTypeDoseFrequencyEmpty
                                                    }
                                                    message="Please select frequency change type"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              )}

                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "changeTypeTech" + idx
                                                    }
                                                    value={3}
                                                    checked={
                                                      data.changeType === 3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose strength change
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Sub-radio for Strength Increase/Decrease */}
                                              {data.changeType === 3 && (
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseStrengthTech" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.changeTypeDoseStrength ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Strength increase
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="option-without-input">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseStrengthTech" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.changeTypeDoseStrength ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Strength decrease
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.changeTypeDoseStrengthEmpty
                                                    }
                                                    message="Please select strength change type"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              )}

                                              {idx == 0 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "changeTypeTech" + idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.changeType === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Unknown if any dose
                                                      changes occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <ErrorField
                                                show={data.changeTypeEmpty}
                                                message="Please select type of change"
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </td>

                                            {/* Column C: Reasons for change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 &&
                                              data.discontinuationReasons
                                                ?.length > 0 ? (
                                                <div>
                                                  {data.discontinuationReasons.map(
                                                    (reason, reasonIdx) => (
                                                      <div
                                                        key={reason.reasonid}
                                                      >
                                                        {/* Primary reason checkbox */}
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label className="option-fbox">
                                                            <input
                                                              type="checkbox"
                                                              name={
                                                                "tech_reason" +
                                                                idx
                                                              }
                                                              id={idx}
                                                              value={
                                                                reason.reasonid
                                                              }
                                                              checked={
                                                                reason.isSelected
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,

                                                                  reasonIdx,
                                                                  null,
                                                                )
                                                              }
                                                            />
                                                            <span
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {
                                                                reason.reasonName
                                                              }
                                                              {reason.supscripttext && (
                                                                <sup>
                                                                  {
                                                                    reason.supscripttext
                                                                  }
                                                                </sup>
                                                              )}
                                                            </span>
                                                          </label>
                                                        </div>

                                                        {/* Adverse Events (only if Adverse Event selected) */}
                                                        {reason.reasonName ===
                                                          DiscontinuationReason.AdverseEvent &&
                                                          reason.isSelected && (
                                                            <div
                                                              style={{
                                                                marginLeft:
                                                                  "24px",
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                            >
                                                              {data.adverseEventReasons?.map(
                                                                (ae, aeIdx) => {
                                                                  const isAEUnknown =
                                                                    ae.reasonName ===
                                                                    "AE type unknown";

                                                                  return (
                                                                    <div
                                                                      key={
                                                                        aeIdx
                                                                      }
                                                                      style={{
                                                                        alignItems:
                                                                          "flex-start",
                                                                      }}
                                                                    >
                                                                      {" "}
                                                                      <label className="option-fbox">
                                                                        <input
                                                                          type={
                                                                            isAEUnknown
                                                                              ? "radio"
                                                                              : "checkbox"
                                                                          }
                                                                          id={
                                                                            idx
                                                                          }
                                                                          name={`tech_adverse_${idx}`}
                                                                          checked={
                                                                            ae.isSelected
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            HandleRepeaterFieldChange(
                                                                              e,
                                                                              reasonIdx,
                                                                              aeIdx,
                                                                            )
                                                                          }
                                                                          style={{
                                                                            marginTop:
                                                                              "6px",
                                                                          }}
                                                                        />

                                                                        <span className="radio-text-padding">
                                                                          {
                                                                            ae.reasonName
                                                                          }
                                                                        </span>
                                                                      </label>
                                                                      {ae.reasonName ===
                                                                        DiscontinuationReason.NeurologicalEvent &&
                                                                        ae.isSelected && (
                                                                          <div
                                                                            style={{
                                                                              marginLeft:
                                                                                "28px",
                                                                              marginTop:
                                                                                "8px",
                                                                            }}
                                                                          >
                                                                            {data
                                                                              .neurologicAEReasonList
                                                                              ?.length >
                                                                              0 &&
                                                                              data.neurologicAEReasonList.map(
                                                                                (
                                                                                  aeNeuro,
                                                                                  aeNeuroIdx,
                                                                                ) => {
                                                                                  return (
                                                                                    <div
                                                                                      key={
                                                                                        aeNeuroIdx
                                                                                      }
                                                                                    >
                                                                                      <label
                                                                                        className="d-flex align-items-start"
                                                                                        htmlFor={`tech_adverse_neuro_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      >
                                                                                        <input
                                                                                          type="checkbox"
                                                                                          id={`tech_adverse_neuro_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          name={`tech_adverse_neuro_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          checked={
                                                                                            aeNeuro.isSelected
                                                                                          }
                                                                                          onChange={(
                                                                                            e,
                                                                                          ) =>
                                                                                            HandleNeuroRepeaterFieldChange(
                                                                                              e,
                                                                                              "381A",
                                                                                              RRMMCohortTreatment.TECVAYLI,
                                                                                              aeNeuroIdx,
                                                                                              idx,
                                                                                            )
                                                                                          }
                                                                                          style={{
                                                                                            marginTop:
                                                                                              "6px",
                                                                                          }}
                                                                                        />

                                                                                        <span
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                          className="radio-text-padding"
                                                                                        >
                                                                                          {
                                                                                            aeNeuro.reasonName
                                                                                          }
                                                                                        </span>
                                                                                      </label>

                                                                                      {aeNeuro.reasonName.includes(
                                                                                        "Other",
                                                                                      ) && (
                                                                                        <div>
                                                                                          <label
                                                                                            htmlFor={`tech_neuro_reasontxt_${reasonIdx}_${aeNeuroIdx}`}
                                                                                          >
                                                                                            <span
                                                                                              style={{
                                                                                                paddingLeft:
                                                                                                  "28px",
                                                                                              }}
                                                                                              className="radio-text-padding"
                                                                                            >
                                                                                              <textarea
                                                                                                style={{
                                                                                                  width:
                                                                                                    "264px",
                                                                                                }}
                                                                                                id={`tech_neuro_reasontxt_${reasonIdx}_${aeNeuroIdx}`}
                                                                                                name={`tech_neuro_reasontxt_${reasonIdx}_${aeNeuroIdx}`}
                                                                                                type="text"
                                                                                                value={
                                                                                                  aeNeuro.reasonText
                                                                                                }
                                                                                                onChange={(
                                                                                                  e,
                                                                                                ) =>
                                                                                                  HandleNeuroRepeaterFieldChange(
                                                                                                    e,
                                                                                                    "381A",
                                                                                                    RRMMCohortTreatment.TECVAYLI,
                                                                                                    aeNeuroIdx,
                                                                                                    idx,
                                                                                                  )
                                                                                                }
                                                                                                maxLength={
                                                                                                  300
                                                                                                }
                                                                                              />
                                                                                            </span>
                                                                                          </label>
                                                                                          <ErrorField
                                                                                            show={
                                                                                              data.neuroOtherTextEmpty
                                                                                            }
                                                                                            message={
                                                                                              TTCharacteristics_MSGS.Q38AENeurologicOther
                                                                                            }
                                                                                          />
                                                                                        </div>
                                                                                      )}
                                                                                    </div>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            <ErrorField
                                                                              show={
                                                                                data.neuroReasonEmpty
                                                                              }
                                                                              message={
                                                                                TTCharacteristics_MSGS.Q38AENeurologicEmpty
                                                                              }
                                                                            />
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}
                                                              <ErrorField
                                                                show={
                                                                  data.aeSubReasonEmpty
                                                                }
                                                                message={
                                                                  TTCharacteristics_MSGS.Q38AEEmpty
                                                                }
                                                              />
                                                            </div>
                                                          )}

                                                        {/* Other reason text */}
                                                        {reason.reasonName.includes(
                                                          "Other",
                                                        ) && (
                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            <textarea
                                                              className="input-dash"
                                                              id={idx}
                                                              name={
                                                                "reasonOtherText_" +
                                                                idx
                                                              }
                                                              value={
                                                                reason.reasonText ||
                                                                ""
                                                              }
                                                              onChange={(e) => {
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  reasonIdx,
                                                                );
                                                              }}
                                                              placeholder="Please specify"
                                                            />
                                                            <ErrorField
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                              show={
                                                                data.reasonOtherTextEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q38ReasonOtherEmpty
                                                              }
                                                            />
                                                          </div>
                                                        )}
                                                      </div>
                                                    ),
                                                  )}
                                                  <div className="">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        name={`discont_unk_${idx}`}
                                                        value={true}
                                                        checked={
                                                          data
                                                            .discontinuationReasons[0]
                                                            .reasonUnk
                                                            ? true
                                                            : ""
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            idx,
                                                            null,
                                                            null,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                        className="radio-text-padding"
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={data.reasonEmpty}
                                                    message={
                                                      TTCharacteristics_MSGS.Q38ReasonEmpty
                                                    }
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.discontinuationSoftError ==
                                                      true
                                                    }
                                                    message={
                                                      "WARNING: you have indicated that at least 1 reason for medication discontinuation was death however no date of death is reported in Q20. Please revise the reason for medication discontinuation to a reason besides death or otherwise add a date of death in Q20."
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                <span className="not-applicable">
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column D: Pattern BEFORE change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType === 2 ? (
                                                <div>
                                                  {/* Frequency Pattern */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeFrequencyTechPerWeekRd" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.patterBeforeChangeDoseFrequency ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <span>
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "patternBeforeFrequencyTechPerWeekTxt" +
                                                              idx
                                                            }
                                                            value={
                                                              data.patterBeforeChangeDoseFrequencyPerWeek
                                                            }
                                                            type="text"
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              )
                                                                return;
                                                              if (
                                                                !/[0-9]/.test(
                                                                  e.key,
                                                                )
                                                              )
                                                                e.preventDefault();
                                                            }}
                                                          />
                                                        </span>
                                                        <span>
                                                          &nbsp;times per week
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeFrequencyTechEveryWeekRd" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.patterBeforeChangeDoseFrequency ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <span>
                                                          Once every&nbsp;
                                                        </span>
                                                        <span>
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "patternBeforeFrequencyTechEveryWeekTxt" +
                                                              idx
                                                            }
                                                            value={
                                                              data.patterBeforeChangeDoseFrequencyEveryWeek
                                                            }
                                                            type="text"
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              )
                                                                return;
                                                              if (
                                                                !/[0-9]/.test(
                                                                  e.key,
                                                                )
                                                              )
                                                                e.preventDefault();
                                                            }}
                                                          />
                                                        </span>
                                                        <span>
                                                          &nbsp;week(s)
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeFrequencyTechUnk" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.patterBeforeChangeDoseFrequency ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeFrequencyEmpty
                                                    }
                                                    message="Please select frequency pattern"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeFrequencyRangeInvalid
                                                    }
                                                    message="Please enter frequency range between 1 and 20."
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                  />
                                                </div>
                                              ) : data.changeType === 3 ? (
                                                <div>
                                                  {/* Strength Pattern */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeChangeDoseStrengthTechMg" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.patterBeforeChangeDoseStrength ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternBeforeChangeDoseStrengthTechMgTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterBeforeChangeDoseStrengthMg
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeChangeDoseStrengthTechKg" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.patterBeforeChangeDoseStrength ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternBeforeChangeDoseStrengthTechKgTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterBeforeChangeDoseStrengthMgKg
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg/kg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeChangeDoseStrengthTechMM" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.patterBeforeChangeDoseStrength ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternBeforeChangeDoseStrengthTechMMTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterBeforeChangeDoseStrengthMgM2
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg/m²</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeChangeDoseStrengthTechUnk" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.patterBeforeChangeDoseStrength ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeStrengthEmpty
                                                    }
                                                    message="Please select strength pattern"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeStrengthRangeInvalid
                                                    }
                                                    message="Please enter units between 0.01 to 4000"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column E: Pattern AFTER change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType === 2 ? (
                                                <div>
                                                  {/* Frequency Pattern AFTER */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterFrequencyTechPerWeekRd" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.patterAfterChangeDoseFrequency ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <span>
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "patternAfterFrequencyTechPerWeekTxt" +
                                                              idx
                                                            }
                                                            value={
                                                              data.patterAfterChangeDoseFrequencyPerWeek
                                                            }
                                                            type="text"
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              )
                                                                return;
                                                              if (
                                                                !/[0-9]/.test(
                                                                  e.key,
                                                                )
                                                              )
                                                                e.preventDefault();
                                                            }}
                                                          />
                                                        </span>
                                                        <span>
                                                          &nbsp;times per week
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterFrequencyTechEveryWeekRd" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.patterAfterChangeDoseFrequency ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <span>
                                                          Once every&nbsp;
                                                        </span>
                                                        <span>
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "patternAfterFrequencyTechEveryWeekText" +
                                                              idx
                                                            }
                                                            value={
                                                              data.patterAfterChangeDoseFrequencyEveryWeek
                                                            }
                                                            type="text"
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              )
                                                                return;
                                                              if (
                                                                !/[0-9]/.test(
                                                                  e.key,
                                                                )
                                                              )
                                                                e.preventDefault();
                                                            }}
                                                          />
                                                        </span>
                                                        <span>
                                                          &nbsp;week(s)
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterFrequencyTechUnk" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.patterAfterChangeDoseFrequency ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternAfterFrequencyEmpty
                                                    }
                                                    message="Please select frequency pattern"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternAfterFrequencyRangeInvalid
                                                    }
                                                    message="Please enter frequency value between 1 and 20."
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.frequencyIncreaseConflict
                                                    }
                                                    message={
                                                      data.patterBeforeChangeDoseFrequency ===
                                                      1
                                                        ? TTCharacteristics_MSGS.FrequencyIncreaseConflict
                                                        : TTCharacteristics_MSGS.FrequencyDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.frequencyDecreaseConflict
                                                    }
                                                    message={
                                                      data.patterBeforeChangeDoseFrequency ===
                                                      2
                                                        ? TTCharacteristics_MSGS.FrequencyIncreaseConflict
                                                        : TTCharacteristics_MSGS.FrequencyDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternAfterUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : data.changeType === 3 ? (
                                                <div>
                                                  {/* Strength Pattern AFTER */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterChangeDoseStrengthTechMg" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternAfterChangeDoseStrengthTechMgTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterAfterChangeDoseStrengthMg
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterChangeDoseStrengthTechKg" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternAfterChangeDoseStrengthTechKgTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterAfterChangeDoseStrengthMgKg
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg/kg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterChangeDoseStrengthTechMM" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternAfterChangeDoseStrengthTechMMTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterAfterChangeDoseStrengthMgM2
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg/m²</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterChangeDoseStrengthTechUnk" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternAfterStrengthEmpty
                                                    }
                                                    message="Please select strength pattern."
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.patternAfterStrengthRangeInvalid
                                                    }
                                                    message="Please enter units between 0.01 to 4000"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.strengthIncreaseConflict
                                                    }
                                                    message="After value should be greater than before for increase"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.strengthDecreaseConflict
                                                    }
                                                    message="After value should be less than before for decrease"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternAfterUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column F: Date of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "dateChangeRdTech" + idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.dateChangeRd === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`dateChangeTech-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={data.dateChange}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateChangeRdTech" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.dateChangeRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Date of change unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeRdEmpty
                                                    }
                                                    message="Please select date option"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={data.dateChangeEmpty}
                                                    message="Please provide date of change"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeOutOfBound
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeBeforeEOF
                                                    }
                                                    message="Date must be before End of Follow-up"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))}

                            {/* Add button */}
                            {Q381ATechDetails &&
                              !hideQ381TechAdd &&
                              Q381ATechDetails.length > 0 &&
                              Q381ATechDetails.length < 50 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={AddQ381ATechRow}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another dose/frequency
                                      change
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}

                        {/* Q38.1.A End */}

                        {isTalveySelected && isNewEcrfA == true && (
                          <div className="question question-weight">
                            <span>Q38.1.A</span>
                            <span className="quest-text-pad">
                              Please provide information on any{" "}
                              <i>dose frequency, or dose strength</i>, changes
                              that occurred from completion of the step-up
                              dosing phase until the end of the line of therapy
                              with{" "}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isTalveySelected && (
                                  <>
                                    TALVEY <sup className="supscript">TM</sup>{" "}
                                    (talquetamab-tgvs)
                                  </>
                                )}
                              </span>{" "}
                              Add additional rows for each type of change that
                              occurred.
                            </span>
                          </div>
                        )}
                        {/* Q38.1.A TALVEY */}

                        {isTalveySelected && isNewEcrfA && (
                          <div className="dependent-section">
                            {Q381ATalvDetails &&
                              Q381ATalvDetails.length > 0 &&
                              Q381ATalvDetails.map((data, idx) => (
                                <div className="loop-section-ul" key={idx}>
                                  <div className="loop-head">
                                    <span
                                      className="question-weight"
                                      style={{ float: "inline-start" }}
                                    >
                                      {GetOrdinal(idx + 1)} Dose/frequency
                                      change
                                    </span>
                                    {idx !== 0 && (
                                      <div
                                        className="delete-btn-div"
                                        style={{ float: "inline-end" }}
                                      >
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            DeleteQ381ATalvRow(idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* ELREXFIO Table */}
                                  <div className="question-bot-sapce">
                                    <div className=" grid-overflow sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "150px",
                                              }}
                                            >
                                              Type of change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "280px",
                                              }}
                                            >
                                              Reason for change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Pattern <i>before</i> change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Pattern <i>after</i> change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of change
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            {/* Column A: Treatment */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                TALVEY
                                                <sup className="supscript">
                                                  TM
                                                </sup>{" "}
                                                (talquetamab-tgvs)
                                              </span>
                                            </td>

                                            {/* Column B: Type of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {idx == 0 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "changeTypeTalv" + idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.changeType === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      No dose frequency or dose
                                                      strength changes occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                {" "}
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "changeTypeTalv" + idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.changeType === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose frequency change
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Sub-radio for Frequency Increase/Decrease */}
                                              {data.changeType === 2 && (
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseFrequencyTalv" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.changeTypeDoseFrequency ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Frequency increase
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="option-without-input">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseFrequencyTalv" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.changeTypeDoseFrequency ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Frequency decrease
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.changeTypeDoseFrequencyEmpty
                                                    }
                                                    message="Please select frequency change type"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              )}

                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "changeTypeTalv" + idx
                                                    }
                                                    value={3}
                                                    checked={
                                                      data.changeType === 3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose strength change
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Sub-radio for Strength Increase/Decrease */}
                                              {data.changeType === 3 && (
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseStrengthTalv" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.changeTypeDoseStrength ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Strength Increase
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="option-without-input">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseStrengthTalv" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.changeTypeDoseStrength ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Strength Decrease
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.changeTypeDoseStrengthEmpty
                                                    }
                                                    message="Please select strength change type"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              )}
                                              {idx == 0 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "changeTypeTalv" + idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.changeType === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Unknown if any dose
                                                      changes occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <ErrorField
                                                show={data.changeTypeEmpty}
                                                message="Please select type of change"
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </td>

                                            {/* Column C: Reasons for change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 &&
                                              data.discontinuationReasons
                                                ?.length > 0 ? (
                                                <div>
                                                  {data.discontinuationReasons.map(
                                                    (reason, reasonIdx) => (
                                                      <div
                                                        key={reason.reasonid}
                                                      >
                                                        {/* Primary reason checkbox */}
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label className="option-fbox">
                                                            <input
                                                              type="checkbox"
                                                              name={
                                                                "talv_reason" +
                                                                idx
                                                              }
                                                              id={idx}
                                                              value={
                                                                reason.reasonid
                                                              }
                                                              checked={
                                                                reason.isSelected
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,

                                                                  reasonIdx,
                                                                  null,
                                                                )
                                                              }
                                                            />
                                                            <span
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {
                                                                reason.reasonName
                                                              }
                                                              {reason.supscripttext && (
                                                                <sup>
                                                                  {
                                                                    reason.supscripttext
                                                                  }
                                                                </sup>
                                                              )}
                                                            </span>
                                                          </label>
                                                        </div>

                                                        {/* Adverse Events (only if Adverse Event selected) */}
                                                        {reason.reasonName ===
                                                          DiscontinuationReason.AdverseEvent &&
                                                          reason.isSelected && (
                                                            <div
                                                              style={{
                                                                marginLeft:
                                                                  "24px",
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                            >
                                                              {data.adverseEventReasons?.map(
                                                                (ae, aeIdx) => {
                                                                  const isAEUnknown =
                                                                    ae.reasonName ===
                                                                    "AE type unknown";

                                                                  return (
                                                                    <div
                                                                      key={
                                                                        aeIdx
                                                                      }
                                                                      style={{
                                                                        alignItems:
                                                                          "flex-start",
                                                                      }}
                                                                    >
                                                                      {" "}
                                                                      <label className="option-fbox">
                                                                        <input
                                                                          type={
                                                                            isAEUnknown
                                                                              ? "radio"
                                                                              : "checkbox"
                                                                          }
                                                                          id={
                                                                            idx
                                                                          }
                                                                          name={`talv_adverse_${idx}`}
                                                                          checked={
                                                                            ae.isSelected
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            HandleRepeaterFieldChange(
                                                                              e,

                                                                              reasonIdx,
                                                                              aeIdx,
                                                                            )
                                                                          }
                                                                          style={{
                                                                            marginTop:
                                                                              "6px",
                                                                          }}
                                                                        />

                                                                        <span className="radio-text-padding">
                                                                          {
                                                                            ae.reasonName
                                                                          }
                                                                        </span>
                                                                      </label>
                                                                      {ae.reasonName ===
                                                                        DiscontinuationReason.NeurologicalEvent &&
                                                                        ae.isSelected && (
                                                                          <div
                                                                            style={{
                                                                              marginLeft:
                                                                                "28px",
                                                                              marginTop:
                                                                                "8px",
                                                                            }}
                                                                          >
                                                                            {data
                                                                              .neurologicAEReasonList
                                                                              ?.length >
                                                                              0 &&
                                                                              data.neurologicAEReasonList.map(
                                                                                (
                                                                                  aeNeuro,
                                                                                  aeNeuroIdx,
                                                                                ) => {
                                                                                  return (
                                                                                    <div
                                                                                      key={
                                                                                        aeNeuroIdx
                                                                                      }
                                                                                    >
                                                                                      <label
                                                                                        className="d-flex align-items-start"
                                                                                        htmlFor={`tal_adverse_neuro_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      >
                                                                                        <input
                                                                                          type="checkbox"
                                                                                          id={`tal_adverse_neuro_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          name={`tal_adverse_neuro_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          checked={
                                                                                            aeNeuro.isSelected
                                                                                          }
                                                                                          onChange={(
                                                                                            e,
                                                                                          ) =>
                                                                                            HandleNeuroRepeaterFieldChange(
                                                                                              e,
                                                                                              "381A",
                                                                                              RRMMCohortTreatment.TALVEY,
                                                                                              aeNeuroIdx,
                                                                                              idx,
                                                                                            )
                                                                                          }
                                                                                          style={{
                                                                                            marginTop:
                                                                                              "6px",
                                                                                          }}
                                                                                        />

                                                                                        <span
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                          className="radio-text-padding"
                                                                                        >
                                                                                          {
                                                                                            aeNeuro.reasonName
                                                                                          }
                                                                                        </span>
                                                                                      </label>

                                                                                      {aeNeuro.reasonName.includes(
                                                                                        "Other",
                                                                                      ) && (
                                                                                        <div>
                                                                                          <label
                                                                                            htmlFor={`tal_neuro_reasontxt_${reasonIdx}_${aeNeuroIdx}`}
                                                                                          >
                                                                                            <span
                                                                                              style={{
                                                                                                paddingLeft:
                                                                                                  "28px",
                                                                                              }}
                                                                                              className="radio-text-padding"
                                                                                            >
                                                                                              <textarea
                                                                                                style={{
                                                                                                  width:
                                                                                                    "264px",
                                                                                                }}
                                                                                                id={`tal_neuro_reasontxt_${reasonIdx}_${aeNeuroIdx}`}
                                                                                                name={`tal_neuro_reasontxt_${reasonIdx}_${aeNeuroIdx}`}
                                                                                                type="text"
                                                                                                value={
                                                                                                  aeNeuro.reasonText
                                                                                                }
                                                                                                onChange={(
                                                                                                  e,
                                                                                                ) =>
                                                                                                  HandleNeuroRepeaterFieldChange(
                                                                                                    e,
                                                                                                    "381A",
                                                                                                    RRMMCohortTreatment.TALVEY,
                                                                                                    aeNeuroIdx,
                                                                                                    idx,
                                                                                                  )
                                                                                                }
                                                                                                maxLength={
                                                                                                  300
                                                                                                }
                                                                                              />
                                                                                            </span>
                                                                                          </label>
                                                                                          <ErrorField
                                                                                            show={
                                                                                              data.neuroOtherTextEmpty
                                                                                            }
                                                                                            message={
                                                                                              TTCharacteristics_MSGS.Q38AENeurologicOther
                                                                                            }
                                                                                          />
                                                                                        </div>
                                                                                      )}
                                                                                    </div>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            <ErrorField
                                                                              show={
                                                                                data.neuroReasonEmpty
                                                                              }
                                                                              message={
                                                                                TTCharacteristics_MSGS.Q38AENeurologicEmpty
                                                                              }
                                                                            />
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}
                                                              <ErrorField
                                                                show={
                                                                  data.aeSubReasonEmpty
                                                                }
                                                                message={
                                                                  TTCharacteristics_MSGS.Q38AEEmpty
                                                                }
                                                              />
                                                            </div>
                                                          )}

                                                        {/* Other reason text */}
                                                        {reason.reasonName.includes(
                                                          "Other",
                                                        ) && (
                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            <textarea
                                                              className="input-dash"
                                                              id={idx}
                                                              name={
                                                                "talv_reasonOtherText_" +
                                                                idx
                                                              }
                                                              value={
                                                                reason.reasonText ||
                                                                ""
                                                              }
                                                              onChange={(e) => {
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  reasonIdx,
                                                                );
                                                              }}
                                                              placeholder="Please specify"
                                                            />
                                                            <ErrorField
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                              show={
                                                                data.reasonOtherTextEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q38ReasonOtherEmpty
                                                              }
                                                            />
                                                          </div>
                                                        )}
                                                      </div>
                                                    ),
                                                  )}
                                                  <div className="">
                                                    <label className="option-fbox">
                                                      <input
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        type="radio"
                                                        id={idx}
                                                        name={`talv_discont_unk_${idx}`}
                                                        value={true}
                                                        checked={
                                                          data
                                                            .discontinuationReasons[0]
                                                            .reasonUnk
                                                            ? true
                                                            : ""
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            idx,
                                                            null,
                                                            null,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                        className="radio-text-padding"
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={data.reasonEmpty}
                                                    message={
                                                      TTCharacteristics_MSGS.Q38ReasonEmpty
                                                    }
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.discontinuationSoftError ==
                                                      true
                                                    }
                                                    message={
                                                      "WARNING: you have indicated that at least 1 reason for medication discontinuation was death however no date of death is reported in Q20. Please revise the reason for medication discontinuation to a reason besides death or otherwise add a date of death in Q20."
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                <span className="not-applicable">
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column D: Pattern BEFORE change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType === 2 ? (
                                                <div>
                                                  {/* Frequency Pattern */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeFrequencyTalvPerWeekRd" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.patterBeforeChangeDoseFrequency ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <span>
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "patternBeforeFrequencyTalvPerWeekTxt" +
                                                              idx
                                                            }
                                                            value={
                                                              data.patterBeforeChangeDoseFrequencyPerWeek
                                                            }
                                                            type="text"
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              )
                                                                return;
                                                              if (
                                                                !/[0-9]/.test(
                                                                  e.key,
                                                                )
                                                              )
                                                                e.preventDefault();
                                                            }}
                                                          />
                                                        </span>
                                                        <span>
                                                          &nbsp;times per week
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeFrequencyTalvEveryWeekRd" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.patterBeforeChangeDoseFrequency ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <span>
                                                          Once every&nbsp;
                                                        </span>
                                                        <span>
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "patternBeforeFrequencyTalvEveryWeekTxt" +
                                                              idx
                                                            }
                                                            value={
                                                              data.patterBeforeChangeDoseFrequencyEveryWeek
                                                            }
                                                            type="text"
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              )
                                                                return;
                                                              if (
                                                                !/[0-9]/.test(
                                                                  e.key,
                                                                )
                                                              )
                                                                e.preventDefault();
                                                            }}
                                                          />
                                                        </span>
                                                        <span>
                                                          &nbsp;week(s)
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeFrequencyTalvUnk" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.patterBeforeChangeDoseFrequency ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeFrequencyEmpty
                                                    }
                                                    message="Please select frequency pattern"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeFrequencyRangeInvalid
                                                    }
                                                    message="Please enter frequency range between 1 and 20."
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : data.changeType === 3 ? (
                                                <div>
                                                  {/* Strength Pattern */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeChangeDoseStrengthTalvMg" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.patterBeforeChangeDoseStrength ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternBeforeChangeDoseStrengthTalvMgTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterBeforeChangeDoseStrengthMg
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeChangeDoseStrengthTalvKg" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.patterBeforeChangeDoseStrength ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternBeforeChangeDoseStrengthTalvKgTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterBeforeChangeDoseStrengthMgKg
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg/kg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeChangeDoseStrengthTalvMM" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.patterBeforeChangeDoseStrength ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternBeforeChangeDoseStrengthTalvMMTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterBeforeChangeDoseStrengthMgM2
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg/m²</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternBeforeChangeDoseStrengthTalvUnk" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.patterBeforeChangeDoseStrength ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeStrengthEmpty
                                                    }
                                                    message="Please select strength pattern"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeStrengthRangeInvalid
                                                    }
                                                    message="Please enter units between 0.01 to 4000"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternBeforeUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column E: Pattern AFTER change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType === 2 ? (
                                                <div>
                                                  {/* Frequency Pattern AFTER */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterFrequencyTalvPerWeekRd" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.patterAfterChangeDoseFrequency ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <span>
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "patternAfterFrequencyTalvPerWeekTxt" +
                                                              idx
                                                            }
                                                            value={
                                                              data.patterAfterChangeDoseFrequencyPerWeek
                                                            }
                                                            type="text"
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              )
                                                                return;
                                                              if (
                                                                !/[0-9]/.test(
                                                                  e.key,
                                                                )
                                                              )
                                                                e.preventDefault();
                                                            }}
                                                          />
                                                        </span>
                                                        <span>
                                                          &nbsp;times per week
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterFrequencyTalvEveryWeekRd" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.patterAfterChangeDoseFrequency ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <span>
                                                          Once every&nbsp;
                                                        </span>
                                                        <span>
                                                          <input
                                                            className="input-dash-custom"
                                                            id={idx}
                                                            name={
                                                              "patternAfterFrequencyTalvEveryWeekText" +
                                                              idx
                                                            }
                                                            value={
                                                              data.patterAfterChangeDoseFrequencyEveryWeek
                                                            }
                                                            type="text"
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              )
                                                                return;
                                                              if (
                                                                !/[0-9]/.test(
                                                                  e.key,
                                                                )
                                                              )
                                                                e.preventDefault();
                                                            }}
                                                          />
                                                        </span>
                                                        <span>
                                                          &nbsp;week(s)
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterFrequencyTalvUnk" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.patterAfterChangeDoseFrequency ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternAfterFrequencyEmpty
                                                    }
                                                    message="Please select frequency pattern"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternAfterFrequencyRangeInvalid
                                                    }
                                                    message="Please enter frequency value between 1 and 20."
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.frequencyIncreaseConflict
                                                    }
                                                    message={
                                                      data.patterBeforeChangeDoseFrequency ===
                                                      1
                                                        ? TTCharacteristics_MSGS.FrequencyIncreaseConflict
                                                        : TTCharacteristics_MSGS.FrequencyDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.frequencyDecreaseConflict
                                                    }
                                                    message={
                                                      data.patterBeforeChangeDoseFrequency ===
                                                      2
                                                        ? TTCharacteristics_MSGS.FrequencyIncreaseConflict
                                                        : TTCharacteristics_MSGS.FrequencyDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternAfterUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : data.changeType === 3 ? (
                                                <div>
                                                  {/* Strength Pattern AFTER */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterChangeDoseStrengthTalvMg" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternAfterChangeDoseStrengthTalvMgTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterAfterChangeDoseStrengthMg
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterChangeDoseStrengthTalvKg" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternAfterChangeDoseStrengthTalvKgTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterAfterChangeDoseStrengthMgKg
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg/kg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterChangeDoseStrengthTalvMM" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-custom"
                                                          id={idx}
                                                          name={
                                                            "patternAfterChangeDoseStrengthTalvMMTxt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.patterAfterChangeDoseStrengthMgM2
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                        <span>&nbsp;mg/m²</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "patternAfterChangeDoseStrengthTalvUnk" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternAfterStrengthEmpty
                                                    }
                                                    message="Please select strength pattern."
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.patternAfterStrengthRangeInvalid
                                                    }
                                                    message="Please enter units between 0.01 to 4000"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.strengthIncreaseConflict
                                                    }
                                                    message="After value should be greater than before for increase"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.strengthDecreaseConflict
                                                    }
                                                    message="After value should be less than before for decrease"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternAfterUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column F: Date of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "dateChangeRdTalv" + idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.dateChangeRd === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`dateChangeTalv-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={data.dateChange}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateChangeRdTalv" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.dateChangeRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Date of change unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeRdEmpty
                                                    }
                                                    message="Please select date option"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={data.dateChangeEmpty}
                                                    message="Please provide date of change"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeOutOfBound
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeBeforeEOF
                                                    }
                                                    message="Date must be before End of Follow-up"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))}

                            {/* Add button */}
                            {Q381ATalvDetails &&
                              !hideQ381TalvAdd &&
                              Q381ATalvDetails.length > 0 &&
                              Q381ATalvDetails.length < 50 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={AddQ381TalvRow}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another dose/frequency
                                      change
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}

                        {/* Q38.2.A start Tech */}
                        {isTechvayliSelected && isNewEcrfA == true && (
                          <div className="question question-weight">
                            <span>Q38.2.A</span>
                            <span className="quest-text-pad">
                              Please provide information on any{" "}
                              <i>dose interruptions or dose delays</i>, that
                              occurred from completion of the step-up dosing
                              phase until the end of the line of therapy with{" "}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isTechvayliSelected && (
                                  <>TECVAYLI® (teclistamab-cqyv)</>
                                )}
                              </span>{" "}
                              Add additional rows for each interruption/delay
                              that occurred.
                            </span>
                          </div>
                        )}

                        {/* Q38.2.A TECVAYLI */}
                        {isTechvayliSelected && isNewEcrfA && (
                          <div className="dependent-section">
                            {Q382ATechDetails &&
                              Q382ATechDetails.length > 0 &&
                              Q382ATechDetails.map((data, idx) => (
                                <div className="loop-section-ul" key={idx}>
                                  <div className="loop-head">
                                    <span
                                      className="question-weight"
                                      style={{ float: "inline-start" }}
                                    >
                                      {GetOrdinal(idx + 1)} Dose Interruption
                                    </span>
                                    {idx !== 0 && (
                                      <div
                                        className="delete-btn-div"
                                        style={{ float: "inline-end" }}
                                      >
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            DeleteQ382ATechRow(idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* Talv Table */}
                                  <div className="question-bot-sapce">
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "150px",
                                              }}
                                            >
                                              Type of change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "280px",
                                              }}
                                            >
                                              Reason for change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Start of dose interruption/delay
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              End of dose interruption/delay
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            {/* Column A: Treatment */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                TECVAYLI® (teclistamab-cqsyv)
                                              </span>
                                            </td>

                                            {/* Column B: Type of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {idx == 0 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "changeInterptTypeTech" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.changeType === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      No dose interruption or
                                                      delay occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "changeInterptTypeTech" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.changeType === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose interruption or delay
                                                  </span>
                                                </label>
                                              </div>
                                              {idx == 0 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "changeInterptTypeTech" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.changeType === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Unknown if dose
                                                      interruption or delay
                                                      occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <ErrorField
                                                show={data.colBError == true}
                                                message="Please select type of change"
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </td>

                                            {/* Column C: Reasons for change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 &&
                                              data.discontinuationReasons
                                                ?.length > 0 ? (
                                                <div>
                                                  {data.discontinuationReasons.map(
                                                    (reason, reasonIdx) => (
                                                      <div
                                                        key={reason.reasonid}
                                                      >
                                                        {/* Primary reason checkbox */}
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label className="option-fbox">
                                                            <input
                                                              type="checkbox"
                                                              name={
                                                                "tech_int_reason" +
                                                                idx
                                                              }
                                                              id={idx}
                                                              value={
                                                                reason.reasonid
                                                              }
                                                              checked={
                                                                reason.isSelected
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,

                                                                  reasonIdx,
                                                                  null,
                                                                )
                                                              }
                                                            />
                                                            <span
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {
                                                                reason.reasonName
                                                              }
                                                              {reason.supscripttext && (
                                                                <sup>
                                                                  {
                                                                    reason.supscripttext
                                                                  }
                                                                </sup>
                                                              )}
                                                            </span>
                                                          </label>
                                                        </div>

                                                        {/* Adverse Events (only if Adverse Event selected) */}
                                                        {reason.reasonName ===
                                                          DiscontinuationReason.AdverseEvent &&
                                                          reason.isSelected && (
                                                            <div
                                                              style={{
                                                                marginLeft:
                                                                  "24px",
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                            >
                                                              {data.adverseEventReasons?.map(
                                                                (ae, aeIdx) => {
                                                                  const isAEUnknown =
                                                                    ae.reasonName ===
                                                                    "AE type unknown";

                                                                  return (
                                                                    <div
                                                                      key={
                                                                        aeIdx
                                                                      }
                                                                      style={{
                                                                        alignItems:
                                                                          "flex-start",
                                                                      }}
                                                                    >
                                                                      <label className="option-fbox">
                                                                        <input
                                                                          type={
                                                                            isAEUnknown
                                                                              ? "radio"
                                                                              : "checkbox"
                                                                          }
                                                                          id={
                                                                            idx
                                                                          }
                                                                          name={`tech_int_adverse_${idx}`}
                                                                          checked={
                                                                            ae.isSelected
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            HandleRepeaterFieldChange(
                                                                              e,

                                                                              reasonIdx,
                                                                              aeIdx,
                                                                            )
                                                                          }
                                                                          style={{
                                                                            marginTop:
                                                                              "6px",
                                                                          }}
                                                                        />

                                                                        <span className="radio-text-padding">
                                                                          {
                                                                            ae.reasonName
                                                                          }
                                                                        </span>
                                                                      </label>
                                                                      {ae.reasonName ===
                                                                        DiscontinuationReason.NeurologicalEvent &&
                                                                        ae.isSelected && (
                                                                          <div
                                                                            style={{
                                                                              marginLeft:
                                                                                "28px",
                                                                              marginTop:
                                                                                "8px",
                                                                            }}
                                                                          >
                                                                            {data
                                                                              .neurologicAEReasonList
                                                                              ?.length >
                                                                              0 &&
                                                                              data.neurologicAEReasonList.map(
                                                                                (
                                                                                  aeNeuro,
                                                                                  aeNeuroIdx,
                                                                                ) => {
                                                                                  return (
                                                                                    <div
                                                                                      key={
                                                                                        aeNeuroIdx
                                                                                      }
                                                                                    >
                                                                                      <label
                                                                                        className="d-flex align-items-start"
                                                                                        htmlFor={`adverse_neuro_tech_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      >
                                                                                        <input
                                                                                          type="checkbox"
                                                                                          id={`adverse_neuro_tech_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          name={`adverse_neuro_tech_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          checked={
                                                                                            aeNeuro.isSelected
                                                                                          }
                                                                                          onChange={(
                                                                                            e,
                                                                                          ) =>
                                                                                            HandleNeuroRepeaterFieldChange(
                                                                                              e,
                                                                                              "382A",
                                                                                              RRMMCohortTreatment.TECVAYLI,
                                                                                              aeNeuroIdx,
                                                                                              idx,
                                                                                            )
                                                                                          }
                                                                                          style={{
                                                                                            marginTop:
                                                                                              "6px",
                                                                                          }}
                                                                                        />

                                                                                        <span
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                          className="radio-text-padding"
                                                                                        >
                                                                                          {
                                                                                            aeNeuro.reasonName
                                                                                          }
                                                                                        </span>
                                                                                      </label>

                                                                                      {aeNeuro.reasonName.includes(
                                                                                        "Other",
                                                                                      ) && (
                                                                                        <div>
                                                                                          <label
                                                                                            htmlFor={`neuro_reasontxt_tech_${reasonIdx}_${aeNeuroIdx}`}
                                                                                          >
                                                                                            <span
                                                                                              style={{
                                                                                                paddingLeft:
                                                                                                  "28px",
                                                                                              }}
                                                                                              className="radio-text-padding"
                                                                                            >
                                                                                              <textarea
                                                                                                style={{
                                                                                                  width:
                                                                                                    "264px",
                                                                                                }}
                                                                                                id={`neuro_reasontxt_tech_${reasonIdx}_${aeNeuroIdx}`}
                                                                                                name={`neuro_reasontxt_tech_${reasonIdx}_${aeNeuroIdx}`}
                                                                                                type="text"
                                                                                                value={
                                                                                                  aeNeuro.reasonText
                                                                                                }
                                                                                                onChange={(
                                                                                                  e,
                                                                                                ) =>
                                                                                                  HandleNeuroRepeaterFieldChange(
                                                                                                    e,
                                                                                                    "382A",
                                                                                                    RRMMCohortTreatment.TECVAYLI,
                                                                                                    aeNeuroIdx,
                                                                                                    idx,
                                                                                                  )
                                                                                                }
                                                                                                maxLength={
                                                                                                  300
                                                                                                }
                                                                                              />
                                                                                            </span>
                                                                                          </label>
                                                                                          <ErrorField
                                                                                            show={
                                                                                              data.neuroOtherTextEmpty
                                                                                            }
                                                                                            message={
                                                                                              TTCharacteristics_MSGS.Q38AENeurologicOther
                                                                                            }
                                                                                          />
                                                                                        </div>
                                                                                      )}
                                                                                    </div>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            <ErrorField
                                                                              show={
                                                                                data.neuroReasonEmpty
                                                                              }
                                                                              message={
                                                                                TTCharacteristics_MSGS.Q38AENeurologicEmpty
                                                                              }
                                                                            />
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}
                                                              <ErrorField
                                                                show={
                                                                  data.aeSubReasonEmpty
                                                                }
                                                                message={
                                                                  TTCharacteristics_MSGS.Q38AEEmpty
                                                                }
                                                              />
                                                            </div>
                                                          )}

                                                        {/* Other reason text */}
                                                        {reason.reasonName.includes(
                                                          "Other",
                                                        ) && (
                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            <textarea
                                                              className="input-dash"
                                                              id={idx}
                                                              name={
                                                                "reasonOtherText_Tec_int_" +
                                                                idx
                                                              }
                                                              value={
                                                                reason.reasonText ||
                                                                ""
                                                              }
                                                              onChange={(e) => {
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  reasonIdx,
                                                                );
                                                              }}
                                                              placeholder="Please specify"
                                                            />
                                                            <ErrorField
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                              show={
                                                                data.reasonOtherTextEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q38ReasonOtherEmpty
                                                              }
                                                            />
                                                          </div>
                                                        )}
                                                      </div>
                                                    ),
                                                  )}
                                                  <div className="">
                                                    <label className="option-fbox">
                                                      <input
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        type="radio"
                                                        id={idx}
                                                        name={`discont_unk_Tech_int_${idx}`}
                                                        value={true}
                                                        checked={
                                                          data
                                                            .discontinuationReasons[0]
                                                            .reasonUnk
                                                            ? true
                                                            : ""
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            idx,
                                                            null,
                                                            null,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                        className="radio-text-padding"
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={data.colCError}
                                                    message={
                                                      TTCharacteristics_MSGS.Q38ReasonEmpty
                                                    }
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.discontinuationSoftError ==
                                                      true
                                                    }
                                                    message={
                                                      "WARNING: you have indicated that at least 1 reason for medication discontinuation was death however no date of death is reported in Q20. Please revise the reason for medication discontinuation to a reason besides death or otherwise add a date of death in Q20."
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                <span className="not-applicable">
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column D: Start of dose interruption*/}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "dateStrtChangeRdTechInt" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.startDoseDtRd === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`dateStrtChangeTechInt-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={data.startDoseDt}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateStrtChangeRdTechInt" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.startDoseDtRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Start date of dose
                                                        interruption or delay
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.colDError == true
                                                    }
                                                    message="Please select start of dose interruption/delay"
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidstartDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.startDateChangeOutOfBound
                                                    }
                                                    message="Date must be between Index Date and End of Follow-up"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.interruptionStartDateUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q382AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column E: End of dose interruption */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  {/* Frequency Pattern AFTER */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateEndChangeRdTechInt" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.endDoseDtRd === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Dose interruption or
                                                        delay ongoing
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "dateEndChangeRdTechInt" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.endDoseDtRd === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`dateEndChangeTechInt-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={data.endDoseDt}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateEndChangeRdTechInt" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.endDoseDtRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        End date of dose
                                                        interruption or delay
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.colFError == true
                                                    }
                                                    message="Please select end of dose interruption/delay"
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.interruptionEndDateUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q382AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidEndDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.endDateChangeOutOfBound
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))}

                            {/* Add button */}
                            {Q382ATechDetails &&
                              !hideQ382TechAdd &&
                              Q382ATechDetails.length > 0 &&
                              Q382ATechDetails.length < 50 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={AddQ382TechRow}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another dose/frequency
                                      change
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}

                        {/* Q38.2.A End */}
                        {/* Q38.2.A start Tech */}
                        {isTalveySelected && isNewEcrfA == true && (
                          <div className="question question-weight">
                            <span>Q38.2.A</span>
                            <span className="quest-text-pad">
                              Please provide information on any{" "}
                              <i>dose interruptions or dose delays</i>, that
                              occurred from completion of the step-up dosing
                              phase until the end of the line of therapy with{" "}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isTalveySelected && (
                                  <>
                                    TALVEY <sup className="supscript">TM</sup>{" "}
                                    (talquetamab-tgvs)
                                  </>
                                )}
                              </span>{" "}
                              Add additional rows for each interruption/delay
                              that occurred.
                            </span>
                          </div>
                        )}
                        {/* Q38.2.A TALVEY */}
                        {isTalveySelected && isNewEcrfA && (
                          <div className="dependent-section">
                            {Q382ATalvDetails &&
                              Q382ATalvDetails.length > 0 &&
                              Q382ATalvDetails.map((data, idx) => (
                                <div className="loop-section-ul" key={idx}>
                                  <div className="loop-head">
                                    <span
                                      className="question-weight"
                                      style={{ float: "inline-start" }}
                                    >
                                      {GetOrdinal(idx + 1)} Dose Interruption
                                    </span>
                                    {idx !== 0 && (
                                      <div
                                        className="delete-btn-div"
                                        style={{ float: "inline-end" }}
                                      >
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            DeleteQ382ATalvRow(idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* Talv Table */}
                                  <div className="question-bot-sapce">
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "150px",
                                              }}
                                            >
                                              Type of change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "280px",
                                              }}
                                            >
                                              Reason for change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Start of dose interruption/delay
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              End of dose interruption/delay
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            {/* Column A: Treatment */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                TALVEY
                                                <sup className="supscript">
                                                  TM
                                                </sup>{" "}
                                                (talquetamab-tgvs)
                                              </span>
                                            </td>

                                            {/* Column B: Type of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {idx == 0 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "changeInterptTypeTalv" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.changeType === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      No dose interruption or
                                                      delay occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}

                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "changeInterptTypeTalv" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.changeType === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose interruption or delay
                                                  </span>
                                                </label>
                                              </div>
                                              {idx == 0 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "changeInterptTypeTalv" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.changeType === 99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Unknown if dose
                                                      interruption or delay
                                                      occurred
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                              <ErrorField
                                                show={data.colBError == true}
                                                message="Please select type of change"
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </td>

                                            {/* Column C: Reasons for change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 &&
                                              data.discontinuationReasons
                                                ?.length > 0 ? (
                                                <div>
                                                  {data.discontinuationReasons.map(
                                                    (reason, reasonIdx) => (
                                                      <div
                                                        key={reason.reasonid}
                                                      >
                                                        {/* Primary reason checkbox */}
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label className="option-fbox">
                                                            <input
                                                              type="checkbox"
                                                              name={
                                                                "talv_int_reason" +
                                                                idx
                                                              }
                                                              id={idx}
                                                              value={
                                                                reason.reasonid
                                                              }
                                                              checked={
                                                                reason.isSelected
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,

                                                                  reasonIdx,
                                                                  null,
                                                                )
                                                              }
                                                            />
                                                            <span
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {
                                                                reason.reasonName
                                                              }
                                                              {reason.supscripttext && (
                                                                <sup>
                                                                  {
                                                                    reason.supscripttext
                                                                  }
                                                                </sup>
                                                              )}
                                                            </span>
                                                          </label>
                                                        </div>

                                                        {/* Adverse Events (only if Adverse Event selected) */}
                                                        {reason.reasonName ===
                                                          DiscontinuationReason.AdverseEvent &&
                                                          reason.isSelected && (
                                                            <div
                                                              style={{
                                                                marginLeft:
                                                                  "24px",
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                            >
                                                              {data.adverseEventReasons?.map(
                                                                (ae, aeIdx) => {
                                                                  const isAEUnknown =
                                                                    ae.reasonName ===
                                                                    "AE type unknown";

                                                                  return (
                                                                    <div
                                                                      key={
                                                                        aeIdx
                                                                      }
                                                                      style={{
                                                                        alignItems:
                                                                          "flex-start",
                                                                      }}
                                                                    >
                                                                      <label className="option-fbox">
                                                                        <input
                                                                          type={
                                                                            isAEUnknown
                                                                              ? "radio"
                                                                              : "checkbox"
                                                                          }
                                                                          id={
                                                                            idx
                                                                          }
                                                                          name={`talv_int_adverse_${idx}`}
                                                                          checked={
                                                                            ae.isSelected
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            HandleRepeaterFieldChange(
                                                                              e,

                                                                              reasonIdx,
                                                                              aeIdx,
                                                                            )
                                                                          }
                                                                          style={{
                                                                            marginTop:
                                                                              "6px",
                                                                          }}
                                                                        />

                                                                        <span className="radio-text-padding">
                                                                          {
                                                                            ae.reasonName
                                                                          }
                                                                        </span>
                                                                      </label>
                                                                      {ae.reasonName ===
                                                                        DiscontinuationReason.NeurologicalEvent &&
                                                                        ae.isSelected && (
                                                                          <div
                                                                            style={{
                                                                              marginLeft:
                                                                                "28px",
                                                                              marginTop:
                                                                                "8px",
                                                                            }}
                                                                          >
                                                                            {data
                                                                              .neurologicAEReasonList
                                                                              ?.length >
                                                                              0 &&
                                                                              data.neurologicAEReasonList.map(
                                                                                (
                                                                                  aeNeuro,
                                                                                  aeNeuroIdx,
                                                                                ) => {
                                                                                  return (
                                                                                    <div
                                                                                      key={
                                                                                        aeNeuroIdx
                                                                                      }
                                                                                    >
                                                                                      <label
                                                                                        className="d-flex align-items-start"
                                                                                        htmlFor={`adverse_neuro_tal_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      >
                                                                                        <input
                                                                                          type="checkbox"
                                                                                          id={`adverse_neuro_tal_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          name={`adverse_neuro_tal_${reasonIdx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          checked={
                                                                                            aeNeuro.isSelected
                                                                                          }
                                                                                          onChange={(
                                                                                            e,
                                                                                          ) =>
                                                                                            HandleNeuroRepeaterFieldChange(
                                                                                              e,
                                                                                              "382A",
                                                                                              RRMMCohortTreatment.TALVEY,
                                                                                              aeNeuroIdx,
                                                                                              idx,
                                                                                            )
                                                                                          }
                                                                                          style={{
                                                                                            marginTop:
                                                                                              "6px",
                                                                                          }}
                                                                                        />

                                                                                        <span
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                          className="radio-text-padding"
                                                                                        >
                                                                                          {
                                                                                            aeNeuro.reasonName
                                                                                          }
                                                                                        </span>
                                                                                      </label>

                                                                                      {aeNeuro.reasonName.includes(
                                                                                        "Other",
                                                                                      ) && (
                                                                                        <div>
                                                                                          <label
                                                                                            htmlFor={`neuro_reasontxt_tal_${reasonIdx}_${aeNeuroIdx}`}
                                                                                          >
                                                                                            <span
                                                                                              style={{
                                                                                                paddingLeft:
                                                                                                  "28px",
                                                                                              }}
                                                                                              className="radio-text-padding"
                                                                                            >
                                                                                              <textarea
                                                                                                style={{
                                                                                                  width:
                                                                                                    "264px",
                                                                                                }}
                                                                                                id={`neuro_reasontxt_tal_${reasonIdx}_${aeNeuroIdx}`}
                                                                                                name={`neuro_reasontxt_tal_${reasonIdx}_${aeNeuroIdx}`}
                                                                                                type="text"
                                                                                                value={
                                                                                                  aeNeuro.reasonText
                                                                                                }
                                                                                                onChange={(
                                                                                                  e,
                                                                                                ) =>
                                                                                                  HandleNeuroRepeaterFieldChange(
                                                                                                    e,
                                                                                                    "382A",
                                                                                                    RRMMCohortTreatment.TALVEY,
                                                                                                    aeNeuroIdx,
                                                                                                    idx,
                                                                                                  )
                                                                                                }
                                                                                                maxLength={
                                                                                                  300
                                                                                                }
                                                                                              />
                                                                                            </span>
                                                                                          </label>
                                                                                          <ErrorField
                                                                                            show={
                                                                                              data.neuroOtherTextEmpty
                                                                                            }
                                                                                            message={
                                                                                              TTCharacteristics_MSGS.Q38AENeurologicOther
                                                                                            }
                                                                                          />
                                                                                        </div>
                                                                                      )}
                                                                                    </div>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            <ErrorField
                                                                              show={
                                                                                data.neuroReasonEmpty
                                                                              }
                                                                              message={
                                                                                TTCharacteristics_MSGS.Q38AENeurologicEmpty
                                                                              }
                                                                            />
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}
                                                              <ErrorField
                                                                show={
                                                                  data.aeSubReasonEmpty
                                                                }
                                                                message={
                                                                  TTCharacteristics_MSGS.Q38AEEmpty
                                                                }
                                                              />
                                                            </div>
                                                          )}

                                                        {/* Other reason text */}
                                                        {reason.reasonName.includes(
                                                          "Other",
                                                        ) && (
                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            <textarea
                                                              className="input-dash"
                                                              id={idx}
                                                              name={
                                                                "reasonOtherText_Talv_int_" +
                                                                idx
                                                              }
                                                              value={
                                                                reason.reasonText ||
                                                                ""
                                                              }
                                                              onChange={(e) => {
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  reasonIdx,
                                                                );
                                                              }}
                                                              placeholder="Please specify"
                                                            />
                                                            <ErrorField
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                              show={
                                                                data.reasonOtherTextEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q38ReasonOtherEmpty
                                                              }
                                                            />
                                                          </div>
                                                        )}
                                                      </div>
                                                    ),
                                                  )}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                        id={idx}
                                                        name={`discont_unk_Talv_int_${idx}`}
                                                        value={true}
                                                        checked={
                                                          data
                                                            .discontinuationReasons[0]
                                                            .reasonUnk
                                                            ? true
                                                            : ""
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            idx,
                                                            null,
                                                            null,
                                                          )
                                                        }
                                                      />

                                                      <span className="radio-text-padding">
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={data.colCError}
                                                    message={
                                                      TTCharacteristics_MSGS.Q38ReasonEmpty
                                                    }
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.discontinuationSoftError ==
                                                      true
                                                    }
                                                    message={
                                                      "WARNING: you have indicated that at least 1 reason for medication discontinuation was death however no date of death is reported in Q20. Please revise the reason for medication discontinuation to a reason besides death or otherwise add a date of death in Q20."
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                <span className="not-applicable">
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column D: Start of dose interruption*/}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  {/* Frequency Pattern */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "dateStrtChangeRdTalvInt" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.startDoseDtRd === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`dateStrtChangeTalvInt-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={data.startDoseDt}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateStrtChangeRdTalvInt" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.startDoseDtRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Start date of dose
                                                        interruption or delay
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.colDError == true
                                                    }
                                                    message="Please select start of dose interruption/delay"
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.interruptionStartDateUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q382AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidstartDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.startDateChangeOutOfBound
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column E: End of dose interruption */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  {/* Frequency Pattern AFTER */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateEndChangeRdTalvInt" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.endDoseDtRd === 1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Dose interruption or
                                                        delay ongoing
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "dateEndChangeRdTalvInt" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.endDoseDtRd === 2
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`dateEndChangeTalvInt-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={data.endDoseDt}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateEndChangeRdTalvInt" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.endDoseDtRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        End date of dose
                                                        interruption or delay
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.colFError == true
                                                    }
                                                    message="Please select end of dose interruption/delay"
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.interruptionEndDateUnknownWarning
                                                    }
                                                    message={
                                                      TTCharacteristics_MSGS.Q382AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidEndDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.endDateChangeOutOfBound
                                                    }
                                                    message="Date must be between Index Date and End of Follow-up"
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))}

                            {/* Add button */}
                            {Q382ATalvDetails &&
                              !hideQ382TalvAdd &&
                              Q382ATalvDetails.length > 0 &&
                              Q382ATalvDetails.length < 50 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={AddQ382TalvRow}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another dose/frequency
                                      change
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                        {/* Question 39  start*/}

                        {/* show if Techvayli selected */}
                        <div className="">
                          {isTechvayliSelected &&
                            Q37TechDetails &&
                            Q37TechDetails.length > 0 &&
                            Q37TechDetails.map((data, idx) => (
                              <React.Fragment key={idx}>
                                <div className="sub-question-bot-sapce ">
                                  <div className="question question-weight">
                                    <span>Q39.</span>
                                    <span className="quest-text-pad">
                                      Which medications were used, if any,
                                      during the <b>step-up dosing phase</b> of{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        TECVAYLI® (teclistamab-cqyv)
                                      </span>{" "}
                                      i.e from
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        {" "}
                                        {showTechDate()}{" "}
                                      </span>
                                      until the end of step-up dosing?{" "}
                                      <i>Select all that apply.</i>
                                      <br />
                                      If you cannot determine if an
                                      administration is part of the{" "}
                                      <strong>Step-Up Dosing Phase, </strong>
                                      please infer the dosing phase using the
                                      TECVAYLI® (teclistamab-cqyv) dosing label
                                      information provided.
                                    </span>
                                  </div>
                                  <div className="radio-text-padding">
                                    <div className="double-dig-answer">
                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"tocilizumab_tech" + idx}
                                            checked={data.tocilizumab_tech}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Tocilizumab
                                          </span>
                                        </label>
                                      </div>

                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"granulocyte_tech" + idx}
                                            checked={data.granulocyte_tech}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Granulocyte colony-stimulating
                                            factor (G-CSF)
                                          </span>
                                        </label>
                                      </div>
                                      {/* Phase 2  */}
                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"steroids_tech" + idx}
                                            checked={data.steroids_tech}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Steroids
                                          </span>
                                        </label>
                                      </div>

                                      <div className="option-without-input">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={"noneoftheabove_tech" + idx}
                                            value={99}
                                            checked={
                                              data.noneoftheabove_tech === 99
                                            }
                                            onChange={HandleFieldChange}
                                          />

                                          <span className="radio-text-padding">
                                            None of the above{" "}
                                          </span>
                                        </label>
                                      </div>
                                      <ErrorField
                                        show={data.q39TechEmptyHard}
                                        message={
                                          TTCharacteristics_MSGS.Q39TechEmptyHard
                                        }
                                        style={{
                                          paddingLeft: "0px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Q39.1 */}
                                {data.tocilizumab_tech && !isNewEcrfA && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.1.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why Tocilizumab
                                        was used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          TECVAYLI® (teclistamab-cqyv)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      {/* TECVAYLI® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "20%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "15%",
                                                  }}
                                                >
                                                  Medication
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "45%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {/* Tecvayli */}

                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    TECVAYLI® (teclistamab-cqyv)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Tocilizumab
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "cytokin_tech" + idx
                                                          }
                                                          checked={
                                                            data.cytokin_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          for cytokine release
                                                          syndrome (CRS)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_crs_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_crs_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          for CRS
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "crs_tech" + idx
                                                          }
                                                          checked={
                                                            data.crs_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          CRS
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "neurotoxicity_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.neurotoxicity_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_neurotoxicity_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_neurotoxicity_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "tmt_neurotoxicity_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_neurotoxicity_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tmt_tech_unknown" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_tech_unknown
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.q39TechReasonHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q39TechReasonHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* Q39.1.A */}
                                {data.tocilizumab_tech && isNewEcrfA && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.1.A.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why tocilizumab
                                        was used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          TECVAYLI® (teclistamab-cqyv)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-section">
                                      <ErrorField
                                        show={
                                          q391ATechAdministrationDateOutOfRange
                                        }
                                        message={
                                          TTCharacteristics_MSGS.Q391AAdministrationDateOutOfRange
                                        }
                                        style={{
                                          paddingLeft: "0px",
                                          paddingBottom: "10px",
                                          paddingTop: "0px",
                                        }}
                                      />
                                      {/* TECVAYLI */}
                                      {q391ATechTocilzumabList?.length > 0 &&
                                        q391ATechTocilzumabList.map(
                                          (itm, index) => (
                                            <div
                                              className="loop-section-ul"
                                              key={index}
                                            >
                                              <div className="loop-head">
                                                <span
                                                  className="question-weight"
                                                  style={{
                                                    float: "inline-start",
                                                  }}
                                                >
                                                  {GetOrdinal(index + 1)}{" "}
                                                  TECVAYLI® (teclistamab-cqyv)
                                                </span>
                                                {index !== 0 && (
                                                  <div
                                                    className="delete-btn-div"
                                                    style={{
                                                      float: "inline-end",
                                                    }}
                                                  >
                                                    <img
                                                      width="16px"
                                                      src="../Assets/images/Icon-material-delete.png"
                                                      alt=""
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        DeleteQ391ARow(
                                                          index,
                                                          RRMMCohortTreatment.TECVAYLI,
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              </div>
                                              <div className="question-bot-sapce">
                                                <div className="sub-question grid-overflow">
                                                  <table
                                                    style={{
                                                      border: "1px solid black",
                                                      borderCollapse:
                                                        "collapse",
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "20%",
                                                          }}
                                                        >
                                                          Treatment
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "15%",
                                                          }}
                                                        >
                                                          Medication
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "15%",
                                                          }}
                                                        >
                                                          Date of tocilizumab
                                                          administration
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "45%",
                                                          }}
                                                        >
                                                          Reason for receiving
                                                          medication
                                                        </th>
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <span className="quest-text-pad">
                                                            TECVAYLI®
                                                            (teclistamab-cqyv)
                                                          </span>
                                                        </td>

                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <label className="option-fbox">
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                }}
                                                              >
                                                                Tocilizumab
                                                              </span>
                                                            </label>
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={index}
                                                                name={
                                                                  "administrationDateRD_tech" +
                                                                  index
                                                                }
                                                                value={1}
                                                                checked={
                                                                  itm.administrationDateRD_tech ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                <DatePickerComponent
                                                                  ctrlId={
                                                                    "administrationDate_tech-" +
                                                                    index
                                                                  }
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  optionId={1}
                                                                  minDate={dayjs(
                                                                    "01-01-1920",
                                                                  )}
                                                                  maxDate={dayjs()}
                                                                  locale="en"
                                                                  date={
                                                                    itm.administrationDate_tech
                                                                  }
                                                                />
                                                              </span>
                                                            </div>

                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  id={index}
                                                                  name={
                                                                    "administrationDateRD_tech" +
                                                                    index
                                                                  }
                                                                  value={99}
                                                                  checked={
                                                                    itm.administrationDateRD_tech ===
                                                                    99
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                    marginLeft:
                                                                      "-5px",
                                                                  }}
                                                                >
                                                                  Date of
                                                                  administration
                                                                  unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <ErrorField
                                                              show={
                                                                itm.q39TechAdministrationRDEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q40Init_RdHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                itm.q39TechAdministrationDateEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q391ATocilizumabAdministrationDateEmty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                itm.q39TechInvalidAdministrationDate
                                                              }
                                                              message={
                                                                CommonError_Msgs.InvalidDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "primaryProphylacticCrs_tech" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.primaryProphylacticCrs_tech
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Primary
                                                                  prophylactic
                                                                  for cytokine
                                                                  release
                                                                  syndrome (CRS)
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "secondaryProphylacticCrs_tech" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.secondaryProphylacticCrs_tech
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Secondary
                                                                  prophylactic
                                                                  for CRS
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "supportiveCareCrs_tech" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.supportiveCareCrs_tech
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Treatment or
                                                                  supportive
                                                                  care for CRS
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "primaryProphylacticNeurologic_tech" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.primaryProphylacticNeurologic_tech
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Primary
                                                                  prophylactic
                                                                  for neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "secondaryProphylacticNeurologic_tech" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.secondaryProphylacticNeurologic_tech
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Secondary
                                                                  prophylactic
                                                                  for neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "supportiveCareNeurologic_tech" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.supportiveCareNeurologic_tech
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Treatment or
                                                                  supportive
                                                                  care for
                                                                  neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="radio"
                                                                  id={index}
                                                                  name={
                                                                    "medicationReasonUnk_tech" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.medicationReasonUnk_tech
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <ErrorField
                                                              show={
                                                                itm.q39TechReasonEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q39TechReasonHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          ),
                                        )}

                                      {q391ATechTocilzumabList?.length > 0 &&
                                        q391ATechTocilzumabList?.length <
                                          550 && (
                                          <div className="sub-question-bot-sapce-ul mt-2">
                                            <div
                                              className="answer-list-text"
                                              onClick={() =>
                                                AddQ391ARow(
                                                  RRMMCohortTreatment.TECVAYLI,
                                                )
                                              }
                                            >
                                              <a>
                                                <img
                                                  width="18px"
                                                  src="../Assets/images/plus.png"
                                                  alt=""
                                                />
                                              </a>
                                              <a className="radio-text-padding">
                                                Click here to add another
                                                tocilizumab administration of
                                                teclistamab
                                              </a>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                )}

                                {/* Q39.2  */}
                                {data.steroids_tech && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.2.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why steroids were
                                        used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          TECVAYLI® (teclistamab-cqyv)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      {/* TECVAYLI® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Medication
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "35%",
                                                  }}
                                                >
                                                  Name and dose of the
                                                  steroid(s) used
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "50%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {/* Tecvayli */}
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    TECVAYLI® (teclistamab-cqyv)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label>
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Steroids
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                {/* Start */}

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "betamethasone_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.betamethasone_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Betamethasone (total
                                                          dose:
                                                          <input
                                                            className="sub-input-dash-num"
                                                            id={idx}
                                                            name={
                                                              "betamethasone_techNum" +
                                                              idx
                                                            }
                                                            type="text"
                                                            value={
                                                              data.betamethasone_techNum
                                                            }
                                                            onKeyDown={
                                                              AllowOnlyNonZeroNumeric
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                            maxLength={10}
                                                          />
                                                          mg)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "dexamethasone_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.dexamethasone_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Dexamethasone (total
                                                          dose:
                                                          <input
                                                            className="sub-input-dash-num"
                                                            id={idx}
                                                            name={
                                                              "dexamethasone_techNum" +
                                                              idx
                                                            }
                                                            type="text"
                                                            value={
                                                              data.dexamethasone_techNum
                                                            }
                                                            onKeyDown={
                                                              AllowOnlyNonZeroNumeric
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                            maxLength={10}
                                                          />
                                                          mg)
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="option-fbox">
                                                        <input
                                                          type="checkbox"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "hydrocortisone_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.hydrocortisone_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Hydrocortisone (oral
                                                          or intravenous only)
                                                          <br></br>(total dose:
                                                          <input
                                                            className="sub-input-dash-num"
                                                            id={idx}
                                                            name={
                                                              "hydrocortisone_techNum" +
                                                              idx
                                                            }
                                                            type="text"
                                                            value={
                                                              data.hydrocortisone_techNum
                                                            }
                                                            onKeyDown={
                                                              AllowOnlyNonZeroNumeric
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                            maxLength={10}
                                                          />
                                                          mg)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "methylprednisolone" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.methylprednisolone
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Methylprednisolone
                                                          (total dose:
                                                          <input
                                                            className="sub-input-dash-num"
                                                            id={idx}
                                                            name={
                                                              "methylprednisoloneNum" +
                                                              idx
                                                            }
                                                            type="text"
                                                            value={
                                                              data.methylprednisoloneNum
                                                            }
                                                            onKeyDown={
                                                              AllowOnlyNonZeroNumeric
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                            maxLength={10}
                                                          />
                                                          mg)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "prednisolone_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.prednisolone_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Prednisolone (total
                                                          dose:
                                                          <input
                                                            className="sub-input-dash-num"
                                                            id={idx}
                                                            name={
                                                              "prednisolone_techNum" +
                                                              idx
                                                            }
                                                            type="text"
                                                            value={
                                                              data.prednisolone_techNum
                                                            }
                                                            onKeyDown={
                                                              AllowOnlyNonZeroNumeric
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                            maxLength={10}
                                                          />
                                                          mg)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "prednisone_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.prednisone_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Prednisone (total
                                                          dose:
                                                          <input
                                                            className="sub-input-dash-num"
                                                            id={idx}
                                                            name={
                                                              "prednisone_techNum" +
                                                              idx
                                                            }
                                                            type="text"
                                                            value={
                                                              data.prednisone_techNum
                                                            }
                                                            onKeyDown={
                                                              AllowOnlyNonZeroNumeric
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                            maxLength={10}
                                                          />
                                                          mg)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "triamcinolone_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.triamcinolone_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Triamcinolone (total
                                                          dose:
                                                          <input
                                                            className="sub-input-dash-num"
                                                            id={idx}
                                                            name={
                                                              "triamcinolone_techNum" +
                                                              idx
                                                            }
                                                            type="text"
                                                            value={
                                                              data.triamcinolone_techNum
                                                            }
                                                            onKeyDown={
                                                              AllowOnlyNonZeroNumeric
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                            maxLength={10}
                                                          />
                                                          mg)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dose_name_tech_unknown" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.dose_name_tech_unknown
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.name_dose_steroidsHardEmpty
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.name_dose_steroidsHardEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.steroids_tech_txtEmpty
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.steroids_tech_txtEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                {/* End */}

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "steroid_pre_tmt_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.steroid_pre_tmt_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          As a pre-treatment per
                                                          label recommendation
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "cytokin_tech_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.cytokin_tech_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Primary prophylactic
                                                          for cytokine release
                                                          syndrome (CRS)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_tech_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_tech_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Secondary prophylactic
                                                          for CRS
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "crs_tech_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.crs_tech_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          CRS
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "neurotoxicity_tech_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.neurotoxicity_tech_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Primary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_neurotoxicity_tech_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_neurotoxicity_tech_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Secondary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "tmt_neurotoxicity_tech_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_neurotoxicity_tech_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Treatment or
                                                          supportive care for
                                                          neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tmt_steroids_tech_unknown" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_steroids_tech_unknown
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.q39TechSteroidsEmptyHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q39TechSteroidsEmptyHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* Q39.3 */}

                                {data.granulocyte_tech && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.3.</span>
                                      <span className="quest-text-pad">
                                        Why was G-CSF used while receiving
                                        treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          TECVAYLI® (teclistamab-cqyv)
                                        </span>
                                        ? <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      {/* TECVAYLI® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "25%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "25%",
                                                  }}
                                                >
                                                  Medication
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "45%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {/* Tecvayli */}
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    TECVAYLI® (teclistamab-cqyv)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label>
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Granulocyte
                                                        colony-stimulating
                                                        factor (G-CSF)
                                                      </span>
                                                    </label>
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "prophylactic_use_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.prophylactic_use_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          use
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_use_tech" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_use_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          use
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "oth_use_tech" + idx
                                                          }
                                                          checked={
                                                            data.oth_use_tech
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Other use
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          value={99}
                                                          name={
                                                            "unknown_tech" + idx
                                                          }
                                                          checked={
                                                            data.unknown_tech ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.q39TechGranulocyteEmptyHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q39GranulocyteEmptyHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            ))}
                        </div>

                        {/* -------------------- */}
                        {/*Show if Talvey selected  */}
                        <div className="">
                          {isTalveySelected &&
                            Q37TalDetails &&
                            Q37TalDetails.length > 0 &&
                            Q37TalDetails.map((data, idx) => (
                              <React.Fragment key={idx}>
                                <div className="sub-question-bot-sapce">
                                  <div className="question question-weight">
                                    <span>Q39.</span>
                                    <span className="quest-text-pad">
                                      Which medications were used, if any,
                                      during the <b>step-up dosing phase</b> of{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        TALVEY
                                        <sup className="supscript">TM</sup>{" "}
                                        (talquetamab-tgvs)
                                      </span>{" "}
                                      i.e from
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        {" "}
                                        {showTalDate()}{" "}
                                      </span>
                                      <span>
                                        until the end of step-up dosing?
                                      </span>{" "}
                                      <i>Select all that apply.</i>
                                      <br />
                                      If you cannot determine if an
                                      administration is part of the{" "}
                                      <strong>Step-Up Dosing Phase, </strong>
                                      please infer the dosing phase using the
                                      TALVEY
                                      <sup className="supscript">TM</sup>{" "}
                                      (talquetamab-tgvs) dosing label
                                      information provided.
                                    </span>
                                  </div>

                                  <div className="radio-text-padding">
                                    <div className="double-dig-answer">
                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"tocilizumab_tal" + idx}
                                            checked={data.tocilizumab_tal}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Tocilizumab
                                          </span>
                                        </label>
                                      </div>
                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"granulocyte_tal" + idx}
                                            checked={data.granulocyte_tal}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Granulocyte colony-stimulating
                                            factor (G-CSF)
                                          </span>
                                        </label>
                                      </div>

                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"steroids_tal" + idx}
                                            checked={data.steroids_tal}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Steroids
                                          </span>
                                        </label>
                                      </div>

                                      <div className="option-without-input">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={"noneoftheabove_tal" + idx}
                                            value={99}
                                            checked={
                                              data.noneoftheabove_tal === 99
                                            }
                                            onChange={HandleFieldChange}
                                          />

                                          <span className="radio-text-padding">
                                            None of the above{" "}
                                          </span>
                                        </label>
                                      </div>
                                      <ErrorField
                                        show={data.q39TalEmptyHard}
                                        message={
                                          TTCharacteristics_MSGS.Q39TalEmptyHard
                                        }
                                        style={{
                                          paddingLeft: "0px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Q39.1 */}
                                {data.tocilizumab_tal && !isNewEcrfA && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.1.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why Tocilizumab
                                        was used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          TALVEY
                                          <sup className="supscript">
                                            TM
                                          </sup>{" "}
                                          (talquetamab-tgvs)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      {/* TECVAYLI® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question  grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "20%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "15%",
                                                  }}
                                                >
                                                  Medication
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "45%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {/* Tecvayli */}
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    TALVEY
                                                    <sup className="supscript">
                                                      TM
                                                    </sup>{" "}
                                                    (talquetamab-tgvs)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label>
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Tocilizumab
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "cytokin_tal" + idx
                                                          }
                                                          checked={
                                                            data.cytokin_tal
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          for cytokine release
                                                          syndrome (CRS)
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_crs_tal" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_crs_tal
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          for CRS
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={"crs_tal" + idx}
                                                          checked={data.crs_tal}
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          CRS
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "neurotoxicity_tal" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.neurotoxicity_tal
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_neurotoxicity_tal" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_neurotoxicity_tal
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "tmt_neurotoxicity_tal" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_neurotoxicity_tal
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tmt_talvey_unknown" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_talvey_unknown
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.q39TalReasonHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q39TalReasonHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {/* Q39.1.A */}
                                {data.tocilizumab_tal && isNewEcrfA && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.1.A.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why tocilizumab
                                        was used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          TALVEY
                                          <sup className="supscript">
                                            TM
                                          </sup>{" "}
                                          (talquetamab-tgvs)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-section">
                                      <ErrorField
                                        show={
                                          q391ATalAdministrationDateOutOfRange
                                        }
                                        message={
                                          TTCharacteristics_MSGS.Q391AAdministrationDateOutOfRange
                                        }
                                        style={{
                                          paddingLeft: "0px",
                                          paddingBottom: "10px",
                                          paddingTop: "0px",
                                        }}
                                      />
                                      {/* TALVEY */}
                                      {q391ATalTocilzumabList?.length > 0 &&
                                        q391ATalTocilzumabList.map(
                                          (itm, index) => (
                                            <div
                                              className="loop-section-ul"
                                              key={index}
                                            >
                                              <div className="loop-head">
                                                <span
                                                  className="question-weight"
                                                  style={{
                                                    float: "inline-start",
                                                  }}
                                                >
                                                  {GetOrdinal(index + 1)} TALVEY
                                                  <sup className="supscript">
                                                    TM
                                                  </sup>{" "}
                                                  (talquetamab-tgvs)
                                                </span>
                                                {index !== 0 && (
                                                  <div
                                                    className="delete-btn-div"
                                                    style={{
                                                      float: "inline-end",
                                                    }}
                                                  >
                                                    <img
                                                      width="16px"
                                                      src="../Assets/images/Icon-material-delete.png"
                                                      alt=""
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        DeleteQ391ARow(
                                                          index,
                                                          RRMMCohortTreatment.TALVEY,
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              </div>
                                              <div className="question-bot-sapce">
                                                <div className="sub-question grid-overflow">
                                                  <table
                                                    style={{
                                                      border: "1px solid black",
                                                      borderCollapse:
                                                        "collapse",
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "20%",
                                                          }}
                                                        >
                                                          Treatment
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "15%",
                                                          }}
                                                        >
                                                          Medication
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "15%",
                                                          }}
                                                        >
                                                          Date of tocilizumab
                                                          administration
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "45%",
                                                          }}
                                                        >
                                                          Reason for receiving
                                                          medication
                                                        </th>
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <span className="quest-text-pad">
                                                            TALVEY
                                                            <sup className="supscript">
                                                              TM
                                                            </sup>{" "}
                                                            (talquetamab-tgvs)
                                                          </span>
                                                        </td>

                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div>
                                                              <div
                                                                className="option-without-input"
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label className="option-fbox">
                                                                  <span
                                                                    className="radio-text-padding"
                                                                    style={{
                                                                      paddingLeft:
                                                                        "10px",
                                                                    }}
                                                                  >
                                                                    Tocilizumab
                                                                  </span>
                                                                </label>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={index}
                                                                name={
                                                                  "administrationDateRD_tal" +
                                                                  index
                                                                }
                                                                value={1}
                                                                checked={
                                                                  itm.administrationDateRD_tal ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                <DatePickerComponent
                                                                  ctrlId={
                                                                    "administrationDate_tal-" +
                                                                    index
                                                                  }
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  optionId={1}
                                                                  minDate={dayjs(
                                                                    "01-01-1920",
                                                                  )}
                                                                  maxDate={dayjs()}
                                                                  locale="en"
                                                                  date={
                                                                    itm.administrationDate_tal
                                                                  }
                                                                />
                                                              </span>
                                                            </div>

                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  id={index}
                                                                  name={
                                                                    "administrationDateRD_tal" +
                                                                    index
                                                                  }
                                                                  value={99}
                                                                  checked={
                                                                    itm.administrationDateRD_tal ===
                                                                    99
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                    marginLeft:
                                                                      "-5px",
                                                                  }}
                                                                >
                                                                  Date of
                                                                  administration
                                                                  unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <ErrorField
                                                              show={
                                                                itm.q39TalAdministrationRDEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q40Init_RdHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                itm.q39TalAdministrationDateEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q391ATocilizumabAdministrationDateEmty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                itm.q39TalInvalidAdministrationDate
                                                              }
                                                              message={
                                                                CommonError_Msgs.InvalidDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "primaryProphylacticCrs_tal" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.primaryProphylacticCrs_tal
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Primary
                                                                  prophylactic
                                                                  for cytokine
                                                                  release
                                                                  syndrome (CRS)
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "secondaryProphylacticCrs_tal" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.secondaryProphylacticCrs_tal
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Secondary
                                                                  prophylactic
                                                                  for CRS
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "supportiveCareCrs_tal" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.supportiveCareCrs_tal
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Treatment or
                                                                  supportive
                                                                  care for CRS
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "primaryProphylacticNeurologic_tal" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.primaryProphylacticNeurologic_tal
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Primary
                                                                  prophylactic
                                                                  for neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "secondaryProphylacticNeurologic_tal" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.secondaryProphylacticNeurologic_tal
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Secondary
                                                                  prophylactic
                                                                  for neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "supportiveCareNeurologic_tal" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.supportiveCareNeurologic_tal
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Treatment or
                                                                  supportive
                                                                  care for
                                                                  neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="radio"
                                                                  id={index}
                                                                  name={
                                                                    "medicationReasonUnk_tal" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.medicationReasonUnk_tal
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <ErrorField
                                                              show={
                                                                itm.q39TalReasonEmpty
                                                              }
                                                              message={
                                                                TTCharacteristics_MSGS.Q39TalReasonHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          ),
                                        )}

                                      {q391ATalTocilzumabList?.length > 0 &&
                                        q391ATalTocilzumabList?.length <
                                          550 && (
                                          <div className="sub-question-bot-sapce-ul mt-2">
                                            <div
                                              className="answer-list-text"
                                              onClick={() =>
                                                AddQ391ARow(
                                                  RRMMCohortTreatment.TALVEY,
                                                )
                                              }
                                            >
                                              <a>
                                                <img
                                                  width="18px"
                                                  src="../Assets/images/plus.png"
                                                  alt=""
                                                />
                                              </a>
                                              <a className="radio-text-padding">
                                                Click here to add another
                                                tocilizumab administration of
                                                talquetamab
                                              </a>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                )}

                                {/* Q39.2 */}

                                {data.steroids_tal && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.2.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why steroids were
                                        used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          TALVEY
                                          <sup className="supscript">
                                            TM
                                          </sup>{" "}
                                          (talquetamab-tgvs)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      {/* TECVAYLI® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Medication
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "35%",
                                                  }}
                                                >
                                                  Name and dose of the
                                                  steroid(s) used
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "50%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {/* Tecvayli */}

                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    TALVEY
                                                    <sup className="supscript">
                                                      TM
                                                    </sup>{" "}
                                                    (talquetamab-tgvs)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label>
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Steroids
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                {/* Start */}

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div className="option-fbox">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "betamethasone_tal" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.betamethasone_tal
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Betamethasone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "betamethasone_talNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.betamethasone_talNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "dexamethasone_tal" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.dexamethasone_tal
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Dexamethasone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "dexamethasone_talNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.dexamethasone_talNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div className="">
                                                        <label className="option-fbox">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "hydrocortisone_tal" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.hydrocortisone_tal
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Hydrocortisone (oral
                                                            or intravenous only)
                                                            <br></br>
                                                            (total dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "hydrocortisone_talNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.hydrocortisone_talNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "methylprednisolone_tal" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.methylprednisolone_tal
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Methylprednisolone
                                                            (total dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "methylprednisolone_talNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.methylprednisolone_talNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "prednisolone_tal" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.prednisolone_tal
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Prednisolone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "prednisolone_talNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.prednisolone_talNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "prednisone_tal" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.prednisone_tal
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Prednisone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "prednisone_talNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.prednisone_talNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "triamcinolone_tal" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.triamcinolone_tal
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Triamcinolone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "triamcinolone_talNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.triamcinolone_talNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "dose_name_tal_unknown" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.dose_name_tal_unknown
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.name_dose_steroids_talHardEmpty
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.name_dose_steroidstalHardEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.steroids_tal_txtEmpty
                                                        }
                                                        message={
                                                          TTCharacteristics_MSGS.steroids_tal_txtEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </td>

                                                {/* End */}

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "steroid_pre_tmt_tal" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.steroid_pre_tmt_tal
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          As a pre-treatment per
                                                          label recommendation
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "cytokin_tal_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.cytokin_tal_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Primary prophylactic
                                                          for cytokine release
                                                          syndrome (CRS)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_tal_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_tal_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Secondary prophylactic
                                                          for CRS
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "crs_tal_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.crs_tal_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Treatment or
                                                          supportive care for
                                                          CRS
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "neurotoxicity_tal_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.neurotoxicity_tal_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Primary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_neurotoxicity_tal_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_neurotoxicity_tal_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Secondary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "tmt_neurotoxicity_tal_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_neurotoxicity_tal_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Treatment or
                                                          supportive care for
                                                          neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tmt_tal_unknown" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_tal_unknown
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.q39TalSteroidsEmptyHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q39TalSteroidsEmptyHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {data.granulocyte_tal && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.3.</span>
                                      <span className="quest-text-pad">
                                        Why was G-CSF used while receiving
                                        treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          TALVEY
                                          <sup className="supscript">
                                            TM
                                          </sup>{" "}
                                          (talquetamab-tgvs)
                                        </span>
                                        ? <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "25%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "25%",
                                                  }}
                                                >
                                                  Medication
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "45%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    TALVEY
                                                    <sup className="supscript">
                                                      TM
                                                    </sup>{" "}
                                                    (talquetamab-tgvs)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label>
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Granulocyte
                                                            colony-stimulating
                                                            factor (G-CSF)
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "prophylactic_use_tal" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.prophylactic_use_tal
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          use
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_use_tal" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_use_tal
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          use
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "oth_use_tal" + idx
                                                          }
                                                          checked={
                                                            data.oth_use_tal
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Other use
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          value={99}
                                                          name={
                                                            "unknown_tal" + idx
                                                          }
                                                          checked={
                                                            data.unknown_tal ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.q39TalGranulocyteEmptyHard
                                                      }
                                                      message={
                                                        TTCharacteristics_MSGS.Q39GranulocyteEmptyHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            ))}
                        </div>
                        {/* Question 39 end */}
                      </>
                    )}

                    {/* 40 start */}
                    {(isTechvayliSelected || isTalveySelected) && (
                      <div>
                        <div className="question question-weight">
                          <span>Q40.</span>
                          <span className="quest-text-pad">
                            Summarize information related to the usage of
                            intravenous immune globulin (IVIG) during the
                            patient’s treatment with{" "}
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                                fontWeight: "bolder",
                              }}
                            >
                              {isTechvayliSelected && (
                                <>TECVAYLI® (teclistamab-cqyv)</>
                              )}

                              {isTechvayliSelected &&
                                isTalveySelected &&
                                " and "}

                              {isTalveySelected && (
                                <>
                                  TALVEY <sup className="supscript">TM</sup>{" "}
                                  (talquetamab-tgvs)
                                </>
                              )}
                            </span>
                          </span>
                        </div>

                        <div className="question-bot-sapce">
                          <div className="sub-question grid-overflow">
                            <table
                              style={{
                                border: "1px solid black",
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Treatment
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      width: "33%",
                                    }}
                                  >
                                    Intended dosing frequency
                                  </th>

                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      width: "16%",
                                    }}
                                  >
                                    Last IgG level prior to most
                                    <br /> recent IVIG administration
                                  </th>

                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      width: "15%",
                                    }}
                                  >
                                    Initiation date of IVIG
                                  </th>

                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      width: "45%",
                                    }}
                                  >
                                    Reason for receiving medication Select all
                                    that apply.
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {/* Tecvayli */}

                                {isTechvayliSelected &&
                                  Q37TechDetails.length > 0 &&
                                  Q37TechDetails.map((data, idx) => (
                                    <tr key={idx}>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <span className="quest-text-pad">
                                          TECVAYLI® (teclistamab-cqyv)
                                        </span>
                                      </td>

                                      {/* Dosing freq column */}
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <div>
                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={1}
                                                checked={
                                                  data.Q40dosingfreqRd === 1
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Patient never received IVIG
                                                during treatment
                                              </span>
                                            </label>
                                          </div>
                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={2}
                                                checked={
                                                  data.Q40dosingfreqRd === 2
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Biweekly (every 2 weeks)
                                              </span>
                                            </label>
                                          </div>
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={3}
                                                checked={
                                                  data.Q40dosingfreqRd === 3
                                                }
                                                onChange={HandleFieldChange}
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Monthly
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={4}
                                                checked={
                                                  data.Q40dosingfreqRd === 4
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Bimonthly (every 2 months)
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={5}
                                                checked={
                                                  data.Q40dosingfreqRd === 5
                                                }
                                                onChange={HandleFieldChange}
                                              />

                                              <span
                                                style={{
                                                  marginLeft: "4px",
                                                  paddingRight: "15px",
                                                  marginBottom: "0px",
                                                  padding: "0",
                                                }}
                                              >
                                                Other frequency, please specify:
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                    marginBottom: "0px",
                                                    padding: "0",
                                                  }}
                                                >
                                                  <textarea
                                                    name={
                                                      "dosing_freq_oth_txt" +
                                                      idx
                                                    }
                                                    className="input-dash"
                                                    type="text"
                                                    value={
                                                      data.dosing_freq_oth_txt
                                                    }
                                                    onChange={HandleFieldChange}
                                                    maxLength={300}
                                                    id={idx}
                                                  />
                                                </div>
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={99}
                                                checked={
                                                  data.Q40dosingfreqRd === 99
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Unknown
                                              </span>
                                            </label>
                                          </div>

                                          <ErrorField
                                            show={data.Q40DosingFreqEmptyHard}
                                            message={
                                              TTCharacteristics_MSGS.Q40DosingFreqEmptyHard
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />

                                          <ErrorField
                                            show={
                                              data.Q40DosingFreqTxtEmptyHard
                                            }
                                            message={
                                              TTCharacteristics_MSGS.Q40DosingFreqTxtEmptyHard
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                        </div>
                                      </td>

                                      {/* Last  IgG Level */}
                                      {data.Q40dosingfreqRd !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  style={{ marginTop: "6px" }}
                                                  id={idx}
                                                  name={"Q40IgILevelRd" + idx}
                                                  value={1}
                                                  checked={
                                                    data.Q40IgILevelRd === 1
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  {"<"} 400 mg/dL
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"Q40IgILevelRd" + idx}
                                                  value={2}
                                                  checked={
                                                    data.Q40IgILevelRd === 2
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  400-500 mg/dL
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"Q40IgILevelRd" + idx}
                                                  value={3}
                                                  checked={
                                                    data.Q40IgILevelRd === 3
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  {">"} 500 mg/dL
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"Q40IgILevelRd" + idx}
                                                  value={99}
                                                  checked={
                                                    data.Q40IgILevelRd === 99
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={data.Q40IgGEmptyHard}
                                              message={
                                                TTCharacteristics_MSGS.Q40IgGEmptyHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            //alignContent: "flex-start",
                                            textAlign: "center",
                                            padding: "8px",
                                            //textAlign: 'start'
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}

                                      {/* IVIG */}
                                      {data.Q40dosingfreqRd !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40init_dt_Rd" + idx}
                                                value={1}
                                                checked={
                                                  data.Q40init_dt_Rd === 1
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                <DatePickerComponent
                                                  ctrlId={"Q40init_dt-" + idx}
                                                  // selectedDate={selectedDate}
                                                  //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  optionId={1}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                  date={data.Q40init_dt}
                                                />
                                              </span>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"Q40init_dt_Rd" + idx}
                                                  value={99}
                                                  checked={
                                                    data.Q40init_dt_Rd === 99
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  // className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Date of initiation unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={data.Q40Init_RdHard}
                                              message={
                                                TTCharacteristics_MSGS.Q40Init_RdHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />

                                            <ErrorField
                                              show={data.Q40Init_dtHard}
                                              message={
                                                TTCharacteristics_MSGS.Q40Init_dtHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                            <ErrorField
                                              show={data.InvalidQ40init_dt}
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                            <ErrorField
                                              show={data.init_dt_before_eof}
                                              message={
                                                TTCharacteristics_MSGS.Q40DateOutOfRange
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            padding: "8px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}

                                      {/* Medication Reason */}
                                      {data.Q40dosingfreqRd !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div className="">
                                              <label
                                                className="option-fbox"
                                                style={{
                                                  alignItems: "baseline",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={"primaryProf" + idx}
                                                  checked={data.primaryProf}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "6px",
                                                  }}
                                                >
                                                  Primary prophylactic for
                                                  infections
                                                </span>
                                              </label>
                                            </div>

                                            <div className="">
                                              <label
                                                className="option-fbox"
                                                style={{
                                                  alignItems: "baseline",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={"secondaryProf" + idx}
                                                  checked={data.secondaryProf}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "6px",
                                                  }}
                                                >
                                                  Secondary prophylactic for
                                                  infections
                                                </span>
                                              </label>
                                            </div>

                                            <div className="">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={"otherReson" + idx}
                                                  checked={data.otherReson}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "6px",
                                                  }}
                                                >
                                                  Other reason
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={data.Q40ReasonEmptyHard}
                                              message={
                                                TTCharacteristics_MSGS.Q40ReasonEmptyHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            //alignContent: "flex-start",
                                            textAlign: "center",
                                            padding: "8px",
                                            //textAlign: 'start'
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}
                                    </tr>
                                  ))}

                                {isTalveySelected &&
                                  Q37TalDetails.length > 0 &&
                                  Q37TalDetails.map((data, idx) => (
                                    <tr key={idx}>
                                      <>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span className="quest-text-pad">
                                            TALVEY{" "}
                                            <sup className="supscript">TM</sup>{" "}
                                            (talquetamab-tgvs)
                                          </span>
                                        </td>

                                        {/* Dosing freq column */}
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q40dosingfreqRd_Tal" + idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.Q40dosingfreqRd_Tal ===
                                                    1
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Patient never received IVIG
                                                  during treatment
                                                </span>
                                              </label>
                                            </div>
                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q40dosingfreqRd_Tal" + idx
                                                  }
                                                  value={2}
                                                  checked={
                                                    data.Q40dosingfreqRd_Tal ===
                                                    2
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Biweekly (every 2 weeks)
                                                </span>
                                              </label>
                                            </div>
                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  style={{ marginTop: "6px" }}
                                                  id={idx}
                                                  name={
                                                    "Q40dosingfreqRd_Tal" + idx
                                                  }
                                                  value={3}
                                                  checked={
                                                    data.Q40dosingfreqRd_Tal ===
                                                    3
                                                  }
                                                  onChange={HandleFieldChange}
                                                />

                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Monthly
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q40dosingfreqRd_Tal" + idx
                                                  }
                                                  value={4}
                                                  checked={
                                                    data.Q40dosingfreqRd_Tal ===
                                                    4
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Bimonthly (every 2 months)
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q40dosingfreqRd_Tal" + idx
                                                  }
                                                  value={5}
                                                  checked={
                                                    data.Q40dosingfreqRd_Tal ===
                                                    5
                                                  }
                                                  onChange={HandleFieldChange}
                                                />

                                                <span
                                                  style={{
                                                    marginLeft: "4px",
                                                    paddingRight: "15px",
                                                    marginBottom: "0px",
                                                    padding: "0",
                                                  }}
                                                >
                                                  Other frequency, please
                                                  specify:
                                                  <div
                                                    style={{
                                                      paddingLeft: "15px",
                                                      marginBottom: "0px",
                                                      padding: "0",
                                                    }}
                                                  >
                                                    <textarea
                                                      name={
                                                        "dosing_freq_oth_txt_Tal" +
                                                        idx
                                                      }
                                                      className="input-dash"
                                                      type="text"
                                                      value={
                                                        data.dosing_freq_oth_txt_Tal
                                                      }
                                                      onChange={
                                                        HandleFieldChange
                                                      }
                                                      maxLength={300}
                                                      id={idx}
                                                    />
                                                  </div>
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q40dosingfreqRd_Tal" + idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    data.Q40dosingfreqRd_Tal ===
                                                    99
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={
                                                data.Q40TalDosingFreqEmptyHard
                                              }
                                              message={
                                                TTCharacteristics_MSGS.Q40DosingFreqEmptyHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />

                                            <ErrorField
                                              show={
                                                data.Q40TalDosingFreqTxtEmptyHard
                                              }
                                              message={
                                                TTCharacteristics_MSGS.Q40DosingFreqTxtEmptyHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>

                                        {/* Last  IgG Level */}
                                        {data.Q40dosingfreqRd_Tal !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    style={{
                                                      marginTop: "6px",
                                                    }}
                                                    id={idx}
                                                    name={
                                                      "Q40IgILevelRd_Tal" + idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q40IgILevelRd_Tal ===
                                                      1
                                                    }
                                                    onChange={HandleFieldChange}
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    {"<"} 400 mg/dL
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q40IgILevelRd_Tal" + idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.Q40IgILevelRd_Tal ===
                                                      2
                                                    }
                                                    onChange={HandleFieldChange}
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    400-500 mg/dL
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q40IgILevelRd_Tal" + idx
                                                    }
                                                    value={3}
                                                    checked={
                                                      data.Q40IgILevelRd_Tal ===
                                                      3
                                                    }
                                                    onChange={HandleFieldChange}
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    {">"} 500 mg/dL
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q40IgILevelRd_Tal" + idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q40IgILevelRd_Tal ===
                                                      99
                                                    }
                                                    onChange={HandleFieldChange}
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={data.Q40TalIgGEmptyHard}
                                                message={
                                                  TTCharacteristics_MSGS.Q40IgGEmptyHard
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              textAlign: "center",
                                              padding: "8px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}

                                        {/* IVIG */}
                                        {data.Q40dosingfreqRd_Tal !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q40init_dt_Rd_Tal" + idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.Q40init_dt_Rd_Tal === 1
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  <DatePickerComponent
                                                    ctrlId={
                                                      "Q40init_dt_Tal-" + idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    optionId={1}
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                    date={data.Q40init_dt_Tal}
                                                  />
                                                </span>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q40init_dt_Rd_Tal" + idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q40init_dt_Rd_Tal ===
                                                      99
                                                    }
                                                    onChange={HandleFieldChange}
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Date of initiation unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={data.Q40TalInit_RdHard}
                                                message={
                                                  TTCharacteristics_MSGS.Q40Init_RdHard
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={data.Q40TalInit_dtHard}
                                                message={
                                                  TTCharacteristics_MSGS.Q40Init_dtHard
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.InvalidQ40init_dt_Tal
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.init_dt_before_eof_Tal
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q40DateOutOfRange
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              textAlign: "center",
                                              padding: "8px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}

                                        {/* Medication Reason */}
                                        {data.Q40dosingfreqRd_Tal !== 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div className="">
                                                <label
                                                  className="option-fbox"
                                                  style={{
                                                    alignItems: "baseline",
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "primaryProf_Tal" + idx
                                                    }
                                                    checked={
                                                      data.primaryProf_Tal
                                                    }
                                                    onChange={HandleFieldChange}
                                                  />
                                                  <span
                                                    style={{
                                                      marginLeft: "6px",
                                                    }}
                                                  >
                                                    Primary prophylactic for
                                                    infections
                                                  </span>
                                                </label>
                                              </div>

                                              <div className="">
                                                <label
                                                  className="option-fbox"
                                                  style={{
                                                    alignItems: "baseline",
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "secondaryProf_Tal" + idx
                                                    }
                                                    checked={
                                                      data.secondaryProf_Tal
                                                    }
                                                    onChange={HandleFieldChange}
                                                  />
                                                  <span
                                                    style={{
                                                      marginLeft: "6px",
                                                    }}
                                                  >
                                                    Secondary prophylactic for
                                                    infections
                                                  </span>
                                                </label>
                                              </div>

                                              <div className="">
                                                <label>
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "otherReson_Tal" + idx
                                                    }
                                                    checked={
                                                      data.otherReson_Tal
                                                    }
                                                    onChange={HandleFieldChange}
                                                  />
                                                  <span
                                                    style={{
                                                      marginLeft: "6px",
                                                    }}
                                                  >
                                                    Other reason
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q40TalReasonEmptyHard
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q40ReasonEmptyHard
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              //alignContent: "flex-start",
                                              textAlign: "center",
                                              padding: "8px",
                                              //textAlign: 'start'
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}
                                      </>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* 40 end */}

                    {/* 40.1.A start -- */}
                    {isNewEcrfB &&
                      isTechvayliSelected &&
                      Q37TechDetails[0]?.Q40dosingfreqRd != null &&
                      Q37TechDetails[0]?.Q40dosingfreqRd !== 1 && (
                        <div className="question question-weight">
                          <span>Q40.1.B</span>
                          <span className="quest-text-pad">
                            Please provide{" "}
                            <i>information on each IVIG administration</i>{" "}
                            received during the patient’s treatment with{" "}
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                                fontWeight: "bolder",
                              }}
                            >
                              {isTechvayliSelected && (
                                <>TECVAYLI® (teclistamab-cqyv).</>
                              )}
                            </span>{" "}
                            Add additional rows for each assessment, as needed.
                          </span>
                        </div>
                      )}

                    {isNewEcrfB &&
                      isTechvayliSelected &&
                      Q37TechDetails[0]?.Q40dosingfreqRd != null &&
                      Q37TechDetails[0]?.Q40dosingfreqRd != 1 && (
                        <div className="dependent-section">
                          <ErrorField
                            show={q40Tec_WarningHard}
                            message={TTCharacteristics_MSGS.WarningForIVIGQ401a}
                            style={{ paddingLeft: "0px" }}
                          />
                          {/* Tecvayli */}
                          {isTechvayliSelected &&
                            Q401aTecDetails.length > 0 &&
                            Q401aTecDetails.map((data, idx) => (
                              <div className="loop-section-ul" key={idx}>
                                <div className="loop-head">
                                  <span
                                    className="question-weight"
                                    style={{ float: "inline-start" }}
                                  >
                                    {GetOrdinal(idx + 1)} IVIG Administration
                                  </span>
                                  {idx !== 0 && (
                                    <div
                                      className="delete-btn-div"
                                      style={{ float: "inline-end" }}
                                    >
                                      <img
                                        width="16px"
                                        src="../Assets/images/Icon-material-delete.png"
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          DeleteQ401aTechvayliRow(idx)
                                        }
                                      />
                                    </div>
                                  )}
                                </div>

                                <div className="question-bot-sapce">
                                  <div
                                    className="sub-question"
                                    style={{ overflowX: "auto" }}
                                  >
                                    <table
                                      style={{
                                        border: "1px solid black",
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Treatment
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "33%",
                                            }}
                                          >
                                            Date of IVIG administration
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "33%",
                                            }}
                                          >
                                            Intended dosing frequency
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "15%",
                                            }}
                                          >
                                            Reason for receiving IVIG
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "45%",
                                            }}
                                          >
                                            Dosing type
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "45%",
                                            }}
                                          >
                                            Dosage
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "45%",
                                            }}
                                          >
                                            Body Weight
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "45%",
                                            }}
                                          >
                                            Date of weight assessment
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        <tr key={idx}>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <span className="quest-text-pad">
                                              TECVAYLI® (teclistamab-cqyv)
                                            </span>
                                          </td>

                                          {/* IVIG admission date*/}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q401ainit_dt_Rd_Tec" + idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.Q401ainit_dt_Rd_Tec ===
                                                    1
                                                  }
                                                  onChange={
                                                    HandleQ401aFieldChange
                                                  }
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  <DatePickerComponent
                                                    ctrlId={
                                                      "Q401ainit_Tec_dt-" + idx
                                                    }
                                                    HandleDateChange={
                                                      HandleQ401aRepeaterDateChange
                                                    }
                                                    optionId={1}
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                    date={data.Q401ainit_Tec_dt}
                                                  />
                                                </span>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401ainit_dt_Rd_Tec" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q401ainit_dt_Rd_Tec ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Date of initiation unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={data.Q401aInit_Tec_RdHard}
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={data.Q401aInit_Tec_dtHard}
                                                message={
                                                  TTCharacteristics_MSGS.Q401aDateAdm_Hard
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q401aInvalidQ401ainit_Tec_dt
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q401aInit_Tec_dt_before_eof
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOFAfterIndex
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>

                                          {/* Intended Dosing */}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "start",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tec" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tec ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tec_WeekValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tec_WeekValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                        onKeyDown={(e) => {
                                                          if (
                                                            [
                                                              "Backspace",
                                                              "ArrowLeft",
                                                              "ArrowRight",
                                                              "Delete",
                                                              "Tab",
                                                            ].includes(e.key)
                                                          )
                                                            return;
                                                          if (
                                                            !/[0-9]/.test(e.key)
                                                          )
                                                            e.preventDefault();
                                                        }}
                                                      />
                                                    </span>
                                                    <span>
                                                      &nbsp;times per week
                                                    </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tec" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tec ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tec_MonthValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tec_MonthValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                        onKeyDown={(e) => {
                                                          if (
                                                            [
                                                              "Backspace",
                                                              "ArrowLeft",
                                                              "ArrowRight",
                                                              "Delete",
                                                              "Tab",
                                                            ].includes(e.key)
                                                          )
                                                            return;
                                                          if (
                                                            !/[0-9]/.test(e.key)
                                                          )
                                                            e.preventDefault();
                                                        }}
                                                      />
                                                    </span>
                                                    <span>
                                                      &nbsp;times per month{" "}
                                                    </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label
                                                  className="option-fbox"
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tec" +
                                                      idx
                                                    }
                                                    value={3}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tec ===
                                                      3
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      whiteSpace: "nowrap",
                                                      gap: "4px",
                                                    }}
                                                  >
                                                    <span>
                                                      Once every &nbsp;
                                                    </span>
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tec_OnceWeekValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tec_OnceWeekValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                        onKeyDown={(e) => {
                                                          if (
                                                            [
                                                              "Backspace",
                                                              "ArrowLeft",
                                                              "ArrowRight",
                                                              "Delete",
                                                              "Tab",
                                                            ].includes(e.key)
                                                          )
                                                            return;
                                                          if (
                                                            !/[0-9]/.test(e.key)
                                                          )
                                                            e.preventDefault();
                                                        }}
                                                      />
                                                    </span>
                                                    <span>&nbsp;weeks </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label
                                                  className="option-fbox"
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tec" +
                                                      idx
                                                    }
                                                    value={4}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tec ===
                                                      4
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      whiteSpace: "nowrap",
                                                      gap: "4px",
                                                    }}
                                                  >
                                                    <span>
                                                      Once every &nbsp;
                                                    </span>
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tec_OnceMonthValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tec_OnceMonthValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                        onKeyDown={(e) => {
                                                          if (
                                                            [
                                                              "Backspace",
                                                              "ArrowLeft",
                                                              "ArrowRight",
                                                              "Delete",
                                                              "Tab",
                                                            ].includes(e.key)
                                                          )
                                                            return;
                                                          if (
                                                            !/[0-9]/.test(e.key)
                                                          )
                                                            e.preventDefault();
                                                        }}
                                                      />
                                                    </span>
                                                    <span>&nbsp;months </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label
                                                  className="option-fbox"
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tec" +
                                                      idx
                                                    }
                                                    value={5}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tec ===
                                                      5
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      whiteSpace: "nowrap",
                                                      gap: "4px",
                                                    }}
                                                  >
                                                    <span>
                                                      Other, please specify{" "}
                                                    </span>
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tec_OtherValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tec_OtherValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                      />
                                                    </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tec" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tec ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q401aIntendedDosingEmpty_Tec
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q401aIntendedDosingRangeInvalid_Tec
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aFrequencyEmptyHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>

                                          {/* Reason of IVIG */}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "Q401aPrimaryProf_Tec" +
                                                      idx
                                                    }
                                                    checked={
                                                      data.Q401aPrimaryProf_Tec
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Primary prophylactic for
                                                    infections
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "Q401aSecProf_Tec" + idx
                                                    }
                                                    checked={
                                                      data.Q401aSecProf_Tec
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Secondary prophylactic for
                                                    infections
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "Q401aOtherProf_Tec" + idx
                                                    }
                                                    checked={
                                                      data.Q401aOtherProf_Tec
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Other reason
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aUnknownProf_Tec" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q401aUnknownProf_Tec ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q401aReasonIvigEmptyHard_Tec
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelectCheckbox_RdHard
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>

                                          {/* Dosing Type */}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aDosingType_Tec" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q401aDosingType_Tec ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Flat dosage
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{ display: "flex" }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aDosingType_Tec" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.Q401aDosingType_Tec ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Weight-based dosage
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q401aDosingType_TecEmptyHard
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>

                                          {/* Dosage*/}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "start",
                                            }}
                                          >
                                            <div>
                                              {data.Q401aDosingType_Tec ===
                                                1 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aDosage_Tec" + idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.Q401aDosage_Tec ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <input
                                                        className="input-dash-custom"
                                                        id={idx}
                                                        name={
                                                          "Q401aDosage_Tec_GValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aDosage_Tec_GValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                        onKeyDown={
                                                          AllowNumericWithDecimal
                                                        }
                                                        maxLength={10}
                                                      />
                                                      <span>&nbsp;g</span>
                                                    </span>
                                                  </label>
                                                </div>
                                              )}

                                              {data.Q401aDosingType_Tec ===
                                                2 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aDosage_Tec" + idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.Q401aDosage_Tec ===
                                                        2
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q401aDosage_Tec_MgValue" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q401aDosage_Tec_MgValue
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ401aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                      </span>
                                                      <span>&nbsp;mg/kg </span>
                                                    </span>
                                                  </label>
                                                </div>
                                              )}

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aDosage_Tec" + idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q401aDosage_Tec ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q401aDosageFrequencyEmpty_Tec
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q401aDosageRangeInvalid_Tec
                                                }
                                                message={
                                                  data.Q401aDosage_Tec === 1
                                                    ? TTCharacteristics_MSGS.Q401aDosageEmptyHardG
                                                    : TTCharacteristics_MSGS.Q401aDosageEmptyHardMG
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>

                                          {/* Body Weight*/}
                                          {data.Q401aDosingType_Tec === 2 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              <div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aWeight_Tec" + idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.Q401aWeight_Tec ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q401aWeight_Value_KgTec" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q401aWeight_Value_KgTec
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ401aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                      </span>
                                                      <span>&nbsp;kg</span>
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aWeight_Tec" + idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.Q401aWeight_Tec ===
                                                        2
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q401aWeight_Value_LbsTec" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q401aWeight_Value_LbsTec
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ401aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                      </span>
                                                      <span>&nbsp;lbs </span>
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aWeight_Tec" + idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.Q401aWeight_Tec ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q401aWeightEmpty_Tec
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.Q401aWeightRangeInvalid_Tec
                                                  }
                                                  message={
                                                    data.Q401aWeight_Tec === 1
                                                      ? TTCharacteristics_MSGS.Q401aBodyWeightEmptyHardKg
                                                      : TTCharacteristics_MSGS.Q401aBodyWeightEmptyHardLbs
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </div>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                //alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                  verticalAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          {/* Weight assessment date */}

                                          {data.Q401aDosingType_Tec === 2 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div>
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aWeight_Asses_Tec" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q401aWeight_Asses_Tec ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    <DatePickerComponent
                                                      ctrlId={
                                                        "Q401aWeight_Asses_Tec_dt-" +
                                                        idx
                                                      }
                                                      HandleDateChange={
                                                        HandleQ401aRepeaterDateChange
                                                      }
                                                      optionId={1}
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                      date={
                                                        data.Q401aWeight_Asses_Tec_dt
                                                      }
                                                    />
                                                  </span>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aWeight_Asses_Tec" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.Q401aWeight_Asses_Tec ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      Date of initiation unknown
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q401aWeight_AssesEmptyHard_Tec
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />

                                                <ErrorField
                                                  show={
                                                    data.Q401aWeight_AssesDtEmptyHard_Tec
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.Q401aDateWeight_Hard
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.Q401aWeight_AssesDtInvalid_Tec
                                                  }
                                                  message={
                                                    CommonError_Msgs.InvalidDate
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.Q401aWeight_Asses_dt_before_eof_Tec
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.DateBeforeEOFAfterIndex
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </div>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                //alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                  verticalAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ))}
                          {/* Add button */}
                          {Q401aTecDetails && (
                            <div className="sub-question-bot-sapce-ul mt-2">
                              <div
                                className="answer-list-text"
                                onClick={AddQ401aTecRow}
                              >
                                <a>
                                  <img
                                    width="18px"
                                    src="../Assets/images/plus.png"
                                    alt=""
                                  />
                                </a>
                                <a className="radio-text-padding">
                                  Click here to add IVIG administration received
                                </a>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    {/* 40.1.A  end */}

                    {/* 40.1.A start -- && data.Q40dosingfreqRd_Tal != 1*/}
                    {isNewEcrfB &&
                      isTalveySelected &&
                      Q37TalDetails[0]?.Q40dosingfreqRd_Tal != null &&
                      Q37TalDetails[0]?.Q40dosingfreqRd_Tal !== 1 && (
                        <div>
                          <div className="question question-weight">
                            <span>Q40.1.B</span>
                            <span className="quest-text-pad">
                              Please provide{" "}
                              <i>information on each IVIG administration</i>{" "}
                              received during the patient’s treatment with{" "}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isTalveySelected && (
                                  <>
                                    TALVEY <sup className="supscript">TM</sup>{" "}
                                    (talquetamab-tgvs).
                                  </>
                                )}{" "}
                              </span>
                              Add additional rows for each assessment, as
                              needed.
                            </span>
                          </div>
                        </div>
                      )}

                    {isNewEcrfB &&
                      isTalveySelected &&
                      Q37TalDetails[0]?.Q40dosingfreqRd_Tal != null &&
                      Q37TalDetails[0]?.Q40dosingfreqRd_Tal !== 1 && (
                        <div className="dependent-section">
                          <ErrorField
                            show={q40Tal_WarningHard}
                            message={TTCharacteristics_MSGS.WarningForIVIGQ401a}
                            style={{ paddingLeft: "0px" }}
                          />

                          {/* Talvey */}
                          {isTalveySelected &&
                            Q401aTalDetails.length > 0 &&
                            Q401aTalDetails.map((data, idx) => (
                              <div className="loop-section-ul" key={idx}>
                                <div className="loop-head">
                                  <span
                                    className="question-weight"
                                    style={{ float: "inline-start" }}
                                  >
                                    {GetOrdinal(idx + 1)} IVIG Administration
                                  </span>
                                  {idx !== 0 && (
                                    <div
                                      className="delete-btn-div"
                                      style={{ float: "inline-end" }}
                                    >
                                      <img
                                        width="16px"
                                        src="../Assets/images/Icon-material-delete.png"
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          DeleteQ401aTalveyRow(idx)
                                        }
                                      />
                                    </div>
                                  )}
                                </div>

                                <div className="question-bot-sapce">
                                  <div
                                    className="sub-question"
                                    style={{ overflowX: "auto" }}
                                  >
                                    <table
                                      style={{
                                        border: "1px solid black",
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Treatment
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "33%",
                                            }}
                                          >
                                            Date of IVIG administration
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "33%",
                                            }}
                                          >
                                            Intended dosing frequency
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "15%",
                                            }}
                                          >
                                            Reason for receiving IVIG
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "45%",
                                            }}
                                          >
                                            Dosing type
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "45%",
                                            }}
                                          >
                                            Dosage
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "45%",
                                            }}
                                          >
                                            Body Weight
                                          </th>

                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              width: "45%",
                                            }}
                                          >
                                            Date of weight assessment
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        <tr key={idx}>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <span className="quest-text-pad">
                                              TALVEY
                                              <sup className="supscript">
                                                TM
                                              </sup>{" "}
                                              (talquetamab-tgvs)
                                            </span>
                                          </td>

                                          {/* IVIG admission date*/}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q401ainit_dt_Rd_Tal" + idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.Q401ainit_dt_Rd_Tal ===
                                                    1
                                                  }
                                                  onChange={
                                                    HandleQ401aFieldChange
                                                  }
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  <DatePickerComponent
                                                    ctrlId={
                                                      "Q401ainit_Tal_dt-" + idx
                                                    }
                                                    HandleDateChange={
                                                      HandleQ401aRepeaterDateChange
                                                    }
                                                    optionId={1}
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                    date={data.Q401ainit_Tal_dt}
                                                  />
                                                </span>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401ainit_dt_Rd_Tal" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q401ainit_dt_Rd_Tal ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Date of initiation unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={data.Q401aInit_Tal_RdHard}
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />

                                              <ErrorField
                                                show={data.Q401aInit_Tal_dtHard}
                                                message={
                                                  TTCharacteristics_MSGS.Q401aDateAdm_Hard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q401aInvalidQ401ainit_Tal_dt
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q401aInit_Tal_dt_before_eof
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.DateBeforeEOFAfterIndex
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>

                                          {/* Intended Dosing */}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "start",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tal" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tal ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tal_WeekValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tal_WeekValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                        onKeyDown={(e) => {
                                                          if (
                                                            [
                                                              "Backspace",
                                                              "ArrowLeft",
                                                              "ArrowRight",
                                                              "Delete",
                                                              "Tab",
                                                            ].includes(e.key)
                                                          )
                                                            return;
                                                          if (
                                                            !/[0-9]/.test(e.key)
                                                          )
                                                            e.preventDefault();
                                                        }}
                                                      />
                                                    </span>
                                                    <span>
                                                      &nbsp;times per week
                                                    </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tal" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tal ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tal_MonthValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tal_MonthValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                        onKeyDown={(e) => {
                                                          if (
                                                            [
                                                              "Backspace",
                                                              "ArrowLeft",
                                                              "ArrowRight",
                                                              "Delete",
                                                              "Tab",
                                                            ].includes(e.key)
                                                          )
                                                            return;
                                                          if (
                                                            !/[0-9]/.test(e.key)
                                                          )
                                                            e.preventDefault();
                                                        }}
                                                      />
                                                    </span>
                                                    <span>
                                                      &nbsp;times per month{" "}
                                                    </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label
                                                  className="option-fbox"
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tal" +
                                                      idx
                                                    }
                                                    value={3}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tal ===
                                                      3
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      whiteSpace: "nowrap",
                                                      gap: "4px",
                                                    }}
                                                  >
                                                    <span>
                                                      Once every &nbsp;
                                                    </span>
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tal_OnceWeekValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tal_OnceWeekValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                        onKeyDown={(e) => {
                                                          if (
                                                            [
                                                              "Backspace",
                                                              "ArrowLeft",
                                                              "ArrowRight",
                                                              "Delete",
                                                              "Tab",
                                                            ].includes(e.key)
                                                          )
                                                            return;
                                                          if (
                                                            !/[0-9]/.test(e.key)
                                                          )
                                                            e.preventDefault();
                                                        }}
                                                      />
                                                    </span>
                                                    <span>&nbsp;weeks </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label
                                                  className="option-fbox"
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tal" +
                                                      idx
                                                    }
                                                    value={4}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tal ===
                                                      4
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      whiteSpace: "nowrap",
                                                      gap: "4px",
                                                    }}
                                                  >
                                                    <span>
                                                      Once every &nbsp;
                                                    </span>
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tal_OnceMonthValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tal_OnceMonthValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                        onKeyDown={(e) => {
                                                          if (
                                                            [
                                                              "Backspace",
                                                              "ArrowLeft",
                                                              "ArrowRight",
                                                              "Delete",
                                                              "Tab",
                                                            ].includes(e.key)
                                                          )
                                                            return;
                                                          if (
                                                            !/[0-9]/.test(e.key)
                                                          )
                                                            e.preventDefault();
                                                        }}
                                                      />
                                                    </span>
                                                    <span>&nbsp;months </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label
                                                  className="option-fbox"
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tal" +
                                                      idx
                                                    }
                                                    value={5}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tal ===
                                                      5
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      whiteSpace: "nowrap",
                                                      gap: "4px",
                                                    }}
                                                  >
                                                    <span>
                                                      Other, please
                                                      specify:{" "}
                                                    </span>
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q401aIntendedDosing_Tal_OtherValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q401aIntendedDosing_Tal_OtherValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ401aFieldChange
                                                        }
                                                      />
                                                    </span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aIntendedDosing_Tal" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q401aIntendedDosing_Tal ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q401aIntendedDosingEmpty_Tal
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q401aIntendedDosingRangeInvalid_Tal
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aFrequencyEmptyHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>

                                          {/* Reason of IVIG */}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "Q401aPrimaryProf_Tal" +
                                                      idx
                                                    }
                                                    checked={
                                                      data.Q401aPrimaryProf_Tal
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Primary prophylactic for
                                                    infections
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "Q401aSecProf_Tal" + idx
                                                    }
                                                    checked={
                                                      data.Q401aSecProf_Tal
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Secondary prophylactic for
                                                    infections
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="checkbox"
                                                    id={idx}
                                                    name={
                                                      "Q401aOtherProf_Tal" + idx
                                                    }
                                                    checked={
                                                      data.Q401aOtherProf_Tal
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Other reason
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aUnknownProf_Tal" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q401aUnknownProf_Tal ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q401aReasonIvigEmptyHard_Tal
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelectCheckbox_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>

                                          {/* Dosing Type */}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aDosingType_Tal" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q401aDosingType_Tal ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Flat dosage
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aDosingType_Tal" +
                                                      idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.Q401aDosingType_Tal ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Weight-based dosage
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q401aDosingType_TalEmptyHard
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>

                                          {/* Dosage*/}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "start",
                                            }}
                                          >
                                            <div>
                                              {data.Q401aDosingType_Tal ===
                                                1 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aDosage_Tal" + idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.Q401aDosage_Tal ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q401aDosage_Tal_GValue" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q401aDosage_Tal_GValue
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ401aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                      </span>
                                                      <span>&nbsp;g</span>
                                                    </span>
                                                  </label>
                                                </div>
                                              )}

                                              {data.Q401aDosingType_Tal ===
                                                2 && (
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aDosage_Tal" + idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.Q401aDosage_Tal ===
                                                        2
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q401aDosage_Tal_MgValue" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q401aDosage_Tal_MgValue
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ401aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                      </span>
                                                      <span>&nbsp;mg/kg </span>
                                                    </span>
                                                  </label>
                                                </div>
                                              )}

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aDosage_Tal" + idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q401aDosage_Tal ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q401aDosageFrequencyEmpty_Tal
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q401aDosageRangeInvalid_Tal
                                                }
                                                message={
                                                  data.Q401aDosage_Tal === 1
                                                    ? TTCharacteristics_MSGS.Q401aDosageEmptyHardG
                                                    : TTCharacteristics_MSGS.Q401aDosageEmptyHardMG
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>

                                          {/* Body Weight*/}
                                          {data.Q401aDosingType_Tal === 2 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              <div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aWeight_Tal" + idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.Q401aWeight_Tal ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q401aWeight_Value_KgTal" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q401aWeight_Value_KgTal
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ401aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                      </span>
                                                      <span>&nbsp;kg</span>
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aWeight_Tal" + idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.Q401aWeight_Tal ===
                                                        2
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q401aWeight_Value_LbsTal" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q401aWeight_Value_LbsTal
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ401aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                          maxLength={10}
                                                        />
                                                      </span>
                                                      <span>&nbsp;lbs </span>
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aWeight_Tal" + idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.Q401aWeight_Tal ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q401aWeightEmpty_Tal
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.Q401aWeightRangeInvalid_Tal
                                                  }
                                                  message={
                                                    data.Q401aWeight_Tal === 1
                                                      ? TTCharacteristics_MSGS.Q401aBodyWeightEmptyHardKg
                                                      : TTCharacteristics_MSGS.Q401aBodyWeightEmptyHardLbs
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </div>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                //alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                  verticalAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}

                                          {/* Weight assessment date */}
                                          {data.Q401aDosingType_Tal === 2 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q401aWeight_Asses_Tal" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q401aWeight_Asses_Tal ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ401aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    <DatePickerComponent
                                                      ctrlId={
                                                        "Q401aWeight_Asses_Tal_dt-" +
                                                        idx
                                                      }
                                                      HandleDateChange={
                                                        HandleQ401aRepeaterDateChange
                                                      }
                                                      optionId={1}
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                      date={
                                                        data.Q401aWeight_Asses_Tal_dt
                                                      }
                                                    />
                                                  </span>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q401aWeight_Asses_Tal" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.Q401aWeight_Asses_Tal ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleQ401aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      Date of initiation unknown
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q401aWeight_AssesEmptyHard_Tal
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.Q401aSelect_RdHard
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />

                                                <ErrorField
                                                  show={
                                                    data.Q401aWeight_AssesDtEmptyHard_Tal
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.Q401aDateWeight_Hard
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.Q401aWeight_AssesDtInvalid_Tal
                                                  }
                                                  message={
                                                    CommonError_Msgs.InvalidDate
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.Q401aWeight_Asses_dt_before_eof_Tal
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.DateBeforeEOFAfterIndex
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </div>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                //alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                  verticalAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ))}
                          {/* Add button */}
                          {Q401aTalDetails && (
                            <div className="sub-question-bot-sapce-ul mt-2">
                              <div
                                className="answer-list-text"
                                onClick={AddQ401aTalRow}
                              >
                                <a>
                                  <img
                                    width="18px"
                                    src="../Assets/images/plus.png"
                                    alt=""
                                  />
                                </a>
                                <a className="radio-text-padding">
                                  Click here to add IVIG administration received
                                </a>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    {/* 40.1.A  end */}

                    {/* 40.2.A start */}
                    {isNewEcrfB &&
                      (isTechvayliSelected || isTalveySelected) && (
                        <div>
                          <div className="question question-weight">
                            <span>Q40.2.B</span>
                            <span className="quest-text-pad">
                              Please provide the immunoglobulin G (IgG) level{" "}
                              <i>at the start of bispecific treatment</i>{" "}
                              {isTechvayliSelected && (
                                <>
                                  (ranging from
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                      fontWeight: "bolder",
                                    }}
                                  >
                                    {" "}
                                    {showTechDate91()}{" "}
                                  </span>
                                  to{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                      fontWeight: "bolder",
                                    }}
                                  >
                                    {" "}
                                    {getTecTalQ402BUpperLimitDate(
                                      null,
                                      RRMMCohortTreatment.TECVAYLI,
                                    )}{" "}
                                  </span>
                                  ) with{" "}
                                </>
                              )}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isTechvayliSelected && (
                                  <>TECVAYLI® (teclistamab-cqyv)</>
                                )}

                                {isTechvayliSelected && isTalveySelected
                                  ? " and "
                                  : isTechvayliSelected
                                    ? "."
                                    : ""}
                              </span>
                              <span>
                                {isTalveySelected && (
                                  <>
                                    (ranging from
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {showTalDate91()}{" "}
                                    </span>
                                    to{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {getTecTalQ402BUpperLimitDate(
                                        null,
                                        RRMMCohortTreatment.TALVEY,
                                      )}{" "}
                                    </span>
                                    ) with{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      TALVEY <sup className="supscript">TM</sup>{" "}
                                      (talquetamab-tgvs)
                                    </span>
                                    .
                                  </>
                                )}
                              </span>
                            </span>
                          </div>

                          <div className="question-bot-sapce">
                            <div className="sub-question grid-overflow">
                              <table
                                style={{
                                  border: "1px solid black",
                                  borderCollapse: "collapse",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Treatment
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "33%",
                                      }}
                                    >
                                      Date of IgG assessment at the start of
                                      bispecific treatment
                                    </th>

                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "16%",
                                      }}
                                    >
                                      IgG level at the start of bispecific
                                      treatment
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {/* Tecvayli */}
                                  {isTechvayliSelected &&
                                    Q402aTecDetails.length > 0 &&
                                    Q402aTecDetails.map((data, idx) => (
                                      <tr key={idx}>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span className="quest-text-pad">
                                            TECVAYLI® (teclistamab-cqyv)
                                          </span>
                                        </td>

                                        {/* IgG assessment */}
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                              }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q402aIgg_assessment_Tec" +
                                                    idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.Q402aIgg_assessment_Tec ===
                                                    1
                                                  }
                                                  onChange={
                                                    HandleQ402aFieldChange
                                                  }
                                                />
                                                <span
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  No IgG assessment performed at
                                                  treatment initiation
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "Q402aIgg_assessment_Tec" +
                                                  idx
                                                }
                                                value={2}
                                                checked={
                                                  data.Q402aIgg_assessment_Tec ===
                                                  2
                                                }
                                                onChange={
                                                  HandleQ402aFieldChange
                                                }
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                <DatePickerComponent
                                                  ctrlId={
                                                    "Q402aIgg_assessment_Tec_dt-" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleQ402aRepeaterDateChange
                                                  }
                                                  optionId={1}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                  date={
                                                    data.Q402aIgg_assessment_Tec_dt
                                                  }
                                                />
                                              </span>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                              }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q402aIgg_assessment_Tec" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    data.Q402aIgg_assessment_Tec ===
                                                    99
                                                  }
                                                  onChange={
                                                    HandleQ402aFieldChange
                                                  }
                                                />
                                                <span
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Date of initiation unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={
                                                data.Q402aIgg_assessment_Tec_RdHard
                                              }
                                              message={
                                                TTCharacteristics_MSGS.Q402aSelect_RdHard
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />

                                            <ErrorField
                                              show={
                                                data.Q402aIgg_assessment_Tec_dtHard
                                              }
                                              message={
                                                TTCharacteristics_MSGS.Q402aIggDateAdm_Hard
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                data.Q402aIgg_assessment_Tec_dtInvalid
                                              }
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                data.Q402aIgg_assessment_Tec_dt_before_eof
                                              }
                                              message={
                                                TTCharacteristics_MSGS.Q402BDateBeforeEOFAfterIndex91
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </div>
                                        </td>

                                        {/* IgG level */}
                                        {data.Q402aIgg_assessment_Tec != 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "start",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q402aIgg_level_Tec" + idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q402aIgg_level_Tec ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ402aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q402aIgg_level_Tec_MgValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q402aIgg_level_Tec_MgValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ402aFieldChange
                                                        }
                                                        onKeyDown={
                                                          AllowNumericWithDecimal
                                                        }
                                                      />
                                                    </span>
                                                    <span>&nbsp;mg/dL</span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q402aIgg_level_Tec" + idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.Q402aIgg_level_Tec ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleQ402aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q402aIgg_level_Tec_GValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q402aIgg_level_Tec_GValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ402aFieldChange
                                                        }
                                                        onKeyDown={
                                                          AllowNumericWithDecimal
                                                        }
                                                      />
                                                    </span>
                                                    <span>&nbsp;g/L</span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q402aIgg_level_Tec" + idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q402aIgg_level_Tec ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ402aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q402aIgg_level_Tec_Empty
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q402aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q402aIgg_level_Tec_RangeInvalid
                                                }
                                                message={
                                                  data.Q402aIgg_level_Tec === 1
                                                    ? TTCharacteristics_MSGS.Q402aLevelRangeHardMG
                                                    : data.Q402aIgg_level_Tec ===
                                                        2
                                                      ? TTCharacteristics_MSGS.Q402aLevelRangeHardGL
                                                      : ""
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              //alignContent: "flex-start",
                                              textAlign: "center",
                                              padding: "8px",
                                              //textAlign: 'start'
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}
                                      </tr>
                                    ))}

                                  {isTalveySelected &&
                                    Q402aTalDetails.length > 0 &&
                                    Q402aTalDetails.map((data, idx) => (
                                      <tr key={idx}>
                                        <>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <span className="quest-text-pad">
                                              TALVEY{" "}
                                              <sup className="supscript">
                                                TM
                                              </sup>{" "}
                                              (talquetamab-tgvs)
                                            </span>
                                          </td>

                                          {/* IgG assessment */}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q402aIgg_assessment_Tal" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q402aIgg_assessment_Tal ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ402aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    No IgG assessment performed
                                                    at treatment initiation
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q402aIgg_assessment_Tal" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={
                                                    data.Q402aIgg_assessment_Tal ===
                                                    2
                                                  }
                                                  onChange={
                                                    HandleQ402aFieldChange
                                                  }
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  <DatePickerComponent
                                                    ctrlId={
                                                      "Q402aIgg_assessment_Tal_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleQ402aRepeaterDateChange
                                                    }
                                                    optionId={1}
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                    date={
                                                      data.Q402aIgg_assessment_Tal_dt
                                                    }
                                                  />
                                                </span>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q402aIgg_assessment_Tal" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q402aIgg_assessment_Tal ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ402aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Date of initiation unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q402aIgg_assessment_Tal_RdHard
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q402aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Q402aIgg_assessment_Tal_dtHard
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q402aIggDateAdm_Hard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q402aIgg_assessment_Tal_dtInvalid
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q402aIgg_assessment_Tal_dt_before_eof
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q402BDateBeforeEOFAfterIndex91
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>

                                          {/* IgG level */}
                                          {data.Q402aIgg_assessment_Tal != 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              <div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q402aIgg_level_Tal" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.Q402aIgg_level_Tal ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleQ402aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q402aIgg_level_Tal_MgValue" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q402aIgg_level_Tal_MgValue
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ402aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                        />
                                                      </span>
                                                      <span>&nbsp;mg/dL</span>
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q402aIgg_level_Tal" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.Q402aIgg_level_Tal ===
                                                        2
                                                      }
                                                      onChange={
                                                        HandleQ402aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q402aIgg_level_Tal_GValue" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q402aIgg_level_Tal_GValue
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ402aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                        />
                                                      </span>
                                                      <span>&nbsp;g/L</span>
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q402aIgg_level_Tal" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.Q402aIgg_level_Tal ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleQ402aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q402aIgg_level_Tal_Empty
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.Q402aSelect_RdHard
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.Q402aIgg_level_Tal_RangeInvalid
                                                  }
                                                  message={
                                                    data.Q402aIgg_level_Tal ===
                                                    1
                                                      ? TTCharacteristics_MSGS.Q402aLevelRangeHardMG
                                                      : data.Q402aIgg_level_Tal ===
                                                          2
                                                        ? TTCharacteristics_MSGS.Q402aLevelRangeHardGL
                                                        : ""
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </div>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                //alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                  verticalAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}
                                        </>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                    {/* 40.2.A end */}

                    {/* 40.3.A start */}
                    {isNewEcrfB &&
                      (isTechvayliSelected || isTalveySelected) &&
                      ((Q37TechDetails[0]?.Q40dosingfreqRd != null &&
                        Q37TechDetails[0]?.Q40dosingfreqRd != 1) ||
                        (Q37TalDetails[0]?.Q40dosingfreqRd_Tal != null &&
                          Q37TalDetails[0]?.Q40dosingfreqRd_Tal != 1)) && (
                        <div>
                          <div className="question question-weight">
                            <span>Q40.3.B</span>
                            <span className="quest-text-pad">
                              Please provide the{" "}
                              <i>
                                last immunoglobulin G (IgG) level before the
                                start of IVIG{" "}
                              </i>{" "}
                              {isTechvayliSelected && (
                                <>
                                  (ranging from
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                      fontWeight: "bolder",
                                    }}
                                  >
                                    {" "}
                                    {showTechQ40Date91()}{" "}
                                  </span>
                                  to{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                      fontWeight: "bolder",
                                    }}
                                  >
                                    {" "}
                                    {showTechQ40Date()}{" "}
                                  </span>
                                  ) while on treatment with{" "}
                                </>
                              )}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isTechvayliSelected && (
                                  <>TECVAYLI® (teclistamab-cqyv)</>
                                )}

                                {isTechvayliSelected && isTalveySelected
                                  ? " and "
                                  : isTechvayliSelected
                                    ? "."
                                    : ""}
                              </span>
                              <span>
                                {isTalveySelected && (
                                  <>
                                    (ranging from
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {showTalQ40Date91()}{" "}
                                    </span>
                                    to{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {showTalQ40Date()}{" "}
                                    </span>
                                    ) while on treatment with{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      TALVEY <sup className="supscript">TM</sup>{" "}
                                      (talquetamab-tgvs)
                                    </span>
                                    .
                                  </>
                                )}
                              </span>
                            </span>
                          </div>

                          <div className="question-bot-sapce">
                            <div className="sub-question grid-overflow">
                              <table
                                style={{
                                  border: "1px solid black",
                                  borderCollapse: "collapse",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Treatment
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "33%",
                                      }}
                                    >
                                      Date of last IgG assessment before start
                                      of IVIG
                                    </th>

                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "16%",
                                      }}
                                    >
                                      Last IgG level before start of IVIG
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {/* Tecvayli */}
                                  {isTechvayliSelected &&
                                    Q403aTecDetails.length > 0 &&
                                    Q37TechDetails[0]?.Q40dosingfreqRd !=
                                      null &&
                                    Q37TechDetails[0]?.Q40dosingfreqRd != 1 &&
                                    Q403aTecDetails.map((data, idx) => (
                                      <tr key={idx}>
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <span className="quest-text-pad">
                                            TECVAYLI® (teclistamab-cqyv)
                                          </span>
                                        </td>

                                        {/* IgG assessment */}
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                              }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q403aIgg_assessment_Tec" +
                                                    idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.Q403aIgg_assessment_Tec ===
                                                    1
                                                  }
                                                  onChange={
                                                    HandleQ403aFieldChange
                                                  }
                                                />
                                                <span
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  No IgG assessment performed at
                                                  IVIG initiation
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "Q403aIgg_assessment_Tec" +
                                                  idx
                                                }
                                                value={2}
                                                checked={
                                                  data.Q403aIgg_assessment_Tec ===
                                                  2
                                                }
                                                onChange={
                                                  HandleQ403aFieldChange
                                                }
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                <DatePickerComponent
                                                  ctrlId={
                                                    "Q403aIgg_assessment_Tec_dt-" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleQ403aRepeaterDateChange
                                                  }
                                                  optionId={1}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                  date={
                                                    data.Q403aIgg_assessment_Tec_dt
                                                  }
                                                />
                                              </span>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                              }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q403aIgg_assessment_Tec" +
                                                    idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    data.Q403aIgg_assessment_Tec ===
                                                    99
                                                  }
                                                  onChange={
                                                    HandleQ403aFieldChange
                                                  }
                                                />
                                                <span
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Date of initiation unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={
                                                data.Q403aIgg_assessment_Tec_RdHard
                                              }
                                              message={
                                                TTCharacteristics_MSGS.Q402aSelect_RdHard
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />

                                            <ErrorField
                                              show={
                                                data.Q403aIgg_assessment_Tec_dtHard
                                              }
                                              message={
                                                TTCharacteristics_MSGS.Q402aIggDateAdm_Hard
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                data.Q403aIgg_assessment_Tec_dtInvalid
                                              }
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={
                                                data.Q403aIgg_assessment_Tec_dt_before_eof
                                              }
                                              message={
                                                TTCharacteristics_MSGS.Q403BDateRangeError
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </div>
                                        </td>

                                        {/* IgG level */}
                                        {data.Q403aIgg_assessment_Tec != 1 ? (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "start",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q403aIgg_level_Tec" + idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q403aIgg_level_Tec ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ403aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q403aIgg_level_Tec_MgValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q403aIgg_level_Tec_MgValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ403aFieldChange
                                                        }
                                                        onKeyDown={
                                                          AllowNumericWithDecimal
                                                        }
                                                      />
                                                    </span>
                                                    <span>&nbsp;mg/dL</span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q403aIgg_level_Tec" + idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.Q403aIgg_level_Tec ===
                                                      2
                                                    }
                                                    onChange={
                                                      HandleQ403aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <span>
                                                      <input
                                                        className="input-dash-ttcustom"
                                                        id={idx}
                                                        name={
                                                          "Q403aIgg_level_Tec_GValue" +
                                                          idx
                                                        }
                                                        value={
                                                          data.Q403aIgg_level_Tec_GValue
                                                        }
                                                        type="text"
                                                        onChange={
                                                          HandleQ403aFieldChange
                                                        }
                                                        onKeyDown={
                                                          AllowNumericWithDecimal
                                                        }
                                                      />
                                                    </span>
                                                    <span>&nbsp;g/L</span>
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q403aIgg_level_Tec" + idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q403aIgg_level_Tec ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ403aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q403aIgg_level_Tec_Empty
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q402aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q403aIgg_level_Tec_RangeInvalid
                                                }
                                                message={
                                                  data.Q403aIgg_level_Tec === 1
                                                    ? TTCharacteristics_MSGS.Q402aLevelRangeHardMG
                                                    : data.Q403aIgg_level_Tec ===
                                                        2
                                                      ? TTCharacteristics_MSGS.Q402aLevelRangeHardGL
                                                      : ""
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              //alignContent: "flex-start",
                                              textAlign: "center",
                                              padding: "8px",
                                              //textAlign: 'start'
                                            }}
                                          >
                                            <span
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "center",
                                              }}
                                              className="not-applicable"
                                            >
                                              <b>Not applicable</b>
                                            </span>
                                          </td>
                                        )}
                                      </tr>
                                    ))}

                                  {isTalveySelected &&
                                    Q403aTalDetails.length > 0 &&
                                    Q37TalDetails[0]?.Q40dosingfreqRd_Tal !=
                                      null &&
                                    Q37TalDetails[0]?.Q40dosingfreqRd_Tal !=
                                      1 &&
                                    Q403aTalDetails.map((data, idx) => (
                                      <tr key={idx}>
                                        <>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <span className="quest-text-pad">
                                              TALVEY{" "}
                                              <sup className="supscript">
                                                TM
                                              </sup>{" "}
                                              (talquetamab-tgvs)
                                            </span>
                                          </td>

                                          {/* IgG assessment */}
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q403aIgg_assessment_Tal" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q403aIgg_assessment_Tal ===
                                                      1
                                                    }
                                                    onChange={
                                                      HandleQ403aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    No IgG assessment performed
                                                    at IVIG initiation
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "Q403aIgg_assessment_Tal" +
                                                    idx
                                                  }
                                                  value={2}
                                                  checked={
                                                    data.Q403aIgg_assessment_Tal ===
                                                    2
                                                  }
                                                  onChange={
                                                    HandleQ403aFieldChange
                                                  }
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  <DatePickerComponent
                                                    ctrlId={
                                                      "Q403aIgg_assessment_Tal_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleQ403aRepeaterDateChange
                                                    }
                                                    optionId={1}
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                    date={
                                                      data.Q403aIgg_assessment_Tal_dt
                                                    }
                                                  />
                                                </span>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "Q403aIgg_assessment_Tal" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q403aIgg_assessment_Tal ===
                                                      99
                                                    }
                                                    onChange={
                                                      HandleQ403aFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Date unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q403aIgg_assessment_Tal_RdHard
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q402aSelect_RdHard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Q403aIgg_assessment_Tal_dtHard
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q402aIggDateAdm_Hard
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q403aIgg_assessment_Tal_dtInvalid
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                              <ErrorField
                                                show={
                                                  data.Q403aIgg_assessment_Tal_dt_before_eof
                                                }
                                                message={
                                                  TTCharacteristics_MSGS.Q403BDateRangeError
                                                }
                                                style={{
                                                  paddingLeft: "0px",
                                                }}
                                              />
                                            </div>
                                          </td>

                                          {/* IgG level */}
                                          {data.Q403aIgg_assessment_Tal != 1 ? (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              <div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q403aIgg_level_Tal" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.Q403aIgg_level_Tal ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleQ403aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q403aIgg_level_Tal_MgValue" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q403aIgg_level_Tal_MgValue
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ403aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                        />
                                                      </span>
                                                      <span>&nbsp;mg/dL</span>
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q403aIgg_level_Tal" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.Q403aIgg_level_Tal ===
                                                        2
                                                      }
                                                      onChange={
                                                        HandleQ403aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        <input
                                                          className="input-dash-ttcustom"
                                                          id={idx}
                                                          name={
                                                            "Q403aIgg_level_Tal_GValue" +
                                                            idx
                                                          }
                                                          value={
                                                            data.Q403aIgg_level_Tal_GValue
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleQ403aFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                        />
                                                      </span>
                                                      <span>&nbsp;g/L</span>
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "Q403aIgg_level_Tal" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.Q403aIgg_level_Tal ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleQ403aFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q403aIgg_level_Tal_Empty
                                                  }
                                                  message={
                                                    TTCharacteristics_MSGS.Q402aSelect_RdHard
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.Q403aIgg_level_Tal_RangeInvalid
                                                  }
                                                  message={
                                                    data.Q403aIgg_level_Tal ===
                                                    1
                                                      ? TTCharacteristics_MSGS.Q402aLevelRangeHardMG
                                                      : data.Q403aIgg_level_Tal ===
                                                          2
                                                        ? TTCharacteristics_MSGS.Q402aLevelRangeHardGL
                                                        : ""
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </div>
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                //alignContent: "flex-start",
                                                textAlign: "center",
                                                padding: "8px",
                                                //textAlign: 'start'
                                              }}
                                            >
                                              <span
                                                style={{
                                                  textAlign: "center",
                                                  verticalAlign: "center",
                                                }}
                                                className="not-applicable"
                                              >
                                                <b>Not applicable</b>
                                              </span>
                                            </td>
                                          )}
                                        </>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                    {/* 40.3.A end */}
                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TTCharacteristics;
